module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "1aba");
/******/ })
/************************************************************************/
/******/ ({

/***/ "022d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "026f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterWell.vue?vue&type=template&id=5f533db2&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm btn-outline-primary mr-2 mb-2",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.label)+"  "),_c('i',{staticClass:"fa fa-times"})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/FilterWell.vue?vue&type=template&id=5f533db2&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterWell.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */ var FilterWellvue_type_script_lang_js_ = ({
  props: {
    label: String
  }
});
// CONCATENATED MODULE: ./src/tables/FilterWell.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_FilterWellvue_type_script_lang_js_ = (FilterWellvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/tables/FilterWell.vue?vue&type=custom&index=0&blockType=docs
var FilterWellvue_type_custom_index_0_blockType_docs = __webpack_require__("ae84");

// CONCATENATED MODULE: ./src/tables/FilterWell.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tables_FilterWellvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof FilterWellvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(FilterWellvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var FilterWell = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "0293":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "029a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonAction_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("330e");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonAction_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonAction_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonAction_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "06eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputFile_vue_vue_type_style_index_0_id_33e178de_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7b9a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputFile_vue_vue_type_style_index_0_id_33e178de_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputFile_vue_vue_type_style_index_0_id_33e178de_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "06f6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NavTabs_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9ecf");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NavTabs_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NavTabs_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_NavTabs_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "084c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/_formGroup.vue?vue&type=template&id=6ed25fa3&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:_vm.inplace ? 'm0' : 'bg-white rounded p-2'},[(_vm.label && !_vm.inplace && !_vm.editMeta)?_c('label',{staticClass:"mb-0 mr-2",attrs:{"for":_vm.id}},[_c('b',[_vm._v(_vm._s(_vm.label))])]):(_vm.editMeta)?_c('label',[_c('InputString',{attrs:{"inplace":true,"value":_vm.label},on:{"input":function($event){return _vm.$emit('update:label', $event)}}})],1):_vm._e(),(_vm.required)?_c('span',{staticClass:"float-right"},[_vm._v("(required)")]):_vm._e(),(_vm.description && !_vm.inplace && !_vm.editMeta)?_c('small',{staticClass:"form-text text-muted",attrs:{"id":_vm.id + 'Description'}},[_vm._v(" "+_vm._s(_vm.description)+" ")]):(_vm.editMeta)?_c('small',{staticClass:"form-text text-muted",attrs:{"id":_vm.id + 'Description'}},[_c('InputText',{attrs:{"inplace":true,"value":_vm.description},on:{"input":function($event){return _vm.$emit('update:description', $event)}}})],1):_vm._e(),_vm._t("default"),(_vm.errorMessage)?_c('small',{staticClass:"text-danger form-text"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/_formGroup.vue?vue&type=template&id=6ed25fa3&

// EXTERNAL MODULE: ./src/forms/InputString.vue + 4 modules
var InputString = __webpack_require__("ffa4");

// EXTERNAL MODULE: ./src/forms/InputText.vue + 4 modules
var InputText = __webpack_require__("d622");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/_formGroup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var _formGroupvue_type_script_lang_js_ = ({
  components: {
    InputString: InputString["a" /* default */],
    InputText: InputText["a" /* default */]
  },
  name: "FormGroup",

  data() {
    return {
      labelEdit: null
    };
  },

  props: {
    /** id for which this is the group */
    id: String,

    /** value to be shown as input */
    placeholder: String,

    /** label to be shown next to the input */
    label: String,

    /** optional description string shown below */
    description: String,

    /** if required */
    required: Boolean,

    /** String with graphqlError state */
    errorMessage: String,

    /** whether inplace */
    inplace: Boolean,

    /** whether inplace metadata edit */
    editMeta: Boolean
  }
});
// CONCATENATED MODULE: ./src/forms/_formGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_formGroupvue_type_script_lang_js_ = (_formGroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// CONCATENATED MODULE: ./src/forms/_formGroup.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_formGroupvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var _formGroup = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "09e7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterContainer_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7d21");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterContainer_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterContainer_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterContainer_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0ab8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("18f1");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0acc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRefSelect.vue?vue&type=template&id=e868ad5e&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroup',_vm._g(_vm._b({},'FormGroup',_vm.$props,false),_vm.$listeners),[_vm._l((_vm.valueArray),function(el,idx){return _c('InputAppend',_vm._b({key:idx,attrs:{"showPlus":_vm.showPlus(idx),"showClear":_vm.showClear(idx)},on:{"clear":function($event){return _vm.clearValue(idx)},"add":_vm.addRow}},'InputAppend',_vm.$props,false),[(_vm.readonly)?_c('input',{staticClass:"form-control",attrs:{"type":"hidden"}}):_vm._e(),_c('select',{class:{ 'form-control': true, 'is-invalid': _vm.errorMessage },attrs:{"id":_vm.id,"disabled":_vm.readonly},on:{"click":function($event){return _vm.openSelect(idx)}}},[(_vm.valueArray[idx] && !_vm.showSelect)?_c('option',{attrs:{"selected":"","readonly":_vm.readonly},domProps:{"value":_vm.valueArray[idx]}},[_vm._v(" "+_vm._s(_vm.refLabel ? _vm.applyJsTemplate(el) : _vm.flattenObject(el))+" ")]):_vm._e()])])}),(_vm.showSelect)?_c('LayoutModal',{attrs:{"title":_vm.title},on:{"close":_vm.closeSelect},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('TableSearch',{attrs:{"table":_vm.table,"filter":_vm.filter,"graphqlURL":_vm.graphqlURL},on:{"select":function($event){return _vm.select($event)},"deselect":function($event){return _vm.deselect(_vm.selectIdx)}},scopedSlots:_vm._u([{key:"rowheader",fn:function(slotProps){return [_c('ButtonAction',{on:{"click":function($event){return _vm.select(slotProps.rowkey)}}},[_vm._v(" Select ")])]}}],null,false,1679400557)})]},proxy:true},{key:"footer",fn:function(){return [_c('ButtonAlt',{on:{"click":_vm.closeSelect}},[_vm._v("Close")])]},proxy:true}],null,false,903672644)}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputRefSelect.vue?vue&type=template&id=e868ad5e&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/tables/TableSearch.vue + 4 modules
var TableSearch = __webpack_require__("7f62");

// EXTERNAL MODULE: ./src/layout/LayoutModal.vue + 4 modules
var LayoutModal = __webpack_require__("ed0c");

// EXTERNAL MODULE: ./src/forms/_formGroup.vue + 4 modules
var _formGroup = __webpack_require__("084c");

// EXTERNAL MODULE: ./src/forms/ButtonAlt.vue + 4 modules
var ButtonAlt = __webpack_require__("bd01");

// EXTERNAL MODULE: ./src/forms/_inputAppend.vue + 4 modules
var _inputAppend = __webpack_require__("5807");

// EXTERNAL MODULE: ./src/forms/ButtonAction.vue + 4 modules
var ButtonAction = __webpack_require__("c268");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRefSelect.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var InputRefSelectvue_type_script_lang_js_ = ({
  name: "InputRefSelect",
  extends: _baseInput["a" /* default */],
  data: function () {
    return {
      showSelect: false,
      selectIdx: null
    };
  },
  components: {
    TableSearch: TableSearch["a" /* default */],
    LayoutModal: LayoutModal["a" /* default */],
    FormGroup: _formGroup["default"],
    ButtonAction: ButtonAction["a" /* default */],
    ButtonAlt: ButtonAlt["a" /* default */],
    InputAppend: _inputAppend["a" /* default */]
  },
  props: {
    /** change if graphql URL != 'graphql'*/
    graphqlURL: {
      default: "graphql",
      type: String
    },
    table: String,
    filter: Object,
    refLabel: String
  },
  computed: {
    title() {
      return "Select " + this.table;
    }

  },
  methods: {
    select(event) {
      this.showSelect = false;
      this.emitValue(event, this.selectIdx);
    },

    closeSelect() {
      this.showSelect = false;
      this.reload();
    },

    openSelect(idx) {
      this.showSelect = true;
      this.selectIdx = idx;
    },

    deselect(idx) {
      this.showSelect = false;
      this.clearValue(idx);
      this.emitValue();
    },

    flattenObject(object) {
      let result = "";
      Object.keys(object).forEach(key => {
        if (object[key] === null) {//nothing
        } else if (typeof object[key] === "object") {
          result += this.flattenObject(object[key]);
        } else {
          result += " " + object[key];
        }
      });
      return result;
    },

    applyJsTemplate(object) {
      const names = Object.keys(object);
      const vals = Object.values(object);

      try {
        return new Function(...names, "return `" + this.refLabel + "`;")(...vals);
      } catch (err) {
        return err.message + " we got keys:" + JSON.stringify(names) + " vals:" + JSON.stringify(vals) + " and template: " + this.refLabel;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputRefSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputRefSelectvue_type_script_lang_js_ = (InputRefSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputRefSelect.vue?vue&type=custom&index=0&blockType=docs
var InputRefSelectvue_type_custom_index_0_blockType_docs = __webpack_require__("4eb4");

// CONCATENATED MODULE: ./src/forms/InputRefSelect.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputRefSelectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputRefSelectvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputRefSelectvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputRefSelect = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "0ca2":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "dl[data-v-366673e6]{width:100%;overflow:hidden}dt[data-v-366673e6]{width:35%;text-align:right}dd[data-v-366673e6],dt[data-v-366673e6]{float:left}dd[data-v-366673e6]{width:65%;padding:0;margin:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0dcd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableMolgenis.vue?vue&type=template&id=01efe152&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1",staticStyle:{"max-width":"100%"}},[_c('table',{staticClass:"table table-sm bg-white table-bordered table-hover",class:{ 'table-hover': _vm.showSelect }},[_c('thead',[_c('Draggable',{attrs:{"list":_vm.columns,"handle":".column-drag-header","ghost-class":"border-primary","tag":"tr"},on:{"change":function($event){return _vm.$emit('update:columns', $event)}}},[(_vm.hasColheader)?_c('th',{staticStyle:{"width":"1px"},attrs:{"slot":"header","scope":"col"},slot:"header"},[_c('h6',{staticClass:"mb-0 mt-2 d-inline"},[_vm._v(" # ")]),_c('span',{staticStyle:{"text-align":"left","font-weight":"normal"}},[_vm._t("colheader")],2)]):_vm._e(),_vm._l((_vm.columnsWithoutMeta),function(col){return _c('th',{key:col.name + col.showColumn,staticClass:"column-drag-header",style:(col.showColumn ? '' : 'display: none'),attrs:{"scope":"col"}},[_c('h6',{staticClass:"mb-0"},[_vm._v(_vm._s(col.name))])])})],2)],1),_c('tbody',_vm._l((_vm.data),function(row,idx){return _c('tr',{key:idx + JSON.stringify(row) + _vm.isSelected(row),class:(_vm.isSelected(row) ? 'table-primary' : 'table-hover') +
          (row['mg_draft'] ? 'alert alert-warning' : '')},[(_vm.hasColheader)?_c('td',[_c('div',{staticStyle:{"display":"flex"}},[(_vm.showSelect)?_c('div',{staticClass:"form-check form-check-inline mr-1"},[_c('input',{staticClass:"form-check-input position-static",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isSelected(row)},on:{"click":function($event){return _vm.onRowClick(row)}}})]):_vm._e(),_vm._t("rowheader",null,{"row":row,"metadata":_vm.tableMetadata,"rowkey":_vm.getKey(row)})],2),(row.mg_draft)?_c('i',{staticClass:"fas fa-user-edit"},[_vm._v("draft")]):_vm._e()]):_vm._e(),_vm._l((_vm.columnsWithoutMeta),function(col){return _c('td',{key:idx + col.name + _vm.isSelected(row),staticStyle:{"cursor":"pointer"},style:(col.showColumn ? '' : 'display: none'),on:{"click":function($event){return _vm.onRowClick(row)}}},[_c('data-display-cell',{attrs:{"data":row[col.name],"metaData":col}})],1)})],2)}),0)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/TableMolgenis.vue?vue&type=template&id=01efe152&scoped=true&

// EXTERNAL MODULE: ../node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__("ca98");
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/DataDisplayCell.vue?vue&type=template&id=763ac6c6&
var DataDisplayCellvue_type_template_id_763ac6c6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmpty)?_c(_vm.cellTypeComponentName,{tag:"component",attrs:{"data":_vm.data,"metaData":_vm.metaData}}):_vm._e()}
var DataDisplayCellvue_type_template_id_763ac6c6_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/DataDisplayCell.vue?vue&type=template&id=763ac6c6&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/StringDisplay.vue?vue&type=template&id=95ad50e8&
var StringDisplayvue_type_template_id_95ad50e8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(_vm._s(_vm.data))])}
var StringDisplayvue_type_template_id_95ad50e8_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/cellTypes/StringDisplay.vue?vue&type=template&id=95ad50e8&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/StringDisplay.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var StringDisplayvue_type_script_lang_js_ = ({
  name: "StringDisplay",
  props: {
    data: {
      type: [String, Object, Number, Boolean],
      required: true
    },
    metaData: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./src/tables/cellTypes/StringDisplay.vue?vue&type=script&lang=js&
 /* harmony default export */ var cellTypes_StringDisplayvue_type_script_lang_js_ = (StringDisplayvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// CONCATENATED MODULE: ./src/tables/cellTypes/StringDisplay.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  cellTypes_StringDisplayvue_type_script_lang_js_,
  StringDisplayvue_type_template_id_95ad50e8_render,
  StringDisplayvue_type_template_id_95ad50e8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StringDisplay = (component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/FileDisplay.vue?vue&type=template&id=2151e6c5&
var FileDisplayvue_type_template_id_2151e6c5_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.id)?_c('a',{attrs:{"href":_vm.data.url}},[_vm._v(" "+_vm._s(_vm.metaData.name)+"."+_vm._s(_vm.data.extension)+" ("+_vm._s(_vm.fileSize)+") ")]):_vm._e()}
var FileDisplayvue_type_template_id_2151e6c5_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/cellTypes/FileDisplay.vue?vue&type=template&id=2151e6c5&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/FileDisplay.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var FileDisplayvue_type_script_lang_js_ = ({
  name: "FileDisplay",
  props: {
    data: {
      type: [Object],
      required: true
    },
    metaData: {
      type: Object,
      required: true
    },
    computend: {
      fileSize() {
        const SI_SYMBOL = ["", "k", "M", "G", "T", "P", "E"]; // what tier? (determines SI symbol)

        const tier = Math.log10(this.data.size) / 3 | 0; // if zero, we don't need a suffix

        if (tier == 0) {
          return this.data.size;
        } // get suffix and determine scale


        var suffix = SI_SYMBOL[tier];
        var scale = Math.pow(10, tier * 3); // scale the number

        var scaled = this.number / scale; // format number and add suffix

        return scaled.toFixed(1) + suffix;
      }

    }
  }
});
// CONCATENATED MODULE: ./src/tables/cellTypes/FileDisplay.vue?vue&type=script&lang=js&
 /* harmony default export */ var cellTypes_FileDisplayvue_type_script_lang_js_ = (FileDisplayvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tables/cellTypes/FileDisplay.vue





/* normalize component */

var FileDisplay_component = Object(componentNormalizer["a" /* default */])(
  cellTypes_FileDisplayvue_type_script_lang_js_,
  FileDisplayvue_type_template_id_2151e6c5_render,
  FileDisplayvue_type_template_id_2151e6c5_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FileDisplay = (FileDisplay_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/TextDisplay.vue?vue&type=template&id=59d383f2&
var TextDisplayvue_type_template_id_59d383f2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReadMore',{attrs:{"text":_vm.data}})}
var TextDisplayvue_type_template_id_59d383f2_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/cellTypes/TextDisplay.vue?vue&type=template&id=59d383f2&

// EXTERNAL MODULE: ./src/layout/ReadMore.vue + 4 modules
var ReadMore = __webpack_require__("4b97");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/TextDisplay.vue?vue&type=script&lang=js&
//
//
//
//

/* harmony default export */ var TextDisplayvue_type_script_lang_js_ = ({
  name: "TextDisplay",
  components: {
    ReadMore: ReadMore["a" /* default */]
  },
  props: {
    data: {
      type: [String, Object, Array, Number, Boolean],
      required: true
    },
    metaData: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./src/tables/cellTypes/TextDisplay.vue?vue&type=script&lang=js&
 /* harmony default export */ var cellTypes_TextDisplayvue_type_script_lang_js_ = (TextDisplayvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tables/cellTypes/TextDisplay.vue





/* normalize component */

var TextDisplay_component = Object(componentNormalizer["a" /* default */])(
  cellTypes_TextDisplayvue_type_script_lang_js_,
  TextDisplayvue_type_template_id_59d383f2_render,
  TextDisplayvue_type_template_id_59d383f2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TextDisplay = (TextDisplay_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/ListDisplay.vue?vue&type=template&id=1bdd26b7&scoped=true&
var ListDisplayvue_type_template_id_1bdd26b7_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.length > _vm.foldCuttOff),expression:"data.length > foldCuttOff"}],staticClass:"btn btn-sm float-right fold-btn",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onFoldClicked.apply(null, arguments)}}},[[(_vm.isFolded)?_c('svg',{staticClass:"svg-inline--fa fa-chevron-down fa-w-14",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"chevron-down","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"}})]):_c('svg',{staticClass:"svg-inline--fa fa-chevron-up fa-w-14",attrs:{"aria-hidden":"true","focusable":"false","data-prefix":"fas","data-icon":"chevron-up","role":"img","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"}})])]],2),_vm._l((_vm.visibleListItems),function(listItem,index){return _c('div',{key:index},[(_vm.useObjectDisplay)?_c('object-display',{attrs:{"data":listItem,"metaData":_vm.metaData}}):_c('string-display',{attrs:{"data":listItem,"metaData":_vm.metaData}})],1)})],2)}
var ListDisplayvue_type_template_id_1bdd26b7_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/cellTypes/ListDisplay.vue?vue&type=template&id=1bdd26b7&scoped=true&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/ObjectDisplay.vue?vue&type=template&id=7d60c23c&
var ObjectDisplayvue_type_template_id_7d60c23c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasTemplate)?_c('div',[_vm._v(_vm._s(_vm.asTemplate))]):_c('div',[_vm._v(_vm._s(_vm.asDotSeparatedString))])}
var ObjectDisplayvue_type_template_id_7d60c23c_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/cellTypes/ObjectDisplay.vue?vue&type=template&id=7d60c23c&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/ObjectDisplay.vue?vue&type=script&lang=js&
//
//
//
//
//
/* harmony default export */ var ObjectDisplayvue_type_script_lang_js_ = ({
  name: "ObjectDisplay",
  props: {
    data: {
      type: [Object],
      required: true
    },
    metaData: {
      type: [Object],
      required: true
    }
  },
  computed: {
    hasTemplate() {
      return !!this.metaData.refLabel;
    },

    asTemplate() {
      const names = Object.keys(this.data);
      const vals = Object.values(this.data);

      try {
        return new Function(...names, "return `" + this.metaData.refLabel + "`;")(...vals);
      } catch (err) {
        const namesString = JSON.stringify(names);
        const valsString = JSON.stringify(vals);
        return `${err.message} we got keys: ${namesString} vals: ${valsString} and template: ${this.metaData.refLabel}`;
      }
    },

    asDotSeparatedString() {
      let result = "";
      Object.keys(this.data).forEach(key => {
        if (this.data[key] === null) {//nothing
        } else if (typeof this.data[key] === "object") {
          result += this.flattenObject(this.data[key]);
        } else {
          result += "." + this.data[key];
        }
      });
      return result.replace(/^\./, "");
    }

  }
});
// CONCATENATED MODULE: ./src/tables/cellTypes/ObjectDisplay.vue?vue&type=script&lang=js&
 /* harmony default export */ var cellTypes_ObjectDisplayvue_type_script_lang_js_ = (ObjectDisplayvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tables/cellTypes/ObjectDisplay.vue





/* normalize component */

var ObjectDisplay_component = Object(componentNormalizer["a" /* default */])(
  cellTypes_ObjectDisplayvue_type_script_lang_js_,
  ObjectDisplayvue_type_template_id_7d60c23c_render,
  ObjectDisplayvue_type_template_id_7d60c23c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ObjectDisplay = (ObjectDisplay_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/cellTypes/ListDisplay.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ListDisplayvue_type_script_lang_js_ = ({
  name: "ListDisplay",
  components: {
    ObjectDisplay: ObjectDisplay,
    StringDisplay: StringDisplay
  },

  data() {
    return {
      isFolded: true
    };
  },

  props: {
    data: {
      type: [Array],
      required: true
    },
    metaData: {
      type: Object,
      required: true
    },
    foldCuttOff: {
      type: Number,
      required: false,
      default: () => 3
    }
  },
  computed: {
    useObjectDisplay() {
      return ["REF_ARRAY", "ONTOLOGY_ARRAY", "REFBACK"].includes(this.metaData.columnType);
    },

    visibleListItems() {
      return this.isFolded ? this.data.slice(0, this.foldCuttOff) : this.data;
    }

  },
  methods: {
    onFoldClicked(event) {
      this.isFolded = !this.isFolded; // remove click focus (without destoying tab focus)

      event.target.blur();
      event.target.parentElement.blur();
    }

  }
});
// CONCATENATED MODULE: ./src/tables/cellTypes/ListDisplay.vue?vue&type=script&lang=js&
 /* harmony default export */ var cellTypes_ListDisplayvue_type_script_lang_js_ = (ListDisplayvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/cellTypes/ListDisplay.vue?vue&type=style&index=0&id=1bdd26b7&scoped=true&lang=css&
var ListDisplayvue_type_style_index_0_id_1bdd26b7_scoped_true_lang_css_ = __webpack_require__("ecf8");

// CONCATENATED MODULE: ./src/tables/cellTypes/ListDisplay.vue






/* normalize component */

var ListDisplay_component = Object(componentNormalizer["a" /* default */])(
  cellTypes_ListDisplayvue_type_script_lang_js_,
  ListDisplayvue_type_template_id_1bdd26b7_scoped_true_render,
  ListDisplayvue_type_template_id_1bdd26b7_scoped_true_staticRenderFns,
  false,
  null,
  "1bdd26b7",
  null
  
)

/* harmony default export */ var ListDisplay = (ListDisplay_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/DataDisplayCell.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//





const typeMap = {
  FILE: "FileDisplay",
  TEXT: "TextDisplay",
  REFBACK: "ListDisplay",
  REF: "ObjectDisplay",
  ONTOLOGY: "ObjectDisplay"
};
/* harmony default export */ var DataDisplayCellvue_type_script_lang_js_ = ({
  name: "DataDisplayCell",
  components: {
    StringDisplay: StringDisplay,
    FileDisplay: FileDisplay,
    TextDisplay: TextDisplay,
    ListDisplay: ListDisplay,
    ObjectDisplay: ObjectDisplay
  },
  props: {
    data: {
      type: [String, Object, Array, Number, Boolean],
      required: false
    },
    metaData: {
      type: Object,
      required: true
    }
  },
  computed: {
    cellTypeComponentName() {
      return this.isArrayType ? "ListDisplay" : typeMap[this.metaData.columnType] || "StringDisplay";
    },

    isArrayType() {
      return this.metaData.columnType.includes("ARRAY") > 0;
    },

    isEmpty() {
      return this.data === undefined || this.data === null || Array.isArray(this.data) && this.data.length === 0;
    }

  }
});
// CONCATENATED MODULE: ./src/tables/DataDisplayCell.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_DataDisplayCellvue_type_script_lang_js_ = (DataDisplayCellvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tables/DataDisplayCell.vue





/* normalize component */

var DataDisplayCell_component = Object(componentNormalizer["a" /* default */])(
  tables_DataDisplayCellvue_type_script_lang_js_,
  DataDisplayCellvue_type_template_id_763ac6c6_render,
  DataDisplayCellvue_type_template_id_763ac6c6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DataDisplayCell = (DataDisplayCell_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableMolgenis.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Table that uses MOLGENIS metadata format to configure itself. Provide 'metadata' and 'data' and your table is ready.
 * Can be used without backend to configure a table. Note, columns can be dragged.
 */


/* harmony default export */ var TableMolgenisvue_type_script_lang_js_ = ({
  components: {
    Draggable: vuedraggable_umd_default.a,
    DataDisplayCell: DataDisplayCell
  },
  props: {
    /** selection, two-way binded*/
    selection: Array,

    /** column metadata, two-way binded to allow for reorder */
    columns: Array,

    /** not two way binded, table metadata */
    tableMetadata: Object,

    /** json structure in molgenis json data format matching the column metadata */
    data: Array,

    /** if select show be shown */
    showSelect: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    countColumns() {
      return this.columnsWithoutMeta.filter(c => c.showColumn).length;
    },

    columnsWithoutMeta() {
      return this.columns.filter(c => c.columnType != "HEADING");
    }

  },

  created() {
    this.initShowColumn();
  },

  methods: {
    hasColheader() {
      return this.showSelect || !!this.$slots.colheader || !!this.$slots.rowheader;
    },

    initShowColumn() {
      if (this.columns) {
        let update = this.columns;

        for (var key in update) {
          if (update[key].showColumn == undefined) {
            update[key].showColumn = true;
            this.$emit("update:columns", update);
          }
        }
      }
    },

    getKey(row) {
      let result = {};
      this.columns.filter(c => c.key == 1).map(c => result[c.name] = row[c.name]);
      return result;
    },

    isSelected(row) {
      let key = this.getKey(row);
      let found = false;

      if (Array.isArray(this.selection)) {
        this.selection.forEach(s => {
          if (s != null && this.deepEqual(key, s)) {
            found = true;
          }
        });
      }

      return found;
    },

    /** horrible that this is not standard, found this here https://dmitripavlutin.com/how-to-compare-objects-in-javascript/#4-deep-equality*/
    deepEqual(object1, object2) {
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = this.isObject(val1) && this.isObject(val2);

        if (areObjects && !this.deepEqual(val1, val2) || !areObjects && val1 !== val2) {
          return false;
        }
      }

      return true;
    },

    isObject(object) {
      return object != null && typeof object === "object";
    },

    onRowClick(row) {
      if (this.showSelect) {
        //deep copy
        let update = JSON.parse(JSON.stringify(this.selection));
        let key = this.getKey(row);

        if (this.isSelected(row)) {
          /** when a row is deselected */
          update = update.filter(item => JSON.stringify(item, Object.keys(item).sort()) !== JSON.stringify(key, Object.keys(key).sort()));
          this.$emit("deselect", this.getKey(row));
        } else {
          /** when a row is selected */
          update.push(this.getKey(row));
          this.$emit("select", this.getKey(row));
        }

        this.$emit("update:selection", update);
      } else {
        this.$emit("click", this.getKey(row));
      }
    }

  }
});
// CONCATENATED MODULE: ./src/tables/TableMolgenis.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_TableMolgenisvue_type_script_lang_js_ = (TableMolgenisvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/TableMolgenis.vue?vue&type=style&index=0&id=01efe152&scoped=true&lang=css&
var TableMolgenisvue_type_style_index_0_id_01efe152_scoped_true_lang_css_ = __webpack_require__("cf2b");

// EXTERNAL MODULE: ./src/tables/TableMolgenis.vue?vue&type=custom&index=0&blockType=docs
var TableMolgenisvue_type_custom_index_0_blockType_docs = __webpack_require__("e9a9");

// CONCATENATED MODULE: ./src/tables/TableMolgenis.vue






/* normalize component */

var TableMolgenis_component = Object(componentNormalizer["a" /* default */])(
  tables_TableMolgenisvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "01efe152",
  null
  
)

/* custom blocks */

if (typeof TableMolgenisvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(TableMolgenisvue_type_custom_index_0_blockType_docs["default"])(TableMolgenis_component)

/* harmony default export */ var TableMolgenis = __webpack_exports__["a"] = (TableMolgenis_component.exports);

/***/ }),

/***/ "0ead":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "0ead2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonEdit_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("93ab");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonEdit_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonEdit_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonEdit_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0f1e":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".modal[data-v-66761957]{height:100%;overflow:scroll;background-color:hsla(0,0%,80.4%,.5);max-width:100vw}.modal-body[data-v-66761957]{max-height:calc(100vh - 200px);overflow-y:auto}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "0f35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/Spinner.vue?vue&type=template&id=8e741814&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}]


// CONCATENATED MODULE: ./src/layout/Spinner.vue?vue&type=template&id=8e741814&

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/layout/Spinner.vue?vue&type=custom&index=0&blockType=docs
var Spinnervue_type_custom_index_0_blockType_docs = __webpack_require__("38a5");

// CONCATENATED MODULE: ./src/layout/Spinner.vue

var script = {}


/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof Spinnervue_type_custom_index_0_blockType_docs["default"] === 'function') Object(Spinnervue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var Spinner = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "1099":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "113e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMetadataMixin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fa15");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMetadataMixin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMetadataMixin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMetadataMixin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "115a":
/***/ (function(module, exports) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),

/***/ "117c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ReactNativeFile = __webpack_require__("ee24");

module.exports = function isExtractableFile(value) {
  return (
    (typeof File !== 'undefined' && value instanceof File) ||
    (typeof Blob !== 'undefined' && value instanceof Blob) ||
    value instanceof ReactNativeFile
  );
};


/***/ }),

/***/ "1197":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "128f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "th[data-v-01efe152]{background-color:#fff}.column-drag-header[data-v-01efe152]:hover{cursor:-webkit-grab;cursor:grab}.column-drag-header:hover .column-remove[data-v-01efe152]{visibility:visible}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "15e7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/IconAction.vue?vue&type=template&id=7377db35&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn pl-1 pr-1 btn-outline-primary border-0",on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[(_vm.label)?_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('i',{class:'fas fa-fw fa-' + _vm.icon})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/IconAction.vue?vue&type=template&id=7377db35&

// EXTERNAL MODULE: ./src/forms/ButtonAction.vue + 4 modules
var ButtonAction = __webpack_require__("c268");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/IconAction.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//

/** Button that is shown as a icon. Choose font-awesome icon name as 'icon' parameter to show particular icon. */

/* harmony default export */ var IconActionvue_type_script_lang_js_ = ({
  extends: ButtonAction["a" /* default */],
  props: {
    label: String,
    icon: String
  }
});
// CONCATENATED MODULE: ./src/forms/IconAction.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_IconActionvue_type_script_lang_js_ = (IconActionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/IconAction.vue?vue&type=custom&index=0&blockType=docs
var IconActionvue_type_custom_index_0_blockType_docs = __webpack_require__("6553");

// CONCATENATED MODULE: ./src/forms/IconAction.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_IconActionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof IconActionvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(IconActionvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var IconAction = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "1713":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__("3623")):undefined}("undefined"!=typeof self?self:this,(function(t){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=1)}([function(e,n){e.exports=t},function(t,e,n){"use strict";n.r(e),n.d(e,"Component",(function(){return p})),n.d(e,"Plugin",(function(){return d}));var r=n(0),o=n.n(r),i=["onChange","onClose","onDestroy","onMonthChange","onOpen","onYearChange"];function u(){return(u=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}var a=function(t){return t.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase()},f=function(t){return t&&t.length?t:null},l=function(t){return u({},t)},s=i.concat(["onValueUpdate","onDayCreate","onParseConfig","onReady","onPreCalendarPosition","onKeyDown"]),c=["locale","showMonths"],p={name:"flat-pickr",render:function(t){return t("input",{attrs:{type:"text","data-input":!0},props:{disabled:this.disabled},on:{input:this.onInput}})},props:{value:{default:null,required:!0,validator:function(t){return null===t||t instanceof Date||"string"==typeof t||t instanceof String||t instanceof Array||"number"==typeof t}},config:{type:Object,default:function(){return{wrap:!1,defaultDate:null}}},events:{type:Array,default:function(){return i}},disabled:{type:Boolean,default:!1}},data:function(){return{fp:null}},mounted:function(){var t=this;if(!this.fp){var e=l(this.config);this.events.forEach((function(n){var r,i=o.a.defaultConfig[n]||[];e[n]=(r=e[n]||[],r instanceof Array?r:[r]).concat(i,(function(){for(var e=arguments.length,r=new Array(e),o=0;o<e;o++)r[o]=arguments[o];t.$emit.apply(t,[a(n)].concat(r))}))})),e.defaultDate=this.value||e.defaultDate,this.fp=new o.a(this.getElem(),e),this.fpInput().addEventListener("blur",this.onBlur),this.$on("on-close",this.onClose),this.$watch("disabled",this.watchDisabled,{immediate:!0})}},methods:{getElem:function(){return this.config.wrap?this.$el.parentNode:this.$el},onInput:function(t){var e=this,n=t.target;this.$nextTick((function(){e.$emit("input",f(n.value))}))},fpInput:function(){return this.fp.altInput||this.fp.input},onBlur:function(t){this.$emit("blur",f(t.target.value))},onClose:function(t,e){this.$emit("input",f(e))},watchDisabled:function(t){t?this.fpInput().setAttribute("disabled",t):this.fpInput().removeAttribute("disabled")}},watch:{config:{deep:!0,handler:function(t){var e=this,n=l(t);s.forEach((function(t){delete n[t]})),this.fp.set(n),c.forEach((function(t){void 0!==n[t]&&e.fp.set(t,n[t])}))}},value:function(t){t!==f(this.$el.value)&&this.fp&&this.fp.setDate(t,!0)}},beforeDestroy:function(){this.fp&&(this.fpInput().removeEventListener("blur",this.onBlur),this.fp.destroy(),this.fp=null)}},d=function(t,e){var n="flat-pickr";"string"==typeof e&&(n=e),t.component(n,p)};p.install=d;e.default=p}]).default}));

/***/ }),

/***/ "1828":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputHeading_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bb21");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputHeading_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputHeading_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputHeading_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "186f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonDropdown_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("654b");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonDropdown_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonDropdown_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonDropdown_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "18f1":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "1aba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "ButtonAction", function() { return /* reexport */ ButtonAction["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "ButtonAlt", function() { return /* reexport */ ButtonAlt["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "ButtonDanger", function() { return /* reexport */ ButtonDanger; });
__webpack_require__.d(__webpack_exports__, "ButtonDropdown", function() { return /* reexport */ ButtonDropdown; });
__webpack_require__.d(__webpack_exports__, "ButtonOutline", function() { return /* reexport */ ButtonOutline["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "DefaultMenuMixin", function() { return /* reexport */ DefaultMenuMixin; });
__webpack_require__.d(__webpack_exports__, "Footer", function() { return /* reexport */ MolgenisFooter; });
__webpack_require__.d(__webpack_exports__, "FilterSidebar", function() { return /* reexport */ FilterSidebar; });
__webpack_require__.d(__webpack_exports__, "FilterWells", function() { return /* reexport */ FilterWells; });
__webpack_require__.d(__webpack_exports__, "FilterInput", function() { return /* reexport */ FilterInput; });
__webpack_require__.d(__webpack_exports__, "FilterContainer", function() { return /* reexport */ FilterContainer; });
__webpack_require__.d(__webpack_exports__, "IconBar", function() { return /* reexport */ IconBar; });
__webpack_require__.d(__webpack_exports__, "IconAction", function() { return /* reexport */ IconAction["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "IconDanger", function() { return /* reexport */ IconDanger["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputBoolean", function() { return /* reexport */ InputBoolean["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputCheckbox", function() { return /* reexport */ InputCheckbox; });
__webpack_require__.d(__webpack_exports__, "InputHeading", function() { return /* reexport */ InputHeading["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputDate", function() { return /* reexport */ InputDate["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputDateTime", function() { return /* reexport */ InputDateTime["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputDecimal", function() { return /* reexport */ InputDecimal["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputFile", function() { return /* reexport */ InputFile["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputInt", function() { return /* reexport */ InputInt["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputOntology", function() { return /* reexport */ InputOntology["default"]; });
__webpack_require__.d(__webpack_exports__, "InputOntologySubtree", function() { return /* reexport */ InputOntologySubtree["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputPassword", function() { return /* reexport */ InputPassword["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputRadio", function() { return /* reexport */ InputRadio["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputRef", function() { return /* reexport */ InputRef["default"]; });
__webpack_require__.d(__webpack_exports__, "InputRefback", function() { return /* reexport */ InputRefback["default"]; });
__webpack_require__.d(__webpack_exports__, "InputRefSelect", function() { return /* reexport */ InputRefSelect["default"]; });
__webpack_require__.d(__webpack_exports__, "InputRangeInt", function() { return /* reexport */ InputRangeInt; });
__webpack_require__.d(__webpack_exports__, "InputRangeDecimal", function() { return /* reexport */ InputRangeDecimal; });
__webpack_require__.d(__webpack_exports__, "InputRangeDate", function() { return /* reexport */ InputRangeDate; });
__webpack_require__.d(__webpack_exports__, "InputSearch", function() { return /* reexport */ InputSearch["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputSelect", function() { return /* reexport */ InputSelect["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputString", function() { return /* reexport */ InputString["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "InputText", function() { return /* reexport */ InputText["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "LayoutCard", function() { return /* reexport */ LayoutCard; });
__webpack_require__.d(__webpack_exports__, "LayoutForm", function() { return /* reexport */ LayoutForm["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "LayoutModal", function() { return /* reexport */ LayoutModal["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "LayoutNavTabs", function() { return /* reexport */ NavTabs; });
__webpack_require__.d(__webpack_exports__, "MessageError", function() { return /* reexport */ MessageError["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "MessageSuccess", function() { return /* reexport */ MessageSuccess["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "MessageWarning", function() { return /* reexport */ MessageWarning["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "Molgenis", function() { return /* reexport */ Molgenis; });
__webpack_require__.d(__webpack_exports__, "NavBar", function() { return /* reexport */ MolgenisMenu; });
__webpack_require__.d(__webpack_exports__, "NavTabs", function() { return /* reexport */ NavTabs; });
__webpack_require__.d(__webpack_exports__, "Pagination", function() { return /* reexport */ Pagination["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "ReadMore", function() { return /* reexport */ ReadMore["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "RowButtonEdit", function() { return /* reexport */ RowButtonEdit["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "RowButtonAdd", function() { return /* reexport */ RowButtonAdd["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "RowButtonDelete", function() { return /* reexport */ RowButtonDelete["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "RowFormInput", function() { return /* reexport */ RowFormInput["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "SelectionBox", function() { return /* reexport */ SelectionBox["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "Spinner", function() { return /* reexport */ Spinner["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "ShowMore", function() { return /* reexport */ ShowMore; });
__webpack_require__.d(__webpack_exports__, "ShowHide", function() { return /* reexport */ ShowHide; });
__webpack_require__.d(__webpack_exports__, "TableMixin", function() { return /* reexport */ TableMixin["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "TableMetadataMixin", function() { return /* reexport */ TableMetadataMixin["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "TableMolgenis", function() { return /* reexport */ TableMolgenis["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "TableExplorer", function() { return /* reexport */ TableExplorer; });
__webpack_require__.d(__webpack_exports__, "TableSimple", function() { return /* reexport */ TableSimple; });
__webpack_require__.d(__webpack_exports__, "TableSearch", function() { return /* reexport */ TableSearch["a" /* default */]; });

// CONCATENATED MODULE: ../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("dc36")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/forms/ButtonAction.vue + 4 modules
var ButtonAction = __webpack_require__("c268");

// EXTERNAL MODULE: ./src/forms/ButtonAlt.vue + 4 modules
var ButtonAlt = __webpack_require__("bd01");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonDanger.vue?vue&type=template&id=0c71e2fc&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/ButtonDanger.vue?vue&type=template&id=0c71e2fc&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonDanger.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/** Button that is shown as a primary action */

/* harmony default export */ var ButtonDangervue_type_script_lang_js_ = ({
  extends: ButtonAction["a" /* default */]
});
// CONCATENATED MODULE: ./src/forms/ButtonDanger.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_ButtonDangervue_type_script_lang_js_ = (ButtonDangervue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/ButtonDanger.vue?vue&type=custom&index=0&blockType=docs
var ButtonDangervue_type_custom_index_0_blockType_docs = __webpack_require__("a010");

// CONCATENATED MODULE: ./src/forms/ButtonDanger.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_ButtonDangervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof ButtonDangervue_type_custom_index_0_blockType_docs["default"] === 'function') Object(ButtonDangervue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var ButtonDanger = (component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonDropdown.vue?vue&type=template&id=bc3f01d8&
var ButtonDropdownvue_type_template_id_bc3f01d8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{staticClass:"dropdown m-0 p-0",class:{ show: _vm.display }},[_c('button',{staticClass:"btn btn-outline-primary border-0",class:{
        'dropdown-toggle': !_vm.icon,
        'nav-link': _vm.isMenuItem,
      },attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":_vm.toggle}},[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.icon)?_c('span',{class:'fa fa-' + _vm.icon + ' fa-lg ml-2'}):_vm._e()])]),(_vm.display)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.toggle),expression:"toggle"}],staticClass:"dropdown-menu bg-white",class:{ show: _vm.display },staticStyle:{"position":"absolute","z-index":"100"}},[_c('div',{staticClass:"form-group dropdown-item"},[_vm._t("default",null,{"close":_vm.toggle})],2)]):_vm._e()])}
var ButtonDropdownvue_type_template_id_bc3f01d8_staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/ButtonDropdown.vue?vue&type=template&id=bc3f01d8&

// EXTERNAL MODULE: ../node_modules/v-click-outside/dist/v-click-outside.umd.js
var v_click_outside_umd = __webpack_require__("27d8");
var v_click_outside_umd_default = /*#__PURE__*/__webpack_require__.n(v_click_outside_umd);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonDropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ButtonDropdownvue_type_script_lang_js_ = ({
  directives: {
    clickOutside: v_click_outside_umd_default.a.directive
  },
  props: {
    label: String,
    icon: String,
    isMenuItem: Boolean
  },

  data() {
    return {
      display: false
    };
  },

  methods: {
    toggle() {
      this.display = !this.display;
    }

  }
});
// CONCATENATED MODULE: ./src/forms/ButtonDropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_ButtonDropdownvue_type_script_lang_js_ = (ButtonDropdownvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/ButtonDropdown.vue?vue&type=custom&index=0&blockType=docs
var ButtonDropdownvue_type_custom_index_0_blockType_docs = __webpack_require__("186f");

// CONCATENATED MODULE: ./src/forms/ButtonDropdown.vue





/* normalize component */

var ButtonDropdown_component = Object(componentNormalizer["a" /* default */])(
  forms_ButtonDropdownvue_type_script_lang_js_,
  ButtonDropdownvue_type_template_id_bc3f01d8_render,
  ButtonDropdownvue_type_template_id_bc3f01d8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof ButtonDropdownvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(ButtonDropdownvue_type_custom_index_0_blockType_docs["default"])(ButtonDropdown_component)

/* harmony default export */ var ButtonDropdown = (ButtonDropdown_component.exports);
// EXTERNAL MODULE: ./src/forms/ButtonOutline.vue + 4 modules
var ButtonOutline = __webpack_require__("de24");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisFooter.vue?vue&type=template&id=124a3c3f&
var MolgenisFootervue_type_template_id_124a3c3f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_vm._m(0),_vm._m(1),_c('br'),_vm._t("default")],2)}
var MolgenisFootervue_type_template_id_124a3c3f_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" This database was created using the "),_c('a',{attrs:{"href":"http://molgenis.org"}},[_vm._v("MOLGENIS")]),_vm._v("  "),_c('a',{attrs:{"href":"http://github.com/mswertz/molgenis-emx2"}},[_vm._v(" molgenis-emx2 ")]),_vm._v(" open source software (license: "),_c('a',{attrs:{"href":"https://github.com/molgenis/molgenis-emx2/blob/master/LICENSE"}},[_vm._v("LGPLv3")]),_vm._v("). ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" Please cite "),_c('a',{attrs:{"href":"https://www.ncbi.nlm.nih.gov/pubmed/30165396"}},[_vm._v(" Van der Velde et al (2018)")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://www.ncbi.nlm.nih.gov/pubmed/21210979"}},[_vm._v(" Swertz et al (2010)")]),_vm._v(" on use. ")])}]


// CONCATENATED MODULE: ./src/layout/MolgenisFooter.vue?vue&type=template&id=124a3c3f&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisFooter.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var MolgenisFootervue_type_script_lang_js_ = ({});
// CONCATENATED MODULE: ./src/layout/MolgenisFooter.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_MolgenisFootervue_type_script_lang_js_ = (MolgenisFootervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/MolgenisFooter.vue?vue&type=custom&index=0&blockType=docs
var MolgenisFootervue_type_custom_index_0_blockType_docs = __webpack_require__("61c6");

// CONCATENATED MODULE: ./src/layout/MolgenisFooter.vue





/* normalize component */

var MolgenisFooter_component = Object(componentNormalizer["a" /* default */])(
  layout_MolgenisFootervue_type_script_lang_js_,
  MolgenisFootervue_type_template_id_124a3c3f_render,
  MolgenisFootervue_type_template_id_124a3c3f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof MolgenisFootervue_type_custom_index_0_blockType_docs["default"] === 'function') Object(MolgenisFootervue_type_custom_index_0_blockType_docs["default"])(MolgenisFooter_component)

/* harmony default export */ var MolgenisFooter = (MolgenisFooter_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterSidebar.vue?vue&type=template&id=22a487f4&
var FilterSidebarvue_type_template_id_22a487f4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('Draggable',{attrs:{"list":_vm.filters,"handle":".filter-header ","ghost-class":"border-primary"}},_vm._l((_vm.filters),function(column,index){return _c('FilterContainer',{key:column.name,style:(column.showFilter ? '' : 'display: none'),attrs:{"expanded":_vm.filters[index].expanded,"title":column.name,"visible":column.showFilter && column.columnType != 'HEADING',"conditions":column.conditions},on:{"update:expanded":function($event){return _vm.$set(_vm.filters[index], "expanded", $event)}}},[_c('FilterInput',{attrs:{"conditions":_vm.filters[index].conditions,"columnType":column.columnType,"refTable":column.refTable,"graphqlURL":_vm.graphqlURL},on:{"update:conditions":[function($event){return _vm.$set(_vm.filters[index], "conditions", $event)},function($event){return _vm.$emit('update:filters', _vm.filters)}]}})],1)}),1)],1)])}
var FilterSidebarvue_type_template_id_22a487f4_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/FilterSidebar.vue?vue&type=template&id=22a487f4&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterContainer.vue?vue&type=template&id=23780467&scoped=true&
var FilterContainervue_type_template_id_23780467_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"mb-2 pt-2 border-top bg-white"},[_c('div',{staticClass:"filter-header d-flex flex-row justify-content-between",on:{"click":function($event){_vm.expanded
        ? _vm.$emit('update:expanded', false)
        : _vm.$emit('update:expanded', true)}}},[_c('h6',{staticClass:"mb-0 font-weight-bold p-2"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.count > 0)?_c('span',{staticClass:"badge badge-secondary"},[_vm._v(_vm._s(_vm.count))]):_vm._e()]),_c('IconAction',{staticClass:"ml-auto",attrs:{"icon":_vm.expanded ? 'angle-up' : 'angle-down'}})],1),_vm._t("header"),(_vm.expanded)?_c('div',{staticClass:"p-2"},[_vm._t("default")],2):_vm._e()],2):_vm._e()}
var FilterContainervue_type_template_id_23780467_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/FilterContainer.vue?vue&type=template&id=23780467&scoped=true&

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterContainer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FilterContainervue_type_script_lang_js_ = ({
  components: {
    IconAction: IconAction["a" /* default */]
  },
  props: {
    title: String,
    visible: Boolean,
    conditions: Array,
    expanded: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hover: false
    };
  },

  computed: {
    count() {
      return Array.isArray(this.conditions) ? this.conditions.length : null;
    }

  }
});
// CONCATENATED MODULE: ./src/tables/FilterContainer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_FilterContainervue_type_script_lang_js_ = (FilterContainervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/FilterContainer.vue?vue&type=style&index=0&id=23780467&scoped=true&lang=css&
var FilterContainervue_type_style_index_0_id_23780467_scoped_true_lang_css_ = __webpack_require__("53f0");

// EXTERNAL MODULE: ./src/tables/FilterContainer.vue?vue&type=custom&index=0&blockType=docs
var FilterContainervue_type_custom_index_0_blockType_docs = __webpack_require__("09e7");

// CONCATENATED MODULE: ./src/tables/FilterContainer.vue






/* normalize component */

var FilterContainer_component = Object(componentNormalizer["a" /* default */])(
  tables_FilterContainervue_type_script_lang_js_,
  FilterContainervue_type_template_id_23780467_scoped_true_render,
  FilterContainervue_type_template_id_23780467_scoped_true_staticRenderFns,
  false,
  null,
  "23780467",
  null
  
)

/* custom blocks */

if (typeof FilterContainervue_type_custom_index_0_blockType_docs["default"] === 'function') Object(FilterContainervue_type_custom_index_0_blockType_docs["default"])(FilterContainer_component)

/* harmony default export */ var FilterContainer = (FilterContainer_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterInput.vue?vue&type=template&id=4a3d745b&
var FilterInputvue_type_template_id_4a3d745b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-width":"10em"}},[(
      _vm.columnType.startsWith('STRING') ||
      _vm.columnType.startsWith('TEXT') ||
      _vm.columnType.startsWith('UUID')
    )?_c('InputString',{attrs:{"list":true,"or":true,"value":_vm.conditions},on:{"input":function($event){return _vm.$emit('update:conditions', $event)}}}):(_vm.columnType.startsWith('INT'))?_c('InputRangeInt',{attrs:{"list":true,"value":_vm.conditions},on:{"input":function($event){return _vm.$emit('update:conditions', $event)}}}):(_vm.columnType.startsWith('DECIMAL'))?_c('InputRangeDecimal',{attrs:{"list":true,"value":_vm.conditions},on:{"input":function($event){return _vm.$emit('update:conditions', $event)}}}):(_vm.columnType.startsWith('DATE'))?_c('InputRangeDate',{attrs:{"list":true,"value":_vm.conditions},on:{"input":function($event){return _vm.$emit('update:conditions', $event)}}}):(_vm.columnType.startsWith('BOOL'))?_c('InputCheckbox',{attrs:{"list":true,"options":['true', 'false'],"value":_vm.conditions},on:{"input":function($event){return _vm.$emit('update:conditions', $event)}}}):(_vm.columnType.startsWith('ONTOLOGY'))?_c('InputOntology',{attrs:{"list":true,"table":_vm.refTable,"value":_vm.conditions,"limit":7,"graphqlURL":_vm.graphqlURL},on:{"input":function($event){return _vm.$emit('update:conditions', $event)}}}):(_vm.columnType.startsWith('REF'))?_c('InputRef',{attrs:{"list":true,"table":_vm.refTable,"value":_vm.conditions,"limit":7,"graphqlURL":_vm.graphqlURL},on:{"input":function($event){return _vm.$emit('update:conditions', $event)}}}):_c('div',[_vm._v("ERROR "+_vm._s(_vm.column))])],1)}
var FilterInputvue_type_template_id_4a3d745b_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/FilterInput.vue?vue&type=template&id=4a3d745b&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputCheckbox.vue?vue&type=template&id=248330cc&
var InputCheckboxvue_type_template_id_248330cc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-group',_vm._g(_vm._b({staticClass:"checkbox-form-group"},'form-group',_vm.$props,false),_vm.$listeners),[_c('div',[_vm._l((_vm.options),function(item,index){return _c('div',{key:index,staticClass:"form-check form-check-inline",class:{ 'is-invalid': _vm.errorMessage }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.result),expression:"result"}],staticClass:"form-check-input",attrs:{"id":_vm.id + index,"type":"checkbox","aria-describedby":_vm.id + 'Help'},domProps:{"value":item,"checked":Array.isArray(_vm.result)?_vm._i(_vm.result,item)>-1:(_vm.result)},on:{"change":[function($event){var $$a=_vm.result,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.result=$$a.concat([$$v]))}else{$$i>-1&&(_vm.result=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.result=$$c}},function($event){_vm.$emit(
            'input',
            _vm.result.filter(function (v) { return v !== 0 || v != null; })
          )}]}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id + index}},[_vm._v(_vm._s(item))])])}),_c('a',{staticClass:"checkbox-clear-value",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.result = [];
        _vm.$emit('input', _vm.result);}}},[_vm._v(" clear ")])],2)])}
var InputCheckboxvue_type_template_id_248330cc_staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputCheckbox.vue?vue&type=template&id=248330cc&

// EXTERNAL MODULE: ./src/forms/InputSelect.vue + 4 modules
var InputSelect = __webpack_require__("bdae");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputCheckbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var InputCheckboxvue_type_script_lang_js_ = ({
  extends: InputSelect["a" /* default */],
  props: {
    list: {
      default: true
    }
  },
  computed: {
    valueArray() {
      let result = this.value;
      if (!result) result = null;

      if (!Array.isArray(result)) {
        result = [result];
      }

      result = this.removeNulls(result);
      return result;
    }

  },

  data() {
    return {
      result: []
    };
  },

  created() {
    this.result = this.valueArray != [null] ? this.valueArray : [];
  }

});
// CONCATENATED MODULE: ./src/forms/InputCheckbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputCheckboxvue_type_script_lang_js_ = (InputCheckboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/InputCheckbox.vue?vue&type=style&index=0&lang=css&
var InputCheckboxvue_type_style_index_0_lang_css_ = __webpack_require__("ec6e");

// EXTERNAL MODULE: ./src/forms/InputCheckbox.vue?vue&type=custom&index=0&blockType=docs
var InputCheckboxvue_type_custom_index_0_blockType_docs = __webpack_require__("356e");

// CONCATENATED MODULE: ./src/forms/InputCheckbox.vue






/* normalize component */

var InputCheckbox_component = Object(componentNormalizer["a" /* default */])(
  forms_InputCheckboxvue_type_script_lang_js_,
  InputCheckboxvue_type_template_id_248330cc_render,
  InputCheckboxvue_type_template_id_248330cc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputCheckboxvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputCheckboxvue_type_custom_index_0_blockType_docs["default"])(InputCheckbox_component)

/* harmony default export */ var InputCheckbox = (InputCheckbox_component.exports);
// EXTERNAL MODULE: ./src/forms/InputString.vue + 4 modules
var InputString = __webpack_require__("ffa4");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRangeInt.vue?vue&type=template&id=623be21e&
var InputRangeIntvue_type_template_id_623be21e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroup',_vm._g(_vm._b({staticClass:"input-group-range"},'FormGroup',_vm.$props,false),_vm.$listeners),_vm._l((_vm.valueArray),function(item,idx){return _c('InputAppend',_vm._b({key:idx + '.' + _vm.valueArray.length,staticClass:"form-group",attrs:{"showClear":_vm.showClear(idx),"showMinus":_vm.showMinus(idx),"showPlus":_vm.showPlus(idx)},on:{"clear":function($event){return _vm.clearValue(idx)},"add":_vm.addRow}},'InputAppend',_vm.$props,false),[_c('InputInt',{staticStyle:{"margin":"0px"},attrs:{"placeholder":"from","clear":false},on:{"input":function($event){return _vm.emitValue($event, idx, 0)}},model:{value:(_vm.valueArray[idx][0]),callback:function ($$v) {_vm.$set(_vm.valueArray[idx], 0, $$v)},expression:"valueArray[idx][0]"}}),_c('InputInt',{staticStyle:{"margin":"0px"},attrs:{"placeholder":"to","clear":false},on:{"input":function($event){return _vm.emitValue($event, idx, 1)}},model:{value:(_vm.valueArray[idx][1]),callback:function ($$v) {_vm.$set(_vm.valueArray[idx], 1, $$v)},expression:"valueArray[idx][1]"}})],1)}),1)}
var InputRangeIntvue_type_template_id_623be21e_staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputRangeInt.vue?vue&type=template&id=623be21e&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/InputInt.vue + 2 modules
var InputInt = __webpack_require__("758c");

// EXTERNAL MODULE: ./src/forms/_formGroup.vue + 4 modules
var _formGroup = __webpack_require__("084c");

// EXTERNAL MODULE: ./src/forms/_inputAppend.vue + 4 modules
var _inputAppend = __webpack_require__("5807");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRangeInt.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/** Input for integer values */

/* harmony default export */ var InputRangeIntvue_type_script_lang_js_ = ({
  components: {
    InputInt: InputInt["a" /* default */],
    FormGroup: _formGroup["default"],
    InputAppend: _inputAppend["a" /* default */]
  },
  extends: _baseInput["a" /* default */],
  computed: {
    //@override
    valueArray() {
      let result = this.value;

      if (!Array.isArray(result)) {
        result = [];

        if (this.list) {
          result = [[]];
        }
      } else {
        //check each row
        if (!this.list) {
          result = [result];
        }
      }

      result = this.removeNulls(result);

      if (result.length == 0 || this.list && this.showNewItem) {
        result.push([null, null]);
      }

      return result;
    }

  },
  methods: {
    //@override
    removeNulls(arr) {
      return arr.filter(v => v && (v[0] != null || v[1] != null));
    },

    //@override
    showPlus(idx) {
      //always on last line
      return this.list && !this.showNewItem && idx == this.valueArray.length - 1 && (this.valueArray[idx][0] != null || this.valueArray[idx][1] != null);
    },

    //@override
    emitValue(event, idx, idx2) {
      this.showNewItem = false;
      let value = event ? event.target ? event.target.value : event : null;
      let result = this.valueArray; //update value

      if (idx >= result.length) result[idx] = [null, null];
      result[idx][idx2] = value; //remove nulls

      result = this.removeNulls(result);

      if (!this.list) {
        if (result && result.length > 0) result = result[0];else result = null;
      }

      this.$emit("input", result);
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputRangeInt.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputRangeIntvue_type_script_lang_js_ = (InputRangeIntvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/InputRangeInt.vue?vue&type=custom&index=0&blockType=docs
var InputRangeIntvue_type_custom_index_0_blockType_docs = __webpack_require__("2da8");

// CONCATENATED MODULE: ./src/forms/InputRangeInt.vue





/* normalize component */

var InputRangeInt_component = Object(componentNormalizer["a" /* default */])(
  forms_InputRangeIntvue_type_script_lang_js_,
  InputRangeIntvue_type_template_id_623be21e_render,
  InputRangeIntvue_type_template_id_623be21e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputRangeIntvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputRangeIntvue_type_custom_index_0_blockType_docs["default"])(InputRangeInt_component)

/* harmony default export */ var InputRangeInt = (InputRangeInt_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRangeDecimal.vue?vue&type=template&id=e03083a8&
var InputRangeDecimalvue_type_template_id_e03083a8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroup',_vm._g(_vm._b({staticClass:"input-group-range"},'FormGroup',_vm.$props,false),_vm.$listeners),_vm._l((_vm.valueArray),function(item,idx){return _c('InputAppend',_vm._b({key:idx,staticClass:"form-group",attrs:{"showClear":_vm.showClear(idx),"showPlus":_vm.showPlus(idx)},on:{"clear":function($event){return _vm.clearValue(idx)},"add":_vm.addRow}},'InputAppend',_vm.$props,false),[_c('InputDecimal',{staticStyle:{"margin":"0px"},attrs:{"placeholder":"from","clear":false},on:{"input":function($event){return _vm.emitValue($event, idx, 0)}},model:{value:(_vm.valueArray[idx][0]),callback:function ($$v) {_vm.$set(_vm.valueArray[idx], 0, $$v)},expression:"valueArray[idx][0]"}}),_c('InputDecimal',{staticStyle:{"margin":"0px"},attrs:{"placeholder":"to","clear":false},on:{"input":function($event){return _vm.emitValue($event, idx, 1)}},model:{value:(_vm.valueArray[idx][1]),callback:function ($$v) {_vm.$set(_vm.valueArray[idx], 1, $$v)},expression:"valueArray[idx][1]"}})],1)}),1)}
var InputRangeDecimalvue_type_template_id_e03083a8_staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputRangeDecimal.vue?vue&type=template&id=e03083a8&

// EXTERNAL MODULE: ./src/forms/InputDecimal.vue + 2 modules
var InputDecimal = __webpack_require__("4b35");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRangeDecimal.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/** Input for integer values */

/* harmony default export */ var InputRangeDecimalvue_type_script_lang_js_ = ({
  extends: InputRangeInt,
  components: {
    InputDecimal: InputDecimal["a" /* default */],
    FormGroup: _formGroup["default"],
    InputAppend: _inputAppend["a" /* default */]
  }
});
// CONCATENATED MODULE: ./src/forms/InputRangeDecimal.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputRangeDecimalvue_type_script_lang_js_ = (InputRangeDecimalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/InputRangeDecimal.vue?vue&type=custom&index=0&blockType=docs
var InputRangeDecimalvue_type_custom_index_0_blockType_docs = __webpack_require__("9683");

// CONCATENATED MODULE: ./src/forms/InputRangeDecimal.vue





/* normalize component */

var InputRangeDecimal_component = Object(componentNormalizer["a" /* default */])(
  forms_InputRangeDecimalvue_type_script_lang_js_,
  InputRangeDecimalvue_type_template_id_e03083a8_render,
  InputRangeDecimalvue_type_template_id_e03083a8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputRangeDecimalvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputRangeDecimalvue_type_custom_index_0_blockType_docs["default"])(InputRangeDecimal_component)

/* harmony default export */ var InputRangeDecimal = (InputRangeDecimal_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRangeDate.vue?vue&type=template&id=9b68b76a&
var InputRangeDatevue_type_template_id_9b68b76a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroup',_vm._g(_vm._b({staticClass:"input-group-range"},'FormGroup',_vm.$props,false),_vm.$listeners),_vm._l((_vm.valueArray),function(item,idx){return _c('InputAppend',_vm._b({key:idx,staticClass:"form-group",attrs:{"showClear":_vm.showClear(idx),"showPlus":_vm.showPlus(idx)},on:{"clear":function($event){return _vm.clearValue(idx)},"add":_vm.addRow}},'InputAppend',_vm.$props,false),[_c('InputDate',{staticStyle:{"margin":"0px"},attrs:{"placeholder":"from","clear":false},on:{"input":function($event){return _vm.emitValue($event, idx, 0)}},model:{value:(_vm.valueArray[idx][0]),callback:function ($$v) {_vm.$set(_vm.valueArray[idx], 0, $$v)},expression:"valueArray[idx][0]"}}),_c('InputDate',{staticStyle:{"margin":"0px"},attrs:{"placeholder":"to","clear":false},on:{"input":function($event){return _vm.emitValue($event, idx, 1)}},model:{value:(_vm.valueArray[idx][1]),callback:function ($$v) {_vm.$set(_vm.valueArray[idx], 1, $$v)},expression:"valueArray[idx][1]"}})],1)}),1)}
var InputRangeDatevue_type_template_id_9b68b76a_staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputRangeDate.vue?vue&type=template&id=9b68b76a&

// EXTERNAL MODULE: ./src/forms/InputDate.vue + 4 modules
var InputDate = __webpack_require__("54cd");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRangeDate.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/** Input for integer values */

/* harmony default export */ var InputRangeDatevue_type_script_lang_js_ = ({
  extends: InputRangeInt,
  components: {
    InputDate: InputDate["a" /* default */],
    FormGroup: _formGroup["default"],
    InputAppend: _inputAppend["a" /* default */]
  }
});
// CONCATENATED MODULE: ./src/forms/InputRangeDate.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputRangeDatevue_type_script_lang_js_ = (InputRangeDatevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/InputRangeDate.vue?vue&type=custom&index=0&blockType=docs
var InputRangeDatevue_type_custom_index_0_blockType_docs = __webpack_require__("7343");

// CONCATENATED MODULE: ./src/forms/InputRangeDate.vue





/* normalize component */

var InputRangeDate_component = Object(componentNormalizer["a" /* default */])(
  forms_InputRangeDatevue_type_script_lang_js_,
  InputRangeDatevue_type_template_id_9b68b76a_render,
  InputRangeDatevue_type_template_id_9b68b76a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputRangeDatevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputRangeDatevue_type_custom_index_0_blockType_docs["default"])(InputRangeDate_component)

/* harmony default export */ var InputRangeDate = (InputRangeDate_component.exports);
// EXTERNAL MODULE: ./src/forms/InputRef.vue + 4 modules
var InputRef = __webpack_require__("c1b6");

// EXTERNAL MODULE: ./src/forms/InputOntology.vue + 4 modules
var InputOntology = __webpack_require__("398c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterInput.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var FilterInputvue_type_script_lang_js_ = ({
  components: {
    InputCheckbox: InputCheckbox,
    InputString: InputString["a" /* default */],
    InputRangeInt: InputRangeInt,
    InputRangeDecimal: InputRangeDecimal,
    InputRangeDate: InputRangeDate,
    InputRef: InputRef["default"],
    InputOntology: InputOntology["default"]
  },
  props: {
    columnType: String,
    refTable: String,
    conditions: Array,
    graphqlURL: String
  }
});
// CONCATENATED MODULE: ./src/tables/FilterInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_FilterInputvue_type_script_lang_js_ = (FilterInputvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tables/FilterInput.vue





/* normalize component */

var FilterInput_component = Object(componentNormalizer["a" /* default */])(
  tables_FilterInputvue_type_script_lang_js_,
  FilterInputvue_type_template_id_4a3d745b_render,
  FilterInputvue_type_template_id_4a3d745b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FilterInput = (FilterInput_component.exports);
// EXTERNAL MODULE: ../node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__("ca98");
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterSidebar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var FilterSidebarvue_type_script_lang_js_ = ({
  components: {
    FilterInput: FilterInput,
    FilterContainer: FilterContainer,
    Draggable: vuedraggable_umd_default.a
  },
  props: {
    filters: Array,
    graphqlURL: String
  },

  created() {
    //default expand
    for (var idx in this.filters) {
      if (this.filters.expanded == undefined) {
        this.expandFilter(idx);
      }
    }
  },

  methods: {
    expandFilter(index) {
      let update = this.filters;
      update[index].expanded = true;
      this.$emit("update:filters", update);
    },

    collapseFilter(index) {
      let update = this.filters;
      update[index].expanded = false;
      this.$emit("update:filters", update);
    },

    hideFilter(idx) {
      let update = this.filters;
      update[idx].showFilter = false;
      this.$emit("update:filters", update);
    },

    flatten(obj, keyName) {
      let result = {};
      Object.keys(obj).forEach(key => {
        var newKey = `${keyName}-${key}`;

        if (typeof obj[key] === "object") {
          result = { ...result,
            ...this.flatten(obj[key], newKey)
          };
        } else {
          result[newKey] = obj[key];
        }
      });
      return result;
    }

  }
});
// CONCATENATED MODULE: ./src/tables/FilterSidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_FilterSidebarvue_type_script_lang_js_ = (FilterSidebarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/FilterSidebar.vue?vue&type=custom&index=0&blockType=docs
var FilterSidebarvue_type_custom_index_0_blockType_docs = __webpack_require__("59a8");

// CONCATENATED MODULE: ./src/tables/FilterSidebar.vue





/* normalize component */

var FilterSidebar_component = Object(componentNormalizer["a" /* default */])(
  tables_FilterSidebarvue_type_script_lang_js_,
  FilterSidebarvue_type_template_id_22a487f4_render,
  FilterSidebarvue_type_template_id_22a487f4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof FilterSidebarvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(FilterSidebarvue_type_custom_index_0_blockType_docs["default"])(FilterSidebar_component)

/* harmony default export */ var FilterSidebar = (FilterSidebar_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterWells.vue?vue&type=template&id=0e15ce12&
var FilterWellsvue_type_template_id_0e15ce12_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.countFilters > 0)?_c('div',[_vm._v(" "+_vm._s(_vm.countFilters)+" filter"+_vm._s(_vm.countFilters > 1 ? "s" : "")+" ("),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.removeAll.apply(null, arguments)}}},[_vm._v(" remove all filters ")]),_vm._v(" ) :"),_c('br'),_vm._l((_vm.filters),function(column,idx){return _c('span',{key:column.name},_vm._l((column.conditions),function(value,idx2){return _c('span',{key:idx2},[(Array.isArray(value))?_c('span',[(value[0] !== null && value[1] !== null)?_c('FilterWell',{attrs:{"label":value[0] + ' < ' + column.name + ' < ' + value[1]},on:{"click":function($event){return _vm.remove(idx, idx2)}}}):(value[0] !== null)?_c('FilterWell',{attrs:{"label":value[0] + ' < ' + column.name},on:{"click":function($event){return _vm.remove(idx, idx2)}}}):(value[1] !== null)?_c('FilterWell',{attrs:{"label":column.name + ' < ' + value[1]},on:{"click":function($event){return _vm.remove(idx, idx2)}}}):_vm._e()],1):_c('span',[_c('FilterWell',{attrs:{"label":column.name + ' = ' + _vm.renderValue(value)},on:{"click":function($event){return _vm.remove(idx, idx2)}}})],1)])}),0)})],2):_vm._e()])}
var FilterWellsvue_type_template_id_0e15ce12_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/FilterWells.vue?vue&type=template&id=0e15ce12&

// EXTERNAL MODULE: ./src/tables/FilterWell.vue + 4 modules
var FilterWell = __webpack_require__("026f");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/FilterWells.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FilterWellsvue_type_script_lang_js_ = ({
  props: {
    /** two-way bindable array of column metadata. Will add 'conditions' property to hold filter values */
    filters: {
      type: Array,
      default: () => []
    }
  },
  components: {
    FilterWell: FilterWell["a" /* default */]
  },
  computed: {
    countFilters() {
      let count = 0;

      if (Array.isArray(this.filters)) {
        this.filters.forEach(column => {
          if (Array.isArray(column.conditions)) {
            column.conditions.forEach(condition => {
              if (Array.isArray(condition)) {
                if (condition[0] !== null || condition[1] != null) {
                  count++;
                }
              } else {
                if (condition != null) {
                  count++;
                }
              }
            });
          }
        });
      }

      return count;
    }

  },
  methods: {
    renderValue(value) {
      if (typeof value === "object" && value !== null) {
        return this.flattenObject(value);
      } else {
        return value;
      }
    },

    flattenObject(object) {
      let result = "";
      Object.keys(object).forEach(key => {
        if (object[key] === null) {//nothing
        } else if (typeof object[key] === "object") {
          result += this.flattenObject(object[key]);
        } else {
          result += " " + object[key];
        }
      });
      return result;
    },

    remove(idx, idx2) {
      let update = this.filters;
      update[idx].conditions.splice(idx2, 1);
      this.$emit("update:filters", update);
    },

    removeAll() {
      let update = this.filters;

      for (var idx in update) {
        if (Array.isArray(update[idx].conditions)) {
          update[idx].conditions.splice(0); // use splice to avoid removing vue reactivity
        }
      }

      this.$emit("update:filters", update);
    }

  }
});
// CONCATENATED MODULE: ./src/tables/FilterWells.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_FilterWellsvue_type_script_lang_js_ = (FilterWellsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/FilterWells.vue?vue&type=custom&index=0&blockType=docs
var FilterWellsvue_type_custom_index_0_blockType_docs = __webpack_require__("393b");

// CONCATENATED MODULE: ./src/tables/FilterWells.vue





/* normalize component */

var FilterWells_component = Object(componentNormalizer["a" /* default */])(
  tables_FilterWellsvue_type_script_lang_js_,
  FilterWellsvue_type_template_id_0e15ce12_render,
  FilterWellsvue_type_template_id_0e15ce12_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof FilterWellsvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(FilterWellsvue_type_custom_index_0_blockType_docs["default"])(FilterWells_component)

/* harmony default export */ var FilterWells = (FilterWells_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/IconBar.vue?vue&type=template&id=44aa7d4e&
var IconBarvue_type_template_id_44aa7d4e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","align-self":"flex-end"}},[_c('label',[_vm._t("default")],2)])}
var IconBarvue_type_template_id_44aa7d4e_staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/IconBar.vue?vue&type=template&id=44aa7d4e&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/IconBar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//

/** Layout multiple icons as a toolbar. */
/* harmony default export */ var IconBarvue_type_script_lang_js_ = ({});
// CONCATENATED MODULE: ./src/forms/IconBar.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_IconBarvue_type_script_lang_js_ = (IconBarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/IconBar.vue?vue&type=custom&index=0&blockType=docs
var IconBarvue_type_custom_index_0_blockType_docs = __webpack_require__("3c59");

// CONCATENATED MODULE: ./src/forms/IconBar.vue





/* normalize component */

var IconBar_component = Object(componentNormalizer["a" /* default */])(
  forms_IconBarvue_type_script_lang_js_,
  IconBarvue_type_template_id_44aa7d4e_render,
  IconBarvue_type_template_id_44aa7d4e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof IconBarvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(IconBarvue_type_custom_index_0_blockType_docs["default"])(IconBar_component)

/* harmony default export */ var IconBar = (IconBar_component.exports);
// EXTERNAL MODULE: ./src/forms/IconDanger.vue + 4 modules
var IconDanger = __webpack_require__("3212");

// EXTERNAL MODULE: ./src/forms/InputBoolean.vue + 4 modules
var InputBoolean = __webpack_require__("6223");

// EXTERNAL MODULE: ./src/forms/InputHeading.vue + 4 modules
var InputHeading = __webpack_require__("7022");

// EXTERNAL MODULE: ./src/forms/InputDateTime.vue + 2 modules
var InputDateTime = __webpack_require__("d3dd");

// EXTERNAL MODULE: ./src/forms/InputFile.vue + 4 modules
var InputFile = __webpack_require__("b5c9");

// EXTERNAL MODULE: ./src/forms/InputOntologySubtree.vue + 4 modules
var InputOntologySubtree = __webpack_require__("6d7a");

// EXTERNAL MODULE: ./src/forms/InputPassword.vue + 4 modules
var InputPassword = __webpack_require__("91f4");

// EXTERNAL MODULE: ./src/forms/InputRadio.vue + 4 modules
var InputRadio = __webpack_require__("a386");

// EXTERNAL MODULE: ./src/forms/InputRefSelect.vue + 4 modules
var InputRefSelect = __webpack_require__("0acc");

// EXTERNAL MODULE: ./src/forms/InputRefback.vue + 4 modules
var InputRefback = __webpack_require__("edb6");

// EXTERNAL MODULE: ./src/forms/InputSearch.vue + 4 modules
var InputSearch = __webpack_require__("e1de");

// EXTERNAL MODULE: ./src/forms/InputText.vue + 4 modules
var InputText = __webpack_require__("d622");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/LayoutCard.vue?vue&type=template&id=73e3b44c&scoped=true&
var LayoutCardvue_type_template_id_73e3b44c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{ 'card-fullscreen': _vm.fullscreen }},[_c('div',{ref:"header",staticClass:"card-header text-center",on:{"click":_vm.toggleCollapse}},[(_vm.title)?_c('h4',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("header"),(!_vm.collapse)?_c('IconAction',{staticClass:"card-fullscreen-icon",attrs:{"icon":_vm.fullscreen ? 'compress' : 'expand'},on:{"click":_vm.toggle}}):_vm._e()],2),(!this.collapse || !_vm.collapsed)?_c('div',{directives:[{name:"scroll-lock",rawName:"v-scroll-lock",value:(_vm.fullscreen),expression:"fullscreen"}],staticClass:"card-body",style:(_vm.bodyheight)},[_vm._t("default")],2):_vm._e()])}
var LayoutCardvue_type_template_id_73e3b44c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/LayoutCard.vue?vue&type=template&id=73e3b44c&scoped=true&

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// EXTERNAL MODULE: ../node_modules/v-scroll-lock/dist/v-scroll-lock.esm.js
var v_scroll_lock_esm = __webpack_require__("f42c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/LayoutCard.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(v_scroll_lock_esm["a" /* default */]);
/* harmony default export */ var LayoutCardvue_type_script_lang_js_ = ({
  directives: {
    VScrollLock: v_scroll_lock_esm["a" /* default */]
  },
  components: {
    IconAction: IconAction["a" /* default */]
  },
  props: {
    /** Title that is shown on the card (optional) */
    title: String,

    /** If the cared should be collapsed **/
    collapse: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      fullscreen: false,
      collapsed: true
    };
  },
  methods: {
    toggle() {
      this.fullscreen = !this.fullscreen;
    },

    toggleCollapse() {
      if (this.collapse) {
        this.collapsed = !this.collapsed;
      }
    }

  },
  computed: {
    bodyheight() {
      if (this.$refs.header && this.fullscreen) {
        let header = this.$refs.header.clientHeight;
        let footer = this.$refs.footer.clientHeight;
        return `height: calc(100vh - ${header + footer}px)`;
      }

      return "";
    }

  }
});
// CONCATENATED MODULE: ./src/layout/LayoutCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_LayoutCardvue_type_script_lang_js_ = (LayoutCardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/LayoutCard.vue?vue&type=style&index=0&id=73e3b44c&scoped=true&lang=css&
var LayoutCardvue_type_style_index_0_id_73e3b44c_scoped_true_lang_css_ = __webpack_require__("9905");

// EXTERNAL MODULE: ./src/layout/LayoutCard.vue?vue&type=custom&index=0&blockType=docs
var LayoutCardvue_type_custom_index_0_blockType_docs = __webpack_require__("4f57");

// CONCATENATED MODULE: ./src/layout/LayoutCard.vue






/* normalize component */

var LayoutCard_component = Object(componentNormalizer["a" /* default */])(
  layout_LayoutCardvue_type_script_lang_js_,
  LayoutCardvue_type_template_id_73e3b44c_scoped_true_render,
  LayoutCardvue_type_template_id_73e3b44c_scoped_true_staticRenderFns,
  false,
  null,
  "73e3b44c",
  null
  
)

/* custom blocks */

if (typeof LayoutCardvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(LayoutCardvue_type_custom_index_0_blockType_docs["default"])(LayoutCard_component)

/* harmony default export */ var LayoutCard = (LayoutCard_component.exports);
// EXTERNAL MODULE: ./src/layout/LayoutForm.vue + 4 modules
var LayoutForm = __webpack_require__("494f");

// EXTERNAL MODULE: ./src/layout/LayoutModal.vue + 4 modules
var LayoutModal = __webpack_require__("ed0c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/NavTabs.vue?vue&type=template&id=ad133248&
var NavTabsvue_type_template_id_ad133248_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[(_vm.label)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link disabled",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.label))])]):_vm._e(),_vm._l((_vm.options),function(item,index){return _c('li',{key:index,staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",class:{ active: item === _vm.value },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.select(item)}}},[_vm._v(" "+_vm._s(item)+" ")])])})],2)}
var NavTabsvue_type_template_id_ad133248_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/NavTabs.vue?vue&type=template&id=ad133248&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/NavTabs.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var NavTabsvue_type_script_lang_js_ = ({
  extends: InputSelect["a" /* default */],
  methods: {
    select(item) {
      this.value = item;
      this.$emit("input", this.value);
    }

  }
});
// CONCATENATED MODULE: ./src/layout/NavTabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_NavTabsvue_type_script_lang_js_ = (NavTabsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/NavTabs.vue?vue&type=custom&index=0&blockType=docs
var NavTabsvue_type_custom_index_0_blockType_docs = __webpack_require__("06f6");

// CONCATENATED MODULE: ./src/layout/NavTabs.vue





/* normalize component */

var NavTabs_component = Object(componentNormalizer["a" /* default */])(
  layout_NavTabsvue_type_script_lang_js_,
  NavTabsvue_type_template_id_ad133248_render,
  NavTabsvue_type_template_id_ad133248_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof NavTabsvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(NavTabsvue_type_custom_index_0_blockType_docs["default"])(NavTabs_component)

/* harmony default export */ var NavTabs = (NavTabs_component.exports);
// EXTERNAL MODULE: ./src/forms/MessageSuccess.vue + 2 modules
var MessageSuccess = __webpack_require__("e74d");

// EXTERNAL MODULE: ./src/forms/MessageError.vue + 2 modules
var MessageError = __webpack_require__("25b1");

// EXTERNAL MODULE: ./src/forms/MessageWarning.vue + 2 modules
var MessageWarning = __webpack_require__("db4e");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/Molgenis.vue?vue&type=template&id=13591df7&
var Molgenisvue_type_template_id_13591df7_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#f4f4f4"}},[_c('div',{staticStyle:{"min-height":"calc(100vh - 70px)"}},[_c('MolgenisTheme',{attrs:{"href":"https://fonts.googleapis.com/css?family=Oswald:500|Roboto|Roboto+Mono&display=swap"}}),_c('MolgenisMenu',{attrs:{"logo":_vm.logo,"active":"My search","items":_vm.menu,"session":_vm.session}},[_c('MolgenisSession',{key:_vm.timestamp,model:{value:(_vm.session),callback:function ($$v) {_vm.session=$$v},expression:"session"}})],1),(_vm.showCrumbs && Object.keys(_vm.crumbs).length > 1)?_c('Breadcrumb',{attrs:{"crumbs":_vm.crumbs}}):_vm._e(),_c('div',{staticClass:"container-fluid p-3",staticStyle:{"padding-bottom":"50px"}},[(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)],1),_c('Footer',[(_vm.session && _vm.session.manifest)?_c('span',[_vm._v(" Software version: "),_c('a',{attrs:{"href":'https://github.com/molgenis/molgenis-emx2/releases/tag/v' +
          _vm.session.manifest.SpecificationVersion}},[_vm._v(_vm._s(_vm.session.manifest.SpecificationVersion))]),_vm._v(". "),(_vm.session.manifest.DatabaseVersion)?_c('span',[_vm._v("Database version: "),_c('a',{attrs:{"href":'https://github.com/molgenis/molgenis-emx2/releases/tag/v' +
            _vm.session.manifest.DatabaseVersion}},[_vm._v(_vm._s(_vm.session.manifest.DatabaseVersion))]),_vm._v(".")]):_vm._e()]):_vm._e()])],1)}
var Molgenisvue_type_template_id_13591df7_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/Molgenis.vue?vue&type=template&id=13591df7&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisMenu.vue?vue&type=template&id=02ff56d6&
var MolgenisMenuvue_type_template_id_02ff56d6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar bg-primary navbar-expand-lg navbar-dark"},[_vm._m(0),(_vm.logo)?_c('a',{staticClass:"navbar-brand"},[_c('img',{attrs:{"src":_vm.logo,"alt":"brand-logo","height":"30"}})]):_vm._e(),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarNav"}},[(_vm.items)?_c('ul',{staticClass:"navbar-nav"},_vm._l((_vm.permittedItems),function(item){return _c('li',{key:item.label,staticClass:"nav-item",class:{
          active: item.active,
          dropdown: item.submenu,
        }},[(item.submenu && item.submenu.length > 0)?_c('ButtonDropdown',{staticClass:"nav-item",attrs:{"label":item.label,"icon":"caret-down","isMenuItem":"true"}},_vm._l((item.submenu),function(sub){return _c('a',{key:sub.label,staticClass:"dropdown-item",attrs:{"href":_vm.addBaseUrl(sub.href),"target":sub.newWindow ? '_blank' : '_self'}},[_vm._v(_vm._s(sub.label))])}),0):_c('a',{staticClass:"nav-link",attrs:{"href":_vm.addBaseUrl(item.href),"target":item.newWindow ? '_blank' : '_self'}},[_vm._v(_vm._s(item.label)+" ")])],1)}),0):_vm._e()]),_vm._t("default")],2)}
var MolgenisMenuvue_type_template_id_02ff56d6_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarNav","aria-controls":"navbarNav","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('span',{staticClass:"navbar-toggler-icon"})])}]


// CONCATENATED MODULE: ./src/layout/MolgenisMenu.vue?vue&type=template&id=02ff56d6&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisMenu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/** You can use the slot to put a component in the right of menu, e.g. an 'Account' component */

/* harmony default export */ var MolgenisMenuvue_type_script_lang_js_ = ({
  components: {
    ButtonDropdown: ButtonDropdown
  },
  props: {
    /** the navbar items in format {name:'name', href:'href',role:[], submenu:[]}.
     * If href is null then you will return to baseURL.
     * Href is prefixed with 'baseURL' unless startwith 'http' or '/'.
     * If role then menu items are filtered based on session.roles.
     * Submenu is optional
     */
    items: Array,

    /** logo to show*/
    logo: String,

    /** session information, so we can check role permissions */
    session: Object,

    /** prefix for relative href. Will default to schema name, i.e. first directory in path, e.g. "/pet store/ */
    baseURL: {
      type: String,
      default: () => {
        let path = window.location.pathname.split("/")[1]; //add trailing slash if path; when in root we return only /

        return "/" + (path ? path + "/" : "");
      }
    }
  },
  computed: {
    permittedItems() {
      return this.items.filter(this.permitted);
    },

    homeUrl() {
      const findFirst = menu => {
        return menu.find(item => {
          //will be first non-submenu item that is permitted
          if (item.href) {
            return item;
          } // in case it is a item with submenu and without href, find first submenu item


          if (item.submenu) {
            return findFirst(item.submenu.filter(this.permitted));
          }
        });
      };

      const firstItem = findFirst(this.permittedItems); //default: go home

      return firstItem ? this.addBaseUrl(firstItem.href) : this.baseURL;
    }

  },
  methods: {
    addBaseUrl(href) {
      // fully qualified URLs or relative URL navigation supported (although we should deprecate the '../' option
      if (href && (href.startsWith("http://") || href.startsWith("https://") || href.startsWith("/") || href.startsWith(".."))) {
        return href;
      } else {
        //relative paths use the baseURL
        return this.baseURL + (href ? href : "");
      }
    },

    permitted(item) {
      if (!item.role) {
        return true;
      }

      if (this.session && Array.isArray(this.session.roles)) {
        if (this.session.email == "admin") {
          return true;
        }

        if (item.role == "Viewer") {
          return this.session.roles.some(r => ["Viewer", "Editor", "Manager", "Owner"].includes(r));
        } else if (item.role == "Editor") {
          return this.session.roles.some(r => ["Editor", "Manager", "Owner"].includes(r));
        } else if (item.role == "Manager") {
          return this.session.roles.some(r => ["Manager", "Owner"].includes(r));
        }
      }

      return false;
    }

  }
});
// CONCATENATED MODULE: ./src/layout/MolgenisMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_MolgenisMenuvue_type_script_lang_js_ = (MolgenisMenuvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/MolgenisMenu.vue?vue&type=custom&index=0&blockType=docs
var MolgenisMenuvue_type_custom_index_0_blockType_docs = __webpack_require__("4df2");

// CONCATENATED MODULE: ./src/layout/MolgenisMenu.vue





/* normalize component */

var MolgenisMenu_component = Object(componentNormalizer["a" /* default */])(
  layout_MolgenisMenuvue_type_script_lang_js_,
  MolgenisMenuvue_type_template_id_02ff56d6_render,
  MolgenisMenuvue_type_template_id_02ff56d6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof MolgenisMenuvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(MolgenisMenuvue_type_custom_index_0_blockType_docs["default"])(MolgenisMenu_component)

/* harmony default export */ var MolgenisMenu = (MolgenisMenu_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisSession.vue?vue&type=template&id=5c9c3852&
var MolgenisSessionvue_type_template_id_5c9c3852_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('Spinner'):_c('div',[_c('div',[(_vm.session.email && _vm.session.email != 'anonymous')?_c('span',[_c('a',{staticClass:"text-light",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showChangePasswordForm = true}}},[_vm._v(" Hi "+_vm._s(_vm.session.email))]),_vm._v("  "),(_vm.showChangePasswordForm)?_c('ChangePasswordForm',{attrs:{"error":_vm.error},on:{"cancel":function($event){_vm.showChangePasswordForm = false}}}):_vm._e(),_c('ButtonOutline',{attrs:{"light":true},on:{"click":_vm.signout}},[_vm._v("Sign out")])],1):_c('span',[_c('ButtonOutline',{attrs:{"light":true},on:{"click":function($event){_vm.showSigninForm = true}}},[_vm._v(" Sign in")]),(_vm.showSigninForm)?_c('SigninForm',{attrs:{"error":_vm.error},on:{"signin":_vm.changed,"cancel":_vm.closeSigninForm}}):_vm._e(),_c('ButtonAlt',{attrs:{"light":true},on:{"click":function($event){_vm.showSignupForm = true}}},[_vm._v("Sign up")]),(_vm.showSignupForm)?_c('SignupForm',{attrs:{"error":_vm.error},on:{"close":_vm.closeSignupForm}}):_vm._e()],1)])])}
var MolgenisSessionvue_type_template_id_5c9c3852_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/MolgenisSession.vue?vue&type=template&id=5c9c3852&

// EXTERNAL MODULE: ./src/layout/Spinner.vue + 2 modules
var Spinner = __webpack_require__("0f35");

// EXTERNAL MODULE: ./src/layout/MolgenisSignin.vue + 4 modules
var MolgenisSignin = __webpack_require__("be64");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisSignup.vue?vue&type=template&id=97ae6860&
var MolgenisSignupvue_type_template_id_97ae6860_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('Spinner'):(_vm.success)?_c('LayoutModal',{attrs:{"title":"Sign up","show":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('MessageSuccess',[_vm._v(_vm._s(_vm.success))])]},proxy:true},{key:"footer",fn:function(){return [_c('ButtonAlt',{on:{"click":_vm.close}},[_vm._v("Close")])]},proxy:true}])}):_c('LayoutModal',{attrs:{"title":"Sign up","show":true},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('LayoutForm',[(_vm.error)?_c('MessageError',[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('InputString',{attrs:{"label":"Email address","placeholder":"Enter valid email address","description":"Please enter your email address"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('InputPassword',{attrs:{"label":"Password","placeholder":"Enter password","description":"Please enter the password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_c('InputPassword',{attrs:{"label":"Password Repeat","placeholder":"Enter password","description":"Please enter the password again"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signup.apply(null, arguments)}},model:{value:(_vm.password2),callback:function ($$v) {_vm.password2=$$v},expression:"password2"}})],1)]},proxy:true},{key:"footer",fn:function(){return [_c('ButtonAlt',{on:{"click":_vm.close}},[_vm._v("Cancel")]),_c('ButtonAction',{on:{"click":_vm.signup}},[_vm._v("Sign up")])]},proxy:true}])})}
var MolgenisSignupvue_type_template_id_97ae6860_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/MolgenisSignup.vue?vue&type=template&id=97ae6860&

// EXTERNAL MODULE: ../node_modules/graphql-request/dist/index.js
var dist = __webpack_require__("9b3c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisSignup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var MolgenisSignupvue_type_script_lang_js_ = ({
  components: {
    ButtonAction: ButtonAction["a" /* default */],
    ButtonAlt: ButtonAlt["a" /* default */],
    InputPassword: InputPassword["a" /* default */],
    InputString: InputString["a" /* default */],
    MessageError: MessageError["a" /* default */],
    MessageSuccess: MessageSuccess["a" /* default */],
    LayoutForm: LayoutForm["a" /* default */],
    Spinner: Spinner["a" /* default */],
    LayoutModal: LayoutModal["a" /* default */]
  },
  data: function () {
    return {
      email: null,
      password: null,
      password2: null,
      loading: false,
      error: null,
      success: null
    };
  },
  methods: {
    signup() {
      if (this.email == null || this.password == null || this.password2 == null) {
        this.error = "Error: valid email address and password should be filled in";
      } else if (this.password !== this.password2) {
        this.error = "Error: Passwords entered must be the same";
      } else {
        this.error = null;
        this.loading = true;
        Object(dist["request"])("/api/graphql", `mutation{signup(email: "${this.email}", password: "${this.password}"){status,message}}`).then(data => {
          if (data.signup.status === "SUCCESS") {
            this.success = "Success. Signed up with email: " + this.email;
          } else {
            this.error = "Signup failed: " + data.signup.message;
          }
        }).catch(error => {
          this.error = "Sign up failed: " + error.response.message;
        });
        this.loading = false;
      }
    },

    close() {
      /**
       * when close is pushed
       */
      this.error = null;
      this.$emit("close");
    }

  }
});
// CONCATENATED MODULE: ./src/layout/MolgenisSignup.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_MolgenisSignupvue_type_script_lang_js_ = (MolgenisSignupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/MolgenisSignup.vue?vue&type=custom&index=0&blockType=docs
var MolgenisSignupvue_type_custom_index_0_blockType_docs = __webpack_require__("d03d");

// CONCATENATED MODULE: ./src/layout/MolgenisSignup.vue





/* normalize component */

var MolgenisSignup_component = Object(componentNormalizer["a" /* default */])(
  layout_MolgenisSignupvue_type_script_lang_js_,
  MolgenisSignupvue_type_template_id_97ae6860_render,
  MolgenisSignupvue_type_template_id_97ae6860_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof MolgenisSignupvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(MolgenisSignupvue_type_custom_index_0_blockType_docs["default"])(MolgenisSignup_component)

/* harmony default export */ var MolgenisSignup = (MolgenisSignup_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisAccount.vue?vue&type=template&id=539ba3ee&
var MolgenisAccountvue_type_template_id_539ba3ee_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('Spinner'):_c('LayoutModal',{attrs:{"title":"Change account","show":true},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('LayoutForm',[_c('h2',[_vm._v("Change password")]),(_vm.success)?_c('MessageSuccess',[_vm._v(_vm._s(_vm.success))]):_vm._e(),(_vm.graphqlError)?_c('MessageError',[_vm._v(_vm._s(_vm.graphqlError))]):_vm._e(),_c('InputPassword',{attrs:{"label":"Password","placeholder":"Enter password","description":"Please enter the password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_c('InputPassword',{attrs:{"label":"Password Repeat","placeholder":"Enter password","description":"Please enter the password again"},model:{value:(_vm.password2),callback:function ($$v) {_vm.password2=$$v},expression:"password2"}})],1)]},proxy:true},{key:"footer",fn:function(){return [_c('ButtonAlt',{on:{"click":_vm.close}},[_vm._v("Close")]),_c('ButtonAction',{on:{"click":_vm.updatePassword}},[_vm._v("Update password")])]},proxy:true}])})}
var MolgenisAccountvue_type_template_id_539ba3ee_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/MolgenisAccount.vue?vue&type=template&id=539ba3ee&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisAccount.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var MolgenisAccountvue_type_script_lang_js_ = ({
  components: {
    LayoutModal: LayoutModal["a" /* default */],
    ButtonAlt: ButtonAlt["a" /* default */],
    ButtonAction: ButtonAction["a" /* default */],
    InputPassword: InputPassword["a" /* default */],
    MessageError: MessageError["a" /* default */],
    MessageSuccess: MessageSuccess["a" /* default */],
    Spinner: Spinner["a" /* default */]
  },
  props: {
    user: String
  },

  data() {
    return {
      password: null,
      password2: null,
      loading: false,
      graphqlError: null,
      success: null
    };
  },

  methods: {
    updatePassword() {
      if (this.password !== this.password2) {
        this.error = "Error: Passwords entered must be the same";
      } else {
        this.error = null;
        this.loading = true;
        Object(dist["request"])("graphql", `mutation{changePassword(password: "${this.password}"){status,message}}`).then(data => {
          if (data.changePassword.status === "SUCCESS") {
            this.success = "Success. Password changed";
          } else {
            this.error = "Password change failed: " + data.changePassword.message;
          }
        }).catch(error => {
          this.graphqlError = JSON.stringify(error);
        });
        this.loading = false;
      }
    },

    close() {
      this.error = null;
      this.$emit("cancel");
    }

  }
});
// CONCATENATED MODULE: ./src/layout/MolgenisAccount.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_MolgenisAccountvue_type_script_lang_js_ = (MolgenisAccountvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/MolgenisAccount.vue?vue&type=custom&index=0&blockType=docs
var MolgenisAccountvue_type_custom_index_0_blockType_docs = __webpack_require__("219f");

// CONCATENATED MODULE: ./src/layout/MolgenisAccount.vue





/* normalize component */

var MolgenisAccount_component = Object(componentNormalizer["a" /* default */])(
  layout_MolgenisAccountvue_type_script_lang_js_,
  MolgenisAccountvue_type_template_id_539ba3ee_render,
  MolgenisAccountvue_type_template_id_539ba3ee_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof MolgenisAccountvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(MolgenisAccountvue_type_custom_index_0_blockType_docs["default"])(MolgenisAccount_component)

/* harmony default export */ var MolgenisAccount = (MolgenisAccount_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisSession.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/** Element that is supposed to be put in menu holding all controls for user account */

/* harmony default export */ var MolgenisSessionvue_type_script_lang_js_ = ({
  components: {
    ButtonOutline: ButtonOutline["a" /* default */],
    SigninForm: MolgenisSignin["a" /* default */],
    SignupForm: MolgenisSignup,
    ChangePasswordForm: MolgenisAccount,
    Spinner: Spinner["a" /* default */],
    ButtonAlt: ButtonAlt["a" /* default */]
  },
  props: {
    graphql: {
      default: "graphql",
      type: String
    }
  },
  data: function () {
    return {
      /** @ignore */
      showSigninForm: false,
      showSignupForm: false,
      showChangePasswordForm: false,
      error: null,
      loading: false,
      session: {},
      version: null
    };
  },
  watch: {
    email() {
      this.showSigninForm = false;
      this.showSignupForm = false;
    }

  },

  created() {
    this.reload();
  },

  methods: {
    reload() {
      this.loading = true;
      Object(dist["request"])(this.graphql, `{_session{email,roles},_settings(keys: ["menu", "page.", "cssURL", "logoURL"]){key,value},_manifest{ImplementationVersion,SpecificationVersion,DatabaseVersion}}`).then(data => {
        if (data._session != undefined) {
          this.session = data._session;
        } else {
          this.session = {};
        } //convert settings to object


        this.session.settings = {};

        data._settings.forEach(s => this.session.settings[s.key] = s.value.startsWith("[") || s.value.startsWith("{") ? this.parseJson(s.value) : s.value);

        this.session.manifest = data._manifest;
        this.loading = false;
        this.$emit("input", this.session);
      }).catch(error => {
        if (error.response.status === 504) {
          this.error = "Error. Server cannot be reached.";
        } else {
          this.error = "internal server error " + error;
        }

        this.loading = false;
      });
    },

    parseJson(value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        this.error = "Parsing of settings failed: " + e + ". value: " + value;
        return null;
      }
    },

    changed() {
      this.reload();
      this.showSigninForm = false;
      this.$emit("input", this.session);
    },

    closeSigninForm() {
      this.showSigninForm = false;
      this.error = null;
    },

    closeSignupForm() {
      this.showSignupForm = false;
      this.error = null;
    },

    signout() {
      this.loading = true;
      this.showSigninForm = false;
      Object(dist["request"])("graphql", `mutation{signout{status}}`).then(data => {
        if (data.signout.status === "SUCCESS") {
          this.session = {};
        } else {
          this.error = "sign out failed";
        }

        this.loading = false;
        this.$emit("input", this.session);
        this.reload();
      }).catch(error => this.error = "internal server error" + error);
    }

  }
});
// CONCATENATED MODULE: ./src/layout/MolgenisSession.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_MolgenisSessionvue_type_script_lang_js_ = (MolgenisSessionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/MolgenisSession.vue?vue&type=custom&index=0&blockType=docs
var MolgenisSessionvue_type_custom_index_0_blockType_docs = __webpack_require__("f484");

// CONCATENATED MODULE: ./src/layout/MolgenisSession.vue





/* normalize component */

var MolgenisSession_component = Object(componentNormalizer["a" /* default */])(
  layout_MolgenisSessionvue_type_script_lang_js_,
  MolgenisSessionvue_type_template_id_5c9c3852_render,
  MolgenisSessionvue_type_template_id_5c9c3852_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof MolgenisSessionvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(MolgenisSessionvue_type_custom_index_0_blockType_docs["default"])(MolgenisSession_component)

/* harmony default export */ var MolgenisSession = (MolgenisSession_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisTheme.vue?vue&type=template&id=6ab7e824&
var MolgenisThemevue_type_template_id_6ab7e824_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var MolgenisThemevue_type_template_id_6ab7e824_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/MolgenisTheme.vue?vue&type=template&id=6ab7e824&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisTheme.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var MolgenisThemevue_type_script_lang_js_ = ({
  props: {
    href: String
  },
  methods: {
    appendFile() {
      let file = document.createElement("link");
      file.rel = "stylesheet";
      file.href = this.href;
      document.head.appendChild(file);
    }

  },

  mounted() {
    this.appendFile();
  },

  watch: {
    href() {
      this.appendFile();
    }

  }
});
// CONCATENATED MODULE: ./src/layout/MolgenisTheme.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_MolgenisThemevue_type_script_lang_js_ = (MolgenisThemevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/layout/MolgenisTheme.vue





/* normalize component */

var MolgenisTheme_component = Object(componentNormalizer["a" /* default */])(
  layout_MolgenisThemevue_type_script_lang_js_,
  MolgenisThemevue_type_template_id_6ab7e824_render,
  MolgenisThemevue_type_template_id_6ab7e824_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MolgenisTheme = (MolgenisTheme_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/mixins/DefaultMenuMixin.vue?vue&type=script&lang=js&
/* harmony default export */ var DefaultMenuMixinvue_type_script_lang_js_ = ({
  computed: {
    defaultMenu() {
      return [{
        label: "Tables",
        href: "tables",
        role: "Viewer"
      }, {
        label: "Schema",
        href: "schema",
        role: "Manager"
      }, {
        label: "Up/Download",
        href: "updownload",
        role: "Editor"
      }, {
        label: "Graphql",
        href: "graphql-playground",
        role: "Viewer"
      }, {
        label: "Settings",
        href: "settings",
        role: "Manager"
      }, {
        label: "Help",
        href: "docs",
        role: "Viewer"
      }];
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/DefaultMenuMixin.vue?vue&type=script&lang=js&
 /* harmony default export */ var mixins_DefaultMenuMixinvue_type_script_lang_js_ = (DefaultMenuMixinvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/mixins/DefaultMenuMixin.vue
var DefaultMenuMixin_render, DefaultMenuMixin_staticRenderFns




/* normalize component */

var DefaultMenuMixin_component = Object(componentNormalizer["a" /* default */])(
  mixins_DefaultMenuMixinvue_type_script_lang_js_,
  DefaultMenuMixin_render,
  DefaultMenuMixin_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DefaultMenuMixin = (DefaultMenuMixin_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/Breadcrumb.vue?vue&type=template&id=4c1fea84&
var Breadcrumbvue_type_template_id_4c1fea84_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.crumbs),function(url,label){return _c('li',{key:label,staticClass:"breadcrumb-item",class:{ active: label === _vm.lastKey }},[(label == _vm.lastKey)?_c('a',{attrs:{"aria-current":"page"}},[_vm._v(_vm._s(label))]):_c('a',{attrs:{"href":url}},[_vm._v(_vm._s(label))])])}),0)])}
var Breadcrumbvue_type_template_id_4c1fea84_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/Breadcrumb.vue?vue&type=template&id=4c1fea84&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/Breadcrumb.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Breadcrumbvue_type_script_lang_js_ = ({
  props: {
    /* pass Object {'label':'url'} pairs*/
    crumbs: Object
  },
  computed: {
    lastKey() {
      return Object.keys(this.crumbs)[Object.keys(this.crumbs).length - 1];
    }

  }
});
// CONCATENATED MODULE: ./src/layout/Breadcrumb.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_Breadcrumbvue_type_script_lang_js_ = (Breadcrumbvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/Breadcrumb.vue?vue&type=custom&index=0&blockType=docs
var Breadcrumbvue_type_custom_index_0_blockType_docs = __webpack_require__("dd2b");

// CONCATENATED MODULE: ./src/layout/Breadcrumb.vue





/* normalize component */

var Breadcrumb_component = Object(componentNormalizer["a" /* default */])(
  layout_Breadcrumbvue_type_script_lang_js_,
  Breadcrumbvue_type_template_id_4c1fea84_render,
  Breadcrumbvue_type_template_id_4c1fea84_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof Breadcrumbvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(Breadcrumbvue_type_custom_index_0_blockType_docs["default"])(Breadcrumb_component)

/* harmony default export */ var Breadcrumb = (Breadcrumb_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/Molgenis.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/**
 Provides wrapper for your apps, including a little bit of contextual state, most notably 'account' that can be reacted to using v-model.
 */

/* harmony default export */ var Molgenisvue_type_script_lang_js_ = ({
  components: {
    MolgenisSession: MolgenisSession,
    MolgenisMenu: MolgenisMenu,
    Footer: MolgenisFooter,
    MolgenisTheme: MolgenisTheme,
    Breadcrumb: Breadcrumb
  },
  mixins: [DefaultMenuMixin],
  props: {
    menuItems: Array,
    title: String,
    showCrumbs: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      session: null,
      cssURL: null,
      logoURL: null,
      cssLoaded: false,
      fullscreen: false,
      timestamp: Date.now()
    };
  },
  computed: {
    crumbs() {
      this.$route;
      let path = decodeURI(window.location.pathname.replace(location.search, "")).split("/");
      let url = "/";
      let result = {
        databases: url
      };

      if (window.location.pathname != "/apps/central/") {
        path.forEach(el => {
          if (el != "") {
            url += el + "/";
            result[el] = url;
          }
        });
      }

      if (this.$route) {
        path = decodeURI(location.hash.split("?")[0]).substr(1).split("/");
        url += "#";
        path.forEach(el => {
          if (el != "") {
            url += "/" + el;
            result[el] = url;
          }
        });
      }

      return result;
    },

    logo() {
      if (this.logoURL) return this.logoURL;else return "/apps/styleguide/assets/img/molgenis_logo_white.png";
    },

    css() {
      if (this.cssURL) return this.cssURL;else return "theme.css";
    },

    menu() {
      if (this.session && this.session.settings && this.session.settings.menu) {
        return this.session.settings.menu;
      } else if (this.menuItems) {
        return this.menuItems;
      } else {
        return this.defaultMenu;
      }
    }

  },
  watch: {
    session: {
      deep: true,

      handler() {
        if (this.session != undefined && this.session.settings) {
          if (this.session.settings.cssURL) {
            this.cssURL = this.session.settings.cssURL;
          }

          if (this.session.settings.logoURL) {
            this.logoURL = this.session.settings.logoURL;
          }
        } //load themeCss


        fetch(this.css).then(() => {
          this.cssLoaded = true;
        });
        this.$emit("input", this.session);
      }

    }
  },
  methods: {
    toggle() {
      this.fullscreen = !this.fullscreen;
    }

  }
});
// CONCATENATED MODULE: ./src/layout/Molgenis.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_Molgenisvue_type_script_lang_js_ = (Molgenisvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/Molgenis.vue?vue&type=custom&index=0&blockType=docs
var Molgenisvue_type_custom_index_0_blockType_docs = __webpack_require__("abe4");

// CONCATENATED MODULE: ./src/layout/Molgenis.vue





/* normalize component */

var Molgenis_component = Object(componentNormalizer["a" /* default */])(
  layout_Molgenisvue_type_script_lang_js_,
  Molgenisvue_type_template_id_13591df7_render,
  Molgenisvue_type_template_id_13591df7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof Molgenisvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(Molgenisvue_type_custom_index_0_blockType_docs["default"])(Molgenis_component)

/* harmony default export */ var Molgenis = (Molgenis_component.exports);
// EXTERNAL MODULE: ./src/tables/TableMolgenis.vue + 34 modules
var TableMolgenis = __webpack_require__("0dcd");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableExplorer.vue?vue&type=template&id=78a15904&
var TableExplorervue_type_template_id_78a15904_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[(_vm.columns)?_c('div',[(_vm.graphqlError)?_c('MessageError',[_vm._v(_vm._s(_vm.graphqlError))]):_vm._e(),_c('div',{staticClass:"bg-white"},[(_vm.showHeader)?_c('h1',{staticClass:"pl-2"},[_vm._v(" "+_vm._s(_vm.table)+" ")]):_vm._e(),(_vm.showHeader && _vm.tableMetadata)?_c('p',{staticClass:"pl-2"},[_vm._v(" "+_vm._s(_vm.tableMetadata.description)+" ")]):_vm._e(),_c('div',{staticClass:"\n          navbar\n          pl-0\n          ml-0\n          shadow-none\n          navbar-expand-lg\n          justify-content-between\n          mb-3\n          pt-3\n          bg-white\n        "},[_c('div',{staticClass:"btn-group"},[_c('ShowHide',{staticClass:"navbar-nav",attrs:{"columns":_vm.columns,"checkAttribute":"showFilter","exclude":['HEADING', 'FILE'],"label":"filters","icon":"filter"},on:{"update:columns":[function($event){_vm.columns=$event},_vm.emitFilters]}}),_c('ShowHide',{staticClass:"navbar-nav",attrs:{"columns":_vm.columns,"checkAttribute":"showColumn","label":"columns","icon":"columns","id":"showColumn","defaultValue":true},on:{"update:columns":[function($event){_vm.columns=$event},_vm.emitColumns]}}),_c('ButtonDropdown',{attrs:{"label":"download","icon":"download"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('IconAction',{staticClass:"float-right",staticStyle:{"margin-top":"-10px","margin-right":"-10px"},attrs:{"icon":"times"},on:{"click":scope.close}}),_c('h6',[_vm._v("Download")]),_c('ButtonAlt',{attrs:{"href":'../api/zip/' + _vm.table}},[_vm._v("zip")]),_c('br'),_c('ButtonAlt',{attrs:{"href":'../api/excel/' + _vm.table}},[_vm._v("excel")]),_c('br'),_c('ButtonAlt',{attrs:{"href":'../api/jsonld/' + _vm.table}},[_vm._v("jsonld")]),_c('br'),_c('ButtonAlt',{attrs:{"href":'../api/ttl/' + _vm.table}},[_vm._v("ttl")])]}}],null,false,2495468443)}),_c('IconAction',{staticClass:"ml-2",attrs:{"label":"view","icon":_vm.viewIcon},on:{"click":_vm.toggleView}})],1),_c('InputSearch',{staticClass:"navbar-nav",model:{value:(_vm.searchTerms),callback:function ($$v) {_vm.searchTerms=$$v},expression:"searchTerms"}}),_c('Pagination',{staticClass:"navbar-nav",attrs:{"limit":_vm.limit,"count":_vm.count},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}),(_vm.view != _vm.View.RECORD)?_c('div',{staticClass:"btn-group m-0"},[_c('span',{staticClass:"btn"},[_vm._v("Rows per page:")]),_c('InputSelect',{staticClass:"mb-0",attrs:{"value":_vm.limit,"options":[10, 20, 50, 100],"clear":false},on:{"input":function($event){return _vm.setlimit($event)}}}),(_vm.showSelect)?_c('SelectionBox',{attrs:{"selection":_vm.selectedItems},on:{"update:selection":function($event){_vm.selectedItems=$event}}}):_vm._e(),(_vm.canManage)?_c('TableSettings',{attrs:{"tableName":_vm.table,"cardTemplate":_vm.cardTemplate,"recordTemplate":_vm.recordTemplate,"graphqlURL":_vm.graphqlURL},on:{"update:cardTemplate":function($event){_vm.cardTemplate=$event},"update:card-template":function($event){_vm.cardTemplate=$event},"update:recordTemplate":function($event){_vm.recordTemplate=$event},"update:record-template":function($event){_vm.recordTemplate=$event}}}):_vm._e()],1):_vm._e()],1)]),_c('div',{staticClass:"d-flex"},[(_vm.countFilters)?_c('div',{staticClass:"col-3 pl-0"},[_c('FilterSidebar',{attrs:{"filters":_vm.columns,"graphqlURL":_vm.graphqlURL},on:{"update:filters":[function($event){_vm.columns=$event},_vm.emitConditions]}})],1):_vm._e(),_c('div',{staticClass:"flex-grow-1 pr-0 pl-0",class:_vm.countFilters > 0 ? 'col-9' : 'col-12'},[_c('FilterWells',{staticClass:"border-top pt-3 pb-3",attrs:{"filters":_vm.columns},on:{"update:filters":[function($event){_vm.columns=$event},_vm.emitConditions]}}),(_vm.loading)?_c('div',[_c('Spinner')],1):_vm._e(),(!_vm.loading && _vm.view == _vm.View.CARDS)?_c('TableCards',{attrs:{"data":_vm.data,"columns":_vm.columns,"table-name":_vm.table,"canEdit":_vm.canEdit,"template":_vm.cardTemplate},on:{"reload":_vm.reload,"click":function($event){return _vm.$emit('click', $event)}}}):_vm._e(),(!_vm.loading && _vm.view == _vm.View.RECORD)?_c('RecordCard',{attrs:{"data":_vm.data,"table-name":_vm.table,"columns":_vm.columns,"canEdit":_vm.canEdit,"template":_vm.recordTemplate},on:{"click":function($event){return _vm.$emit('click', $event)}}}):_vm._e(),(!_vm.loading && _vm.view == _vm.View.TABLE)?_c('TableMolgenis',{attrs:{"selection":_vm.selectedItems,"columns":_vm.columns,"table-metadata":_vm.tableMetadata,"data":_vm.data,"showSelect":_vm.showSelect},on:{"update:selection":function($event){_vm.selectedItems=$event},"update:columns":function($event){_vm.columns=$event},"click":function($event){return _vm.$emit('click', $event)}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('label',[_vm._v(_vm._s(_vm.count)+" records found")])]},proxy:true},{key:"colheader",fn:function(){return [(_vm.canEdit)?_c('RowButtonAdd',{staticClass:"d-inline p-0",attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL},on:{"close":_vm.reload}}):_vm._e()]},proxy:true},{key:"rowheader",fn:function(slotProps){return [(_vm.canEdit)?_c('RowButtonEdit',{attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL,"pkey":_vm.getPkey(slotProps.row)},on:{"close":_vm.reload}}):_vm._e(),(_vm.canEdit)?_c('RowButtonDelete',{attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL,"pkey":_vm.getPkey(slotProps.row)},on:{"close":_vm.reload}}):_vm._e()]}}],null,false,2459058415)}):_vm._e()],1)])],1):_vm._e()])}
var TableExplorervue_type_template_id_78a15904_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/TableExplorer.vue?vue&type=template&id=78a15904&

// EXTERNAL MODULE: ./src/tables/RowButtonAdd.vue + 4 modules
var RowButtonAdd = __webpack_require__("fc2a");

// EXTERNAL MODULE: ./src/tables/RowButtonDelete.vue + 4 modules
var RowButtonDelete = __webpack_require__("c64d");

// EXTERNAL MODULE: ./src/tables/RowButtonEdit.vue + 4 modules
var RowButtonEdit = __webpack_require__("42ad");

// EXTERNAL MODULE: ./src/mixins/TableMixin.vue + 2 modules
var TableMixin = __webpack_require__("89c1");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/ShowHide.vue?vue&type=template&id=dd63efa4&
var ShowHidevue_type_template_id_dd63efa4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonDropdown',{attrs:{"icon":_vm.icon,"label":_vm.label},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('IconAction',{staticClass:"float-right",staticStyle:{"margin-top":"-10px","margin-right":"-10px"},attrs:{"icon":"times"},on:{"click":scope.close}}),_c('div',[_c('h6',[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('b',[_vm._v(" data ( "),_c('ButtonAlt',{staticClass:"pl-0",on:{"click":function($event){return _vm.showAll(true)}}},[_vm._v("all")]),_c('ButtonAlt',{staticClass:"p-0",on:{"click":function($event){return _vm.hideAll(true)}}},[_vm._v("none")]),_vm._v(" ) ")],1),_vm._l((_vm.columns),function(col,key){return _c('div',{key:key},[(_vm.exclude.length == 0 || !_vm.exclude.includes(col.columnType))?_c('span',[(col.name == 'mg_draft')?_c('b',{staticClass:"ml-0"},[_vm._v(" metadata ( "),_c('ButtonAlt',{staticClass:"pl-0",on:{"click":function($event){return _vm.showAll(false)}}},[_vm._v("all")]),_c('ButtonAlt',{staticClass:"p-0",on:{"click":function($event){return _vm.hideAll(false)}}},[_vm._v("none")]),_vm._v(" ) ")],1):_vm._e(),(col.columnType != 'HEADING')?_c('div',{staticClass:"form-check"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":col.name},domProps:{"checked":col[_vm.checkAttribute] == undefined
                ? _vm.defaultValue
                : col[_vm.checkAttribute]},on:{"input":function($event){$event.preventDefault();return _vm.change(key, !col[_vm.checkAttribute])}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":col.name}},[_vm._v(" "+_vm._s(col.name)+" ")])]):_vm._e()]):_vm._e()])})],2)]}}])})}
var ShowHidevue_type_template_id_dd63efa4_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/ShowHide.vue?vue&type=template&id=dd63efa4&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/ShowHide.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ShowHidevue_type_script_lang_js_ = ({
  components: {
    ButtonAlt: ButtonAlt["a" /* default */],
    ButtonDropdown: ButtonDropdown,
    IconAction: IconAction["a" /* default */]
  },
  props: {
    columns: Array,
    label: String,
    icon: String,
    exclude: {
      type: Array,
      default: () => []
    },
    checkAttribute: String,
    defaultValue: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    value(col) {
      return col[this.checkAttribute] == undefined ? this.defaultValue : col[this.checkAttribute];
    },

    change(key, value) {
      let update = JSON.parse(JSON.stringify(this.columns));
      update[key][this.checkAttribute] = value;
      this.$emit("update:columns", update);
    },

    hideAll(data) {
      let update = JSON.parse(JSON.stringify(this.columns));

      for (var key in update) {
        if (data && !update[key].name.startsWith("mg_") || !data && update[key].name.startsWith("mg_")) {
          update[key][this.checkAttribute] = false;
        }
      }

      this.$emit("update:columns", update);
    },

    showAll(data) {
      let update = JSON.parse(JSON.stringify(this.columns));

      for (var key in update) {
        if (data && !update[key].name.startsWith("mg_") || !data && update[key].name.startsWith("mg_")) {
          update[key][this.checkAttribute] = true;
        }
      }

      this.$emit("update:columns", update);
    }

  }
});
// CONCATENATED MODULE: ./src/tables/ShowHide.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_ShowHidevue_type_script_lang_js_ = (ShowHidevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/ShowHide.vue?vue&type=custom&index=0&blockType=docs
var ShowHidevue_type_custom_index_0_blockType_docs = __webpack_require__("d62d");

// CONCATENATED MODULE: ./src/tables/ShowHide.vue





/* normalize component */

var ShowHide_component = Object(componentNormalizer["a" /* default */])(
  tables_ShowHidevue_type_script_lang_js_,
  ShowHidevue_type_template_id_dd63efa4_render,
  ShowHidevue_type_template_id_dd63efa4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof ShowHidevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(ShowHidevue_type_custom_index_0_blockType_docs["default"])(ShowHide_component)

/* harmony default export */ var ShowHide = (ShowHide_component.exports);
// EXTERNAL MODULE: ./src/tables/Pagination.vue + 4 modules
var Pagination = __webpack_require__("5a2b");

// EXTERNAL MODULE: ./src/tables/SelectionBox.vue + 4 modules
var SelectionBox = __webpack_require__("a870");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableCards.vue?vue&type=template&id=6a16d47f&
var TableCardsvue_type_template_id_6a16d47f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-columns"},_vm._l((_vm.data),function(row){return _c('RowCard',{key:JSON.stringify(row) + _vm.template,attrs:{"row":row,"columns":_vm.columns,"tableName":_vm.tableName,"can-edit":_vm.canEdit,"template":_vm.template},on:{"reload":function($event){return _vm.$emit('reload')},"click":function($event){return _vm.$emit('click', $event)}}})}),1)}
var TableCardsvue_type_template_id_6a16d47f_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/TableCards.vue?vue&type=template&id=6a16d47f&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowCard.vue?vue&type=template&id=366673e6&scoped=true&
var RowCardvue_type_template_id_366673e6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",on:{"click":function($event){return _vm.$emit('click', _vm.row)}}},[_c('div',{staticClass:"card-text"},[_c('span',{staticClass:"float-right"},[(_vm.canEdit)?_c('RowButtonDelete',{staticClass:"d-inline",attrs:{"table":_vm.tableName,"pkey":_vm.getKey(_vm.row)},on:{"close":function($event){return _vm.$emit('reload')}}}):_vm._e(),(_vm.canEdit)?_c('RowButtonEdit',{staticClass:"mt-0",attrs:{"table":_vm.tableName,"pkey":_vm.getKey(_vm.row)},on:{"close":function($event){return _vm.$emit('reload')}}}):_vm._e()],1),(_vm.template)?_c('VueTemplate',{attrs:{"template":_vm.template,"a":_vm.row}}):_c('dl',_vm._l((_vm.columns),function(col){return _c('div',{key:col.name},[(
              col.showColumn && _vm.row[col.name] && col.name != 'mg_tableclass'
            )?_c('dt',{staticClass:"pr-3"},[_vm._v(" "+_vm._s(col.name)+" ")]):_vm._e(),(
              col.showColumn && _vm.row[col.name] && col.name != 'mg_tableclass'
            )?_c('dd',{staticClass:"pl-3"},[_c('RenderValue',{attrs:{"col":col,"row":_vm.row}})],1):_vm._e()])}),0)],1)])])}
var RowCardvue_type_template_id_366673e6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/RowCard.vue?vue&type=template&id=366673e6&scoped=true&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RenderValue.vue?vue&type=template&id=6aec5954&
var RenderValuevue_type_template_id_6aec5954_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row[_vm.col.name] && Array.isArray(_vm.row[_vm.col.name]))?_c('span',_vm._l((_vm.row[_vm.col.name]),function(val,idx){return _c('span',{key:idx},[_vm._v(" "+_vm._s(_vm.col.refLabel ? _vm.applyJsTemplate(_vm.col.refLabel, val) : val)+" ")])}),0):(_vm.row[_vm.col.name])?_c('span',[_vm._v(" "+_vm._s(_vm.col.refLabel ? _vm.applyJsTemplate(_vm.col.refLabel, _vm.row[_vm.col.name]) : _vm.row[_vm.col.name])+" ")]):_vm._e()}
var RenderValuevue_type_template_id_6aec5954_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/RenderValue.vue?vue&type=template&id=6aec5954&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RenderValue.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var RenderValuevue_type_script_lang_js_ = ({
  props: {
    row: Object,
    col: Object
  },
  methods: {
    applyJsTemplate(template, object) {
      const names = Object.keys(object);
      const vals = Object.values(object);

      try {
        return new Function(...names, "return `" + template + "`;")(...vals);
      } catch (err) {
        return err.message + " we got keys:" + JSON.stringify(names) + " vals:" + JSON.stringify(vals) + " and template: " + template;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/tables/RenderValue.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_RenderValuevue_type_script_lang_js_ = (RenderValuevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tables/RenderValue.vue





/* normalize component */

var RenderValue_component = Object(componentNormalizer["a" /* default */])(
  tables_RenderValuevue_type_script_lang_js_,
  RenderValuevue_type_template_id_6aec5954_render,
  RenderValuevue_type_template_id_6aec5954_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RenderValue = (RenderValue_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/VueTemplate.vue?vue&type=template&id=516c66d7&
var VueTemplatevue_type_template_id_516c66d7_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('runtime-template-compiler',_vm._b({attrs:{"template":"<div>" + _vm.template + "</div>"}},'runtime-template-compiler',Object.assign({}, _vm.row),false))}
var VueTemplatevue_type_template_id_516c66d7_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/VueTemplate.vue?vue&type=template&id=516c66d7&

// CONCATENATED MODULE: ../node_modules/vue-runtime-template-compiler/dist/vue-runtime-template-compiler.esm.js
var VueRuntimeTemplateCompiler=function(e){var r={};function t(a){if(r[a])return r[a].exports;var n=r[a]={i:a,l:!1,exports:{}};return e[a].call(n.exports,n,n.exports,t),n.l=!0,n.exports}return t.m=e,t.c=r,t.d=function(e,r,a){t.o(e,r)||Object.defineProperty(e,r,{enumerable:!0,get:a})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,r){if(1&r&&(e=t(e)),8&r)return e;if(4&r&&"object"==typeof e&&e&&e.__esModule)return e;var a=Object.create(null);if(t.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:e}),2&r&&"string"!=typeof e)for(var n in e)t.d(a,n,function(r){return e[r]}.bind(null,n));return a},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,r){return Object.prototype.hasOwnProperty.call(e,r)},t.p="/dist/",t(t.s=7)}([function(e,r){var t;t=function(){return this}();try{t=t||new Function("return this")()}catch(e){"object"==typeof window&&(t=window)}e.exports=t},function(e,r){e.exports=function(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e}},function(e,r,t){(function(e,t){(function(r){"use strict";var a=/\r?\n/g,n=/^\s*$/,o=/^(\r?\n)*[\t\s]/;function i(e,r){for(var t=0;e.charAt(t)===r;)t++;return t}var s=Object.freeze({}),u=Object.prototype.toString;function c(e){return"[object Object]"===u.call(e)}function l(e,r){for(var t=Object.create(null),a=e.split(","),n=0;n<a.length;n++)t[a[n]]=!0;return r?function(e){return t[e.toLowerCase()]}:function(e){return t[e]}}var p=l("slot,component",!0);l("key,ref,slot,slot-scope,is");var d=Object.prototype.hasOwnProperty;function f(e,r){return d.call(e,r)}function m(e){var r=Object.create(null);return function(t){return r[t]||(r[t]=e(t))}}var g=/-(\w)/g,h=m((function(e){return e.replace(g,(function(e,r){return r?r.toUpperCase():""}))})),v=/\B([A-Z])/g,b=m((function(e){return e.replace(v,"-$1").toLowerCase()}));function y(e,r){for(var t in r)e[t]=r[t];return e}function w(e,r,t){}Function.prototype.bind;var q=function(e,r,t){return!1},D=l("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),A=l("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),x=l("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track");function E(e,r,t,a){Object.defineProperty(e,r,{value:t,enumerable:!!a,writable:!0,configurable:!0})}var k=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,S=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,T="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/.source+"]*",C="((?:"+T+"\\:)?"+T+")",L=new RegExp("^<"+C),R=/^\s*(\/?)>/,O=new RegExp("^<\\/"+C+"[^>]*>"),F=/^<!DOCTYPE [^>]+>/i,N=/^<!\--/,B=/^<!\[/,U=l("script,style,textarea",!0),V={},_={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},j=/&(?:lt|gt|quot|amp|#39);/g,P=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,I=l("pre,textarea",!0),$=function(e,r){return e&&I(e)&&"\n"===r[0]};function M(e,r){var t=r?P:j;return e.replace(t,(function(e){return _[e]}))}function H(e,r){for(var t,a,n=[],o=r.expectHTML,i=r.isUnaryTag||q,s=r.canBeLeftOpenTag||q,u=0;e;){if(t=e,a&&U(a)){var c=0,l=a.toLowerCase(),p=V[l]||(V[l]=new RegExp("([\\s\\S]*?)(</"+l+"[^>]*>)","i")),d=e.replace(p,(function(e,t,a){return c=a.length,U(l)||"noscript"===l||(t=t.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),$(l,t)&&(t=t.slice(1)),r.chars&&r.chars(t),""}));u+=e.length-d.length,e=d,_(l,u-c,u)}else{var f=e.indexOf("<");if(0===f){if(N.test(e)){var m=e.indexOf("--\x3e");if(m>=0){r.shouldKeepComment&&r.comment(e.substring(4,m),u,u+m+3),E(m+3);continue}}if(B.test(e)){var g=e.indexOf("]>");if(g>=0){E(g+2);continue}}var h=e.match(F);if(h){E(h[0].length);continue}var v=e.match(O);if(v){var b=u;E(v[0].length),_(v[1],b,u);continue}var y=T();if(y){C(y),$(y.tagName,e)&&E(1);continue}}var w=void 0,D=void 0,A=void 0;if(f>=0){for(D=e.slice(f);!(O.test(D)||L.test(D)||N.test(D)||B.test(D)||(A=D.indexOf("<",1))<0);)f+=A,D=e.slice(f);w=e.substring(0,f)}f<0&&(w=e),w&&E(w.length),r.chars&&w&&r.chars(w,u-w.length,u)}if(e===t){r.chars&&r.chars(e),!n.length&&r.warn&&r.warn('Mal-formatted tag at end of template: "'+e+'"',{start:u+e.length});break}}function E(r){u+=r,e=e.substring(r)}function T(){var r=e.match(L);if(r){var t,a,n={tagName:r[1],attrs:[],start:u};for(E(r[0].length);!(t=e.match(R))&&(a=e.match(S)||e.match(k));)a.start=u,E(a[0].length),a.end=u,n.attrs.push(a);if(t)return n.unarySlash=t[1],E(t[0].length),n.end=u,n}}function C(e){var t=e.tagName,u=e.unarySlash;o&&("p"===a&&x(t)&&_(a),s(t)&&a===t&&_(t));for(var c=i(t)||!!u,l=e.attrs.length,p=new Array(l),d=0;d<l;d++){var f=e.attrs[d],m=f[3]||f[4]||f[5]||"",g="a"===t&&"href"===f[1]?r.shouldDecodeNewlinesForHref:r.shouldDecodeNewlines;p[d]={name:f[1],value:M(m,g)},r.outputSourceRange&&(p[d].start=f.start+f[0].match(/^\s*/).length,p[d].end=f.end)}c||(n.push({tag:t,lowerCasedTag:t.toLowerCase(),attrs:p,start:e.start,end:e.end}),a=t),r.start&&r.start(t,p,c,e.start,e.end)}function _(e,t,o){var i,s;if(null==t&&(t=u),null==o&&(o=u),e)for(s=e.toLowerCase(),i=n.length-1;i>=0&&n[i].lowerCasedTag!==s;i--);else i=0;if(i>=0){for(var c=n.length-1;c>=i;c--)(c>i||!e&&r.warn)&&r.warn("tag <"+n[c].tag+"> has no matching end tag.",{start:n[c].start,end:n[c].end}),r.end&&r.end(n[c].tag,t,o);n.length=i,a=i&&n[i-1].tag}else"br"===s?r.start&&r.start(e,[],!0,t,o):"p"===s&&(r.start&&r.start(e,[],!1,t,o),r.end&&r.end(e,t,o))}_()}var G,z=/\r?\n/g,J=/./g,Z=l("script,style,template",!0),K="__proto__"in{},Y="undefined"!=typeof window,W="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,Q=(W&&WXEnvironment.platform.toLowerCase(),Y&&window.navigator.userAgent.toLowerCase()),X=Q&&/msie|trident/.test(Q),ee=(Q&&Q.indexOf("msie 9.0"),Q&&Q.indexOf("edge/")>0),re=(Q&&Q.indexOf("android"),Q&&/iphone|ipad|ipod|ios/.test(Q),Q&&/chrome\/\d+/.test(Q),Q&&/phantomjs/.test(Q),Q&&Q.match(/firefox\/(\d+)/),{}.watch);if(Y)try{var te={};Object.defineProperty(te,"passive",{get:function(){}}),window.addEventListener("test-passive",null,te)}catch(e){}var ae=function(){return void 0===G&&(G=!Y&&!W&&void 0!==e&&e.process&&"server"===e.process.env.VUE_ENV),G};function ne(e){return"function"==typeof e&&/native code/.test(e.toString())}Y&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;var oe="undefined"!=typeof Symbol&&ne(Symbol)&&"undefined"!=typeof Reflect&&ne(Reflect.ownKeys);"undefined"!=typeof Set&&ne(Set)&&Set;var ie,se,ue,ce=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],le={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!0,devtools:!0,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:q,isReservedAttr:q,isUnknownElement:q,getTagNamespace:w,parsePlatformTagName:function(e){return e},mustUseProp:q,async:!0,_lifecycleHooks:ce},pe=w,de="undefined"!=typeof console,fe=/(?:^|[-_])(\w)/g;ie=function(e,r){var t=r?pe(r):"";de&&!le.silent&&console.error("[Vue warn]: "+e+t)},se=function(e,r){de&&!le.silent&&console.warn("[Vue tip]: "+e+(r?pe(r):""))},ue=function(e,r){if(e.$root===e)return"<Root>";var t="function"==typeof e&&null!=e.cid?e.options:e._isVue?e.$options||e.constructor.options:e,a=t.name||t._componentTag,n=t.__file;if(!a&&n){var o=n.match(/([^/\\]+)\.vue$/);a=o&&o[1]}return(a?"<"+function(e){return e.replace(fe,(function(e){return e.toUpperCase()})).replace(/[-_]/g,"")}(a)+">":"<Anonymous>")+(n&&!1!==r?" at "+n:"")},pe=function(e){if(e._isVue&&e.$parent){for(var r=[],t=0;e;){if(r.length>0){var a=r[r.length-1];if(a.constructor===e.constructor){t++,e=e.$parent;continue}t>0&&(r[r.length-1]=[a,t],t=0)}r.push(e),e=e.$parent}return"\n\nfound in\n\n"+r.map((function(e,r){return""+(0===r?"---\x3e ":function(e,r){for(var t="";r;)r%2==1&&(t+=e),r>1&&(e+=e),r>>=1;return t}(" ",5+2*r))+(Array.isArray(e)?ue(e[0])+"... ("+e[1]+" recursive calls)":ue(e))})).join("\n")}return"\n\n(found in "+ue(e)+")"};var me=0,ge=function(){this.id=me++,this.subs=[]};ge.prototype.addSub=function(e){this.subs.push(e)},ge.prototype.removeSub=function(e){!function(e,r){if(e.length){var t=e.indexOf(r);t>-1&&e.splice(t,1)}}(this.subs,e)},ge.prototype.depend=function(){ge.target&&ge.target.addDep(this)},ge.prototype.notify=function(){for(var e=this.subs.slice(),r=0,t=e.length;r<t;r++)e[r].update()},ge.target=null;var he=function(e,r,t,a,n,o,i,s){this.tag=e,this.data=r,this.children=t,this.text=a,this.elm=n,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=r&&r.key,this.componentOptions=i,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},ve={child:{configurable:!0}};ve.child.get=function(){return this.componentInstance},Object.defineProperties(he.prototype,ve);var be=Array.prototype,ye=Object.create(be);["push","pop","shift","unshift","splice","sort","reverse"].forEach((function(e){var r=be[e];E(ye,e,(function(){for(var t=[],a=arguments.length;a--;)t[a]=arguments[a];var n,o=r.apply(this,t),i=this.__ob__;switch(e){case"push":case"unshift":n=t;break;case"splice":n=t.slice(2)}return n&&i.observeArray(n),i.dep.notify(),o}))}));var we=Object.getOwnPropertyNames(ye),qe=function(e){var r;this.value=e,this.dep=new ge,this.vmCount=0,E(e,"__ob__",this),Array.isArray(e)?(K?(r=ye,e.__proto__=r):function(e,r,t){for(var a=0,n=t.length;a<n;a++){var o=t[a];E(e,o,r[o])}}(e,ye,we),this.observeArray(e)):this.walk(e)};function De(e,r){var t,a;if(!(null===(t=e)||"object"!=typeof t||e instanceof he))return f(e,"__ob__")&&e.__ob__ instanceof qe?a=e.__ob__:ae()||!Array.isArray(e)&&!c(e)||!Object.isExtensible(e)||e._isVue||(a=new qe(e)),r&&a&&a.vmCount++,a}function Ae(e,r,t,a,n){var o=new ge,i=Object.getOwnPropertyDescriptor(e,r);if(!i||!1!==i.configurable){var s=i&&i.get,u=i&&i.set;s&&!u||2!==arguments.length||(t=e[r]);var c=!n&&De(t);Object.defineProperty(e,r,{enumerable:!0,configurable:!0,get:function(){var r=s?s.call(e):t;return ge.target&&(o.depend(),c&&(c.dep.depend(),Array.isArray(r)&&Ee(r))),r},set:function(r){var i=s?s.call(e):t;r===i||r!=r&&i!=i||(a&&a(),s&&!u||(u?u.call(e,r):t=r,c=!n&&De(r),o.notify()))}})}}function xe(e,r,t){var a;if((null==e||"string"==typeof(a=e)||"number"==typeof a||"symbol"==typeof a||"boolean"==typeof a)&&ie("Cannot set reactive property on undefined, null, or primitive value: "+e),Array.isArray(e)&&function(e){var r=parseFloat(String(e));return r>=0&&Math.floor(r)===r&&isFinite(e)}(r))return e.length=Math.max(e.length,r),e.splice(r,1,t),t;if(r in e&&!(r in Object.prototype))return e[r]=t,t;var n=e.__ob__;return e._isVue||n&&n.vmCount?(ie("Avoid adding reactive properties to a Vue instance or its root $data at runtime - declare it upfront in the data option."),t):n?(Ae(n.value,r,t),n.dep.notify(),t):(e[r]=t,t)}function Ee(e){for(var r=void 0,t=0,a=e.length;t<a;t++)(r=e[t])&&r.__ob__&&r.__ob__.dep.depend(),Array.isArray(r)&&Ee(r)}qe.prototype.walk=function(e){for(var r=Object.keys(e),t=0;t<r.length;t++)Ae(e,r[t])},qe.prototype.observeArray=function(e){for(var r=0,t=e.length;r<t;r++)De(e[r])};var ke=le.optionMergeStrategies;function Se(e,r){if(!r)return e;for(var t,a,n,o=oe?Reflect.ownKeys(r):Object.keys(r),i=0;i<o.length;i++)"__ob__"!==(t=o[i])&&(a=e[t],n=r[t],f(e,t)?a!==n&&c(a)&&c(n)&&Se(a,n):xe(e,t,n));return e}function Te(e,r,t){return t?function(){var a="function"==typeof r?r.call(t,t):r,n="function"==typeof e?e.call(t,t):e;return a?Se(a,n):n}:r?e?function(){return Se("function"==typeof r?r.call(this,this):r,"function"==typeof e?e.call(this,this):e)}:r:e}function Ce(e,r){var t=r?e?e.concat(r):Array.isArray(r)?r:[r]:e;return t?function(e){for(var r=[],t=0;t<e.length;t++)-1===r.indexOf(e[t])&&r.push(e[t]);return r}(t):t}function Le(e,r,t,a){var n=Object.create(e||null);return r?(Oe(a,r,t),y(n,r)):n}ke.el=ke.propsData=function(e,r,t,a){return t||ie('option "'+a+'" can only be used during instance creation with the `new` keyword.'),Re(e,r)},ke.data=function(e,r,t){return t?Te(e,r,t):r&&"function"!=typeof r?(ie('The "data" option should be a function that returns a per-instance value in component definitions.',t),e):Te(e,r)},ce.forEach((function(e){ke[e]=Ce})),["component","directive","filter"].forEach((function(e){ke[e+"s"]=Le})),ke.watch=function(e,r,t,a){if(e===re&&(e=void 0),r===re&&(r=void 0),!r)return Object.create(e||null);if(Oe(a,r,t),!e)return r;var n={};for(var o in y(n,e),r){var i=n[o],s=r[o];i&&!Array.isArray(i)&&(i=[i]),n[o]=i?i.concat(s):Array.isArray(s)?s:[s]}return n},ke.props=ke.methods=ke.inject=ke.computed=function(e,r,t,a){if(r&&Oe(a,r,t),!e)return r;var n=Object.create(null);return y(n,e),r&&y(n,r),n},ke.provide=Te;var Re=function(e,r){return void 0===r?e:r};function Oe(e,r,t){c(r)||ie('Invalid value for option "'+e+'": expected an Object, but got '+function(e){return u.call(e).slice(8,-1)}(r)+".",t)}var Fe=[];if("undefined"!=typeof Promise&&ne(Promise));else if(X||"undefined"==typeof MutationObserver||!ne(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())void 0!==t&&ne(t);else{var Ne=new MutationObserver((function(){var e=Fe.slice(0);Fe.length=0;for(var r=0;r<e.length;r++)e[r]()})),Be=document.createTextNode(String(1));Ne.observe(Be,{characterData:!0})}l("style,class");var Ue=l("input,textarea,option,select,progress"),Ve=l("contenteditable,draggable,spellcheck"),_e=(l("events,caret,typing,plaintext-only"),l("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible")),je=l("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Pe=l("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0);l("text,number,password,search,email,tel,url");var Ie=/[\w).+\-_$\]]/;function $e(e){var r,t,a,n,o,i=!1,s=!1,u=!1,c=!1,l=0,p=0,d=0,f=0;for(a=0;a<e.length;a++)if(t=r,r=e.charCodeAt(a),i)39===r&&92!==t&&(i=!1);else if(s)34===r&&92!==t&&(s=!1);else if(u)96===r&&92!==t&&(u=!1);else if(c)47===r&&92!==t&&(c=!1);else if(124!==r||124===e.charCodeAt(a+1)||124===e.charCodeAt(a-1)||l||p||d){switch(r){case 34:s=!0;break;case 39:i=!0;break;case 96:u=!0;break;case 40:d++;break;case 41:d--;break;case 91:p++;break;case 93:p--;break;case 123:l++;break;case 125:l--}if(47===r){for(var m=a-1,g=void 0;m>=0&&" "===(g=e.charAt(m));m--);g&&Ie.test(g)||(c=!0)}}else void 0===n?(f=a+1,n=e.slice(0,a).trim()):h();function h(){(o||(o=[])).push(e.slice(f,a).trim()),f=a+1}if(void 0===n?n=e.slice(0,a).trim():0!==f&&h(),o)for(a=0;a<o.length;a++)n=Me(n,o[a]);return n}function Me(e,r){var t=r.indexOf("(");if(t<0)return'_f("'+r+'")('+e+")";var a=r.slice(0,t),n=r.slice(t+1);return'_f("'+a+'")('+e+(")"!==n?","+n:n)}var He=/\{\{((?:.|\r?\n)+?)\}\}/g,Ge=/[-.*+?^${}()|[\]\/\\]/g,ze=m((function(e){var r=e[0].replace(Ge,"\\$&"),t=e[1].replace(Ge,"\\$&");return new RegExp(r+"((?:.|\\n)+?)"+t,"g")}));function Je(e,r){var t=r?ze(r):He;if(t.test(e)){for(var a,n,o,i=[],s=[],u=t.lastIndex=0;a=t.exec(e);){(n=a.index)>u&&(s.push(o=e.slice(u,n)),i.push(JSON.stringify(o)));var c=$e(a[1].trim());i.push("_s("+c+")"),s.push({"@binding":c}),u=n+a[0].length}return u<e.length&&(s.push(o=e.slice(u)),i.push(JSON.stringify(o))),{expression:i.join("+"),tokens:s}}}function Ze(e,r){console.error("[Vue compiler]: "+e)}function Ke(e,r){return e?e.map((function(e){return e[r]})).filter((function(e){return e})):[]}function Ye(e,r,t,a,n){(e.props||(e.props=[])).push(ir({name:r,value:t,dynamic:n},a)),e.plain=!1}function We(e,r,t,a,n){(n?e.dynamicAttrs||(e.dynamicAttrs=[]):e.attrs||(e.attrs=[])).push(ir({name:r,value:t,dynamic:n},a)),e.plain=!1}function Qe(e,r,t,a){e.attrsMap[r]=t,e.attrsList.push(ir({name:r,value:t},a))}function Xe(e,r,t,a,n,o,i,s){(e.directives||(e.directives=[])).push(ir({name:r,rawName:t,value:a,arg:n,isDynamicArg:o,modifiers:i},s)),e.plain=!1}function er(e,r,t){return t?"_p("+r+',"'+e+'")':e+r}function rr(e,r,t,a,n,o,i,u){var c;a=a||s,o&&a.prevent&&a.passive&&o("passive and prevent can't be used together. Passive handler can't prevent default event.",i),a.right?u?r="("+r+")==='click'?'contextmenu':("+r+")":"click"===r&&(r="contextmenu",delete a.right):a.middle&&(u?r="("+r+")==='click'?'mouseup':("+r+")":"click"===r&&(r="mouseup")),a.capture&&(delete a.capture,r=er("!",r,u)),a.once&&(delete a.once,r=er("~",r,u)),a.passive&&(delete a.passive,r=er("&",r,u)),a.native?(delete a.native,c=e.nativeEvents||(e.nativeEvents={})):c=e.events||(e.events={});var l=ir({value:t.trim(),dynamic:u},i);a!==s&&(l.modifiers=a);var p=c[r];Array.isArray(p)?n?p.unshift(l):p.push(l):c[r]=p?n?[l,p]:[p,l]:l,e.plain=!1}function tr(e,r){return e.rawAttrsMap[":"+r]||e.rawAttrsMap["v-bind:"+r]||e.rawAttrsMap[r]}function ar(e,r,t){var a=nr(e,":"+r)||nr(e,"v-bind:"+r);if(null!=a)return $e(a);if(!1!==t){var n=nr(e,r);if(null!=n)return JSON.stringify(n)}}function nr(e,r,t){var a;if(null!=(a=e.attrsMap[r]))for(var n=e.attrsList,o=0,i=n.length;o<i;o++)if(n[o].name===r){n.splice(o,1);break}return t&&delete e.attrsMap[r],a}function or(e,r){for(var t=e.attrsList,a=0,n=t.length;a<n;a++){var o=t[a];if(r.test(o.name))return t.splice(a,1),o}}function ir(e,r){return r&&(null!=r.start&&(e.start=r.start),null!=r.end&&(e.end=r.end)),e}var sr,ur,cr,lr,pr,dr,fr={staticKeys:["staticClass"],transformNode:function(e,r){var t=r.warn||Ze,a=nr(e,"class");a&&Je(a,r.delimiters)&&t('class="'+a+'": Interpolation inside attributes has been removed. Use v-bind or the colon shorthand instead. For example, instead of <div class="{{ val }}">, use <div :class="val">.',e.rawAttrsMap.class),a&&(e.staticClass=JSON.stringify(a));var n=ar(e,"class",!1);n&&(e.classBinding=n)},genData:function(e){var r="";return e.staticClass&&(r+="staticClass:"+e.staticClass+","),e.classBinding&&(r+="class:"+e.classBinding+","),r}},mr=m((function(e){var r={},t=/:(.+)/;return e.split(/;(?![^(]*\))/g).forEach((function(e){if(e){var a=e.split(t);a.length>1&&(r[a[0].trim()]=a[1].trim())}})),r})),gr={staticKeys:["staticStyle"],transformNode:function(e,r){var t=r.warn||Ze,a=nr(e,"style");a&&(Je(a,r.delimiters)&&t('style="'+a+'": Interpolation inside attributes has been removed. Use v-bind or the colon shorthand instead. For example, instead of <div style="{{ val }}">, use <div :style="val">.',e.rawAttrsMap.style),e.staticStyle=JSON.stringify(mr(a)));var n=ar(e,"style",!1);n&&(e.styleBinding=n)},genData:function(e){var r="";return e.staticStyle&&(r+="staticStyle:"+e.staticStyle+","),e.styleBinding&&(r+="style:("+e.styleBinding+"),"),r}},hr="undefined"!=typeof window?window:void 0!==e?e:"undefined"!=typeof self?self:{},vr=function(e,r){return e(r={exports:{}},r.exports),r.exports}((function(e,r){!function(t){var a=r,n=e&&e.exports==a&&e,o="object"==typeof hr&&hr;o.global!==o&&o.window!==o||(t=o);var i=/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,s=/[\x01-\x7F]/g,u=/[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g,c=/<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g,l={"­":"shy","‌":"zwnj","‍":"zwj","‎":"lrm","⁣":"ic","⁢":"it","⁡":"af","‏":"rlm","​":"ZeroWidthSpace","⁠":"NoBreak","̑":"DownBreve","⃛":"tdot","⃜":"DotDot","\t":"Tab","\n":"NewLine"," ":"puncsp"," ":"MediumSpace"," ":"thinsp"," ":"hairsp"," ":"emsp13"," ":"ensp"," ":"emsp14"," ":"emsp"," ":"numsp"," ":"nbsp","  ":"ThickSpace","‾":"oline",_:"lowbar","‐":"dash","–":"ndash","—":"mdash","―":"horbar",",":"comma",";":"semi","⁏":"bsemi",":":"colon","⩴":"Colone","!":"excl","¡":"iexcl","?":"quest","¿":"iquest",".":"period","‥":"nldr","…":"mldr","·":"middot","'":"apos","‘":"lsquo","’":"rsquo","‚":"sbquo","‹":"lsaquo","›":"rsaquo",'"':"quot","“":"ldquo","”":"rdquo","„":"bdquo","«":"laquo","»":"raquo","(":"lpar",")":"rpar","[":"lsqb","]":"rsqb","{":"lcub","}":"rcub","⌈":"lceil","⌉":"rceil","⌊":"lfloor","⌋":"rfloor","⦅":"lopar","⦆":"ropar","⦋":"lbrke","⦌":"rbrke","⦍":"lbrkslu","⦎":"rbrksld","⦏":"lbrksld","⦐":"rbrkslu","⦑":"langd","⦒":"rangd","⦓":"lparlt","⦔":"rpargt","⦕":"gtlPar","⦖":"ltrPar","⟦":"lobrk","⟧":"robrk","⟨":"lang","⟩":"rang","⟪":"Lang","⟫":"Rang","⟬":"loang","⟭":"roang","❲":"lbbrk","❳":"rbbrk","‖":"Vert","§":"sect","¶":"para","@":"commat","*":"ast","/":"sol",undefined:null,"&":"amp","#":"num","%":"percnt","‰":"permil","‱":"pertenk","†":"dagger","‡":"Dagger","•":"bull","⁃":"hybull","′":"prime","″":"Prime","‴":"tprime","⁗":"qprime","‵":"bprime","⁁":"caret","`":"grave","´":"acute","˜":"tilde","^":"Hat","¯":"macr","˘":"breve","˙":"dot","¨":"die","˚":"ring","˝":"dblac","¸":"cedil","˛":"ogon","ˆ":"circ","ˇ":"caron","°":"deg","©":"copy","®":"reg","℗":"copysr","℘":"wp","℞":"rx","℧":"mho","℩":"iiota","←":"larr","↚":"nlarr","→":"rarr","↛":"nrarr","↑":"uarr","↓":"darr","↔":"harr","↮":"nharr","↕":"varr","↖":"nwarr","↗":"nearr","↘":"searr","↙":"swarr","↝":"rarrw","↝̸":"nrarrw","↞":"Larr","↟":"Uarr","↠":"Rarr","↡":"Darr","↢":"larrtl","↣":"rarrtl","↤":"mapstoleft","↥":"mapstoup","↦":"map","↧":"mapstodown","↩":"larrhk","↪":"rarrhk","↫":"larrlp","↬":"rarrlp","↭":"harrw","↰":"lsh","↱":"rsh","↲":"ldsh","↳":"rdsh","↵":"crarr","↶":"cularr","↷":"curarr","↺":"olarr","↻":"orarr","↼":"lharu","↽":"lhard","↾":"uharr","↿":"uharl","⇀":"rharu","⇁":"rhard","⇂":"dharr","⇃":"dharl","⇄":"rlarr","⇅":"udarr","⇆":"lrarr","⇇":"llarr","⇈":"uuarr","⇉":"rrarr","⇊":"ddarr","⇋":"lrhar","⇌":"rlhar","⇐":"lArr","⇍":"nlArr","⇑":"uArr","⇒":"rArr","⇏":"nrArr","⇓":"dArr","⇔":"iff","⇎":"nhArr","⇕":"vArr","⇖":"nwArr","⇗":"neArr","⇘":"seArr","⇙":"swArr","⇚":"lAarr","⇛":"rAarr","⇝":"zigrarr","⇤":"larrb","⇥":"rarrb","⇵":"duarr","⇽":"loarr","⇾":"roarr","⇿":"hoarr","∀":"forall","∁":"comp","∂":"part","∂̸":"npart","∃":"exist","∄":"nexist","∅":"empty","∇":"Del","∈":"in","∉":"notin","∋":"ni","∌":"notni","϶":"bepsi","∏":"prod","∐":"coprod","∑":"sum","+":"plus","±":"pm","÷":"div","×":"times","<":"lt","≮":"nlt","<⃒":"nvlt","=":"equals","≠":"ne","=⃥":"bne","⩵":"Equal",">":"gt","≯":"ngt",">⃒":"nvgt","¬":"not","|":"vert","¦":"brvbar","−":"minus","∓":"mp","∔":"plusdo","⁄":"frasl","∖":"setmn","∗":"lowast","∘":"compfn","√":"Sqrt","∝":"prop","∞":"infin","∟":"angrt","∠":"ang","∠⃒":"nang","∡":"angmsd","∢":"angsph","∣":"mid","∤":"nmid","∥":"par","∦":"npar","∧":"and","∨":"or","∩":"cap","∩︀":"caps","∪":"cup","∪︀":"cups","∫":"int","∬":"Int","∭":"tint","⨌":"qint","∮":"oint","∯":"Conint","∰":"Cconint","∱":"cwint","∲":"cwconint","∳":"awconint","∴":"there4","∵":"becaus","∶":"ratio","∷":"Colon","∸":"minusd","∺":"mDDot","∻":"homtht","∼":"sim","≁":"nsim","∼⃒":"nvsim","∽":"bsim","∽̱":"race","∾":"ac","∾̳":"acE","∿":"acd","≀":"wr","≂":"esim","≂̸":"nesim","≃":"sime","≄":"nsime","≅":"cong","≇":"ncong","≆":"simne","≈":"ap","≉":"nap","≊":"ape","≋":"apid","≋̸":"napid","≌":"bcong","≍":"CupCap","≭":"NotCupCap","≍⃒":"nvap","≎":"bump","≎̸":"nbump","≏":"bumpe","≏̸":"nbumpe","≐":"doteq","≐̸":"nedot","≑":"eDot","≒":"efDot","≓":"erDot","≔":"colone","≕":"ecolon","≖":"ecir","≗":"cire","≙":"wedgeq","≚":"veeeq","≜":"trie","≟":"equest","≡":"equiv","≢":"nequiv","≡⃥":"bnequiv","≤":"le","≰":"nle","≤⃒":"nvle","≥":"ge","≱":"nge","≥⃒":"nvge","≦":"lE","≦̸":"nlE","≧":"gE","≧̸":"ngE","≨︀":"lvnE","≨":"lnE","≩":"gnE","≩︀":"gvnE","≪":"ll","≪̸":"nLtv","≪⃒":"nLt","≫":"gg","≫̸":"nGtv","≫⃒":"nGt","≬":"twixt","≲":"lsim","≴":"nlsim","≳":"gsim","≵":"ngsim","≶":"lg","≸":"ntlg","≷":"gl","≹":"ntgl","≺":"pr","⊀":"npr","≻":"sc","⊁":"nsc","≼":"prcue","⋠":"nprcue","≽":"sccue","⋡":"nsccue","≾":"prsim","≿":"scsim","≿̸":"NotSucceedsTilde","⊂":"sub","⊄":"nsub","⊂⃒":"vnsub","⊃":"sup","⊅":"nsup","⊃⃒":"vnsup","⊆":"sube","⊈":"nsube","⊇":"supe","⊉":"nsupe","⊊︀":"vsubne","⊊":"subne","⊋︀":"vsupne","⊋":"supne","⊍":"cupdot","⊎":"uplus","⊏":"sqsub","⊏̸":"NotSquareSubset","⊐":"sqsup","⊐̸":"NotSquareSuperset","⊑":"sqsube","⋢":"nsqsube","⊒":"sqsupe","⋣":"nsqsupe","⊓":"sqcap","⊓︀":"sqcaps","⊔":"sqcup","⊔︀":"sqcups","⊕":"oplus","⊖":"ominus","⊗":"otimes","⊘":"osol","⊙":"odot","⊚":"ocir","⊛":"oast","⊝":"odash","⊞":"plusb","⊟":"minusb","⊠":"timesb","⊡":"sdotb","⊢":"vdash","⊬":"nvdash","⊣":"dashv","⊤":"top","⊥":"bot","⊧":"models","⊨":"vDash","⊭":"nvDash","⊩":"Vdash","⊮":"nVdash","⊪":"Vvdash","⊫":"VDash","⊯":"nVDash","⊰":"prurel","⊲":"vltri","⋪":"nltri","⊳":"vrtri","⋫":"nrtri","⊴":"ltrie","⋬":"nltrie","⊴⃒":"nvltrie","⊵":"rtrie","⋭":"nrtrie","⊵⃒":"nvrtrie","⊶":"origof","⊷":"imof","⊸":"mumap","⊹":"hercon","⊺":"intcal","⊻":"veebar","⊽":"barvee","⊾":"angrtvb","⊿":"lrtri","⋀":"Wedge","⋁":"Vee","⋂":"xcap","⋃":"xcup","⋄":"diam","⋅":"sdot","⋆":"Star","⋇":"divonx","⋈":"bowtie","⋉":"ltimes","⋊":"rtimes","⋋":"lthree","⋌":"rthree","⋍":"bsime","⋎":"cuvee","⋏":"cuwed","⋐":"Sub","⋑":"Sup","⋒":"Cap","⋓":"Cup","⋔":"fork","⋕":"epar","⋖":"ltdot","⋗":"gtdot","⋘":"Ll","⋘̸":"nLl","⋙":"Gg","⋙̸":"nGg","⋚︀":"lesg","⋚":"leg","⋛":"gel","⋛︀":"gesl","⋞":"cuepr","⋟":"cuesc","⋦":"lnsim","⋧":"gnsim","⋨":"prnsim","⋩":"scnsim","⋮":"vellip","⋯":"ctdot","⋰":"utdot","⋱":"dtdot","⋲":"disin","⋳":"isinsv","⋴":"isins","⋵":"isindot","⋵̸":"notindot","⋶":"notinvc","⋷":"notinvb","⋹":"isinE","⋹̸":"notinE","⋺":"nisd","⋻":"xnis","⋼":"nis","⋽":"notnivc","⋾":"notnivb","⌅":"barwed","⌆":"Barwed","⌌":"drcrop","⌍":"dlcrop","⌎":"urcrop","⌏":"ulcrop","⌐":"bnot","⌒":"profline","⌓":"profsurf","⌕":"telrec","⌖":"target","⌜":"ulcorn","⌝":"urcorn","⌞":"dlcorn","⌟":"drcorn","⌢":"frown","⌣":"smile","⌭":"cylcty","⌮":"profalar","⌶":"topbot","⌽":"ovbar","⌿":"solbar","⍼":"angzarr","⎰":"lmoust","⎱":"rmoust","⎴":"tbrk","⎵":"bbrk","⎶":"bbrktbrk","⏜":"OverParenthesis","⏝":"UnderParenthesis","⏞":"OverBrace","⏟":"UnderBrace","⏢":"trpezium","⏧":"elinters","␣":"blank","─":"boxh","│":"boxv","┌":"boxdr","┐":"boxdl","└":"boxur","┘":"boxul","├":"boxvr","┤":"boxvl","┬":"boxhd","┴":"boxhu","┼":"boxvh","═":"boxH","║":"boxV","╒":"boxdR","╓":"boxDr","╔":"boxDR","╕":"boxdL","╖":"boxDl","╗":"boxDL","╘":"boxuR","╙":"boxUr","╚":"boxUR","╛":"boxuL","╜":"boxUl","╝":"boxUL","╞":"boxvR","╟":"boxVr","╠":"boxVR","╡":"boxvL","╢":"boxVl","╣":"boxVL","╤":"boxHd","╥":"boxhD","╦":"boxHD","╧":"boxHu","╨":"boxhU","╩":"boxHU","╪":"boxvH","╫":"boxVh","╬":"boxVH","▀":"uhblk","▄":"lhblk","█":"block","░":"blk14","▒":"blk12","▓":"blk34","□":"squ","▪":"squf","▫":"EmptyVerySmallSquare","▭":"rect","▮":"marker","▱":"fltns","△":"xutri","▴":"utrif","▵":"utri","▸":"rtrif","▹":"rtri","▽":"xdtri","▾":"dtrif","▿":"dtri","◂":"ltrif","◃":"ltri","◊":"loz","○":"cir","◬":"tridot","◯":"xcirc","◸":"ultri","◹":"urtri","◺":"lltri","◻":"EmptySmallSquare","◼":"FilledSmallSquare","★":"starf","☆":"star","☎":"phone","♀":"female","♂":"male","♠":"spades","♣":"clubs","♥":"hearts","♦":"diams","♪":"sung","✓":"check","✗":"cross","✠":"malt","✶":"sext","❘":"VerticalSeparator","⟈":"bsolhsub","⟉":"suphsol","⟵":"xlarr","⟶":"xrarr","⟷":"xharr","⟸":"xlArr","⟹":"xrArr","⟺":"xhArr","⟼":"xmap","⟿":"dzigrarr","⤂":"nvlArr","⤃":"nvrArr","⤄":"nvHarr","⤅":"Map","⤌":"lbarr","⤍":"rbarr","⤎":"lBarr","⤏":"rBarr","⤐":"RBarr","⤑":"DDotrahd","⤒":"UpArrowBar","⤓":"DownArrowBar","⤖":"Rarrtl","⤙":"latail","⤚":"ratail","⤛":"lAtail","⤜":"rAtail","⤝":"larrfs","⤞":"rarrfs","⤟":"larrbfs","⤠":"rarrbfs","⤣":"nwarhk","⤤":"nearhk","⤥":"searhk","⤦":"swarhk","⤧":"nwnear","⤨":"toea","⤩":"tosa","⤪":"swnwar","⤳":"rarrc","⤳̸":"nrarrc","⤵":"cudarrr","⤶":"ldca","⤷":"rdca","⤸":"cudarrl","⤹":"larrpl","⤼":"curarrm","⤽":"cularrp","⥅":"rarrpl","⥈":"harrcir","⥉":"Uarrocir","⥊":"lurdshar","⥋":"ldrushar","⥎":"LeftRightVector","⥏":"RightUpDownVector","⥐":"DownLeftRightVector","⥑":"LeftUpDownVector","⥒":"LeftVectorBar","⥓":"RightVectorBar","⥔":"RightUpVectorBar","⥕":"RightDownVectorBar","⥖":"DownLeftVectorBar","⥗":"DownRightVectorBar","⥘":"LeftUpVectorBar","⥙":"LeftDownVectorBar","⥚":"LeftTeeVector","⥛":"RightTeeVector","⥜":"RightUpTeeVector","⥝":"RightDownTeeVector","⥞":"DownLeftTeeVector","⥟":"DownRightTeeVector","⥠":"LeftUpTeeVector","⥡":"LeftDownTeeVector","⥢":"lHar","⥣":"uHar","⥤":"rHar","⥥":"dHar","⥦":"luruhar","⥧":"ldrdhar","⥨":"ruluhar","⥩":"rdldhar","⥪":"lharul","⥫":"llhard","⥬":"rharul","⥭":"lrhard","⥮":"udhar","⥯":"duhar","⥰":"RoundImplies","⥱":"erarr","⥲":"simrarr","⥳":"larrsim","⥴":"rarrsim","⥵":"rarrap","⥶":"ltlarr","⥸":"gtrarr","⥹":"subrarr","⥻":"suplarr","⥼":"lfisht","⥽":"rfisht","⥾":"ufisht","⥿":"dfisht","⦚":"vzigzag","⦜":"vangrt","⦝":"angrtvbd","⦤":"ange","⦥":"range","⦦":"dwangle","⦧":"uwangle","⦨":"angmsdaa","⦩":"angmsdab","⦪":"angmsdac","⦫":"angmsdad","⦬":"angmsdae","⦭":"angmsdaf","⦮":"angmsdag","⦯":"angmsdah","⦰":"bemptyv","⦱":"demptyv","⦲":"cemptyv","⦳":"raemptyv","⦴":"laemptyv","⦵":"ohbar","⦶":"omid","⦷":"opar","⦹":"operp","⦻":"olcross","⦼":"odsold","⦾":"olcir","⦿":"ofcir","⧀":"olt","⧁":"ogt","⧂":"cirscir","⧃":"cirE","⧄":"solb","⧅":"bsolb","⧉":"boxbox","⧍":"trisb","⧎":"rtriltri","⧏":"LeftTriangleBar","⧏̸":"NotLeftTriangleBar","⧐":"RightTriangleBar","⧐̸":"NotRightTriangleBar","⧜":"iinfin","⧝":"infintie","⧞":"nvinfin","⧣":"eparsl","⧤":"smeparsl","⧥":"eqvparsl","⧫":"lozf","⧴":"RuleDelayed","⧶":"dsol","⨀":"xodot","⨁":"xoplus","⨂":"xotime","⨄":"xuplus","⨆":"xsqcup","⨍":"fpartint","⨐":"cirfnint","⨑":"awint","⨒":"rppolint","⨓":"scpolint","⨔":"npolint","⨕":"pointint","⨖":"quatint","⨗":"intlarhk","⨢":"pluscir","⨣":"plusacir","⨤":"simplus","⨥":"plusdu","⨦":"plussim","⨧":"plustwo","⨩":"mcomma","⨪":"minusdu","⨭":"loplus","⨮":"roplus","⨯":"Cross","⨰":"timesd","⨱":"timesbar","⨳":"smashp","⨴":"lotimes","⨵":"rotimes","⨶":"otimesas","⨷":"Otimes","⨸":"odiv","⨹":"triplus","⨺":"triminus","⨻":"tritime","⨼":"iprod","⨿":"amalg","⩀":"capdot","⩂":"ncup","⩃":"ncap","⩄":"capand","⩅":"cupor","⩆":"cupcap","⩇":"capcup","⩈":"cupbrcap","⩉":"capbrcup","⩊":"cupcup","⩋":"capcap","⩌":"ccups","⩍":"ccaps","⩐":"ccupssm","⩓":"And","⩔":"Or","⩕":"andand","⩖":"oror","⩗":"orslope","⩘":"andslope","⩚":"andv","⩛":"orv","⩜":"andd","⩝":"ord","⩟":"wedbar","⩦":"sdote","⩪":"simdot","⩭":"congdot","⩭̸":"ncongdot","⩮":"easter","⩯":"apacir","⩰":"apE","⩰̸":"napE","⩱":"eplus","⩲":"pluse","⩳":"Esim","⩷":"eDDot","⩸":"equivDD","⩹":"ltcir","⩺":"gtcir","⩻":"ltquest","⩼":"gtquest","⩽":"les","⩽̸":"nles","⩾":"ges","⩾̸":"nges","⩿":"lesdot","⪀":"gesdot","⪁":"lesdoto","⪂":"gesdoto","⪃":"lesdotor","⪄":"gesdotol","⪅":"lap","⪆":"gap","⪇":"lne","⪈":"gne","⪉":"lnap","⪊":"gnap","⪋":"lEg","⪌":"gEl","⪍":"lsime","⪎":"gsime","⪏":"lsimg","⪐":"gsiml","⪑":"lgE","⪒":"glE","⪓":"lesges","⪔":"gesles","⪕":"els","⪖":"egs","⪗":"elsdot","⪘":"egsdot","⪙":"el","⪚":"eg","⪝":"siml","⪞":"simg","⪟":"simlE","⪠":"simgE","⪡":"LessLess","⪡̸":"NotNestedLessLess","⪢":"GreaterGreater","⪢̸":"NotNestedGreaterGreater","⪤":"glj","⪥":"gla","⪦":"ltcc","⪧":"gtcc","⪨":"lescc","⪩":"gescc","⪪":"smt","⪫":"lat","⪬":"smte","⪬︀":"smtes","⪭":"late","⪭︀":"lates","⪮":"bumpE","⪯":"pre","⪯̸":"npre","⪰":"sce","⪰̸":"nsce","⪳":"prE","⪴":"scE","⪵":"prnE","⪶":"scnE","⪷":"prap","⪸":"scap","⪹":"prnap","⪺":"scnap","⪻":"Pr","⪼":"Sc","⪽":"subdot","⪾":"supdot","⪿":"subplus","⫀":"supplus","⫁":"submult","⫂":"supmult","⫃":"subedot","⫄":"supedot","⫅":"subE","⫅̸":"nsubE","⫆":"supE","⫆̸":"nsupE","⫇":"subsim","⫈":"supsim","⫋︀":"vsubnE","⫋":"subnE","⫌︀":"vsupnE","⫌":"supnE","⫏":"csub","⫐":"csup","⫑":"csube","⫒":"csupe","⫓":"subsup","⫔":"supsub","⫕":"subsub","⫖":"supsup","⫗":"suphsub","⫘":"supdsub","⫙":"forkv","⫚":"topfork","⫛":"mlcp","⫤":"Dashv","⫦":"Vdashl","⫧":"Barv","⫨":"vBar","⫩":"vBarv","⫫":"Vbar","⫬":"Not","⫭":"bNot","⫮":"rnmid","⫯":"cirmid","⫰":"midcir","⫱":"topcir","⫲":"nhpar","⫳":"parsim","⫽":"parsl","⫽⃥":"nparsl","♭":"flat","♮":"natur","♯":"sharp","¤":"curren","¢":"cent",$:"dollar","£":"pound","¥":"yen","€":"euro","¹":"sup1","½":"half","⅓":"frac13","¼":"frac14","⅕":"frac15","⅙":"frac16","⅛":"frac18","²":"sup2","⅔":"frac23","⅖":"frac25","³":"sup3","¾":"frac34","⅗":"frac35","⅜":"frac38","⅘":"frac45","⅚":"frac56","⅝":"frac58","⅞":"frac78","𝒶":"ascr","𝕒":"aopf","𝔞":"afr","𝔸":"Aopf","𝔄":"Afr","𝒜":"Ascr","ª":"ordf","á":"aacute","Á":"Aacute","à":"agrave","À":"Agrave","ă":"abreve","Ă":"Abreve","â":"acirc","Â":"Acirc","å":"aring","Å":"angst","ä":"auml","Ä":"Auml","ã":"atilde","Ã":"Atilde","ą":"aogon","Ą":"Aogon","ā":"amacr","Ā":"Amacr","æ":"aelig","Æ":"AElig","𝒷":"bscr","𝕓":"bopf","𝔟":"bfr","𝔹":"Bopf","ℬ":"Bscr","𝔅":"Bfr","𝔠":"cfr","𝒸":"cscr","𝕔":"copf","ℭ":"Cfr","𝒞":"Cscr","ℂ":"Copf","ć":"cacute","Ć":"Cacute","ĉ":"ccirc","Ĉ":"Ccirc","č":"ccaron","Č":"Ccaron","ċ":"cdot","Ċ":"Cdot","ç":"ccedil","Ç":"Ccedil","℅":"incare","𝔡":"dfr","ⅆ":"dd","𝕕":"dopf","𝒹":"dscr","𝒟":"Dscr","𝔇":"Dfr","ⅅ":"DD","𝔻":"Dopf","ď":"dcaron","Ď":"Dcaron","đ":"dstrok","Đ":"Dstrok","ð":"eth","Ð":"ETH","ⅇ":"ee","ℯ":"escr","𝔢":"efr","𝕖":"eopf","ℰ":"Escr","𝔈":"Efr","𝔼":"Eopf","é":"eacute","É":"Eacute","è":"egrave","È":"Egrave","ê":"ecirc","Ê":"Ecirc","ě":"ecaron","Ě":"Ecaron","ë":"euml","Ë":"Euml","ė":"edot","Ė":"Edot","ę":"eogon","Ę":"Eogon","ē":"emacr","Ē":"Emacr","𝔣":"ffr","𝕗":"fopf","𝒻":"fscr","𝔉":"Ffr","𝔽":"Fopf","ℱ":"Fscr","ﬀ":"fflig","ﬃ":"ffilig","ﬄ":"ffllig","ﬁ":"filig",fj:"fjlig","ﬂ":"fllig","ƒ":"fnof","ℊ":"gscr","𝕘":"gopf","𝔤":"gfr","𝒢":"Gscr","𝔾":"Gopf","𝔊":"Gfr","ǵ":"gacute","ğ":"gbreve","Ğ":"Gbreve","ĝ":"gcirc","Ĝ":"Gcirc","ġ":"gdot","Ġ":"Gdot","Ģ":"Gcedil","𝔥":"hfr","ℎ":"planckh","𝒽":"hscr","𝕙":"hopf","ℋ":"Hscr","ℌ":"Hfr","ℍ":"Hopf","ĥ":"hcirc","Ĥ":"Hcirc","ℏ":"hbar","ħ":"hstrok","Ħ":"Hstrok","𝕚":"iopf","𝔦":"ifr","𝒾":"iscr","ⅈ":"ii","𝕀":"Iopf","ℐ":"Iscr","ℑ":"Im","í":"iacute","Í":"Iacute","ì":"igrave","Ì":"Igrave","î":"icirc","Î":"Icirc","ï":"iuml","Ï":"Iuml","ĩ":"itilde","Ĩ":"Itilde","İ":"Idot","į":"iogon","Į":"Iogon","ī":"imacr","Ī":"Imacr","ĳ":"ijlig","Ĳ":"IJlig","ı":"imath","𝒿":"jscr","𝕛":"jopf","𝔧":"jfr","𝒥":"Jscr","𝔍":"Jfr","𝕁":"Jopf","ĵ":"jcirc","Ĵ":"Jcirc","ȷ":"jmath","𝕜":"kopf","𝓀":"kscr","𝔨":"kfr","𝒦":"Kscr","𝕂":"Kopf","𝔎":"Kfr","ķ":"kcedil","Ķ":"Kcedil","𝔩":"lfr","𝓁":"lscr","ℓ":"ell","𝕝":"lopf","ℒ":"Lscr","𝔏":"Lfr","𝕃":"Lopf","ĺ":"lacute","Ĺ":"Lacute","ľ":"lcaron","Ľ":"Lcaron","ļ":"lcedil","Ļ":"Lcedil","ł":"lstrok","Ł":"Lstrok","ŀ":"lmidot","Ŀ":"Lmidot","𝔪":"mfr","𝕞":"mopf","𝓂":"mscr","𝔐":"Mfr","𝕄":"Mopf","ℳ":"Mscr","𝔫":"nfr","𝕟":"nopf","𝓃":"nscr","ℕ":"Nopf","𝒩":"Nscr","𝔑":"Nfr","ń":"nacute","Ń":"Nacute","ň":"ncaron","Ň":"Ncaron","ñ":"ntilde","Ñ":"Ntilde","ņ":"ncedil","Ņ":"Ncedil","№":"numero","ŋ":"eng","Ŋ":"ENG","𝕠":"oopf","𝔬":"ofr","ℴ":"oscr","𝒪":"Oscr","𝔒":"Ofr","𝕆":"Oopf","º":"ordm","ó":"oacute","Ó":"Oacute","ò":"ograve","Ò":"Ograve","ô":"ocirc","Ô":"Ocirc","ö":"ouml","Ö":"Ouml","ő":"odblac","Ő":"Odblac","õ":"otilde","Õ":"Otilde","ø":"oslash","Ø":"Oslash","ō":"omacr","Ō":"Omacr","œ":"oelig","Œ":"OElig","𝔭":"pfr","𝓅":"pscr","𝕡":"popf","ℙ":"Popf","𝔓":"Pfr","𝒫":"Pscr","𝕢":"qopf","𝔮":"qfr","𝓆":"qscr","𝒬":"Qscr","𝔔":"Qfr","ℚ":"Qopf","ĸ":"kgreen","𝔯":"rfr","𝕣":"ropf","𝓇":"rscr","ℛ":"Rscr","ℜ":"Re","ℝ":"Ropf","ŕ":"racute","Ŕ":"Racute","ř":"rcaron","Ř":"Rcaron","ŗ":"rcedil","Ŗ":"Rcedil","𝕤":"sopf","𝓈":"sscr","𝔰":"sfr","𝕊":"Sopf","𝔖":"Sfr","𝒮":"Sscr","Ⓢ":"oS","ś":"sacute","Ś":"Sacute","ŝ":"scirc","Ŝ":"Scirc","š":"scaron","Š":"Scaron","ş":"scedil","Ş":"Scedil","ß":"szlig","𝔱":"tfr","𝓉":"tscr","𝕥":"topf","𝒯":"Tscr","𝔗":"Tfr","𝕋":"Topf","ť":"tcaron","Ť":"Tcaron","ţ":"tcedil","Ţ":"Tcedil","™":"trade","ŧ":"tstrok","Ŧ":"Tstrok","𝓊":"uscr","𝕦":"uopf","𝔲":"ufr","𝕌":"Uopf","𝔘":"Ufr","𝒰":"Uscr","ú":"uacute","Ú":"Uacute","ù":"ugrave","Ù":"Ugrave","ŭ":"ubreve","Ŭ":"Ubreve","û":"ucirc","Û":"Ucirc","ů":"uring","Ů":"Uring","ü":"uuml","Ü":"Uuml","ű":"udblac","Ű":"Udblac","ũ":"utilde","Ũ":"Utilde","ų":"uogon","Ų":"Uogon","ū":"umacr","Ū":"Umacr","𝔳":"vfr","𝕧":"vopf","𝓋":"vscr","𝔙":"Vfr","𝕍":"Vopf","𝒱":"Vscr","𝕨":"wopf","𝓌":"wscr","𝔴":"wfr","𝒲":"Wscr","𝕎":"Wopf","𝔚":"Wfr","ŵ":"wcirc","Ŵ":"Wcirc","𝔵":"xfr","𝓍":"xscr","𝕩":"xopf","𝕏":"Xopf","𝔛":"Xfr","𝒳":"Xscr","𝔶":"yfr","𝓎":"yscr","𝕪":"yopf","𝒴":"Yscr","𝔜":"Yfr","𝕐":"Yopf","ý":"yacute","Ý":"Yacute","ŷ":"ycirc","Ŷ":"Ycirc","ÿ":"yuml","Ÿ":"Yuml","𝓏":"zscr","𝔷":"zfr","𝕫":"zopf","ℨ":"Zfr","ℤ":"Zopf","𝒵":"Zscr","ź":"zacute","Ź":"Zacute","ž":"zcaron","Ž":"Zcaron","ż":"zdot","Ż":"Zdot","Ƶ":"imped","þ":"thorn","Þ":"THORN","ŉ":"napos","α":"alpha","Α":"Alpha","β":"beta","Β":"Beta","γ":"gamma","Γ":"Gamma","δ":"delta","Δ":"Delta","ε":"epsi","ϵ":"epsiv","Ε":"Epsilon","ϝ":"gammad","Ϝ":"Gammad","ζ":"zeta","Ζ":"Zeta","η":"eta","Η":"Eta","θ":"theta","ϑ":"thetav","Θ":"Theta","ι":"iota","Ι":"Iota","κ":"kappa","ϰ":"kappav","Κ":"Kappa","λ":"lambda","Λ":"Lambda","μ":"mu","µ":"micro","Μ":"Mu","ν":"nu","Ν":"Nu","ξ":"xi","Ξ":"Xi","ο":"omicron","Ο":"Omicron","π":"pi","ϖ":"piv","Π":"Pi","ρ":"rho","ϱ":"rhov","Ρ":"Rho","σ":"sigma","Σ":"Sigma","ς":"sigmaf","τ":"tau","Τ":"Tau","υ":"upsi","Υ":"Upsilon","ϒ":"Upsi","φ":"phi","ϕ":"phiv","Φ":"Phi","χ":"chi","Χ":"Chi","ψ":"psi","Ψ":"Psi","ω":"omega","Ω":"ohm","а":"acy","А":"Acy","б":"bcy","Б":"Bcy","в":"vcy","В":"Vcy","г":"gcy","Г":"Gcy","ѓ":"gjcy","Ѓ":"GJcy","д":"dcy","Д":"Dcy","ђ":"djcy","Ђ":"DJcy","е":"iecy","Е":"IEcy","ё":"iocy","Ё":"IOcy","є":"jukcy","Є":"Jukcy","ж":"zhcy","Ж":"ZHcy","з":"zcy","З":"Zcy","ѕ":"dscy","Ѕ":"DScy","и":"icy","И":"Icy","і":"iukcy","І":"Iukcy","ї":"yicy","Ї":"YIcy","й":"jcy","Й":"Jcy","ј":"jsercy","Ј":"Jsercy","к":"kcy","К":"Kcy","ќ":"kjcy","Ќ":"KJcy","л":"lcy","Л":"Lcy","љ":"ljcy","Љ":"LJcy","м":"mcy","М":"Mcy","н":"ncy","Н":"Ncy","њ":"njcy","Њ":"NJcy","о":"ocy","О":"Ocy","п":"pcy","П":"Pcy","р":"rcy","Р":"Rcy","с":"scy","С":"Scy","т":"tcy","Т":"Tcy","ћ":"tshcy","Ћ":"TSHcy","у":"ucy","У":"Ucy","ў":"ubrcy","Ў":"Ubrcy","ф":"fcy","Ф":"Fcy","х":"khcy","Х":"KHcy","ц":"tscy","Ц":"TScy","ч":"chcy","Ч":"CHcy","џ":"dzcy","Џ":"DZcy","ш":"shcy","Ш":"SHcy","щ":"shchcy","Щ":"SHCHcy","ъ":"hardcy","Ъ":"HARDcy","ы":"ycy","Ы":"Ycy","ь":"softcy","Ь":"SOFTcy","э":"ecy","Э":"Ecy","ю":"yucy","Ю":"YUcy","я":"yacy","Я":"YAcy","ℵ":"aleph","ℶ":"beth","ℷ":"gimel","ℸ":"daleth"},p=/["&'<>`]/g,d={'"':"&quot;","&":"&amp;","'":"&#x27;","<":"&lt;",">":"&gt;","`":"&#x60;"},f=/&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/,m=/[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/,g=/&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g,h={aacute:"á",Aacute:"Á",abreve:"ă",Abreve:"Ă",ac:"∾",acd:"∿",acE:"∾̳",acirc:"â",Acirc:"Â",acute:"´",acy:"а",Acy:"А",aelig:"æ",AElig:"Æ",af:"⁡",afr:"𝔞",Afr:"𝔄",agrave:"à",Agrave:"À",alefsym:"ℵ",aleph:"ℵ",alpha:"α",Alpha:"Α",amacr:"ā",Amacr:"Ā",amalg:"⨿",amp:"&",AMP:"&",and:"∧",And:"⩓",andand:"⩕",andd:"⩜",andslope:"⩘",andv:"⩚",ang:"∠",ange:"⦤",angle:"∠",angmsd:"∡",angmsdaa:"⦨",angmsdab:"⦩",angmsdac:"⦪",angmsdad:"⦫",angmsdae:"⦬",angmsdaf:"⦭",angmsdag:"⦮",angmsdah:"⦯",angrt:"∟",angrtvb:"⊾",angrtvbd:"⦝",angsph:"∢",angst:"Å",angzarr:"⍼",aogon:"ą",Aogon:"Ą",aopf:"𝕒",Aopf:"𝔸",ap:"≈",apacir:"⩯",ape:"≊",apE:"⩰",apid:"≋",apos:"'",ApplyFunction:"⁡",approx:"≈",approxeq:"≊",aring:"å",Aring:"Å",ascr:"𝒶",Ascr:"𝒜",Assign:"≔",ast:"*",asymp:"≈",asympeq:"≍",atilde:"ã",Atilde:"Ã",auml:"ä",Auml:"Ä",awconint:"∳",awint:"⨑",backcong:"≌",backepsilon:"϶",backprime:"‵",backsim:"∽",backsimeq:"⋍",Backslash:"∖",Barv:"⫧",barvee:"⊽",barwed:"⌅",Barwed:"⌆",barwedge:"⌅",bbrk:"⎵",bbrktbrk:"⎶",bcong:"≌",bcy:"б",Bcy:"Б",bdquo:"„",becaus:"∵",because:"∵",Because:"∵",bemptyv:"⦰",bepsi:"϶",bernou:"ℬ",Bernoullis:"ℬ",beta:"β",Beta:"Β",beth:"ℶ",between:"≬",bfr:"𝔟",Bfr:"𝔅",bigcap:"⋂",bigcirc:"◯",bigcup:"⋃",bigodot:"⨀",bigoplus:"⨁",bigotimes:"⨂",bigsqcup:"⨆",bigstar:"★",bigtriangledown:"▽",bigtriangleup:"△",biguplus:"⨄",bigvee:"⋁",bigwedge:"⋀",bkarow:"⤍",blacklozenge:"⧫",blacksquare:"▪",blacktriangle:"▴",blacktriangledown:"▾",blacktriangleleft:"◂",blacktriangleright:"▸",blank:"␣",blk12:"▒",blk14:"░",blk34:"▓",block:"█",bne:"=⃥",bnequiv:"≡⃥",bnot:"⌐",bNot:"⫭",bopf:"𝕓",Bopf:"𝔹",bot:"⊥",bottom:"⊥",bowtie:"⋈",boxbox:"⧉",boxdl:"┐",boxdL:"╕",boxDl:"╖",boxDL:"╗",boxdr:"┌",boxdR:"╒",boxDr:"╓",boxDR:"╔",boxh:"─",boxH:"═",boxhd:"┬",boxhD:"╥",boxHd:"╤",boxHD:"╦",boxhu:"┴",boxhU:"╨",boxHu:"╧",boxHU:"╩",boxminus:"⊟",boxplus:"⊞",boxtimes:"⊠",boxul:"┘",boxuL:"╛",boxUl:"╜",boxUL:"╝",boxur:"└",boxuR:"╘",boxUr:"╙",boxUR:"╚",boxv:"│",boxV:"║",boxvh:"┼",boxvH:"╪",boxVh:"╫",boxVH:"╬",boxvl:"┤",boxvL:"╡",boxVl:"╢",boxVL:"╣",boxvr:"├",boxvR:"╞",boxVr:"╟",boxVR:"╠",bprime:"‵",breve:"˘",Breve:"˘",brvbar:"¦",bscr:"𝒷",Bscr:"ℬ",bsemi:"⁏",bsim:"∽",bsime:"⋍",bsol:"\\",bsolb:"⧅",bsolhsub:"⟈",bull:"•",bullet:"•",bump:"≎",bumpe:"≏",bumpE:"⪮",bumpeq:"≏",Bumpeq:"≎",cacute:"ć",Cacute:"Ć",cap:"∩",Cap:"⋒",capand:"⩄",capbrcup:"⩉",capcap:"⩋",capcup:"⩇",capdot:"⩀",CapitalDifferentialD:"ⅅ",caps:"∩︀",caret:"⁁",caron:"ˇ",Cayleys:"ℭ",ccaps:"⩍",ccaron:"č",Ccaron:"Č",ccedil:"ç",Ccedil:"Ç",ccirc:"ĉ",Ccirc:"Ĉ",Cconint:"∰",ccups:"⩌",ccupssm:"⩐",cdot:"ċ",Cdot:"Ċ",cedil:"¸",Cedilla:"¸",cemptyv:"⦲",cent:"¢",centerdot:"·",CenterDot:"·",cfr:"𝔠",Cfr:"ℭ",chcy:"ч",CHcy:"Ч",check:"✓",checkmark:"✓",chi:"χ",Chi:"Χ",cir:"○",circ:"ˆ",circeq:"≗",circlearrowleft:"↺",circlearrowright:"↻",circledast:"⊛",circledcirc:"⊚",circleddash:"⊝",CircleDot:"⊙",circledR:"®",circledS:"Ⓢ",CircleMinus:"⊖",CirclePlus:"⊕",CircleTimes:"⊗",cire:"≗",cirE:"⧃",cirfnint:"⨐",cirmid:"⫯",cirscir:"⧂",ClockwiseContourIntegral:"∲",CloseCurlyDoubleQuote:"”",CloseCurlyQuote:"’",clubs:"♣",clubsuit:"♣",colon:":",Colon:"∷",colone:"≔",Colone:"⩴",coloneq:"≔",comma:",",commat:"@",comp:"∁",compfn:"∘",complement:"∁",complexes:"ℂ",cong:"≅",congdot:"⩭",Congruent:"≡",conint:"∮",Conint:"∯",ContourIntegral:"∮",copf:"𝕔",Copf:"ℂ",coprod:"∐",Coproduct:"∐",copy:"©",COPY:"©",copysr:"℗",CounterClockwiseContourIntegral:"∳",crarr:"↵",cross:"✗",Cross:"⨯",cscr:"𝒸",Cscr:"𝒞",csub:"⫏",csube:"⫑",csup:"⫐",csupe:"⫒",ctdot:"⋯",cudarrl:"⤸",cudarrr:"⤵",cuepr:"⋞",cuesc:"⋟",cularr:"↶",cularrp:"⤽",cup:"∪",Cup:"⋓",cupbrcap:"⩈",cupcap:"⩆",CupCap:"≍",cupcup:"⩊",cupdot:"⊍",cupor:"⩅",cups:"∪︀",curarr:"↷",curarrm:"⤼",curlyeqprec:"⋞",curlyeqsucc:"⋟",curlyvee:"⋎",curlywedge:"⋏",curren:"¤",curvearrowleft:"↶",curvearrowright:"↷",cuvee:"⋎",cuwed:"⋏",cwconint:"∲",cwint:"∱",cylcty:"⌭",dagger:"†",Dagger:"‡",daleth:"ℸ",darr:"↓",dArr:"⇓",Darr:"↡",dash:"‐",dashv:"⊣",Dashv:"⫤",dbkarow:"⤏",dblac:"˝",dcaron:"ď",Dcaron:"Ď",dcy:"д",Dcy:"Д",dd:"ⅆ",DD:"ⅅ",ddagger:"‡",ddarr:"⇊",DDotrahd:"⤑",ddotseq:"⩷",deg:"°",Del:"∇",delta:"δ",Delta:"Δ",demptyv:"⦱",dfisht:"⥿",dfr:"𝔡",Dfr:"𝔇",dHar:"⥥",dharl:"⇃",dharr:"⇂",DiacriticalAcute:"´",DiacriticalDot:"˙",DiacriticalDoubleAcute:"˝",DiacriticalGrave:"`",DiacriticalTilde:"˜",diam:"⋄",diamond:"⋄",Diamond:"⋄",diamondsuit:"♦",diams:"♦",die:"¨",DifferentialD:"ⅆ",digamma:"ϝ",disin:"⋲",div:"÷",divide:"÷",divideontimes:"⋇",divonx:"⋇",djcy:"ђ",DJcy:"Ђ",dlcorn:"⌞",dlcrop:"⌍",dollar:"$",dopf:"𝕕",Dopf:"𝔻",dot:"˙",Dot:"¨",DotDot:"⃜",doteq:"≐",doteqdot:"≑",DotEqual:"≐",dotminus:"∸",dotplus:"∔",dotsquare:"⊡",doublebarwedge:"⌆",DoubleContourIntegral:"∯",DoubleDot:"¨",DoubleDownArrow:"⇓",DoubleLeftArrow:"⇐",DoubleLeftRightArrow:"⇔",DoubleLeftTee:"⫤",DoubleLongLeftArrow:"⟸",DoubleLongLeftRightArrow:"⟺",DoubleLongRightArrow:"⟹",DoubleRightArrow:"⇒",DoubleRightTee:"⊨",DoubleUpArrow:"⇑",DoubleUpDownArrow:"⇕",DoubleVerticalBar:"∥",downarrow:"↓",Downarrow:"⇓",DownArrow:"↓",DownArrowBar:"⤓",DownArrowUpArrow:"⇵",DownBreve:"̑",downdownarrows:"⇊",downharpoonleft:"⇃",downharpoonright:"⇂",DownLeftRightVector:"⥐",DownLeftTeeVector:"⥞",DownLeftVector:"↽",DownLeftVectorBar:"⥖",DownRightTeeVector:"⥟",DownRightVector:"⇁",DownRightVectorBar:"⥗",DownTee:"⊤",DownTeeArrow:"↧",drbkarow:"⤐",drcorn:"⌟",drcrop:"⌌",dscr:"𝒹",Dscr:"𝒟",dscy:"ѕ",DScy:"Ѕ",dsol:"⧶",dstrok:"đ",Dstrok:"Đ",dtdot:"⋱",dtri:"▿",dtrif:"▾",duarr:"⇵",duhar:"⥯",dwangle:"⦦",dzcy:"џ",DZcy:"Џ",dzigrarr:"⟿",eacute:"é",Eacute:"É",easter:"⩮",ecaron:"ě",Ecaron:"Ě",ecir:"≖",ecirc:"ê",Ecirc:"Ê",ecolon:"≕",ecy:"э",Ecy:"Э",eDDot:"⩷",edot:"ė",eDot:"≑",Edot:"Ė",ee:"ⅇ",efDot:"≒",efr:"𝔢",Efr:"𝔈",eg:"⪚",egrave:"è",Egrave:"È",egs:"⪖",egsdot:"⪘",el:"⪙",Element:"∈",elinters:"⏧",ell:"ℓ",els:"⪕",elsdot:"⪗",emacr:"ē",Emacr:"Ē",empty:"∅",emptyset:"∅",EmptySmallSquare:"◻",emptyv:"∅",EmptyVerySmallSquare:"▫",emsp:" ",emsp13:" ",emsp14:" ",eng:"ŋ",ENG:"Ŋ",ensp:" ",eogon:"ę",Eogon:"Ę",eopf:"𝕖",Eopf:"𝔼",epar:"⋕",eparsl:"⧣",eplus:"⩱",epsi:"ε",epsilon:"ε",Epsilon:"Ε",epsiv:"ϵ",eqcirc:"≖",eqcolon:"≕",eqsim:"≂",eqslantgtr:"⪖",eqslantless:"⪕",Equal:"⩵",equals:"=",EqualTilde:"≂",equest:"≟",Equilibrium:"⇌",equiv:"≡",equivDD:"⩸",eqvparsl:"⧥",erarr:"⥱",erDot:"≓",escr:"ℯ",Escr:"ℰ",esdot:"≐",esim:"≂",Esim:"⩳",eta:"η",Eta:"Η",eth:"ð",ETH:"Ð",euml:"ë",Euml:"Ë",euro:"€",excl:"!",exist:"∃",Exists:"∃",expectation:"ℰ",exponentiale:"ⅇ",ExponentialE:"ⅇ",fallingdotseq:"≒",fcy:"ф",Fcy:"Ф",female:"♀",ffilig:"ﬃ",fflig:"ﬀ",ffllig:"ﬄ",ffr:"𝔣",Ffr:"𝔉",filig:"ﬁ",FilledSmallSquare:"◼",FilledVerySmallSquare:"▪",fjlig:"fj",flat:"♭",fllig:"ﬂ",fltns:"▱",fnof:"ƒ",fopf:"𝕗",Fopf:"𝔽",forall:"∀",ForAll:"∀",fork:"⋔",forkv:"⫙",Fouriertrf:"ℱ",fpartint:"⨍",frac12:"½",frac13:"⅓",frac14:"¼",frac15:"⅕",frac16:"⅙",frac18:"⅛",frac23:"⅔",frac25:"⅖",frac34:"¾",frac35:"⅗",frac38:"⅜",frac45:"⅘",frac56:"⅚",frac58:"⅝",frac78:"⅞",frasl:"⁄",frown:"⌢",fscr:"𝒻",Fscr:"ℱ",gacute:"ǵ",gamma:"γ",Gamma:"Γ",gammad:"ϝ",Gammad:"Ϝ",gap:"⪆",gbreve:"ğ",Gbreve:"Ğ",Gcedil:"Ģ",gcirc:"ĝ",Gcirc:"Ĝ",gcy:"г",Gcy:"Г",gdot:"ġ",Gdot:"Ġ",ge:"≥",gE:"≧",gel:"⋛",gEl:"⪌",geq:"≥",geqq:"≧",geqslant:"⩾",ges:"⩾",gescc:"⪩",gesdot:"⪀",gesdoto:"⪂",gesdotol:"⪄",gesl:"⋛︀",gesles:"⪔",gfr:"𝔤",Gfr:"𝔊",gg:"≫",Gg:"⋙",ggg:"⋙",gimel:"ℷ",gjcy:"ѓ",GJcy:"Ѓ",gl:"≷",gla:"⪥",glE:"⪒",glj:"⪤",gnap:"⪊",gnapprox:"⪊",gne:"⪈",gnE:"≩",gneq:"⪈",gneqq:"≩",gnsim:"⋧",gopf:"𝕘",Gopf:"𝔾",grave:"`",GreaterEqual:"≥",GreaterEqualLess:"⋛",GreaterFullEqual:"≧",GreaterGreater:"⪢",GreaterLess:"≷",GreaterSlantEqual:"⩾",GreaterTilde:"≳",gscr:"ℊ",Gscr:"𝒢",gsim:"≳",gsime:"⪎",gsiml:"⪐",gt:">",Gt:"≫",GT:">",gtcc:"⪧",gtcir:"⩺",gtdot:"⋗",gtlPar:"⦕",gtquest:"⩼",gtrapprox:"⪆",gtrarr:"⥸",gtrdot:"⋗",gtreqless:"⋛",gtreqqless:"⪌",gtrless:"≷",gtrsim:"≳",gvertneqq:"≩︀",gvnE:"≩︀",Hacek:"ˇ",hairsp:" ",half:"½",hamilt:"ℋ",hardcy:"ъ",HARDcy:"Ъ",harr:"↔",hArr:"⇔",harrcir:"⥈",harrw:"↭",Hat:"^",hbar:"ℏ",hcirc:"ĥ",Hcirc:"Ĥ",hearts:"♥",heartsuit:"♥",hellip:"…",hercon:"⊹",hfr:"𝔥",Hfr:"ℌ",HilbertSpace:"ℋ",hksearow:"⤥",hkswarow:"⤦",hoarr:"⇿",homtht:"∻",hookleftarrow:"↩",hookrightarrow:"↪",hopf:"𝕙",Hopf:"ℍ",horbar:"―",HorizontalLine:"─",hscr:"𝒽",Hscr:"ℋ",hslash:"ℏ",hstrok:"ħ",Hstrok:"Ħ",HumpDownHump:"≎",HumpEqual:"≏",hybull:"⁃",hyphen:"‐",iacute:"í",Iacute:"Í",ic:"⁣",icirc:"î",Icirc:"Î",icy:"и",Icy:"И",Idot:"İ",iecy:"е",IEcy:"Е",iexcl:"¡",iff:"⇔",ifr:"𝔦",Ifr:"ℑ",igrave:"ì",Igrave:"Ì",ii:"ⅈ",iiiint:"⨌",iiint:"∭",iinfin:"⧜",iiota:"℩",ijlig:"ĳ",IJlig:"Ĳ",Im:"ℑ",imacr:"ī",Imacr:"Ī",image:"ℑ",ImaginaryI:"ⅈ",imagline:"ℐ",imagpart:"ℑ",imath:"ı",imof:"⊷",imped:"Ƶ",Implies:"⇒",in:"∈",incare:"℅",infin:"∞",infintie:"⧝",inodot:"ı",int:"∫",Int:"∬",intcal:"⊺",integers:"ℤ",Integral:"∫",intercal:"⊺",Intersection:"⋂",intlarhk:"⨗",intprod:"⨼",InvisibleComma:"⁣",InvisibleTimes:"⁢",iocy:"ё",IOcy:"Ё",iogon:"į",Iogon:"Į",iopf:"𝕚",Iopf:"𝕀",iota:"ι",Iota:"Ι",iprod:"⨼",iquest:"¿",iscr:"𝒾",Iscr:"ℐ",isin:"∈",isindot:"⋵",isinE:"⋹",isins:"⋴",isinsv:"⋳",isinv:"∈",it:"⁢",itilde:"ĩ",Itilde:"Ĩ",iukcy:"і",Iukcy:"І",iuml:"ï",Iuml:"Ï",jcirc:"ĵ",Jcirc:"Ĵ",jcy:"й",Jcy:"Й",jfr:"𝔧",Jfr:"𝔍",jmath:"ȷ",jopf:"𝕛",Jopf:"𝕁",jscr:"𝒿",Jscr:"𝒥",jsercy:"ј",Jsercy:"Ј",jukcy:"є",Jukcy:"Є",kappa:"κ",Kappa:"Κ",kappav:"ϰ",kcedil:"ķ",Kcedil:"Ķ",kcy:"к",Kcy:"К",kfr:"𝔨",Kfr:"𝔎",kgreen:"ĸ",khcy:"х",KHcy:"Х",kjcy:"ќ",KJcy:"Ќ",kopf:"𝕜",Kopf:"𝕂",kscr:"𝓀",Kscr:"𝒦",lAarr:"⇚",lacute:"ĺ",Lacute:"Ĺ",laemptyv:"⦴",lagran:"ℒ",lambda:"λ",Lambda:"Λ",lang:"⟨",Lang:"⟪",langd:"⦑",langle:"⟨",lap:"⪅",Laplacetrf:"ℒ",laquo:"«",larr:"←",lArr:"⇐",Larr:"↞",larrb:"⇤",larrbfs:"⤟",larrfs:"⤝",larrhk:"↩",larrlp:"↫",larrpl:"⤹",larrsim:"⥳",larrtl:"↢",lat:"⪫",latail:"⤙",lAtail:"⤛",late:"⪭",lates:"⪭︀",lbarr:"⤌",lBarr:"⤎",lbbrk:"❲",lbrace:"{",lbrack:"[",lbrke:"⦋",lbrksld:"⦏",lbrkslu:"⦍",lcaron:"ľ",Lcaron:"Ľ",lcedil:"ļ",Lcedil:"Ļ",lceil:"⌈",lcub:"{",lcy:"л",Lcy:"Л",ldca:"⤶",ldquo:"“",ldquor:"„",ldrdhar:"⥧",ldrushar:"⥋",ldsh:"↲",le:"≤",lE:"≦",LeftAngleBracket:"⟨",leftarrow:"←",Leftarrow:"⇐",LeftArrow:"←",LeftArrowBar:"⇤",LeftArrowRightArrow:"⇆",leftarrowtail:"↢",LeftCeiling:"⌈",LeftDoubleBracket:"⟦",LeftDownTeeVector:"⥡",LeftDownVector:"⇃",LeftDownVectorBar:"⥙",LeftFloor:"⌊",leftharpoondown:"↽",leftharpoonup:"↼",leftleftarrows:"⇇",leftrightarrow:"↔",Leftrightarrow:"⇔",LeftRightArrow:"↔",leftrightarrows:"⇆",leftrightharpoons:"⇋",leftrightsquigarrow:"↭",LeftRightVector:"⥎",LeftTee:"⊣",LeftTeeArrow:"↤",LeftTeeVector:"⥚",leftthreetimes:"⋋",LeftTriangle:"⊲",LeftTriangleBar:"⧏",LeftTriangleEqual:"⊴",LeftUpDownVector:"⥑",LeftUpTeeVector:"⥠",LeftUpVector:"↿",LeftUpVectorBar:"⥘",LeftVector:"↼",LeftVectorBar:"⥒",leg:"⋚",lEg:"⪋",leq:"≤",leqq:"≦",leqslant:"⩽",les:"⩽",lescc:"⪨",lesdot:"⩿",lesdoto:"⪁",lesdotor:"⪃",lesg:"⋚︀",lesges:"⪓",lessapprox:"⪅",lessdot:"⋖",lesseqgtr:"⋚",lesseqqgtr:"⪋",LessEqualGreater:"⋚",LessFullEqual:"≦",LessGreater:"≶",lessgtr:"≶",LessLess:"⪡",lesssim:"≲",LessSlantEqual:"⩽",LessTilde:"≲",lfisht:"⥼",lfloor:"⌊",lfr:"𝔩",Lfr:"𝔏",lg:"≶",lgE:"⪑",lHar:"⥢",lhard:"↽",lharu:"↼",lharul:"⥪",lhblk:"▄",ljcy:"љ",LJcy:"Љ",ll:"≪",Ll:"⋘",llarr:"⇇",llcorner:"⌞",Lleftarrow:"⇚",llhard:"⥫",lltri:"◺",lmidot:"ŀ",Lmidot:"Ŀ",lmoust:"⎰",lmoustache:"⎰",lnap:"⪉",lnapprox:"⪉",lne:"⪇",lnE:"≨",lneq:"⪇",lneqq:"≨",lnsim:"⋦",loang:"⟬",loarr:"⇽",lobrk:"⟦",longleftarrow:"⟵",Longleftarrow:"⟸",LongLeftArrow:"⟵",longleftrightarrow:"⟷",Longleftrightarrow:"⟺",LongLeftRightArrow:"⟷",longmapsto:"⟼",longrightarrow:"⟶",Longrightarrow:"⟹",LongRightArrow:"⟶",looparrowleft:"↫",looparrowright:"↬",lopar:"⦅",lopf:"𝕝",Lopf:"𝕃",loplus:"⨭",lotimes:"⨴",lowast:"∗",lowbar:"_",LowerLeftArrow:"↙",LowerRightArrow:"↘",loz:"◊",lozenge:"◊",lozf:"⧫",lpar:"(",lparlt:"⦓",lrarr:"⇆",lrcorner:"⌟",lrhar:"⇋",lrhard:"⥭",lrm:"‎",lrtri:"⊿",lsaquo:"‹",lscr:"𝓁",Lscr:"ℒ",lsh:"↰",Lsh:"↰",lsim:"≲",lsime:"⪍",lsimg:"⪏",lsqb:"[",lsquo:"‘",lsquor:"‚",lstrok:"ł",Lstrok:"Ł",lt:"<",Lt:"≪",LT:"<",ltcc:"⪦",ltcir:"⩹",ltdot:"⋖",lthree:"⋋",ltimes:"⋉",ltlarr:"⥶",ltquest:"⩻",ltri:"◃",ltrie:"⊴",ltrif:"◂",ltrPar:"⦖",lurdshar:"⥊",luruhar:"⥦",lvertneqq:"≨︀",lvnE:"≨︀",macr:"¯",male:"♂",malt:"✠",maltese:"✠",map:"↦",Map:"⤅",mapsto:"↦",mapstodown:"↧",mapstoleft:"↤",mapstoup:"↥",marker:"▮",mcomma:"⨩",mcy:"м",Mcy:"М",mdash:"—",mDDot:"∺",measuredangle:"∡",MediumSpace:" ",Mellintrf:"ℳ",mfr:"𝔪",Mfr:"𝔐",mho:"℧",micro:"µ",mid:"∣",midast:"*",midcir:"⫰",middot:"·",minus:"−",minusb:"⊟",minusd:"∸",minusdu:"⨪",MinusPlus:"∓",mlcp:"⫛",mldr:"…",mnplus:"∓",models:"⊧",mopf:"𝕞",Mopf:"𝕄",mp:"∓",mscr:"𝓂",Mscr:"ℳ",mstpos:"∾",mu:"μ",Mu:"Μ",multimap:"⊸",mumap:"⊸",nabla:"∇",nacute:"ń",Nacute:"Ń",nang:"∠⃒",nap:"≉",napE:"⩰̸",napid:"≋̸",napos:"ŉ",napprox:"≉",natur:"♮",natural:"♮",naturals:"ℕ",nbsp:" ",nbump:"≎̸",nbumpe:"≏̸",ncap:"⩃",ncaron:"ň",Ncaron:"Ň",ncedil:"ņ",Ncedil:"Ņ",ncong:"≇",ncongdot:"⩭̸",ncup:"⩂",ncy:"н",Ncy:"Н",ndash:"–",ne:"≠",nearhk:"⤤",nearr:"↗",neArr:"⇗",nearrow:"↗",nedot:"≐̸",NegativeMediumSpace:"​",NegativeThickSpace:"​",NegativeThinSpace:"​",NegativeVeryThinSpace:"​",nequiv:"≢",nesear:"⤨",nesim:"≂̸",NestedGreaterGreater:"≫",NestedLessLess:"≪",NewLine:"\n",nexist:"∄",nexists:"∄",nfr:"𝔫",Nfr:"𝔑",nge:"≱",ngE:"≧̸",ngeq:"≱",ngeqq:"≧̸",ngeqslant:"⩾̸",nges:"⩾̸",nGg:"⋙̸",ngsim:"≵",ngt:"≯",nGt:"≫⃒",ngtr:"≯",nGtv:"≫̸",nharr:"↮",nhArr:"⇎",nhpar:"⫲",ni:"∋",nis:"⋼",nisd:"⋺",niv:"∋",njcy:"њ",NJcy:"Њ",nlarr:"↚",nlArr:"⇍",nldr:"‥",nle:"≰",nlE:"≦̸",nleftarrow:"↚",nLeftarrow:"⇍",nleftrightarrow:"↮",nLeftrightarrow:"⇎",nleq:"≰",nleqq:"≦̸",nleqslant:"⩽̸",nles:"⩽̸",nless:"≮",nLl:"⋘̸",nlsim:"≴",nlt:"≮",nLt:"≪⃒",nltri:"⋪",nltrie:"⋬",nLtv:"≪̸",nmid:"∤",NoBreak:"⁠",NonBreakingSpace:" ",nopf:"𝕟",Nopf:"ℕ",not:"¬",Not:"⫬",NotCongruent:"≢",NotCupCap:"≭",NotDoubleVerticalBar:"∦",NotElement:"∉",NotEqual:"≠",NotEqualTilde:"≂̸",NotExists:"∄",NotGreater:"≯",NotGreaterEqual:"≱",NotGreaterFullEqual:"≧̸",NotGreaterGreater:"≫̸",NotGreaterLess:"≹",NotGreaterSlantEqual:"⩾̸",NotGreaterTilde:"≵",NotHumpDownHump:"≎̸",NotHumpEqual:"≏̸",notin:"∉",notindot:"⋵̸",notinE:"⋹̸",notinva:"∉",notinvb:"⋷",notinvc:"⋶",NotLeftTriangle:"⋪",NotLeftTriangleBar:"⧏̸",NotLeftTriangleEqual:"⋬",NotLess:"≮",NotLessEqual:"≰",NotLessGreater:"≸",NotLessLess:"≪̸",NotLessSlantEqual:"⩽̸",NotLessTilde:"≴",NotNestedGreaterGreater:"⪢̸",NotNestedLessLess:"⪡̸",notni:"∌",notniva:"∌",notnivb:"⋾",notnivc:"⋽",NotPrecedes:"⊀",NotPrecedesEqual:"⪯̸",NotPrecedesSlantEqual:"⋠",NotReverseElement:"∌",NotRightTriangle:"⋫",NotRightTriangleBar:"⧐̸",NotRightTriangleEqual:"⋭",NotSquareSubset:"⊏̸",NotSquareSubsetEqual:"⋢",NotSquareSuperset:"⊐̸",NotSquareSupersetEqual:"⋣",NotSubset:"⊂⃒",NotSubsetEqual:"⊈",NotSucceeds:"⊁",NotSucceedsEqual:"⪰̸",NotSucceedsSlantEqual:"⋡",NotSucceedsTilde:"≿̸",NotSuperset:"⊃⃒",NotSupersetEqual:"⊉",NotTilde:"≁",NotTildeEqual:"≄",NotTildeFullEqual:"≇",NotTildeTilde:"≉",NotVerticalBar:"∤",npar:"∦",nparallel:"∦",nparsl:"⫽⃥",npart:"∂̸",npolint:"⨔",npr:"⊀",nprcue:"⋠",npre:"⪯̸",nprec:"⊀",npreceq:"⪯̸",nrarr:"↛",nrArr:"⇏",nrarrc:"⤳̸",nrarrw:"↝̸",nrightarrow:"↛",nRightarrow:"⇏",nrtri:"⋫",nrtrie:"⋭",nsc:"⊁",nsccue:"⋡",nsce:"⪰̸",nscr:"𝓃",Nscr:"𝒩",nshortmid:"∤",nshortparallel:"∦",nsim:"≁",nsime:"≄",nsimeq:"≄",nsmid:"∤",nspar:"∦",nsqsube:"⋢",nsqsupe:"⋣",nsub:"⊄",nsube:"⊈",nsubE:"⫅̸",nsubset:"⊂⃒",nsubseteq:"⊈",nsubseteqq:"⫅̸",nsucc:"⊁",nsucceq:"⪰̸",nsup:"⊅",nsupe:"⊉",nsupE:"⫆̸",nsupset:"⊃⃒",nsupseteq:"⊉",nsupseteqq:"⫆̸",ntgl:"≹",ntilde:"ñ",Ntilde:"Ñ",ntlg:"≸",ntriangleleft:"⋪",ntrianglelefteq:"⋬",ntriangleright:"⋫",ntrianglerighteq:"⋭",nu:"ν",Nu:"Ν",num:"#",numero:"№",numsp:" ",nvap:"≍⃒",nvdash:"⊬",nvDash:"⊭",nVdash:"⊮",nVDash:"⊯",nvge:"≥⃒",nvgt:">⃒",nvHarr:"⤄",nvinfin:"⧞",nvlArr:"⤂",nvle:"≤⃒",nvlt:"<⃒",nvltrie:"⊴⃒",nvrArr:"⤃",nvrtrie:"⊵⃒",nvsim:"∼⃒",nwarhk:"⤣",nwarr:"↖",nwArr:"⇖",nwarrow:"↖",nwnear:"⤧",oacute:"ó",Oacute:"Ó",oast:"⊛",ocir:"⊚",ocirc:"ô",Ocirc:"Ô",ocy:"о",Ocy:"О",odash:"⊝",odblac:"ő",Odblac:"Ő",odiv:"⨸",odot:"⊙",odsold:"⦼",oelig:"œ",OElig:"Œ",ofcir:"⦿",ofr:"𝔬",Ofr:"𝔒",ogon:"˛",ograve:"ò",Ograve:"Ò",ogt:"⧁",ohbar:"⦵",ohm:"Ω",oint:"∮",olarr:"↺",olcir:"⦾",olcross:"⦻",oline:"‾",olt:"⧀",omacr:"ō",Omacr:"Ō",omega:"ω",Omega:"Ω",omicron:"ο",Omicron:"Ο",omid:"⦶",ominus:"⊖",oopf:"𝕠",Oopf:"𝕆",opar:"⦷",OpenCurlyDoubleQuote:"“",OpenCurlyQuote:"‘",operp:"⦹",oplus:"⊕",or:"∨",Or:"⩔",orarr:"↻",ord:"⩝",order:"ℴ",orderof:"ℴ",ordf:"ª",ordm:"º",origof:"⊶",oror:"⩖",orslope:"⩗",orv:"⩛",oS:"Ⓢ",oscr:"ℴ",Oscr:"𝒪",oslash:"ø",Oslash:"Ø",osol:"⊘",otilde:"õ",Otilde:"Õ",otimes:"⊗",Otimes:"⨷",otimesas:"⨶",ouml:"ö",Ouml:"Ö",ovbar:"⌽",OverBar:"‾",OverBrace:"⏞",OverBracket:"⎴",OverParenthesis:"⏜",par:"∥",para:"¶",parallel:"∥",parsim:"⫳",parsl:"⫽",part:"∂",PartialD:"∂",pcy:"п",Pcy:"П",percnt:"%",period:".",permil:"‰",perp:"⊥",pertenk:"‱",pfr:"𝔭",Pfr:"𝔓",phi:"φ",Phi:"Φ",phiv:"ϕ",phmmat:"ℳ",phone:"☎",pi:"π",Pi:"Π",pitchfork:"⋔",piv:"ϖ",planck:"ℏ",planckh:"ℎ",plankv:"ℏ",plus:"+",plusacir:"⨣",plusb:"⊞",pluscir:"⨢",plusdo:"∔",plusdu:"⨥",pluse:"⩲",PlusMinus:"±",plusmn:"±",plussim:"⨦",plustwo:"⨧",pm:"±",Poincareplane:"ℌ",pointint:"⨕",popf:"𝕡",Popf:"ℙ",pound:"£",pr:"≺",Pr:"⪻",prap:"⪷",prcue:"≼",pre:"⪯",prE:"⪳",prec:"≺",precapprox:"⪷",preccurlyeq:"≼",Precedes:"≺",PrecedesEqual:"⪯",PrecedesSlantEqual:"≼",PrecedesTilde:"≾",preceq:"⪯",precnapprox:"⪹",precneqq:"⪵",precnsim:"⋨",precsim:"≾",prime:"′",Prime:"″",primes:"ℙ",prnap:"⪹",prnE:"⪵",prnsim:"⋨",prod:"∏",Product:"∏",profalar:"⌮",profline:"⌒",profsurf:"⌓",prop:"∝",Proportion:"∷",Proportional:"∝",propto:"∝",prsim:"≾",prurel:"⊰",pscr:"𝓅",Pscr:"𝒫",psi:"ψ",Psi:"Ψ",puncsp:" ",qfr:"𝔮",Qfr:"𝔔",qint:"⨌",qopf:"𝕢",Qopf:"ℚ",qprime:"⁗",qscr:"𝓆",Qscr:"𝒬",quaternions:"ℍ",quatint:"⨖",quest:"?",questeq:"≟",quot:'"',QUOT:'"',rAarr:"⇛",race:"∽̱",racute:"ŕ",Racute:"Ŕ",radic:"√",raemptyv:"⦳",rang:"⟩",Rang:"⟫",rangd:"⦒",range:"⦥",rangle:"⟩",raquo:"»",rarr:"→",rArr:"⇒",Rarr:"↠",rarrap:"⥵",rarrb:"⇥",rarrbfs:"⤠",rarrc:"⤳",rarrfs:"⤞",rarrhk:"↪",rarrlp:"↬",rarrpl:"⥅",rarrsim:"⥴",rarrtl:"↣",Rarrtl:"⤖",rarrw:"↝",ratail:"⤚",rAtail:"⤜",ratio:"∶",rationals:"ℚ",rbarr:"⤍",rBarr:"⤏",RBarr:"⤐",rbbrk:"❳",rbrace:"}",rbrack:"]",rbrke:"⦌",rbrksld:"⦎",rbrkslu:"⦐",rcaron:"ř",Rcaron:"Ř",rcedil:"ŗ",Rcedil:"Ŗ",rceil:"⌉",rcub:"}",rcy:"р",Rcy:"Р",rdca:"⤷",rdldhar:"⥩",rdquo:"”",rdquor:"”",rdsh:"↳",Re:"ℜ",real:"ℜ",realine:"ℛ",realpart:"ℜ",reals:"ℝ",rect:"▭",reg:"®",REG:"®",ReverseElement:"∋",ReverseEquilibrium:"⇋",ReverseUpEquilibrium:"⥯",rfisht:"⥽",rfloor:"⌋",rfr:"𝔯",Rfr:"ℜ",rHar:"⥤",rhard:"⇁",rharu:"⇀",rharul:"⥬",rho:"ρ",Rho:"Ρ",rhov:"ϱ",RightAngleBracket:"⟩",rightarrow:"→",Rightarrow:"⇒",RightArrow:"→",RightArrowBar:"⇥",RightArrowLeftArrow:"⇄",rightarrowtail:"↣",RightCeiling:"⌉",RightDoubleBracket:"⟧",RightDownTeeVector:"⥝",RightDownVector:"⇂",RightDownVectorBar:"⥕",RightFloor:"⌋",rightharpoondown:"⇁",rightharpoonup:"⇀",rightleftarrows:"⇄",rightleftharpoons:"⇌",rightrightarrows:"⇉",rightsquigarrow:"↝",RightTee:"⊢",RightTeeArrow:"↦",RightTeeVector:"⥛",rightthreetimes:"⋌",RightTriangle:"⊳",RightTriangleBar:"⧐",RightTriangleEqual:"⊵",RightUpDownVector:"⥏",RightUpTeeVector:"⥜",RightUpVector:"↾",RightUpVectorBar:"⥔",RightVector:"⇀",RightVectorBar:"⥓",ring:"˚",risingdotseq:"≓",rlarr:"⇄",rlhar:"⇌",rlm:"‏",rmoust:"⎱",rmoustache:"⎱",rnmid:"⫮",roang:"⟭",roarr:"⇾",robrk:"⟧",ropar:"⦆",ropf:"𝕣",Ropf:"ℝ",roplus:"⨮",rotimes:"⨵",RoundImplies:"⥰",rpar:")",rpargt:"⦔",rppolint:"⨒",rrarr:"⇉",Rrightarrow:"⇛",rsaquo:"›",rscr:"𝓇",Rscr:"ℛ",rsh:"↱",Rsh:"↱",rsqb:"]",rsquo:"’",rsquor:"’",rthree:"⋌",rtimes:"⋊",rtri:"▹",rtrie:"⊵",rtrif:"▸",rtriltri:"⧎",RuleDelayed:"⧴",ruluhar:"⥨",rx:"℞",sacute:"ś",Sacute:"Ś",sbquo:"‚",sc:"≻",Sc:"⪼",scap:"⪸",scaron:"š",Scaron:"Š",sccue:"≽",sce:"⪰",scE:"⪴",scedil:"ş",Scedil:"Ş",scirc:"ŝ",Scirc:"Ŝ",scnap:"⪺",scnE:"⪶",scnsim:"⋩",scpolint:"⨓",scsim:"≿",scy:"с",Scy:"С",sdot:"⋅",sdotb:"⊡",sdote:"⩦",searhk:"⤥",searr:"↘",seArr:"⇘",searrow:"↘",sect:"§",semi:";",seswar:"⤩",setminus:"∖",setmn:"∖",sext:"✶",sfr:"𝔰",Sfr:"𝔖",sfrown:"⌢",sharp:"♯",shchcy:"щ",SHCHcy:"Щ",shcy:"ш",SHcy:"Ш",ShortDownArrow:"↓",ShortLeftArrow:"←",shortmid:"∣",shortparallel:"∥",ShortRightArrow:"→",ShortUpArrow:"↑",shy:"­",sigma:"σ",Sigma:"Σ",sigmaf:"ς",sigmav:"ς",sim:"∼",simdot:"⩪",sime:"≃",simeq:"≃",simg:"⪞",simgE:"⪠",siml:"⪝",simlE:"⪟",simne:"≆",simplus:"⨤",simrarr:"⥲",slarr:"←",SmallCircle:"∘",smallsetminus:"∖",smashp:"⨳",smeparsl:"⧤",smid:"∣",smile:"⌣",smt:"⪪",smte:"⪬",smtes:"⪬︀",softcy:"ь",SOFTcy:"Ь",sol:"/",solb:"⧄",solbar:"⌿",sopf:"𝕤",Sopf:"𝕊",spades:"♠",spadesuit:"♠",spar:"∥",sqcap:"⊓",sqcaps:"⊓︀",sqcup:"⊔",sqcups:"⊔︀",Sqrt:"√",sqsub:"⊏",sqsube:"⊑",sqsubset:"⊏",sqsubseteq:"⊑",sqsup:"⊐",sqsupe:"⊒",sqsupset:"⊐",sqsupseteq:"⊒",squ:"□",square:"□",Square:"□",SquareIntersection:"⊓",SquareSubset:"⊏",SquareSubsetEqual:"⊑",SquareSuperset:"⊐",SquareSupersetEqual:"⊒",SquareUnion:"⊔",squarf:"▪",squf:"▪",srarr:"→",sscr:"𝓈",Sscr:"𝒮",ssetmn:"∖",ssmile:"⌣",sstarf:"⋆",star:"☆",Star:"⋆",starf:"★",straightepsilon:"ϵ",straightphi:"ϕ",strns:"¯",sub:"⊂",Sub:"⋐",subdot:"⪽",sube:"⊆",subE:"⫅",subedot:"⫃",submult:"⫁",subne:"⊊",subnE:"⫋",subplus:"⪿",subrarr:"⥹",subset:"⊂",Subset:"⋐",subseteq:"⊆",subseteqq:"⫅",SubsetEqual:"⊆",subsetneq:"⊊",subsetneqq:"⫋",subsim:"⫇",subsub:"⫕",subsup:"⫓",succ:"≻",succapprox:"⪸",succcurlyeq:"≽",Succeeds:"≻",SucceedsEqual:"⪰",SucceedsSlantEqual:"≽",SucceedsTilde:"≿",succeq:"⪰",succnapprox:"⪺",succneqq:"⪶",succnsim:"⋩",succsim:"≿",SuchThat:"∋",sum:"∑",Sum:"∑",sung:"♪",sup:"⊃",Sup:"⋑",sup1:"¹",sup2:"²",sup3:"³",supdot:"⪾",supdsub:"⫘",supe:"⊇",supE:"⫆",supedot:"⫄",Superset:"⊃",SupersetEqual:"⊇",suphsol:"⟉",suphsub:"⫗",suplarr:"⥻",supmult:"⫂",supne:"⊋",supnE:"⫌",supplus:"⫀",supset:"⊃",Supset:"⋑",supseteq:"⊇",supseteqq:"⫆",supsetneq:"⊋",supsetneqq:"⫌",supsim:"⫈",supsub:"⫔",supsup:"⫖",swarhk:"⤦",swarr:"↙",swArr:"⇙",swarrow:"↙",swnwar:"⤪",szlig:"ß",Tab:"\t",target:"⌖",tau:"τ",Tau:"Τ",tbrk:"⎴",tcaron:"ť",Tcaron:"Ť",tcedil:"ţ",Tcedil:"Ţ",tcy:"т",Tcy:"Т",tdot:"⃛",telrec:"⌕",tfr:"𝔱",Tfr:"𝔗",there4:"∴",therefore:"∴",Therefore:"∴",theta:"θ",Theta:"Θ",thetasym:"ϑ",thetav:"ϑ",thickapprox:"≈",thicksim:"∼",ThickSpace:"  ",thinsp:" ",ThinSpace:" ",thkap:"≈",thksim:"∼",thorn:"þ",THORN:"Þ",tilde:"˜",Tilde:"∼",TildeEqual:"≃",TildeFullEqual:"≅",TildeTilde:"≈",times:"×",timesb:"⊠",timesbar:"⨱",timesd:"⨰",tint:"∭",toea:"⤨",top:"⊤",topbot:"⌶",topcir:"⫱",topf:"𝕥",Topf:"𝕋",topfork:"⫚",tosa:"⤩",tprime:"‴",trade:"™",TRADE:"™",triangle:"▵",triangledown:"▿",triangleleft:"◃",trianglelefteq:"⊴",triangleq:"≜",triangleright:"▹",trianglerighteq:"⊵",tridot:"◬",trie:"≜",triminus:"⨺",TripleDot:"⃛",triplus:"⨹",trisb:"⧍",tritime:"⨻",trpezium:"⏢",tscr:"𝓉",Tscr:"𝒯",tscy:"ц",TScy:"Ц",tshcy:"ћ",TSHcy:"Ћ",tstrok:"ŧ",Tstrok:"Ŧ",twixt:"≬",twoheadleftarrow:"↞",twoheadrightarrow:"↠",uacute:"ú",Uacute:"Ú",uarr:"↑",uArr:"⇑",Uarr:"↟",Uarrocir:"⥉",ubrcy:"ў",Ubrcy:"Ў",ubreve:"ŭ",Ubreve:"Ŭ",ucirc:"û",Ucirc:"Û",ucy:"у",Ucy:"У",udarr:"⇅",udblac:"ű",Udblac:"Ű",udhar:"⥮",ufisht:"⥾",ufr:"𝔲",Ufr:"𝔘",ugrave:"ù",Ugrave:"Ù",uHar:"⥣",uharl:"↿",uharr:"↾",uhblk:"▀",ulcorn:"⌜",ulcorner:"⌜",ulcrop:"⌏",ultri:"◸",umacr:"ū",Umacr:"Ū",uml:"¨",UnderBar:"_",UnderBrace:"⏟",UnderBracket:"⎵",UnderParenthesis:"⏝",Union:"⋃",UnionPlus:"⊎",uogon:"ų",Uogon:"Ų",uopf:"𝕦",Uopf:"𝕌",uparrow:"↑",Uparrow:"⇑",UpArrow:"↑",UpArrowBar:"⤒",UpArrowDownArrow:"⇅",updownarrow:"↕",Updownarrow:"⇕",UpDownArrow:"↕",UpEquilibrium:"⥮",upharpoonleft:"↿",upharpoonright:"↾",uplus:"⊎",UpperLeftArrow:"↖",UpperRightArrow:"↗",upsi:"υ",Upsi:"ϒ",upsih:"ϒ",upsilon:"υ",Upsilon:"Υ",UpTee:"⊥",UpTeeArrow:"↥",upuparrows:"⇈",urcorn:"⌝",urcorner:"⌝",urcrop:"⌎",uring:"ů",Uring:"Ů",urtri:"◹",uscr:"𝓊",Uscr:"𝒰",utdot:"⋰",utilde:"ũ",Utilde:"Ũ",utri:"▵",utrif:"▴",uuarr:"⇈",uuml:"ü",Uuml:"Ü",uwangle:"⦧",vangrt:"⦜",varepsilon:"ϵ",varkappa:"ϰ",varnothing:"∅",varphi:"ϕ",varpi:"ϖ",varpropto:"∝",varr:"↕",vArr:"⇕",varrho:"ϱ",varsigma:"ς",varsubsetneq:"⊊︀",varsubsetneqq:"⫋︀",varsupsetneq:"⊋︀",varsupsetneqq:"⫌︀",vartheta:"ϑ",vartriangleleft:"⊲",vartriangleright:"⊳",vBar:"⫨",Vbar:"⫫",vBarv:"⫩",vcy:"в",Vcy:"В",vdash:"⊢",vDash:"⊨",Vdash:"⊩",VDash:"⊫",Vdashl:"⫦",vee:"∨",Vee:"⋁",veebar:"⊻",veeeq:"≚",vellip:"⋮",verbar:"|",Verbar:"‖",vert:"|",Vert:"‖",VerticalBar:"∣",VerticalLine:"|",VerticalSeparator:"❘",VerticalTilde:"≀",VeryThinSpace:" ",vfr:"𝔳",Vfr:"𝔙",vltri:"⊲",vnsub:"⊂⃒",vnsup:"⊃⃒",vopf:"𝕧",Vopf:"𝕍",vprop:"∝",vrtri:"⊳",vscr:"𝓋",Vscr:"𝒱",vsubne:"⊊︀",vsubnE:"⫋︀",vsupne:"⊋︀",vsupnE:"⫌︀",Vvdash:"⊪",vzigzag:"⦚",wcirc:"ŵ",Wcirc:"Ŵ",wedbar:"⩟",wedge:"∧",Wedge:"⋀",wedgeq:"≙",weierp:"℘",wfr:"𝔴",Wfr:"𝔚",wopf:"𝕨",Wopf:"𝕎",wp:"℘",wr:"≀",wreath:"≀",wscr:"𝓌",Wscr:"𝒲",xcap:"⋂",xcirc:"◯",xcup:"⋃",xdtri:"▽",xfr:"𝔵",Xfr:"𝔛",xharr:"⟷",xhArr:"⟺",xi:"ξ",Xi:"Ξ",xlarr:"⟵",xlArr:"⟸",xmap:"⟼",xnis:"⋻",xodot:"⨀",xopf:"𝕩",Xopf:"𝕏",xoplus:"⨁",xotime:"⨂",xrarr:"⟶",xrArr:"⟹",xscr:"𝓍",Xscr:"𝒳",xsqcup:"⨆",xuplus:"⨄",xutri:"△",xvee:"⋁",xwedge:"⋀",yacute:"ý",Yacute:"Ý",yacy:"я",YAcy:"Я",ycirc:"ŷ",Ycirc:"Ŷ",ycy:"ы",Ycy:"Ы",yen:"¥",yfr:"𝔶",Yfr:"𝔜",yicy:"ї",YIcy:"Ї",yopf:"𝕪",Yopf:"𝕐",yscr:"𝓎",Yscr:"𝒴",yucy:"ю",YUcy:"Ю",yuml:"ÿ",Yuml:"Ÿ",zacute:"ź",Zacute:"Ź",zcaron:"ž",Zcaron:"Ž",zcy:"з",Zcy:"З",zdot:"ż",Zdot:"Ż",zeetrf:"ℨ",ZeroWidthSpace:"​",zeta:"ζ",Zeta:"Ζ",zfr:"𝔷",Zfr:"ℨ",zhcy:"ж",ZHcy:"Ж",zigrarr:"⇝",zopf:"𝕫",Zopf:"ℤ",zscr:"𝓏",Zscr:"𝒵",zwj:"‍",zwnj:"‌"},v={aacute:"á",Aacute:"Á",acirc:"â",Acirc:"Â",acute:"´",aelig:"æ",AElig:"Æ",agrave:"à",Agrave:"À",amp:"&",AMP:"&",aring:"å",Aring:"Å",atilde:"ã",Atilde:"Ã",auml:"ä",Auml:"Ä",brvbar:"¦",ccedil:"ç",Ccedil:"Ç",cedil:"¸",cent:"¢",copy:"©",COPY:"©",curren:"¤",deg:"°",divide:"÷",eacute:"é",Eacute:"É",ecirc:"ê",Ecirc:"Ê",egrave:"è",Egrave:"È",eth:"ð",ETH:"Ð",euml:"ë",Euml:"Ë",frac12:"½",frac14:"¼",frac34:"¾",gt:">",GT:">",iacute:"í",Iacute:"Í",icirc:"î",Icirc:"Î",iexcl:"¡",igrave:"ì",Igrave:"Ì",iquest:"¿",iuml:"ï",Iuml:"Ï",laquo:"«",lt:"<",LT:"<",macr:"¯",micro:"µ",middot:"·",nbsp:" ",not:"¬",ntilde:"ñ",Ntilde:"Ñ",oacute:"ó",Oacute:"Ó",ocirc:"ô",Ocirc:"Ô",ograve:"ò",Ograve:"Ò",ordf:"ª",ordm:"º",oslash:"ø",Oslash:"Ø",otilde:"õ",Otilde:"Õ",ouml:"ö",Ouml:"Ö",para:"¶",plusmn:"±",pound:"£",quot:'"',QUOT:'"',raquo:"»",reg:"®",REG:"®",sect:"§",shy:"­",sup1:"¹",sup2:"²",sup3:"³",szlig:"ß",thorn:"þ",THORN:"Þ",times:"×",uacute:"ú",Uacute:"Ú",ucirc:"û",Ucirc:"Û",ugrave:"ù",Ugrave:"Ù",uml:"¨",uuml:"ü",Uuml:"Ü",yacute:"ý",Yacute:"Ý",yen:"¥",yuml:"ÿ"},b={0:"�",128:"€",130:"‚",131:"ƒ",132:"„",133:"…",134:"†",135:"‡",136:"ˆ",137:"‰",138:"Š",139:"‹",140:"Œ",142:"Ž",145:"‘",146:"’",147:"“",148:"”",149:"•",150:"–",151:"—",152:"˜",153:"™",154:"š",155:"›",156:"œ",158:"ž",159:"Ÿ"},y=[1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65e3,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111],w=String.fromCharCode,q={}.hasOwnProperty,D=function(e,r){return q.call(e,r)},A=function(e,r){if(!e)return r;var t,a={};for(t in r)a[t]=D(e,t)?e[t]:r[t];return a},x=function(e,r){var t="";return e>=55296&&e<=57343||e>1114111?(r&&S("character reference outside the permissible Unicode range"),"�"):D(b,e)?(r&&S("disallowed character reference"),b[e]):(r&&function(e,r){for(var t=-1,a=e.length;++t<a;)if(e[t]==r)return!0;return!1}(y,e)&&S("disallowed character reference"),e>65535&&(t+=w((e-=65536)>>>10&1023|55296),e=56320|1023&e),t+=w(e))},E=function(e){return"&#x"+e.toString(16).toUpperCase()+";"},k=function(e){return"&#"+e+";"},S=function(e){throw Error("Parse error: "+e)},T=function(e,r){(r=A(r,T.options)).strict&&m.test(e)&&S("forbidden code point");var t=r.encodeEverything,a=r.useNamedReferences,n=r.allowUnsafeSymbols,o=r.decimal?k:E,d=function(e){return o(e.charCodeAt(0))};return t?(e=e.replace(s,(function(e){return a&&D(l,e)?"&"+l[e]+";":d(e)})),a&&(e=e.replace(/&gt;\u20D2/g,"&nvgt;").replace(/&lt;\u20D2/g,"&nvlt;").replace(/&#x66;&#x6A;/g,"&fjlig;")),a&&(e=e.replace(c,(function(e){return"&"+l[e]+";"})))):a?(n||(e=e.replace(p,(function(e){return"&"+l[e]+";"}))),e=(e=e.replace(/&gt;\u20D2/g,"&nvgt;").replace(/&lt;\u20D2/g,"&nvlt;")).replace(c,(function(e){return"&"+l[e]+";"}))):n||(e=e.replace(p,d)),e.replace(i,(function(e){var r=e.charCodeAt(0),t=e.charCodeAt(1);return o(1024*(r-55296)+t-56320+65536)})).replace(u,d)};T.options={allowUnsafeSymbols:!1,encodeEverything:!1,strict:!1,useNamedReferences:!1,decimal:!1};var C=function(e,r){var t=(r=A(r,C.options)).strict;return t&&f.test(e)&&S("malformed character reference"),e.replace(g,(function(e,a,n,o,i,s,u,c,l){var p,d,f,m,g,b;return a?h[g=a]:n?(g=n,(b=o)&&r.isAttributeValue?(t&&"="==b&&S("`&` did not start a character reference"),e):(t&&S("named character reference was not terminated by a semicolon"),v[g]+(b||""))):i?(f=i,d=s,t&&!d&&S("character reference was not terminated by a semicolon"),p=parseInt(f,10),x(p,t)):u?(m=u,d=c,t&&!d&&S("character reference was not terminated by a semicolon"),p=parseInt(m,16),x(p,t)):(t&&S("named character reference was not terminated by a semicolon"),e)}))};C.options={isAttributeValue:!1,strict:!1};var L={version:"1.2.0",encode:T,decode:C,escape:function(e){return e.replace(p,(function(e){return d[e]}))},unescape:C};if(a&&!a.nodeType)if(n)n.exports=L;else for(var R in L)D(L,R)&&(a[R]=L[R]);else t.he=L}(hr)}));function br(e,r,t){var a=t||{},n=a.number,o="$$v";a.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),n&&(o="_n("+o+")");var i=yr(r,o);e.model={value:"("+r+")",expression:JSON.stringify(r),callback:"function ($$v) {"+i+"}"}}function yr(e,r){var t=function(e){if(e=e.trim(),sr=e.length,e.indexOf("[")<0||e.lastIndexOf("]")<sr-1)return(lr=e.lastIndexOf("."))>-1?{exp:e.slice(0,lr),key:'"'+e.slice(lr+1)+'"'}:{exp:e,key:null};for(ur=e,lr=pr=dr=0;!qr();)Dr(cr=wr())?xr(cr):91===cr&&Ar(cr);return{exp:e.slice(0,pr),key:e.slice(pr+1,dr)}}(e);return null===t.key?e+"="+r:"$set("+t.exp+", "+t.key+", "+r+")"}function wr(){return ur.charCodeAt(++lr)}function qr(){return lr>=sr}function Dr(e){return 34===e||39===e}function Ar(e){var r=1;for(pr=lr;!qr();)if(Dr(e=wr()))xr(e);else if(91===e&&r++,93===e&&r--,0===r){dr=lr;break}}function xr(e){for(var r=e;!qr()&&(e=wr())!==r;);}var Er,kr,Sr,Tr,Cr,Lr,Rr,Or,Fr,Nr=/^@|^v-on:/,Br=/^v-|^@|^:|^#/,Ur=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,Vr=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,_r=/^\(|\)$/g,jr=/^\[.*\]$/,Pr=/:(.*)$/,Ir=/^:|^\.|^v-bind:/,$r=/\.[^.\]]+(?=[^\]]*$)/g,Mr=/^v-slot(:|$)|^#/,Hr=/[\r\n]/,Gr=/\s+/g,zr=/[\s"'<>\/=]/,Jr=m(vr.decode);function Zr(e,r,t){return{type:1,tag:e,attrsList:r,attrsMap:rt(r),rawAttrsMap:{},parent:t,children:[]}}function Kr(e,r){Er=r.warn||Ze,Lr=r.isPreTag||q,Rr=r.mustUseProp||q,Or=r.getTagNamespace||q;var t=r.isReservedTag||q;Fr=function(e){return!!e.component||!t(e.tag)},Sr=Ke(r.modules,"transformNode"),Tr=Ke(r.modules,"preTransformNode"),Cr=Ke(r.modules,"postTransformNode"),kr=r.delimiters;var a,n,o=[],i=!1!==r.preserveWhitespace,s=r.whitespace,u=!1,c=!1,l=!1;function p(e,r){l||(l=!0,Er(e,r))}function d(e){if(f(e),u||e.processed||(e=Yr(e,r)),o.length||e===a||(a.if&&(e.elseif||e.else)?(m(e),Qr(a,{exp:e.elseif,block:e})):p("Component template should contain exactly one root element. If you are using v-if on multiple elements, use v-else-if to chain them instead.",{start:e.start})),n&&!e.forbidden)if(e.elseif||e.else)i=e,(s=function(e){for(var r=e.length;r--;){if(1===e[r].type)return e[r];" "!==e[r].text&&Er('text "'+e[r].text.trim()+'" between v-if and v-else(-if) will be ignored.',e[r]),e.pop()}}(n.children))&&s.if?Qr(s,{exp:i.elseif,block:i}):Er("v-"+(i.elseif?'else-if="'+i.elseif+'"':"else")+" used on element <"+i.tag+"> without corresponding v-if.",i.rawAttrsMap[i.elseif?"v-else-if":"v-else"]);else{if(e.slotScope){var t=e.slotTarget||'"default"';(n.scopedSlots||(n.scopedSlots={}))[t]=e}n.children.push(e),e.parent=n}var i,s;e.children=e.children.filter((function(e){return!e.slotScope})),f(e),e.pre&&(u=!1),Lr(e.tag)&&(c=!1);for(var l=0;l<Cr.length;l++)Cr[l](e,r)}function f(e){if(!c)for(var r;(r=e.children[e.children.length-1])&&3===r.type&&" "===r.text;)e.children.pop()}function m(e){"slot"!==e.tag&&"template"!==e.tag||p("Cannot use <"+e.tag+"> as component root element because it may contain multiple nodes.",{start:e.start}),e.attrsMap.hasOwnProperty("v-for")&&p("Cannot use v-for on stateful component root element because it renders multiple elements.",e.rawAttrsMap["v-for"])}return H(e,{warn:Er,expectHTML:r.expectHTML,isUnaryTag:r.isUnaryTag,canBeLeftOpenTag:r.canBeLeftOpenTag,shouldDecodeNewlines:r.shouldDecodeNewlines,shouldDecodeNewlinesForHref:r.shouldDecodeNewlinesForHref,shouldKeepComment:r.comments,outputSourceRange:r.outputSourceRange,start:function(e,t,i,s,l){var p=n&&n.ns||Or(e);X&&"svg"===p&&(t=function(e){for(var r=[],t=0;t<e.length;t++){var a=e[t];tt.test(a.name)||(a.name=a.name.replace(at,""),r.push(a))}return r}(t));var f,g=Zr(e,t,n);p&&(g.ns=p),r.outputSourceRange&&(g.start=s,g.end=l,g.rawAttrsMap=g.attrsList.reduce((function(e,r){return e[r.name]=r,e}),{})),t.forEach((function(e){zr.test(e.name)&&Er("Invalid dynamic argument expression: attribute names cannot contain spaces, quotes, <, >, / or =.",{start:e.start+e.name.indexOf("["),end:e.start+e.name.length})})),"style"!==(f=g).tag&&("script"!==f.tag||f.attrsMap.type&&"text/javascript"!==f.attrsMap.type)||ae()||(g.forbidden=!0,Er("Templates should only be responsible for mapping the state to the UI. Avoid placing tags with side-effects in your templates, such as <"+e+">, as they will not be parsed.",{start:g.start}));for(var h=0;h<Tr.length;h++)g=Tr[h](g,r)||g;u||(function(e){null!=nr(e,"v-pre")&&(e.pre=!0)}(g),g.pre&&(u=!0)),Lr(g.tag)&&(c=!0),u?function(e){var r=e.attrsList,t=r.length;if(t)for(var a=e.attrs=new Array(t),n=0;n<t;n++)a[n]={name:r[n].name,value:JSON.stringify(r[n].value)},null!=r[n].start&&(a[n].start=r[n].start,a[n].end=r[n].end);else e.pre||(e.plain=!0)}(g):g.processed||(Wr(g),function(e){var r=nr(e,"v-if");if(r)e.if=r,Qr(e,{exp:r,block:e});else{null!=nr(e,"v-else")&&(e.else=!0);var t=nr(e,"v-else-if");t&&(e.elseif=t)}}(g),function(e){null!=nr(e,"v-once")&&(e.once=!0)}(g)),a||m(a=g),i?d(g):(n=g,o.push(g))},end:function(e,t,a){var i=o[o.length-1];o.length-=1,n=o[o.length-1],r.outputSourceRange&&(i.end=a),d(i)},chars:function(t,a,o){if(n){if(!X||"textarea"!==n.tag||n.attrsMap.placeholder!==t){var l,d,f,m=n.children;(t=c||t.trim()?"script"===(l=n).tag||"style"===l.tag?t:Jr(t):m.length?s?"condense"===s&&Hr.test(t)?"":" ":i?" ":"":"")&&(c||"condense"!==s||(t=t.replace(Gr," ")),!u&&" "!==t&&(d=Je(t,kr))?f={type:2,expression:d.expression,tokens:d.tokens,text:t}:" "===t&&m.length&&" "===m[m.length-1].text||(f={type:3,text:t}),f&&(r.outputSourceRange&&(f.start=a,f.end=o),m.push(f)))}}else t===e?p("Component template requires a root element, rather than just text.",{start:a}):(t=t.trim())&&p('text "'+t+'" outside root element will be ignored.',{start:a})},comment:function(e,t,a){if(n){var o={type:3,text:e,isComment:!0};r.outputSourceRange&&(o.start=t,o.end=a),n.children.push(o)}}}),a}function Yr(e,r){var t;!function(e){var r=ar(e,"key");if(r){if("template"===e.tag&&Er("<template> cannot be keyed. Place the key on real elements instead.",tr(e,"key")),e.for){var t=e.iterator2||e.iterator1,a=e.parent;t&&t===r&&a&&"transition-group"===a.tag&&Er("Do not use v-for index as key on <transition-group> children, this is the same as not using keys.",tr(e,"key"),!0)}e.key=r}}(e),e.plain=!e.key&&!e.scopedSlots&&!e.attrsList.length,function(e){var r=ar(e,"ref");r&&(e.ref=r,e.refInFor=function(e){for(var r=e;r;){if(void 0!==r.for)return!0;r=r.parent}return!1}(e))}(e),function(e){var r;"template"===e.tag?((r=nr(e,"scope"))&&Er('the "scope" attribute for scoped slots have been deprecated and replaced by "slot-scope" since 2.5. The new "slot-scope" attribute can also be used on plain elements in addition to <template> to denote scoped slots.',e.rawAttrsMap.scope,!0),e.slotScope=r||nr(e,"slot-scope")):(r=nr(e,"slot-scope"))&&(e.attrsMap["v-for"]&&Er("Ambiguous combined usage of slot-scope and v-for on <"+e.tag+"> (v-for takes higher priority). Use a wrapper <template> for the scoped slot to make it clearer.",e.rawAttrsMap["slot-scope"],!0),e.slotScope=r);var t=ar(e,"slot");if(t&&(e.slotTarget='""'===t?'"default"':t,e.slotTargetDynamic=!(!e.attrsMap[":slot"]&&!e.attrsMap["v-bind:slot"]),"template"===e.tag||e.slotScope||We(e,"slot",t,tr(e,"slot"))),"template"===e.tag){var a=or(e,Mr);if(a){(e.slotTarget||e.slotScope)&&Er("Unexpected mixed usage of different slot syntaxes.",e),e.parent&&!Fr(e.parent)&&Er("<template v-slot> can only appear at the root level inside the receiving component",e);var n=Xr(a),o=n.name,i=n.dynamic;e.slotTarget=o,e.slotTargetDynamic=i,e.slotScope=a.value||"_empty_"}}else{var s=or(e,Mr);if(s){Fr(e)||Er("v-slot can only be used on components or <template>.",s),(e.slotScope||e.slotTarget)&&Er("Unexpected mixed usage of different slot syntaxes.",e),e.scopedSlots&&Er("To avoid scope ambiguity, the default slot should also use <template> syntax when there are other named slots.",s);var u=e.scopedSlots||(e.scopedSlots={}),c=Xr(s),l=c.name,p=c.dynamic,d=u[l]=Zr("template",[],e);d.slotTarget=l,d.slotTargetDynamic=p,d.children=e.children.filter((function(e){if(!e.slotScope)return e.parent=d,!0})),d.slotScope=s.value||"_empty_",e.children=[],e.plain=!1}}}(e),"slot"===(t=e).tag&&(t.slotName=ar(t,"name"),t.key&&Er("`key` does not work on <slot> because slots are abstract outlets and can possibly expand into multiple elements. Use the key on a wrapping element instead.",tr(t,"key"))),function(e){var r;(r=ar(e,"is"))&&(e.component=r),null!=nr(e,"inline-template")&&(e.inlineTemplate=!0)}(e);for(var a=0;a<Sr.length;a++)e=Sr[a](e,r)||e;return function(e){var r,t,a,n,o,i,s,u,c=e.attrsList;for(r=0,t=c.length;r<t;r++)if(a=n=c[r].name,o=c[r].value,Br.test(a))if(e.hasBindings=!0,(i=et(a.replace(Br,"")))&&(a=a.replace($r,"")),Ir.test(a))a=a.replace(Ir,""),o=$e(o),(u=jr.test(a))&&(a=a.slice(1,-1)),0===o.trim().length&&Er('The value for a v-bind expression cannot be empty. Found in "v-bind:'+a+'"'),i&&(i.prop&&!u&&"innerHtml"===(a=h(a))&&(a="innerHTML"),i.camel&&!u&&(a=h(a)),i.sync&&(s=yr(o,"$event"),u?rr(e,'"update:"+('+a+")",s,null,!1,Er,c[r],!0):(rr(e,"update:"+h(a),s,null,!1,Er,c[r]),b(a)!==h(a)&&rr(e,"update:"+b(a),s,null,!1,Er,c[r])))),i&&i.prop||!e.component&&Rr(e.tag,e.attrsMap.type,a)?Ye(e,a,o,c[r],u):We(e,a,o,c[r],u);else if(Nr.test(a))a=a.replace(Nr,""),(u=jr.test(a))&&(a=a.slice(1,-1)),rr(e,a,o,i,!1,Er,c[r],u);else{var l=(a=a.replace(Br,"")).match(Pr),p=l&&l[1];u=!1,p&&(a=a.slice(0,-(p.length+1)),jr.test(p)&&(p=p.slice(1,-1),u=!0)),Xe(e,a,n,o,p,u,i,c[r]),"model"===a&&nt(e,o)}else Je(o,kr)&&Er(a+'="'+o+'": Interpolation inside attributes has been removed. Use v-bind or the colon shorthand instead. For example, instead of <div id="{{ val }}">, use <div :id="val">.',c[r]),We(e,a,JSON.stringify(o),c[r]),!e.component&&"muted"===a&&Rr(e.tag,e.attrsMap.type,a)&&Ye(e,a,"true",c[r])}(e),e}function Wr(e){var r;if(r=nr(e,"v-for")){var t=function(e){var r=e.match(Ur);if(r){var t={};t.for=r[2].trim();var a=r[1].trim().replace(_r,""),n=a.match(Vr);return n?(t.alias=a.replace(Vr,"").trim(),t.iterator1=n[1].trim(),n[2]&&(t.iterator2=n[2].trim())):t.alias=a,t}}(r);t?y(e,t):Er("Invalid v-for expression: "+r,e.rawAttrsMap["v-for"])}}function Qr(e,r){e.ifConditions||(e.ifConditions=[]),e.ifConditions.push(r)}function Xr(e){var r=e.name.replace(Mr,"");return r||("#"!==e.name[0]?r="default":Er("v-slot shorthand syntax requires a slot name.",e)),jr.test(r)?{name:r.slice(1,-1),dynamic:!0}:{name:'"'+r+'"',dynamic:!1}}function et(e){var r=e.match($r);if(r){var t={};return r.forEach((function(e){t[e.slice(1)]=!0})),t}}function rt(e){for(var r={},t=0,a=e.length;t<a;t++)!r[e[t].name]||X||ee||Er("duplicate attribute: "+e[t].name,e[t]),r[e[t].name]=e[t].value;return r}var tt=/^xmlns:NS\d+/,at=/^NS\d+:/;function nt(e,r){for(var t=e;t;)t.for&&t.alias===r&&Er("<"+e.tag+' v-model="'+r+'">: You are binding v-model directly to a v-for iteration alias. This will not be able to modify the v-for source array because writing to the alias is like modifying a function local variable. Consider using an array of objects and use v-model on an object property instead.',e.rawAttrsMap["v-model"]),t=t.parent}function ot(e){return Zr(e.tag,e.attrsList.slice(),e.parent)}var it,st,ut,ct=[fr,gr,{preTransformNode:function(e,r){if("input"===e.tag){var t,a=e.attrsMap;if(!a["v-model"])return;if((a[":type"]||a["v-bind:type"])&&(t=ar(e,"type")),a.type||t||!a["v-bind"]||(t="("+a["v-bind"]+").type"),t){var n=nr(e,"v-if",!0),o=n?"&&("+n+")":"",i=null!=nr(e,"v-else",!0),s=nr(e,"v-else-if",!0),u=ot(e);Wr(u),Qe(u,"type","checkbox"),Yr(u,r),u.processed=!0,u.if="("+t+")==='checkbox'"+o,Qr(u,{exp:u.if,block:u});var c=ot(e);nr(c,"v-for",!0),Qe(c,"type","radio"),Yr(c,r),Qr(u,{exp:"("+t+")==='radio'"+o,block:c});var l=ot(e);return nr(l,"v-for",!0),Qe(l,":type",t),Yr(l,r),Qr(u,{exp:n,block:l}),i?u.else=!0:s&&(u.elseif=s),u}}}}],lt={expectHTML:!0,modules:ct,directives:{model:function(e,r,t){it=t;var a=r.value,n=r.modifiers,o=e.tag,i=e.attrsMap.type;if("input"===o&&"file"===i&&it("<"+e.tag+' v-model="'+a+'" type="file">:\nFile inputs are read only. Use a v-on:change listener instead.',e.rawAttrsMap["v-model"]),e.component)return br(e,a,n),!1;if("select"===o)!function(e,r,t){var a='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(t&&t.number?"_n(val)":"val")+"});";a=a+" "+yr(r,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),rr(e,"change",a,null,!0)}(e,a,n);else if("input"===o&&"checkbox"===i)!function(e,r,t){var a=t&&t.number,n=ar(e,"value")||"null",o=ar(e,"true-value")||"true",i=ar(e,"false-value")||"false";Ye(e,"checked","Array.isArray("+r+")?_i("+r+","+n+")>-1"+("true"===o?":("+r+")":":_q("+r+","+o+")")),rr(e,"change","var $$a="+r+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+i+");if(Array.isArray($$a)){var $$v="+(a?"_n("+n+")":n)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+yr(r,"$$a.concat([$$v])")+")}else{$$i>-1&&("+yr(r,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+yr(r,"$$c")+"}",null,!0)}(e,a,n);else if("input"===o&&"radio"===i)!function(e,r,t){var a=t&&t.number,n=ar(e,"value")||"null";Ye(e,"checked","_q("+r+","+(n=a?"_n("+n+")":n)+")"),rr(e,"change",yr(r,n),null,!0)}(e,a,n);else{if("input"!==o&&"textarea"!==o)return br(e,a,n),!1;!function(e,r,t){var a=e.attrsMap.type,n=e.attrsMap["v-bind:value"]||e.attrsMap[":value"],o=e.attrsMap["v-bind:type"]||e.attrsMap[":type"];if(n&&!o){var i=e.attrsMap["v-bind:value"]?"v-bind:value":":value";it(i+'="'+n+'" conflicts with v-model on the same element because the latter already expands to a value binding internally',e.rawAttrsMap[i])}var s=t||{},u=s.lazy,c=s.number,l=s.trim,p=!u&&"range"!==a,d=u?"change":"range"===a?"__r":"input",f="$event.target.value";l&&(f="$event.target.value.trim()"),c&&(f="_n("+f+")");var m=yr(r,f);p&&(m="if($event.target.composing)return;"+m),Ye(e,"value","("+r+")"),rr(e,d,m,null,!0),(l||c)&&rr(e,"blur","$forceUpdate()")}(e,a,n)}return!0},text:function(e,r){r.value&&Ye(e,"textContent","_s("+r.value+")",r)},html:function(e,r){r.value&&Ye(e,"innerHTML","_s("+r.value+")",r)}},isPreTag:function(e){return"pre"===e},isUnaryTag:D,mustUseProp:function(e,r,t){return"value"===t&&Ue(e)&&"button"!==r||"selected"===t&&"option"===e||"checked"===t&&"input"===e||"muted"===t&&"video"===e},canBeLeftOpenTag:A,isReservedTag:function(e){return je(e)||Pe(e)},getTagNamespace:function(e){return Pe(e)?"svg":"math"===e?"math":void 0},staticKeys:function(e){return e.reduce((function(e,r){return e.concat(r.staticKeys||[])}),[]).join(",")}(ct)},pt=m((function(e){return l("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(e?","+e:""))}));function dt(e,r){e&&(st=pt(r.staticKeys||""),ut=r.isReservedTag||q,function e(r){if(r.static=function(e){return 2!==e.type&&(3===e.type||!(!e.pre&&(e.hasBindings||e.if||e.for||p(e.tag)||!ut(e.tag)||function(e){for(;e.parent;){if("template"!==(e=e.parent).tag)return!1;if(e.for)return!0}return!1}(e)||!Object.keys(e).every(st))))}(r),1===r.type){if(!ut(r.tag)&&"slot"!==r.tag&&null==r.attrsMap["inline-template"])return;for(var t=0,a=r.children.length;t<a;t++){var n=r.children[t];e(n),n.static||(r.static=!1)}if(r.ifConditions)for(var o=1,i=r.ifConditions.length;o<i;o++){var s=r.ifConditions[o].block;e(s),s.static||(r.static=!1)}}}(e),function e(r,t){if(1===r.type){if((r.static||r.once)&&(r.staticInFor=t),r.static&&r.children.length&&(1!==r.children.length||3!==r.children[0].type))return void(r.staticRoot=!0);if(r.staticRoot=!1,r.children)for(var a=0,n=r.children.length;a<n;a++)e(r.children[a],t||!!r.for);if(r.ifConditions)for(var o=1,i=r.ifConditions.length;o<i;o++)e(r.ifConditions[o].block,t)}}(e,!1))}var ft=/^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,mt=/\([^)]*?\);*$/,gt=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,ht={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},vt={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},bt=function(e){return"if("+e+")return null;"},yt={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:bt("$event.target !== $event.currentTarget"),ctrl:bt("!$event.ctrlKey"),shift:bt("!$event.shiftKey"),alt:bt("!$event.altKey"),meta:bt("!$event.metaKey"),left:bt("'button' in $event && $event.button !== 0"),middle:bt("'button' in $event && $event.button !== 1"),right:bt("'button' in $event && $event.button !== 2")};function wt(e,r){var t=r?"nativeOn:":"on:",a="",n="";for(var o in e){var i=qt(e[o]);e[o]&&e[o].dynamic?n+=o+","+i+",":a+='"'+o+'":'+i+","}return a="{"+a.slice(0,-1)+"}",n?t+"_d("+a+",["+n.slice(0,-1)+"])":t+a}function qt(e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map((function(e){return qt(e)})).join(",")+"]";var r=gt.test(e.value),t=ft.test(e.value),a=gt.test(e.value.replace(mt,""));if(e.modifiers){var n="",o="",i=[];for(var s in e.modifiers)if(yt[s])o+=yt[s],ht[s]&&i.push(s);else if("exact"===s){var u=e.modifiers;o+=bt(["ctrl","shift","alt","meta"].filter((function(e){return!u[e]})).map((function(e){return"$event."+e+"Key"})).join("||"))}else i.push(s);return i.length&&(n+=function(e){return"if(!$event.type.indexOf('key')&&"+e.map(Dt).join("&&")+")return null;"}(i)),o&&(n+=o),"function($event){"+n+(r?"return "+e.value+"($event)":t?"return ("+e.value+")($event)":a?"return "+e.value:e.value)+"}"}return r||t?e.value:"function($event){"+(a?"return "+e.value:e.value)+"}"}function Dt(e){var r=parseInt(e,10);if(r)return"$event.keyCode!=="+r;var t=ht[e],a=vt[e];return"_k($event.keyCode,"+JSON.stringify(e)+","+JSON.stringify(t)+",$event.key,"+JSON.stringify(a)+")"}var At={on:function(e,r){r.modifiers&&ie("v-on without argument does not support modifiers."),e.wrapListeners=function(e){return"_g("+e+","+r.value+")"}},bind:function(e,r){e.wrapData=function(t){return"_b("+t+",'"+e.tag+"',"+r.value+","+(r.modifiers&&r.modifiers.prop?"true":"false")+(r.modifiers&&r.modifiers.sync?",true":"")+")"}},cloak:w},xt=function(e){this.options=e,this.warn=e.warn||Ze,this.transforms=Ke(e.modules,"transformCode"),this.dataGenFns=Ke(e.modules,"genData"),this.directives=y(y({},At),e.directives);var r=e.isReservedTag||q;this.maybeComponent=function(e){return!!e.component||!r(e.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Et(e,r){var t=new xt(r);return{render:"with(this){return "+(e?kt(e,t):'_c("div")')+"}",staticRenderFns:t.staticRenderFns}}function kt(e,r){if(e.parent&&(e.pre=e.pre||e.parent.pre),e.staticRoot&&!e.staticProcessed)return St(e,r);if(e.once&&!e.onceProcessed)return Tt(e,r);if(e.for&&!e.forProcessed)return Lt(e,r);if(e.if&&!e.ifProcessed)return Ct(e,r);if("template"!==e.tag||e.slotTarget||r.pre){if("slot"===e.tag)return function(e,r){var t=e.slotName||'"default"',a=Nt(e,r),n="_t("+t+(a?","+a:""),o=e.attrs||e.dynamicAttrs?_t((e.attrs||[]).concat(e.dynamicAttrs||[]).map((function(e){return{name:h(e.name),value:e.value,dynamic:e.dynamic}}))):null,i=e.attrsMap["v-bind"];return!o&&!i||a||(n+=",null"),o&&(n+=","+o),i&&(n+=(o?"":",null")+","+i),n+")"}(e,r);var t;if(e.component)t=function(e,r,t){var a=r.inlineTemplate?null:Nt(r,t,!0);return"_c("+e+","+Rt(r,t)+(a?","+a:"")+")"}(e.component,e,r);else{var a;(!e.plain||e.pre&&r.maybeComponent(e))&&(a=Rt(e,r));var n=e.inlineTemplate?null:Nt(e,r,!0);t="_c('"+e.tag+"'"+(a?","+a:"")+(n?","+n:"")+")"}for(var o=0;o<r.transforms.length;o++)t=r.transforms[o](e,t);return t}return Nt(e,r)||"void 0"}function St(e,r){e.staticProcessed=!0;var t=r.pre;return e.pre&&(r.pre=e.pre),r.staticRenderFns.push("with(this){return "+kt(e,r)+"}"),r.pre=t,"_m("+(r.staticRenderFns.length-1)+(e.staticInFor?",true":"")+")"}function Tt(e,r){if(e.onceProcessed=!0,e.if&&!e.ifProcessed)return Ct(e,r);if(e.staticInFor){for(var t="",a=e.parent;a;){if(a.for){t=a.key;break}a=a.parent}return t?"_o("+kt(e,r)+","+r.onceId+++","+t+")":(r.warn("v-once can only be used inside v-for that is keyed. ",e.rawAttrsMap["v-once"]),kt(e,r))}return St(e,r)}function Ct(e,r,t,a){return e.ifProcessed=!0,function e(r,t,a,n){if(!r.length)return n||"_e()";var o=r.shift();return o.exp?"("+o.exp+")?"+i(o.block)+":"+e(r,t,a,n):""+i(o.block);function i(e){return a?a(e,t):e.once?Tt(e,t):kt(e,t)}}(e.ifConditions.slice(),r,t,a)}function Lt(e,r,t,a){var n=e.for,o=e.alias,i=e.iterator1?","+e.iterator1:"",s=e.iterator2?","+e.iterator2:"";return r.maybeComponent(e)&&"slot"!==e.tag&&"template"!==e.tag&&!e.key&&r.warn("<"+e.tag+' v-for="'+o+" in "+n+'">: component lists rendered with v-for should have explicit keys. See https://vuejs.org/guide/list.html#key for more info.',e.rawAttrsMap["v-for"],!0),e.forProcessed=!0,(a||"_l")+"(("+n+"),function("+o+i+s+"){return "+(t||kt)(e,r)+"})"}function Rt(e,r){var t="{",a=function(e,r){var t=e.directives;if(t){var a,n,o,i,s="directives:[",u=!1;for(a=0,n=t.length;a<n;a++){o=t[a],i=!0;var c=r.directives[o.name];c&&(i=!!c(e,o,r.warn)),i&&(u=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}return u?s.slice(0,-1)+"]":void 0}}(e,r);a&&(t+=a+","),e.key&&(t+="key:"+e.key+","),e.ref&&(t+="ref:"+e.ref+","),e.refInFor&&(t+="refInFor:true,"),e.pre&&(t+="pre:true,"),e.component&&(t+='tag:"'+e.tag+'",');for(var n=0;n<r.dataGenFns.length;n++)t+=r.dataGenFns[n](e);if(e.attrs&&(t+="attrs:"+_t(e.attrs)+","),e.props&&(t+="domProps:"+_t(e.props)+","),e.events&&(t+=wt(e.events,!1)+","),e.nativeEvents&&(t+=wt(e.nativeEvents,!0)+","),e.slotTarget&&!e.slotScope&&(t+="slot:"+e.slotTarget+","),e.scopedSlots&&(t+=function(e,r,t){var a=e.for||Object.keys(r).some((function(e){var t=r[e];return t.slotTargetDynamic||t.if||t.for||Ot(t)})),n=!!e.if;if(!a)for(var o=e.parent;o;){if(o.slotScope&&"_empty_"!==o.slotScope||o.for){a=!0;break}o.if&&(n=!0),o=o.parent}var i=Object.keys(r).map((function(e){return Ft(r[e],t)})).join(",");return"scopedSlots:_u(["+i+"]"+(a?",null,true":"")+(!a&&n?",null,false,"+function(e){for(var r=5381,t=e.length;t;)r=33*r^e.charCodeAt(--t);return r>>>0}(i):"")+")"}(e,e.scopedSlots,r)+","),e.model&&(t+="model:{value:"+e.model.value+",callback:"+e.model.callback+",expression:"+e.model.expression+"},"),e.inlineTemplate){var o=function(e,r){var t=e.children[0];if(1===e.children.length&&1===t.type||r.warn("Inline-template components must have exactly one child element.",{start:e.start}),t&&1===t.type){var a=Et(t,r.options);return"inlineTemplate:{render:function(){"+a.render+"},staticRenderFns:["+a.staticRenderFns.map((function(e){return"function(){"+e+"}"})).join(",")+"]}"}}(e,r);o&&(t+=o+",")}return t=t.replace(/,$/,"")+"}",e.dynamicAttrs&&(t="_b("+t+',"'+e.tag+'",'+_t(e.dynamicAttrs)+")"),e.wrapData&&(t=e.wrapData(t)),e.wrapListeners&&(t=e.wrapListeners(t)),t}function Ot(e){return 1===e.type&&("slot"===e.tag||e.children.some(Ot))}function Ft(e,r){var t=e.attrsMap["slot-scope"];if(e.if&&!e.ifProcessed&&!t)return Ct(e,r,Ft,"null");if(e.for&&!e.forProcessed)return Lt(e,r,Ft);var a="_empty_"===e.slotScope?"":String(e.slotScope),n="function("+a+"){return "+("template"===e.tag?e.if&&t?"("+e.if+")?"+(Nt(e,r)||"undefined")+":undefined":Nt(e,r)||"undefined":kt(e,r))+"}",o=a?"":",proxy:true";return"{key:"+(e.slotTarget||'"default"')+",fn:"+n+o+"}"}function Nt(e,r,t,a,n){var o=e.children;if(o.length){var i=o[0];if(1===o.length&&i.for&&"template"!==i.tag&&"slot"!==i.tag){var s=t?r.maybeComponent(i)?",1":",0":"";return""+(a||kt)(i,r)+s}var u=t?function(e,r){for(var t=0,a=0;a<e.length;a++){var n=e[a];if(1===n.type){if(Bt(n)||n.ifConditions&&n.ifConditions.some((function(e){return Bt(e.block)}))){t=2;break}(r(n)||n.ifConditions&&n.ifConditions.some((function(e){return r(e.block)})))&&(t=1)}}return t}(o,r.maybeComponent):0,c=n||Ut;return"["+o.map((function(e){return c(e,r)})).join(",")+"]"+(u?","+u:"")}}function Bt(e){return void 0!==e.for||"template"===e.tag||"slot"===e.tag}function Ut(e,r){return 1===e.type?kt(e,r):3===e.type&&e.isComment?function(e){return"_e("+JSON.stringify(e.text)+")"}(e):Vt(e)}function Vt(e){return"_v("+(2===e.type?e.expression:jt(JSON.stringify(e.text)))+")"}function _t(e){for(var r="",t="",a=0;a<e.length;a++){var n=e[a],o=jt(n.value);n.dynamic?t+=n.name+","+o+",":r+='"'+n.name+'":'+o+","}return r="{"+r.slice(0,-1)+"}",t?"_d("+r+",["+t.slice(0,-1)+"])":r}function jt(e){return e.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}var Pt=new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b"),It=new RegExp("\\b"+"delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b")+"\\s*\\([^\\)]*\\)"),$t=/'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;function Mt(e,r){e&&function e(r,t){if(1===r.type){for(var a in r.attrsMap)if(Br.test(a)){var n=r.attrsMap[a];if(n){var o=r.rawAttrsMap[a];"v-for"===a?Gt(r,'v-for="'+n+'"',t,o):"v-slot"===a||"#"===a[0]?Zt(n,a+'="'+n+'"',t,o):Nr.test(a)?Ht(n,a+'="'+n+'"',t,o):Jt(n,a+'="'+n+'"',t,o)}}if(r.children)for(var i=0;i<r.children.length;i++)e(r.children[i],t)}else 2===r.type&&Jt(r.expression,r.text,t,r)}(e,r)}function Ht(e,r,t,a){var n=e.replace($t,""),o=n.match(It);o&&"$"!==n.charAt(o.index-1)&&t('avoid using JavaScript unary operator as property name: "'+o[0]+'" in expression '+r.trim(),a),Jt(e,r,t,a)}function Gt(e,r,t,a){Jt(e.for||"",r,t,a),zt(e.alias,"v-for alias",r,t,a),zt(e.iterator1,"v-for iterator",r,t,a),zt(e.iterator2,"v-for iterator",r,t,a)}function zt(e,r,t,a,n){if("string"==typeof e)try{new Function("var "+e+"=_")}catch(o){a("invalid "+r+' "'+e+'" in expression: '+t.trim(),n)}}function Jt(e,r,t,a){try{new Function("return "+e)}catch(o){var n=e.replace($t,"").match(Pt);t(n?'avoid using JavaScript keyword as property name: "'+n[0]+'"\n  Raw expression: '+r.trim():"invalid expression: "+o.message+" in\n\n    "+e+"\n\n  Raw expression: "+r.trim()+"\n",a)}}function Zt(e,r,t,a){try{new Function(e,"")}catch(n){t("invalid function parameter expression: "+n.message+" in\n\n    "+e+"\n\n  Raw expression: "+r.trim()+"\n",a)}}function Kt(e,r,t){void 0===r&&(r=0),void 0===t&&(t=e.length);for(var a=e.split(/\r?\n/),n=0,o=[],i=0;i<a.length;i++)if((n+=a[i].length+1)>=r){for(var s=i-2;s<=i+2||t>n;s++)if(!(s<0||s>=a.length)){o.push(""+(s+1)+Yt(" ",3-String(s+1).length)+"|  "+a[s]);var u=a[s].length;if(s===i){var c=r-(n-u)+1,l=t>n?u-c:t-r;o.push("   |  "+Yt(" ",c)+Yt("^",l))}else if(s>i){if(t>n){var p=Math.min(t-n,u);o.push("   |  "+Yt("^",p))}n+=u+1}}break}return o.join("\n")}function Yt(e,r){var t="";if(r>0)for(;1&r&&(t+=e),!((r>>>=1)<=0);)e+=e;return t}function Wt(e,r){try{return new Function(e)}catch(t){return r.push({err:t,code:e}),w}}function Qt(e){var r=Object.create(null);return function(t,a,n){var o=(a=y({},a)).warn||ie;delete a.warn;try{new Function("return 1")}catch(e){e.toString().match(/unsafe-eval|CSP/)&&o("It seems you are using the standalone build of Vue.js in an environment with Content Security Policy that prohibits unsafe-eval. The template compiler cannot work in this environment. Consider relaxing the policy to allow unsafe-eval or pre-compiling your templates into render functions.")}var i=a.delimiters?String(a.delimiters)+t:t;if(r[i])return r[i];var s=e(t,a);s.errors&&s.errors.length&&(a.outputSourceRange?s.errors.forEach((function(e){o("Error compiling template:\n\n"+e.msg+"\n\n"+Kt(t,e.start,e.end),n)})):o("Error compiling template:\n\n"+t+"\n\n"+s.errors.map((function(e){return"- "+e})).join("\n")+"\n",n)),s.tips&&s.tips.length&&(a.outputSourceRange?s.tips.forEach((function(e){return se(e.msg,n)})):s.tips.forEach((function(e){return se(e,n)})));var u={},c=[];return u.render=Wt(s.render,c),u.staticRenderFns=s.staticRenderFns.map((function(e){return Wt(e,c)})),s.errors&&s.errors.length||!c.length||o("Failed to generate render function:\n\n"+c.map((function(e){var r=e.err,t=e.code;return r.toString()+" in\n\n"+t+"\n"})).join("\n"),n),r[i]=u}}function Xt(e){return function(r){function t(t,a){var n=Object.create(r),o=[],i=[],s=function(e,r,t){(t?i:o).push(e)};if(a){if(a.outputSourceRange){var u=t.match(/^\s*/)[0].length;s=function(e,r,t){var a={msg:e};r&&(null!=r.start&&(a.start=r.start+u),null!=r.end&&(a.end=r.end+u)),(t?i:o).push(a)}}for(var c in a.modules&&(n.modules=(r.modules||[]).concat(a.modules)),a.directives&&(n.directives=y(Object.create(r.directives||null),a.directives)),a)"modules"!==c&&"directives"!==c&&(n[c]=a[c])}n.warn=s;var l=e(t.trim(),n);return Mt(l.ast,s),l.errors=o,l.tips=i,l}return{compile:t,compileToFunctions:Qt(t)}}}var ea=Xt((function(e,r){var t=Kr(e.trim(),r);!1!==r.optimize&&dt(t,r);var a=Et(t,r);return{ast:t,render:a.render,staticRenderFns:a.staticRenderFns}}))(lt),ra=ea.compile,ta=ea.compileToFunctions,aa=l("accept,accept-charset,accesskey,action,align,alt,async,autocomplete,autofocus,autoplay,autosave,bgcolor,border,buffered,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,http-equiv,name,contenteditable,contextmenu,controls,coords,data,datetime,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,method,for,form,formaction,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,ismap,itemprop,keytype,kind,label,lang,language,list,loop,low,manifest,max,maxlength,media,method,GET,POST,min,multiple,email,file,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,seamless,selected,shape,size,type,text,password,sizes,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,type,usemap,value,width,wrap"),na={acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},oa={"<":"&lt;",">":"&gt;",'"':"&quot;","&":"&amp;"};function ia(e){return oa[e]||e}var sa=/^"(?:[^"\\]|\\.)*"$|^'(?:[^'\\]|\\.)*'$/;function ua(e,r){var t=[];return e.forEach((function(e){var a=e.name,n=e.value;!function(e){return aa(e)||0===e.indexOf("data-")||0===e.indexOf("aria-")}(a=na[a]||a.toLowerCase())||r&&r.some((function(e){return e.name===a}))||t.push(ca(a,n))})),t}function ca(e,r){return sa.test(r)?(r=r.replace(/^'|'$/g,'"'),Ve(e)&&'"false"'!==r&&(r='"true"'),{type:ba,value:_e(e)?" "+e+'="'+e+'"':'""'===r?" "+e:" "+e+'="'+JSON.parse(r)+'"'}):{type:ya,value:"_ssrAttr("+JSON.stringify(e)+","+r+")"}}var la,pa=0,da=1,fa=2,ma=3,ga=4;function ha(e,r){e&&(la=r.isReservedTag||q,function e(r,t){if(function(e){return 2!==e.type&&3!==e.type&&(p(e.tag)||!la(e.tag)||!!e.component||function(e){return 1===e.type&&"select"===e.tag&&null!=e.directives&&e.directives.some((function(e){return"model"===e.name}))}(e))}(r))r.ssrOptimizability=pa;else{var a=t||function(e){return 1===e.type&&e.directives&&e.directives.some((function(e){return!va(e.name)}))}(r),n=function(e){e.ssrOptimizability!==da&&(r.ssrOptimizability=a?ga:fa)};if(a&&(r.ssrOptimizability=ma),1===r.type){for(var o=0,i=r.children.length;o<i;o++){var s=r.children[o];e(s),n(s)}if(r.ifConditions)for(var u=1,c=r.ifConditions.length;u<c;u++){var l=r.ifConditions[u].block;e(l,t),n(l)}null==r.ssrOptimizability||!t&&(r.attrsMap["v-html"]||r.attrsMap["v-text"])?r.ssrOptimizability=da:r.children=function(e){for(var r=e.children,t=[],a=[],n=function(){a.length&&t.push({type:1,parent:e,tag:"template",attrsList:[],attrsMap:{},rawAttrsMap:{},children:a,ssrOptimizability:da}),a=[]},o=0;o<r.length;o++){var i=r[o];i.ssrOptimizability===da?a.push(i):(n(),t.push(i))}return n(),t}(r)}else r.ssrOptimizability=da}}(e,!0))}var va=l("text,html,show,on,bind,model,pre,cloak,once"),ba=0,ya=2;function wa(e,r){if(e.for&&!e.forProcessed)return Lt(e,r,wa);if(e.if&&!e.ifProcessed)return Ct(e,r,wa);if("template"===e.tag&&!e.slotTarget)return e.ssrOptimizability===da?xa(e,r):Da(e,r)||"void 0";switch(e.ssrOptimizability){case da:return function(e,r){return"_ssrNode("+Ea(e,r)+")"}(e,r);case fa:return function(e,r){var t=Da(e,r,!0);return"_ssrNode("+Ca(Sa(e,r))+',"</'+e.tag+'>"'+(t?","+t:"")+")"}(e,r);case ma:return qa(e,r,!0);case ga:return qa(e,r,!1);default:return kt(e,r)}}function qa(e,r,t){var a=e.plain?void 0:Rt(e,r),n=t?"["+xa(e,r)+"]":Da(e,r,!0);return"_c('"+e.tag+"'"+(a?","+a:"")+(n?","+n:"")+")"}function Da(e,r,t){return Nt(e,r,t,wa,Aa)}function Aa(e,r){return 1===e.type?wa(e,r):Vt(e)}function xa(e,r){return e.children.length?"_ssrNode("+Ca(Ta(e,r))+")":""}function Ea(e,r){return"("+Ca(ka(e,r))+")"}function ka(e,r){if(e.for&&!e.forProcessed)return e.forProcessed=!0,[{type:ya,value:Lt(e,r,Ea,"_ssrList")}];if(e.if&&!e.ifProcessed)return e.ifProcessed=!0,[{type:ya,value:Ct(e,r,Ea,'"\x3c!----\x3e"')}];if("template"===e.tag)return Ta(e,r);var t=Sa(e,r),a=Ta(e,r),n=r.options.isUnaryTag,o=n&&n(e.tag)?[]:[{type:ba,value:"</"+e.tag+">"}];return t.concat(a,o)}function Sa(e,r){var t;!function(e,r){if(e.directives)for(var t=0;t<e.directives.length;t++){var a=e.directives[t];if("model"===a.name){r.directives.model(e,a,r.warn),"textarea"===e.tag&&e.props&&(e.props=e.props.filter((function(e){return"value"!==e.name})));break}}}(e,r);var a,n,o,i,s,u,c=[{type:ba,value:"<"+e.tag}];return e.attrs&&c.push.apply(c,e.attrs.map((function(e){return ca(e.name,e.value)}))),e.props&&c.push.apply(c,ua(e.props,e.attrs)),(t=e.attrsMap["v-bind"])&&c.push({type:ya,value:"_ssrAttrs("+t+")"}),(t=e.attrsMap["v-bind.prop"])&&c.push({type:ya,value:"_ssrDOMProps("+t+")"}),(e.staticClass||e.classBinding)&&c.push.apply(c,(a=e.staticClass,n=e.classBinding,a&&!n?[{type:ba,value:' class="'+JSON.parse(a)+'"'}]:[{type:ya,value:"_ssrClass("+(a||"null")+","+(n||"null")+")"}])),(e.staticStyle||e.styleBinding||e.attrsMap["v-show"])&&c.push.apply(c,(o=e.attrsMap.style,i=e.staticStyle,s=e.styleBinding,u=e.attrsMap["v-show"],!o||s||u?[{type:ya,value:"_ssrStyle("+(i||"null")+","+(s||"null")+", "+(u?"{ display: ("+u+") ? '' : 'none' }":"null")+")"}]:[{type:ba,value:" style="+JSON.stringify(o)}])),r.options.scopeId&&c.push({type:ba,value:" "+r.options.scopeId}),c.push({type:ba,value:">"}),c}function Ta(e,r){var t;return(t=e.attrsMap["v-html"])?[{type:ya,value:"_s("+t+")"}]:(t=e.attrsMap["v-text"])||"textarea"===e.tag&&(t=e.attrsMap["v-model"])?[{type:1,value:"_s("+t+")"}]:e.children?function(e,r){for(var t=[],a=0;a<e.length;a++){var n=e[a];if(1===n.type)t.push.apply(t,ka(n,r));else if(2===n.type)t.push({type:1,value:n.expression});else if(3===n.type){var o=n.text.replace(/[<>"&]/g,ia);n.isComment&&(o="\x3c!--"+o+"--\x3e"),t.push({type:ba,value:o})}}return t}(e.children,r):[]}function Ca(e){for(var r=[],t="",a=function(){t&&(r.push(JSON.stringify(t)),t="")},n=0;n<e.length;n++){var o=e[n];o.type===ba?t+=o.value:1===o.type?(a(),r.push("_ssrEscape("+o.value+")")):o.type===ya&&(a(),r.push("("+o.value+")"))}return a(),r.join("+")}var La=Xt((function(e,r){var t=Kr(e.trim(),r);ha(t,r);var a=function(e,r){var t=new xt(r);return{render:"with(this){return "+(e?wa(e,t):'_c("div")')+"}",staticRenderFns:t.staticRenderFns}}(t,r);return{ast:t,render:a.render,staticRenderFns:a.staticRenderFns}}))(lt),Ra=La.compile,Oa=La.compileToFunctions;r.parseComponent=function(e,r){void 0===r&&(r={});var t={template:null,script:null,styles:[],customBlocks:[],errors:[]},s=0,u=null,c=function(e){t.errors.push(e)};return r.outputSourceRange&&(c=function(e,r){var a={msg:e};null!=r.start&&(a.start=r.start),null!=r.end&&(a.end=r.end),t.errors.push(a)}),H(e,{warn:c,start:function(e,r,a,n,o){0===s&&(u={type:e,content:"",start:o,attrs:r.reduce((function(e,r){var t=r.name,a=r.value;return e[t]=a||!0,e}),{})},Z(e)?(function(e,r){for(var t=0;t<r.length;t++){var a=r[t];"lang"===a.name&&(e.lang=a.value),"scoped"===a.name&&(e.scoped=!0),"module"===a.name&&(e.module=a.value||!0),"src"===a.name&&(e.src=a.value)}}(u,r),"style"===e?t.styles.push(u):t[e]=u):t.customBlocks.push(u)),a||s++},end:function(t,c){if(1===s&&u){u.end=c;var l=e.slice(u.start,u.end);!1!==r.deindent&&(l=function(e){if(!o.test(e))return e;for(var r,t,s,u=e.split(a),c=1/0,l=0;l<u.length;l++){var p=u[l];if(!n.test(p))if(r)(t=i(p,r))<c&&(c=t);else{if(" "!==(s=p.charAt(0))&&"\t"!==s)return e;(t=i(p,r=s))<c&&(c=t)}}return u.map((function(e){return e.slice(c)})).join("\n")}(l)),"template"!==u.type&&r.pad&&(l=function(r,t){if("space"===t)return e.slice(0,r.start).replace(J," ");var a=e.slice(0,r.start).split(z).length,n="script"!==r.type||r.lang?"\n":"//\n";return Array(a).join(n)}(u,r.pad)+l),u.content=l,u=null}s--},outputSourceRange:r.outputSourceRange}),t},r.compile=ra,r.compileToFunctions=ta,r.ssrCompile=Ra,r.ssrCompileToFunctions=Oa,r.generateCodeFrame=Kt,Object.defineProperty(r,"__esModule",{value:!0})})(r)}).call(this,t(0),t(4).setImmediate)},function(e,r){function t(r){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?e.exports=t=function(e){return typeof e}:e.exports=t=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},t(r)}e.exports=t},function(e,r,t){(function(e){var a=void 0!==e&&e||"undefined"!=typeof self&&self||window,n=Function.prototype.apply;function o(e,r){this._id=e,this._clearFn=r}r.setTimeout=function(){return new o(n.call(setTimeout,a,arguments),clearTimeout)},r.setInterval=function(){return new o(n.call(setInterval,a,arguments),clearInterval)},r.clearTimeout=r.clearInterval=function(e){e&&e.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(a,this._id)},r.enroll=function(e,r){clearTimeout(e._idleTimeoutId),e._idleTimeout=r},r.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},r._unrefActive=r.active=function(e){clearTimeout(e._idleTimeoutId);var r=e._idleTimeout;r>=0&&(e._idleTimeoutId=setTimeout((function(){e._onTimeout&&e._onTimeout()}),r))},t(5),r.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==e&&e.setImmediate||this&&this.setImmediate,r.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==e&&e.clearImmediate||this&&this.clearImmediate}).call(this,t(0))},function(e,r,t){(function(e,r){!function(e,t){"use strict";if(!e.setImmediate){var a,n,o,i,s,u=1,c={},l=!1,p=e.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(e);d=d&&d.setTimeout?d:e,"[object process]"==={}.toString.call(e.process)?a=function(e){r.nextTick((function(){m(e)}))}:!function(){if(e.postMessage&&!e.importScripts){var r=!0,t=e.onmessage;return e.onmessage=function(){r=!1},e.postMessage("","*"),e.onmessage=t,r}}()?e.MessageChannel?((o=new MessageChannel).port1.onmessage=function(e){m(e.data)},a=function(e){o.port2.postMessage(e)}):p&&"onreadystatechange"in p.createElement("script")?(n=p.documentElement,a=function(e){var r=p.createElement("script");r.onreadystatechange=function(){m(e),r.onreadystatechange=null,n.removeChild(r),r=null},n.appendChild(r)}):a=function(e){setTimeout(m,0,e)}:(i="setImmediate$"+Math.random()+"$",s=function(r){r.source===e&&"string"==typeof r.data&&0===r.data.indexOf(i)&&m(+r.data.slice(i.length))},e.addEventListener?e.addEventListener("message",s,!1):e.attachEvent("onmessage",s),a=function(r){e.postMessage(i+r,"*")}),d.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var r=new Array(arguments.length-1),t=0;t<r.length;t++)r[t]=arguments[t+1];var n={callback:e,args:r};return c[u]=n,a(u),u++},d.clearImmediate=f}function f(e){delete c[e]}function m(e){if(l)setTimeout(m,0,e);else{var r=c[e];if(r){l=!0;try{!function(e){var r=e.callback,t=e.args;switch(t.length){case 0:r();break;case 1:r(t[0]);break;case 2:r(t[0],t[1]);break;case 3:r(t[0],t[1],t[2]);break;default:r.apply(void 0,t)}}(r)}finally{f(e),l=!1}}}}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,t(0),t(6))},function(e,r){var t,a,n=e.exports={};function o(){throw new Error("setTimeout has not been defined")}function i(){throw new Error("clearTimeout has not been defined")}function s(e){if(t===setTimeout)return setTimeout(e,0);if((t===o||!t)&&setTimeout)return t=setTimeout,setTimeout(e,0);try{return t(e,0)}catch(r){try{return t.call(null,e,0)}catch(r){return t.call(this,e,0)}}}!function(){try{t="function"==typeof setTimeout?setTimeout:o}catch(e){t=o}try{a="function"==typeof clearTimeout?clearTimeout:i}catch(e){a=i}}();var u,c=[],l=!1,p=-1;function d(){l&&u&&(l=!1,u.length?c=u.concat(c):p=-1,c.length&&f())}function f(){if(!l){var e=s(d);l=!0;for(var r=c.length;r;){for(u=c,c=[];++p<r;)u&&u[p].run();p=-1,r=c.length}u=null,l=!1,function(e){if(a===clearTimeout)return clearTimeout(e);if((a===i||!a)&&clearTimeout)return a=clearTimeout,clearTimeout(e);try{a(e)}catch(r){try{return a.call(null,e)}catch(r){return a.call(this,e)}}}(e)}}function m(e,r){this.fun=e,this.array=r}function g(){}n.nextTick=function(e){var r=new Array(arguments.length-1);if(arguments.length>1)for(var t=1;t<arguments.length;t++)r[t-1]=arguments[t];c.push(new m(e,r)),1!==c.length||l||s(f)},m.prototype.run=function(){this.fun.apply(null,this.array)},n.title="browser",n.browser=!0,n.env={},n.argv=[],n.version="",n.versions={},n.on=g,n.addListener=g,n.once=g,n.off=g,n.removeListener=g,n.removeAllListeners=g,n.emit=g,n.prependListener=g,n.prependOnceListener=g,n.listeners=function(e){return[]},n.binding=function(e){throw new Error("process.binding is not supported")},n.cwd=function(){return"/"},n.chdir=function(e){throw new Error("process.chdir is not supported")},n.umask=function(){return 0}},function(e,r,t){"use strict";t.r(r),t.d(r,"RuntimeTemplateCompiler",(function(){return h}));var a=t(2),n=t(1),o=t.n(n),i=t(3),s=t.n(i);function u(e,r){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);r&&(a=a.filter((function(r){return Object.getOwnPropertyDescriptor(e,r).enumerable}))),t.push.apply(t,a)}return t}function c(e){for(var r=1;r<arguments.length;r++){var t=null!=arguments[r]?arguments[r]:{};r%2?u(Object(t),!0).forEach((function(r){o()(e,r,t[r])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):u(Object(t)).forEach((function(r){Object.defineProperty(e,r,Object.getOwnPropertyDescriptor(t,r))}))}return e}function l(e){return"object"===s()(e)&&!Array.isArray(e)&&null!==e}function p(e,r){var t=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(t||!Object.assign){var a=function(t){return l(r[t])&&null!==e&&Object.prototype.hasOwnProperty.call(e,t)&&l(e[t])},n=Object.getOwnPropertyNames(r).map((function(n){return o()({},n,a(n)?p(e[n],r[n],t):r[n])})).reduce((function(e,r){return c({},e,{},r)}),{});return c({},e,{},n)}return Object.assign(e,r)}var d={defaultRuntimeTemplate:"<div></div>",defaultCompilerOptions:{outputSourceRange:!1,whitespace:"preserve"}},f=function(e){d=e},m=function(e){e};var g,h=function(e,r,t,a,n,o,i,s){var u,c="function"==typeof e?e.options:e;if(r&&(c.render=r,c.staticRenderFns=t,c._compiled=!0),a&&(c.functional=!0),o&&(c._scopeId="data-v-"+o),i?(u=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),n&&n.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i)},c._ssrRegister=u):n&&(u=s?function(){n.call(this,this.$root.$options.shadowRoot)}:n),u)if(c.functional){c._injectStyles=u;var l=c.render;c.render=function(e,r){return u.call(r),l(e,r)}}else{var p=c.beforeCreate;c.beforeCreate=p?[].concat(p,u):[u]}return{exports:e,options:c}}({name:"RuntimeTemplateCompiler",inheritAttrs:!1,props:{parent:{type:Object,default:void 0},template:{type:String,default:d.defaultRuntimeTemplate},compilerOptions:{type:Object,default:function(){return d.defaultCompilerOptions}},templateProps:{type:Object,default:function(){return{}}}},data:function(){return{isCompiling:!1,compiled:null}},computed:{componentProps:function(){var e=[this.parentData,this.parentProps,this.parentComponent._provided];return{filters:this.parentFilters,components:this.parentComponents,computed:this.parentComputed,methods:this.parentMethods,data:function(){return function(e){var r=arguments.length>1&&void 0!==arguments[1]&&arguments[1],t={},a=!0,n=!1,o=void 0;try{for(var i,s=e[Symbol.iterator]();!(a=(i=s.next()).done);a=!0){var u=i.value;l(u)&&(t=p(t,u,r))}}catch(e){n=!0,o=e}finally{try{a||null==s.return||s.return()}finally{if(n)throw o}}return t}(e)}}},parentComponent:function(){return this.parent||this.$parent},parentData:function(){return this.parentComponent.$data||{}},parentProps:function(){return this.parentComponent.$props||{}},parentOptions:function(){return this.parentComponent.$options||{}},parentComputed:function(){return this.parentOptions.computed||{}},parentComponents:function(){return this.parentOptions.components||{}},parentMethods:function(){return this.parentOptions.methods||{}},parentFilters:function(){return this.parentOptions.filters||{}}},beforeMount:function(){this.compile()},methods:{compile:function(){var e=Object(a.compileToFunctions)(this.template,this.compilerOptions);this.compiled=p(e,this.componentProps,!0)}}},(function(){var e=this.$createElement,r=this._self._c||e;return this.compiled?r(this.compiled,{tag:"component"}):this._e()}),[],!1,null,null,null).exports,v=function(e,r){e.component(r.name,r)},b={install:function(e){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};m(e),f(p(d,r,!0)),v(e,h)}};g=b,"undefined"!=typeof window&&window.Vue&&window.Vue.use(g);r.default=b}]);/* harmony default export */ var vue_runtime_template_compiler_esm = (VueRuntimeTemplateCompiler.default);const _VueRuntimeTemplateCompiler$RuntimeTemplateCompiler=VueRuntimeTemplateCompiler.RuntimeTemplateCompiler;
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/VueTemplate.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//


external_commonjs_vue_commonjs2_vue_root_Vue_default.a.use(vue_runtime_template_compiler_esm);
/* harmony default export */ var VueTemplatevue_type_script_lang_js_ = ({
  props: {
    a: Object,
    template: String
  }
});
// CONCATENATED MODULE: ./src/layout/VueTemplate.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_VueTemplatevue_type_script_lang_js_ = (VueTemplatevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/VueTemplate.vue?vue&type=custom&index=0&blockType=docs
var VueTemplatevue_type_custom_index_0_blockType_docs = __webpack_require__("6ca8");

// CONCATENATED MODULE: ./src/layout/VueTemplate.vue





/* normalize component */

var VueTemplate_component = Object(componentNormalizer["a" /* default */])(
  layout_VueTemplatevue_type_script_lang_js_,
  VueTemplatevue_type_template_id_516c66d7_render,
  VueTemplatevue_type_template_id_516c66d7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof VueTemplatevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(VueTemplatevue_type_custom_index_0_blockType_docs["default"])(VueTemplate_component)

/* harmony default export */ var VueTemplate = (VueTemplate_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowCard.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var RowCardvue_type_script_lang_js_ = ({
  components: {
    RenderValue: RenderValue,
    RowButtonEdit: RowButtonEdit["a" /* default */],
    RowButtonDelete: RowButtonDelete["a" /* default */],
    VueTemplate: VueTemplate
  },
  props: {
    columns: Array,
    tableName: String,
    row: Object,
    template: String,
    canEdit: Boolean
  },
  methods: {
    getKey(row) {
      let result = {};
      this.columns.filter(c => c.key == 1).map(c => result[c.name] = row[c.name]);
      return result;
    }

  }
});
// CONCATENATED MODULE: ./src/tables/RowCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_RowCardvue_type_script_lang_js_ = (RowCardvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/RowCard.vue?vue&type=style&index=0&id=366673e6&scoped=true&lang=css&
var RowCardvue_type_style_index_0_id_366673e6_scoped_true_lang_css_ = __webpack_require__("7a10");

// CONCATENATED MODULE: ./src/tables/RowCard.vue






/* normalize component */

var RowCard_component = Object(componentNormalizer["a" /* default */])(
  tables_RowCardvue_type_script_lang_js_,
  RowCardvue_type_template_id_366673e6_scoped_true_render,
  RowCardvue_type_template_id_366673e6_scoped_true_staticRenderFns,
  false,
  null,
  "366673e6",
  null
  
)

/* harmony default export */ var RowCard = (RowCard_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableCards.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var TableCardsvue_type_script_lang_js_ = ({
  components: {
    RowCard: RowCard
  },
  props: {
    data: Array,
    columns: Array,
    tableName: String,
    canEdit: Boolean,
    template: String
  }
});
// CONCATENATED MODULE: ./src/tables/TableCards.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_TableCardsvue_type_script_lang_js_ = (TableCardsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tables/TableCards.vue





/* normalize component */

var TableCards_component = Object(componentNormalizer["a" /* default */])(
  tables_TableCardsvue_type_script_lang_js_,
  TableCardsvue_type_template_id_6a16d47f_render,
  TableCardsvue_type_template_id_6a16d47f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TableCards = (TableCards_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RecordCard.vue?vue&type=template&id=23be722c&
var RecordCardvue_type_template_id_23be722c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(row){return _c('RowCard',{key:JSON.stringify(row) + _vm.template,attrs:{"row":row,"columns":_vm.columns,"tableName":_vm.tableName,"can-edit":_vm.canEdit,"template":_vm.template},on:{"reload":function($event){return _vm.$emit('reload')},"click":function($event){return _vm.$emit('click', $event)}}})}),1)}
var RecordCardvue_type_template_id_23be722c_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/RecordCard.vue?vue&type=template&id=23be722c&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RecordCard.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var RecordCardvue_type_script_lang_js_ = ({
  components: {
    RowCard: RowCard
  },
  props: {
    data: Array,
    columns: Array,
    tableName: String,
    canEdit: Boolean,
    template: String
  }
});
// CONCATENATED MODULE: ./src/tables/RecordCard.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_RecordCardvue_type_script_lang_js_ = (RecordCardvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tables/RecordCard.vue





/* normalize component */

var RecordCard_component = Object(componentNormalizer["a" /* default */])(
  tables_RecordCardvue_type_script_lang_js_,
  RecordCardvue_type_template_id_23be722c_render,
  RecordCardvue_type_template_id_23be722c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RecordCard = (RecordCard_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableSettings.vue?vue&type=template&id=2df0c4ca&
var TableSettingsvue_type_template_id_2df0c4ca_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.show)?_c('IconAction',{attrs:{"icon":"cog"},on:{"click":function($event){_vm.show = true}}}):_c('LayoutModal',{attrs:{"title":"Table Settings","show":_vm.show},on:{"close":function($event){_vm.show = false}},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.success)?_c('MessageSuccess',[_vm._v(_vm._s(_vm.success))]):_vm._e(),(_vm.graphqlError)?_c('MessageError',[_vm._v(_vm._s(_vm.graphqlError))]):_vm._e(),(_vm.loading)?_c('Spinner'):_c('form',[_c('p',{pre:true},[_vm._v(" The data is in variable 'a'. For example, "),_c('tt',{pre:true},[_vm._v("{{ a }}")]),_vm._v(" will show all values available. "),_c('tt',{pre:true},[_vm._v("{{ a.name }}")]),_vm._v(" will get the 'name' column ")],1),_c('InputText',{attrs:{"name":"cardTemplate","label":"cardTemplate","value":_vm.cardTemplate},on:{"input":_vm.emitCardTemplate}}),_c('InputText',{attrs:{"name":"recordTemplate","label":"recordTemplate","value":_vm.recordTemplate},on:{"input":_vm.emitRecordTemplate}}),_c('ButtonAlt',{on:{"click":function($event){_vm.show = false}}},[_vm._v("Close")]),_c('ButtonAction',{on:{"click":_vm.saveSettings}},[_vm._v("Save settings")])],1)]},proxy:true}])})}
var TableSettingsvue_type_template_id_2df0c4ca_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/TableSettings.vue?vue&type=template&id=2df0c4ca&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableSettings.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var TableSettingsvue_type_script_lang_js_ = ({
  components: {
    Spinner: Spinner["a" /* default */],
    MessageError: MessageError["a" /* default */],
    MessageSuccess: MessageSuccess["a" /* default */],
    IconAction: IconAction["a" /* default */],
    InputText: InputText["a" /* default */],
    ButtonAction: ButtonAction["a" /* default */],
    LayoutModal: LayoutModal["a" /* default */],
    ButtonAlt: ButtonAlt["a" /* default */]
  },
  props: {
    graphqlURL: {
      type: String,
      default: "graphql"
    },
    tableName: String,
    cardTemplate: String,
    recordTemplate: String
  },

  data() {
    return {
      show: false,
      graphqlError: null,
      success: null,
      loading: false
    };
  },

  methods: {
    emitCardTemplate(value) {
      this.$emit("update:cardTemplate", value);
    },

    emitRecordTemplate(value) {
      this.$emit("update:recordTemplate", value);
    },

    saveSettings() {
      this.loading = true;
      this.graphqlError = null;
      this.success = null;
      Object(dist["request"])(this.graphqlURL, `mutation change($settings:[MolgenisSettingsInput]){change(settings:$settings){message}}`, {
        settings: [{
          table: this.tableName,
          key: "cardTemplate",
          value: this.cardTemplate
        }, {
          table: this.tableName,
          key: "recordTemplate",
          value: this.recordTemplate
        }]
      }).then(data => {
        this.success = data.change.message;
        this.loading = false;
      }).catch(error => {
        this.graphqlError = error.response.errors[0].message;
        this.loading = false;
      });
    }

  }
});
// CONCATENATED MODULE: ./src/tables/TableSettings.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_TableSettingsvue_type_script_lang_js_ = (TableSettingsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/tables/TableSettings.vue





/* normalize component */

var TableSettings_component = Object(componentNormalizer["a" /* default */])(
  tables_TableSettingsvue_type_script_lang_js_,
  TableSettingsvue_type_template_id_2df0c4ca_render,
  TableSettingsvue_type_template_id_2df0c4ca_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TableSettings = (TableSettings_component.exports);
// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableExplorer.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















const View = {
  TABLE: "table",
  CARDS: "cards",
  RECORD: "record",
  EDIT: "edit"
};
/* harmony default export */ var TableExplorervue_type_script_lang_js_ = ({
  extends: TableMixin["a" /* default */],
  components: {
    Spinner: Spinner["a" /* default */],
    MessageError: MessageError["a" /* default */],
    TableMolgenis: TableMolgenis["a" /* default */],
    FilterSidebar: FilterSidebar,
    FilterWells: FilterWells,
    RowButtonEdit: RowButtonEdit["a" /* default */],
    RowButtonAdd: RowButtonAdd["a" /* default */],
    RowButtonDelete: RowButtonDelete["a" /* default */],
    ShowHide: ShowHide,
    InputSearch: InputSearch["a" /* default */],
    Pagination: Pagination["a" /* default */],
    ButtonAlt: ButtonAlt["a" /* default */],
    ButtonDropdown: ButtonDropdown,
    SelectionBox: SelectionBox["a" /* default */],
    InputSelect: InputSelect["a" /* default */],
    TableCards: TableCards,
    IconAction: IconAction["a" /* default */],
    RecordCard: RecordCard,
    TableSettings: TableSettings
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    showSelect: {
      type: Boolean,
      default: () => false
    },
    showHeader: {
      type: Boolean,
      default: () => true
    },
    showFilters: {
      type: Array,
      default: () => []
    },
    showColumns: {
      type: Array,
      default: () => []
    },
    showView: {
      type: String,
      default: View.TABLE
    },
    showPage: {
      type: Number,
      default: 1
    },
    showLimit: {
      type: Number,
      default: 20
    },
    conditions: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      View,
      cardTemplate: null,
      recordTemplate: null,
      selectedItems: [],
      page: 1,
      showSubclass: false,
      //a copy of column metadata used to show/hide filters and columns
      columns: [],
      view: View.TABLE
    };
  },

  methods: {
    toggleView() {
      if (this.view == View.TABLE) {
        this.view = View.CARDS;
        this.limit = this.showLimit;
      } else if (this.view == View.CARDS) {
        this.limit = 1;
        this.view = View.RECORD;
      } else {
        this.view = View.TABLE;
        this.limit = this.showLimit;
      }
    },

    emitColumns() {
      let columns = this.columns.filter(c => c.showColumn && c.columnType != "HEADING").map(c => c.name);
      this.$emit("update:showColumns", columns);
    },

    emitFilters() {
      this.$emit("update:showFilters", this.columns.filter(c => c.showFilter && c.columnType != "HEADING").map(c => c.name));
    },

    emitConditions() {
      let result = {};
      this.columns.forEach(c => {
        if (c.conditions && c.conditions.length > 0) result[c.name] = c.conditions;
      });
      this.$emit("update:conditions", result);
    },

    setlimit(limit) {
      this.limit = limit;
      this.page = 1;
      this.$emit("update:showLimit", limit);
    }

  },
  computed: {
    viewIcon() {
      //icon should be next
      if (this.view == View.CARDS) return "list-alt";else if (this.view == View.TABLE) return "th";else return "th-list";
    },

    tableMetadataMerged() {
      let tm = this.tableMetadata;
      tm.columns = this.columns;
      return tm;
    },

    countFilters() {
      if (this.columns) {
        return this.columns.filter(f => f.showFilter).length;
      }

      return null;
    },

    countColumns() {
      if (this.columns) {
        return this.columns.filter(f => f.showColumn).length;
      }

      return null;
    },

    hasSubclass() {
      if (this.columns && this.columns.filter(c => c.name == "mg_tableclass").length > 0) {
        return true;
      }

      return false;
    },

    //overrides from TableMixin
    graphqlFilter() {
      let filter = this.filter ? this.filter : {};

      if (this.columns) {
        this.columns.forEach(col => {
          let conditions = Array.isArray(col.conditions) ? col.conditions.filter(f => f !== "" && f != undefined) : [];

          if (conditions.length > 0) {
            if (col.columnType.startsWith("STRING") || col.columnType.startsWith("TEXT")) {
              filter[col.name] = {
                like: col.conditions
              };
            } else if (col.columnType.startsWith("BOOL")) {
              filter[col.name] = {
                equals: col.conditions
              };
            } else if (col.columnType.startsWith("REF") || col.columnType.startsWith("ONTOLOGY")) {
              filter[col.name] = {
                equals: col.conditions
              };
            } else if (["DECIMAL", "DECIMAL_ARRAY", "INT", "INT_ARRAY", "DATE", "DATE_ARRAY"].includes(col.columnType)) {
              filter[col.name] = {
                between: conditions.flat()
              };
            } else {
              alert("filter unsupported for column type '" + col.columnType + "' (please report a bug)");
            }
          }
        });
      }

      return filter;
    }

  },
  watch: {
    page() {
      this.loading = true;
      this.offset = this.limit * (this.page - 1);
      this.$emit("update:showPage", this.page);
      this.reload();
    },

    showPage() {
      this.page = this.showPage;
    },

    showLimit() {
      this.limit = this.showLimit;
    },

    tableMetadata() {
      this.page = this.showPage;
      this.limit = this.showLimit;

      if (this.columns.length == 0) {
        this.columns.push(...this.tableMetadata.columns); // //init settings

        this.columns.forEach(c => {
          //show columns
          if (this.showColumns && this.showColumns.length > 0) {
            if (this.showColumns.includes(c.name)) {
              c.showColumn = true;
            } else {
              c.showColumn = false;
            }
          } else {
            //default we show all non mg_ columns
            if (!c.name.startsWith("mg_")) {
              c.showColumn = true;
            } else {
              c.showColumn = false;
            }
          } //show filters


          if (this.showFilters && this.showFilters.length > 0) {
            if (this.showFilters.includes(c.name)) {
              c.showFilter = true;
            } else {
              c.showFilter = false;
            }
          } else {
            //default we hide all filters
            c.showFilter = false;
          }
        });

        if (this.showView) {
          this.view = this.showView;
        }

        this.columns.forEach(c => {
          if (this.conditions[c.name] && this.conditions[c.name].length > 0) {
            this.$set(c, "conditions", this.conditions[c.name]); //haat vue reactivity
          } else {
            delete c.conditions;
          }
        }); //table settings

        if (this.tableMetadata.settings) {
          this.tableMetadata.settings.forEach(s => {
            if (s.key == "cardTemplate") this.cardTemplate = s.value;
            if (s.key == "recordTemplate") this.recordTemplate = s.value;
          });
        }
      }

      this.reload();
    }

  }
});
// CONCATENATED MODULE: ./src/tables/TableExplorer.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_TableExplorervue_type_script_lang_js_ = (TableExplorervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/TableExplorer.vue?vue&type=custom&index=0&blockType=docs
var TableExplorervue_type_custom_index_0_blockType_docs = __webpack_require__("94ca");

// CONCATENATED MODULE: ./src/tables/TableExplorer.vue





/* normalize component */

var TableExplorer_component = Object(componentNormalizer["a" /* default */])(
  tables_TableExplorervue_type_script_lang_js_,
  TableExplorervue_type_template_id_78a15904_render,
  TableExplorervue_type_template_id_78a15904_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof TableExplorervue_type_custom_index_0_blockType_docs["default"] === 'function') Object(TableExplorervue_type_custom_index_0_blockType_docs["default"])(TableExplorer_component)

/* harmony default export */ var TableExplorer = (TableExplorer_component.exports);
// EXTERNAL MODULE: ./src/layout/ReadMore.vue + 4 modules
var ReadMore = __webpack_require__("4b97");

// EXTERNAL MODULE: ./src/tables/RowFormInput.vue + 4 modules
var RowFormInput = __webpack_require__("2b6d");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/ShowMore.vue?vue&type=template&id=0bab3d87&
var ShowMorevue_type_template_id_0bab3d87_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('ButtonAlt',{on:{"click":function($event){_vm.show = false}}},[_vm._v(_vm._s(_vm.hideLabel))]),_vm._t("default")],2):_c('ButtonAlt',{on:{"click":function($event){_vm.show = true}}},[_vm._v(_vm._s(_vm.showLabel)+" "),_c('br')])}
var ShowMorevue_type_template_id_0bab3d87_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/ShowMore.vue?vue&type=template&id=0bab3d87&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/ShowMore.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//

/* harmony default export */ var ShowMorevue_type_script_lang_js_ = ({
  components: {
    ButtonAlt: ButtonAlt["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: "debug"
    }
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    showLabel() {
      return "show " + this.title;
    },

    hideLabel() {
      return "hide " + this.title;
    }

  }
});
// CONCATENATED MODULE: ./src/layout/ShowMore.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_ShowMorevue_type_script_lang_js_ = (ShowMorevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/ShowMore.vue?vue&type=custom&index=0&blockType=docs
var ShowMorevue_type_custom_index_0_blockType_docs = __webpack_require__("608b");

// CONCATENATED MODULE: ./src/layout/ShowMore.vue





/* normalize component */

var ShowMore_component = Object(componentNormalizer["a" /* default */])(
  layout_ShowMorevue_type_script_lang_js_,
  ShowMorevue_type_template_id_0bab3d87_render,
  ShowMorevue_type_template_id_0bab3d87_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof ShowMorevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(ShowMorevue_type_custom_index_0_blockType_docs["default"])(ShowMore_component)

/* harmony default export */ var ShowMore = (ShowMore_component.exports);
// EXTERNAL MODULE: ./src/mixins/TableMetadataMixin.vue + 2 modules
var TableMetadataMixin = __webpack_require__("9961");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableSimple.vue?vue&type=template&id=816315cc&scoped=true&
var TableSimplevue_type_template_id_816315cc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered",class:{ 'table-hover': _vm.tableHover }},[_c('thead',[_c('tr',[(_vm.hasColheader)?_c('th',{staticStyle:{"width":"1px"},attrs:{"scope":"col"}},[_vm._t("colheader")],2):_vm._e(),_vm._l((_vm.columns),function(col){return _c('th',{key:col,attrs:{"scope":"col"}},[_vm._v(" "+_vm._s(col)+" ")])})],2)]),_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',{key:JSON.stringify(row)},[(_vm.hasColheader)?_c('td',[_c('div',{staticStyle:{"display":"flex"}},[_vm._t("rowheader",null,{"row":row}),(_vm.selectColumn)?_c('input',{staticClass:"form-check form-check-inline mr-1",attrs:{"type":"checkbox"},domProps:{"checked":_vm.isSelected(row)},on:{"click":function($event){return _vm.onRowClick(row)}}}):_vm._e()],2)]):_vm._e(),_vm._l((_vm.columns),function(col){return _c('td',{key:col,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.onRowClick(row)}}},[(Array.isArray(row[col]))?_c('ul',{staticClass:"list-unstyled"},_vm._l((row[col]),function(item,index3){return _c('li',{key:index3},[_vm._v(" "+_vm._s(item)+" ")])}),0):(row[col])?_c('span',[_vm._v(_vm._s(_vm.flattenObject(row[col])))]):_vm._e()])})],2)}),0)])])}
var TableSimplevue_type_template_id_816315cc_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/TableSimple.vue?vue&type=template&id=816315cc&scoped=true&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableSimple.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/** Data table. Has also option to have row selection. Selection events must be handled outside this view. */
/* harmony default export */ var TableSimplevue_type_script_lang_js_ = ({
  props: {
    /** the column names */
    columns: Array,

    /** list of rows matching column names */
    rows: Array,

    /** set to create select boxes that will yield this columns value when selected. */
    selectColumn: String,

    /** default value */
    defaultValue: Array
  },
  data: function () {
    return {
      selectedItems: []
    };
  },
  watch: {
    selectedItems() {
      this.$emit("input", this.selectedItems);
    }

  },

  created() {
    if (this.defaultValue instanceof Array) {
      this.selectedItems = this.defaultValue;
    } else {
      this.selectedItems.push(this.defaultValue);
    }
  },

  computed: {
    tableHover() {
      return this.selectColumn || this.$listeners && this.$listeners.click;
    },

    hasColheader() {
      return this.selectColumn || !!this.$slots["colheader"] || !!this.$scopedSlots["colheader"] || !!this.$slots["rowheader"] || !!this.$scopedSlots["rowheader"];
    }

  },
  methods: {
    flattenObject(object) {
      let result = "";

      if (typeof object === "object") {
        Object.keys(object).forEach(key => {
          if (object[key] === null) {//nothing
          } else if (typeof object[key] === "object") {
            result += this.flattenObject(object[key]);
          } else {
            result += " " + object[key];
          }
        });
      } else {
        result = object;
      }

      return result.replace(/^\./, "");
    },

    isSelected(row) {
      return this.selectedItems != null && this.selectedItems.includes(row[this.selectColumn]);
    },

    onRowClick(row) {
      if (this.selectColumn) {
        if (this.isSelected(row)) {
          /** when a row is deselected */
          this.selectedItems = this.selectedItems.filter(item => item !== row[this.selectColumn]);
          this.$emit("deselect", row[this.selectColumn]);
        } else {
          /** when a row is selected */
          this.selectedItems.push(row[this.selectColumn]);
          this.$emit("select", row[this.selectColumn]);
        }
      } else {
        this.$emit("click", row);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/tables/TableSimple.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_TableSimplevue_type_script_lang_js_ = (TableSimplevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/TableSimple.vue?vue&type=style&index=0&id=816315cc&scoped=true&lang=css&
var TableSimplevue_type_style_index_0_id_816315cc_scoped_true_lang_css_ = __webpack_require__("4e2c");

// EXTERNAL MODULE: ./src/tables/TableSimple.vue?vue&type=custom&index=0&blockType=docs
var TableSimplevue_type_custom_index_0_blockType_docs = __webpack_require__("52c2");

// CONCATENATED MODULE: ./src/tables/TableSimple.vue






/* normalize component */

var TableSimple_component = Object(componentNormalizer["a" /* default */])(
  tables_TableSimplevue_type_script_lang_js_,
  TableSimplevue_type_template_id_816315cc_scoped_true_render,
  TableSimplevue_type_template_id_816315cc_scoped_true_staticRenderFns,
  false,
  null,
  "816315cc",
  null
  
)

/* custom blocks */

if (typeof TableSimplevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(TableSimplevue_type_custom_index_0_blockType_docs["default"])(TableSimple_component)

/* harmony default export */ var TableSimple = (TableSimple_component.exports);
// EXTERNAL MODULE: ./src/tables/TableSearch.vue + 4 modules
var TableSearch = __webpack_require__("7f62");

// CONCATENATED MODULE: ./src/index.js































































// CONCATENATED MODULE: ../node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ }),

/***/ "1b73":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0ca2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("27b1b386", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "219f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisAccount_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fd53");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisAccount_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisAccount_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisAccount_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "231d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectionBox_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d55b");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectionBox_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectionBox_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SelectionBox_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2499":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDecimal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7338");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDecimal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDecimal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDecimal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "25b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/MessageError.vue?vue&type=template&id=1c06392c&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/MessageError.vue?vue&type=template&id=1c06392c&

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/MessageError.vue?vue&type=custom&index=0&blockType=docs
var MessageErrorvue_type_custom_index_0_blockType_docs = __webpack_require__("3699");

// CONCATENATED MODULE: ./src/forms/MessageError.vue

var script = {}


/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof MessageErrorvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(MessageErrorvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var MessageError = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "25fd":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "270c":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "27d8":
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():undefined}(this,function(){var e="undefined"!=typeof window,n="undefined"!=typeof navigator,t=e&&("ontouchstart"in window||n&&navigator.msMaxTouchPoints>0)?["touchstart"]:["click"];function i(e){var n=e.event,t=e.handler;(0,e.middleware)(n)&&t(n)}function r(e,n){var r=function(e){var n="function"==typeof e;if(!n&&"object"!=typeof e)throw new Error("v-click-outside: Binding value must be a function or an object");return{handler:n?e:e.handler,middleware:e.middleware||function(e){return e},events:e.events||t,isActive:!(!1===e.isActive),detectIframe:!(!1===e.detectIframe)}}(n.value),d=r.handler,o=r.middleware,a=r.detectIframe;if(r.isActive){if(e["__v-click-outside"]=r.events.map(function(n){return{event:n,srcTarget:document.documentElement,handler:function(n){return function(e){var n=e.el,t=e.event,r=e.handler,d=e.middleware,o=t.path||t.composedPath&&t.composedPath();(o?o.indexOf(n)<0:!n.contains(t.target))&&i({event:t,handler:r,middleware:d})}({el:e,event:n,handler:d,middleware:o})}}}),a){var c={event:"blur",srcTarget:window,handler:function(n){return function(e){var n=e.el,t=e.event,r=e.handler,d=e.middleware;setTimeout(function(){var e=document.activeElement;e&&"IFRAME"===e.tagName&&!n.contains(e)&&i({event:t,handler:r,middleware:d})},0)}({el:e,event:n,handler:d,middleware:o})}};e["__v-click-outside"]=[].concat(e["__v-click-outside"],[c])}e["__v-click-outside"].forEach(function(n){var t=n.event,i=n.srcTarget,r=n.handler;return setTimeout(function(){e["__v-click-outside"]&&i.addEventListener(t,r,!1)},0)})}}function d(e){(e["__v-click-outside"]||[]).forEach(function(e){return e.srcTarget.removeEventListener(e.event,e.handler,!1)}),delete e["__v-click-outside"]}var o=e?{bind:r,update:function(e,n){var t=n.value,i=n.oldValue;JSON.stringify(t)!==JSON.stringify(i)&&(d(e),r(e,{value:t}))},unbind:d}:{};return{install:function(e){e.directive("click-outside",o)},directive:o}});
//# sourceMappingURL=v-click-outside.umd.js.map


/***/ }),

/***/ "2b6d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowFormInput.vue?vue&type=template&id=51c93d00&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.columnType === 'HEADING')?_c('InputHeading',_vm._g(_vm._b({},'InputHeading',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'STRING')?_c('InputString',_vm._g(_vm._b({model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputString',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'TEXT')?_c('InputText',_vm._g(_vm._b({model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputText',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'INT')?_c('InputInt',_vm._g(_vm._b({model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputInt',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'DECIMAL')?_c('InputDecimal',_vm._g(_vm._b({model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputDecimal',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'BOOL')?_c('InputBoolean',_vm._g(_vm._b({model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputBoolean',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'ONTOLOGY' || _vm.columnType === 'ONTOLOGY_ARRAY')?_c('InputOntology',_vm._g(_vm._b({attrs:{"table":_vm.table,"list":_vm.columnType === 'ONTOLOGY_ARRAY'},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputOntology',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'REF')?_c('InputRefSelect',_vm._g(_vm._b({attrs:{"filter":_vm.filter,"table":_vm.table},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputRefSelect',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'DATE')?_c('InputDate',_vm._g(_vm._b({model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputDate',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'DATETIME')?_c('InputDateTime',_vm._g(_vm._b({model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputDateTime',_vm.$props,false),_vm.$listeners)):(
      _vm.columnType === 'REF_ARRAY' ||
      _vm.columnType === 'MREF' ||
      _vm.refBackType === 'REF_ARRAY'
    )?_c('InputRef',_vm._g(_vm._b({attrs:{"list":true,"multiple-columns":true,"max-num":35,"table":_vm.table,"graphqlURL":_vm.graphqlURL},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputRef',_vm.$props,false),_vm.$listeners)):(_vm.refBackType == 'REF')?_c('inputRefback',_vm._b({attrs:{"table":_vm.table}},'inputRefback',_vm.$props,false)):(_vm.columnType === 'STRING_ARRAY')?_c('InputString',_vm._g(_vm._b({attrs:{"list":true},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputString',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'TEXT_ARRAY')?_c('InputText',_vm._g(_vm._b({attrs:{"list":true},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputText',_vm.$props,false),_vm.$listeners)):(_vm.columnType === 'FILE')?_c('InputFile',_vm._g(_vm._b({model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'InputFile',_vm.$props,false),_vm.$listeners)):_c('div',[_vm._v("UNSUPPORTED TYPE '"+_vm._s(_vm.columnType)+"'")])],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/RowFormInput.vue?vue&type=template&id=51c93d00&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/InputString.vue + 4 modules
var InputString = __webpack_require__("ffa4");

// EXTERNAL MODULE: ./src/forms/InputInt.vue + 2 modules
var InputInt = __webpack_require__("758c");

// EXTERNAL MODULE: ./src/forms/InputDecimal.vue + 2 modules
var InputDecimal = __webpack_require__("4b35");

// EXTERNAL MODULE: ./src/forms/InputBoolean.vue + 4 modules
var InputBoolean = __webpack_require__("6223");

// EXTERNAL MODULE: ./src/forms/InputDate.vue + 4 modules
var InputDate = __webpack_require__("54cd");

// EXTERNAL MODULE: ./src/forms/InputDateTime.vue + 2 modules
var InputDateTime = __webpack_require__("d3dd");

// EXTERNAL MODULE: ./src/forms/InputFile.vue + 4 modules
var InputFile = __webpack_require__("b5c9");

// EXTERNAL MODULE: ./src/forms/InputText.vue + 4 modules
var InputText = __webpack_require__("d622");

// EXTERNAL MODULE: ./src/forms/InputHeading.vue + 4 modules
var InputHeading = __webpack_require__("7022");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowFormInput.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var RowFormInputvue_type_script_lang_js_ = ({
  name: "RowFormInput",
  extends: _baseInput["a" /* default */],
  props: {
    /** enable editing of label and description*/
    editMeta: Boolean,
    schema: String,
    columnType: String,
    description: String,
    filter: Object,
    table: String,
    refLabel: String,
    refBack: String,
    refBackType: String,
    pkey: Object,
    graphqlURL: {
      default: "graphql",
      type: String
    }
  },

  data() {
    return {
      input: null
    };
  },

  components: {
    InputString: InputString["a" /* default */],
    InputInt: InputInt["a" /* default */],
    InputDecimal: InputDecimal["a" /* default */],
    InputBoolean: InputBoolean["a" /* default */],
    InputRefSelect: () => Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "0acc")),
    //because it uses itself in nested form
    InputDate: InputDate["a" /* default */],
    InputDateTime: InputDateTime["a" /* default */],
    InputFile: InputFile["a" /* default */],
    InputText: InputText["a" /* default */],
    InputHeading: InputHeading["a" /* default */],
    InputOntology: () => Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "398c")),
    //because it uses itself in nested form,
    InputRef: () => Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "c1b6")),
    //because it uses itself in nested form,
    InputRefback: () => Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "edb6")) //because it uses itself in nested form,

  },

  created() {
    this.input = this.value;
  },

  watch: {
    value() {
      this.input = this.value;
    },

    input() {
      this.$emit("input", this.input);
    }

  }
});
// CONCATENATED MODULE: ./src/tables/RowFormInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_RowFormInputvue_type_script_lang_js_ = (RowFormInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/tables/RowFormInput.vue?vue&type=custom&index=0&blockType=docs
var RowFormInputvue_type_custom_index_0_blockType_docs = __webpack_require__("e3df");

// CONCATENATED MODULE: ./src/tables/RowFormInput.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tables_RowFormInputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof RowFormInputvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(RowFormInputvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var RowFormInput = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "2c13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconDanger_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a89d");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconDanger_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconDanger_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconDanger_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2cad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/_appendClear.vue?vue&type=template&id=11915a9c&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn bg-transparent",class:{
    'text-primary': !_vm.error,
    'text-danger': _vm.error,
  },staticStyle:{"margin-left":"-40px","z-index":"100"},attrs:{"disabled":_vm.disabled,"type":"button","title":"Clear","data-clear":""},on:{"click":function($event){return _vm.$emit('clear')}}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa fa-times"},[_c('span',{staticClass:"sr-only",attrs:{"aria-hidden":"true"}},[_vm._v("Clear")])])}]


// CONCATENATED MODULE: ./src/forms/_appendClear.vue?vue&type=template&id=11915a9c&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/_appendClear.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var _appendClearvue_type_script_lang_js_ = ({
  props: {
    disabled: Boolean,
    error: String
  }
});
// CONCATENATED MODULE: ./src/forms/_appendClear.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_appendClearvue_type_script_lang_js_ = (_appendClearvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// CONCATENATED MODULE: ./src/forms/_appendClear.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_appendClearvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var _appendClear = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "2da8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeInt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1197");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeInt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeInt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeInt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "2e19":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".radio-clear-value{display:none}.radio-form-group:hover .radio-clear-value{display:inline}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "2e60":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "2f89":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ReadMore_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8927");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ReadMore_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ReadMore_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ReadMore_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3103":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutModal_vue_vue_type_style_index_0_id_66761957_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e21a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutModal_vue_vue_type_style_index_0_id_66761957_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutModal_vue_vue_type_style_index_0_id_66761957_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3212":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/IconDanger.vue?vue&type=template&id=ecbece00&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn pl-1 pr-1 btn-outline-danger border-0",on:{"click":_vm.onClick}},[(_vm.label)?_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('i',{class:'fas fa-fw fa-' + _vm.icon})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/IconDanger.vue?vue&type=template&id=ecbece00&

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/IconDanger.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/** Button that is shown as a icon */

/* harmony default export */ var IconDangervue_type_script_lang_js_ = ({
  extends: IconAction["a" /* default */]
});
// CONCATENATED MODULE: ./src/forms/IconDanger.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_IconDangervue_type_script_lang_js_ = (IconDangervue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/IconDanger.vue?vue&type=custom&index=0&blockType=docs
var IconDangervue_type_custom_index_0_blockType_docs = __webpack_require__("2c13");

// CONCATENATED MODULE: ./src/forms/IconDanger.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_IconDangervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof IconDangervue_type_custom_index_0_blockType_docs["default"] === 'function') Object(IconDangervue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var IconDanger = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "3250":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d0e5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("2cb8edc6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "32f3":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "330e":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "34d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonDelete_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e10d");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonDelete_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonDelete_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonDelete_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "356e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputCheckbox_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d23b");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputCheckbox_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputCheckbox_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputCheckbox_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3623":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ../node_modules/flatpickr/dist/esm/types/options.js
const HOOKS = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition",
];
const options_defaults = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" &&
        window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: (err) => typeof console !== "undefined" && console.warn(err),
    getWeek: (givenDate) => {
        const date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
        var week1 = new Date(date.getFullYear(), 0, 4);
        return (1 +
            Math.round(((date.getTime() - week1.getTime()) / 86400000 -
                3 +
                ((week1.getDay() + 6) % 7)) /
                7));
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false,
};

// CONCATENATED MODULE: ../node_modules/flatpickr/dist/esm/l10n/default.js
const english = {
    weekdays: {
        shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ],
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
    },
    daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    firstDayOfWeek: 0,
    ordinal: (nth) => {
        const s = nth % 100;
        if (s > 3 && s < 21)
            return "th";
        switch (s % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: ["AM", "PM"],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false,
};
/* harmony default export */ var l10n_default = (english);

// CONCATENATED MODULE: ../node_modules/flatpickr/dist/esm/utils/index.js
const pad = (number, length = 2) => `000${number}`.slice(length * -1);
const utils_int = (bool) => (bool === true ? 1 : 0);
function debounce(fn, wait) {
    let t;
    return function () {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, arguments), wait);
    };
}
const arrayify = (obj) => obj instanceof Array ? obj : [obj];

// CONCATENATED MODULE: ../node_modules/flatpickr/dist/esm/utils/dom.js
function toggleClass(elem, className, bool) {
    if (bool === true)
        return elem.classList.add(className);
    elem.classList.remove(className);
}
function createElement(tag, className, content) {
    const e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined)
        e.textContent = content;
    return e;
}
function clearNode(node) {
    while (node.firstChild)
        node.removeChild(node.firstChild);
}
function findParent(node, condition) {
    if (condition(node))
        return node;
    else if (node.parentNode)
        return findParent(node.parentNode, condition);
    return undefined;
}
function createNumberInput(inputClassName, opts) {
    const wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
        numInput.type = "number";
    }
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined)
        for (const key in opts)
            numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function getEventTarget(event) {
    try {
        if (typeof event.composedPath === "function") {
            const path = event.composedPath();
            return path[0];
        }
        return event.target;
    }
    catch (error) {
        return event.target;
    }
}

// CONCATENATED MODULE: ../node_modules/flatpickr/dist/esm/utils/formatting.js

const doNothing = () => undefined;
const monthToStr = (monthNumber, shorthand, locale) => locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
const revFormat = {
    D: doNothing,
    F: function (dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: (dateObj, hour) => {
        dateObj.setHours(parseFloat(hour));
    },
    H: (dateObj, hour) => {
        dateObj.setHours(parseFloat(hour));
    },
    J: (dateObj, day) => {
        dateObj.setDate(parseFloat(day));
    },
    K: (dateObj, amPM, locale) => {
        dateObj.setHours((dateObj.getHours() % 12) +
            12 * utils_int(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function (dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: (dateObj, seconds) => {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: (_, unixSeconds) => new Date(parseFloat(unixSeconds) * 1000),
    W: function (dateObj, weekNum, locale) {
        const weekNumber = parseInt(weekNum);
        const date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: (dateObj, year) => {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: (_, ISODate) => new Date(ISODate),
    d: (dateObj, day) => {
        dateObj.setDate(parseFloat(day));
    },
    h: (dateObj, hour) => {
        dateObj.setHours(parseFloat(hour));
    },
    i: (dateObj, minutes) => {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: (dateObj, day) => {
        dateObj.setDate(parseFloat(day));
    },
    l: doNothing,
    m: (dateObj, month) => {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: (dateObj, month) => {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: (dateObj, seconds) => {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: (_, unixMillSeconds) => new Date(parseFloat(unixMillSeconds)),
    w: doNothing,
    y: (dateObj, year) => {
        dateObj.setFullYear(2000 + parseFloat(year));
    },
};
const tokenRegex = {
    D: "(\\w+)",
    F: "(\\w+)",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "(\\w+)",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "(\\w+)",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})",
};
const formatting_formats = {
    Z: (date) => date.toISOString(),
    D: function (date, locale, options) {
        return locale.weekdays.shorthand[formatting_formats.w(date, locale, options)];
    },
    F: function (date, locale, options) {
        return monthToStr(formatting_formats.n(date, locale, options) - 1, false, locale);
    },
    G: function (date, locale, options) {
        return pad(formatting_formats.h(date, locale, options));
    },
    H: (date) => pad(date.getHours()),
    J: function (date, locale) {
        return locale.ordinal !== undefined
            ? date.getDate() + locale.ordinal(date.getDate())
            : date.getDate();
    },
    K: (date, locale) => locale.amPM[utils_int(date.getHours() > 11)],
    M: function (date, locale) {
        return monthToStr(date.getMonth(), true, locale);
    },
    S: (date) => pad(date.getSeconds()),
    U: (date) => date.getTime() / 1000,
    W: function (date, _, options) {
        return options.getWeek(date);
    },
    Y: (date) => pad(date.getFullYear(), 4),
    d: (date) => pad(date.getDate()),
    h: (date) => (date.getHours() % 12 ? date.getHours() % 12 : 12),
    i: (date) => pad(date.getMinutes()),
    j: (date) => date.getDate(),
    l: function (date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: (date) => pad(date.getMonth() + 1),
    n: (date) => date.getMonth() + 1,
    s: (date) => date.getSeconds(),
    u: (date) => date.getTime(),
    w: (date) => date.getDay(),
    y: (date) => String(date.getFullYear()).substring(2),
};

// CONCATENATED MODULE: ../node_modules/flatpickr/dist/esm/utils/dates.js



const createDateFormatter = ({ config = options_defaults, l10n = english, isMobile = false, }) => (dateObj, frmt, overrideLocale) => {
    const locale = overrideLocale || l10n;
    if (config.formatDate !== undefined && !isMobile) {
        return config.formatDate(dateObj, frmt, locale);
    }
    return frmt
        .split("")
        .map((c, i, arr) => formatting_formats[c] && arr[i - 1] !== "\\"
        ? formatting_formats[c](dateObj, locale, config)
        : c !== "\\"
            ? c
            : "")
        .join("");
};
const createDateParser = ({ config = options_defaults, l10n = english }) => (date, givenFormat, timeless, customLocale) => {
    if (date !== 0 && !date)
        return undefined;
    const locale = customLocale || l10n;
    let parsedDate;
    const dateOrig = date;
    if (date instanceof Date)
        parsedDate = new Date(date.getTime());
    else if (typeof date !== "string" &&
        date.toFixed !== undefined)
        parsedDate = new Date(date);
    else if (typeof date === "string") {
        const format = givenFormat || (config || options_defaults).dateFormat;
        const datestr = String(date).trim();
        if (datestr === "today") {
            parsedDate = new Date();
            timeless = true;
        }
        else if (/Z$/.test(datestr) ||
            /GMT$/.test(datestr))
            parsedDate = new Date(date);
        else if (config && config.parseDate)
            parsedDate = config.parseDate(date, format);
        else {
            parsedDate =
                !config || !config.noCalendar
                    ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)
                    : new Date(new Date().setHours(0, 0, 0, 0));
            let matched, ops = [];
            for (let i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
                const token = format[i];
                const isBackSlash = token === "\\";
                const escaped = format[i - 1] === "\\" || isBackSlash;
                if (tokenRegex[token] && !escaped) {
                    regexStr += tokenRegex[token];
                    const match = new RegExp(regexStr).exec(date);
                    if (match && (matched = true)) {
                        ops[token !== "Y" ? "push" : "unshift"]({
                            fn: revFormat[token],
                            val: match[++matchIndex],
                        });
                    }
                }
                else if (!isBackSlash)
                    regexStr += ".";
                ops.forEach(({ fn, val }) => (parsedDate = fn(parsedDate, val, locale) || parsedDate));
            }
            parsedDate = matched ? parsedDate : undefined;
        }
    }
    if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
        config.errorHandler(new Error(`Invalid date provided: ${dateOrig}`));
        return undefined;
    }
    if (timeless === true)
        parsedDate.setHours(0, 0, 0, 0);
    return parsedDate;
};
function compareDates(date1, date2, timeless = true) {
    if (timeless !== false) {
        return (new Date(date1.getTime()).setHours(0, 0, 0, 0) -
            new Date(date2.getTime()).setHours(0, 0, 0, 0));
    }
    return date1.getTime() - date2.getTime();
}
function compareTimes(date1, date2) {
    return (3600 * (date1.getHours() - date2.getHours()) +
        60 * (date1.getMinutes() - date2.getMinutes()) +
        date1.getSeconds() -
        date2.getSeconds());
}
const isBetween = (ts, ts1, ts2) => {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
const duration = {
    DAY: 86400000,
};
function getDefaultHours(config) {
    let hours = config.defaultHour;
    let minutes = config.defaultMinute;
    let seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        const minHour = config.minDate.getHours();
        const minMinutes = config.minDate.getMinutes();
        const minSeconds = config.minDate.getSeconds();
        if (hours < minHour) {
            hours = minHour;
        }
        if (hours === minHour && minutes < minMinutes) {
            minutes = minMinutes;
        }
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds)
            seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        const maxHr = config.maxDate.getHours();
        const maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr)
            minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes)
            seconds = config.maxDate.getSeconds();
    }
    return { hours, minutes, seconds };
}

// EXTERNAL MODULE: ../node_modules/flatpickr/dist/esm/utils/polyfills.js
var polyfills = __webpack_require__("52c5");

// CONCATENATED MODULE: ../node_modules/flatpickr/dist/esm/index.js







const DEBOUNCED_CHANGE_MS = 300;
function FlatpickrInstance(element, instanceConfig) {
    const self = {
        config: Object.assign(Object.assign({}, options_defaults), flatpickr.defaultConfig),
        l10n: l10n_default,
    };
    self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self._createElement = createElement;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth(month = self.currentMonth, yr = self.currentYear) {
                if (month === 1 && ((yr % 4 === 0 && yr % 100 !== 0) || yr % 400 === 0))
                    return 29;
                return self.l10n.daysInMonth[month];
            },
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile)
            build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) {
                setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            }
            updateValue(false);
        }
        setCalendarWidth();
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) {
            positionCalendar();
        }
        triggerEvent("onReady");
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        const config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) {
            return;
        }
        else if (config.noCalendar !== true) {
            window.requestAnimationFrame(function () {
                if (self.calendarContainer !== undefined) {
                    self.calendarContainer.style.visibility = "hidden";
                    self.calendarContainer.style.display = "block";
                }
                if (self.daysContainer !== undefined) {
                    const daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                    self.daysContainer.style.width = daysWidth + "px";
                    self.calendarContainer.style.width =
                        daysWidth +
                            (self.weekWrapper !== undefined
                                ? self.weekWrapper.offsetWidth
                                : 0) +
                            "px";
                    self.calendarContainer.style.removeProperty("visibility");
                    self.calendarContainer.style.removeProperty("display");
                }
            });
        }
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            const defaultDate = self.config.minDate === undefined ||
                compareDates(new Date(), self.config.minDate) >= 0
                ? new Date()
                : new Date(self.config.minDate.getTime());
            const defaults = getDefaultHours(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [defaultDate];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") {
            timeWrapper(e);
        }
        const prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) {
            self._debouncedChange();
        }
    }
    function ampm2military(hour, amPM) {
        return (hour % 12) + 12 * utils_int(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch (hour % 24) {
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined)
            return;
        let hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined
            ? (parseInt(self.secondElement.value, 10) || 0) % 60
            : 0;
        if (self.amPM !== undefined) {
            hours = ampm2military(hours, self.amPM.textContent);
        }
        const limitMinHours = self.config.minTime !== undefined ||
            (self.config.minDate &&
                self.minDateHasTime &&
                self.latestSelectedDateObj &&
                compareDates(self.latestSelectedDateObj, self.config.minDate, true) ===
                    0);
        const limitMaxHours = self.config.maxTime !== undefined ||
            (self.config.maxDate &&
                self.maxDateHasTime &&
                self.latestSelectedDateObj &&
                compareDates(self.latestSelectedDateObj, self.config.maxDate, true) ===
                    0);
        if (limitMaxHours) {
            const maxTime = self.config.maxTime !== undefined
                ? self.config.maxTime
                : self.config.maxDate;
            hours = Math.min(hours, maxTime.getHours());
            if (hours === maxTime.getHours())
                minutes = Math.min(minutes, maxTime.getMinutes());
            if (minutes === maxTime.getMinutes())
                seconds = Math.min(seconds, maxTime.getSeconds());
        }
        if (limitMinHours) {
            const minTime = self.config.minTime !== undefined
                ? self.config.minTime
                : self.config.minDate;
            hours = Math.max(hours, minTime.getHours());
            if (hours === minTime.getHours() && minutes < minTime.getMinutes())
                minutes = minTime.getMinutes();
            if (minutes === minTime.getMinutes())
                seconds = Math.max(seconds, minTime.getSeconds());
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        const date = dateObj || self.latestSelectedDateObj;
        if (date) {
            setHours(date.getHours(), date.getMinutes(), date.getSeconds());
        }
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) {
            self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        }
        if (!self.hourElement || !self.minuteElement || self.isMobile)
            return;
        self.hourElement.value = pad(!self.config.time_24hr
            ? ((12 + hours) % 12) + 12 * utils_int(hours % 12 === 0)
            : hours);
        self.minuteElement.value = pad(minutes);
        if (self.amPM !== undefined)
            self.amPM.textContent = self.l10n.amPM[utils_int(hours >= 12)];
        if (self.secondElement !== undefined)
            self.secondElement.value = pad(seconds);
    }
    function onYearInput(event) {
        const eventTarget = getEventTarget(event);
        const year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 ||
            (event.key === "Enter" && !/[^\d]/.test(year.toString()))) {
            changeYear(year);
        }
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array)
            return event.forEach((ev) => bind(element, ev, handler, options));
        if (element instanceof Array)
            return element.forEach((el) => bind(el, event, handler, options));
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: () => element.removeEventListener(event, handler),
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) {
            ["open", "close", "toggle", "clear"].forEach((evt) => {
                Array.prototype.forEach.call(self.element.querySelectorAll(`[data-${evt}]`), (el) => bind(el, "click", self[evt]));
            });
        }
        if (self.isMobile) {
            setupMobile();
            return;
        }
        const debouncedResize = debounce(onResize, 50);
        self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
            bind(self.daysContainer, "mouseover", (e) => {
                if (self.config.mode === "range")
                    onMouseOver(getEventTarget(e));
            });
        bind(window.document.body, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static)
            bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined)
            bind(window.document, "touchstart", documentClick);
        else
            bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, { capture: true });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, ["keyup", "increment"], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined &&
            self.minuteElement !== undefined &&
            self.hourElement !== undefined) {
            const selText = (e) => getEventTarget(e).select();
            bind(self.timeContainer, ["increment"], updateTime);
            bind(self.timeContainer, "blur", updateTime, { capture: true });
            bind(self.timeContainer, "click", timeIncrement);
            bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
            if (self.secondElement !== undefined)
                bind(self.secondElement, "focus", () => self.secondElement && self.secondElement.select());
            if (self.amPM !== undefined) {
                bind(self.amPM, "click", (e) => {
                    updateTime(e);
                    triggerChange();
                });
            }
        }
        if (self.config.allowInput) {
            bind(self._input, "blur", onBlur);
        }
    }
    function jumpToDate(jumpDate, triggerChange) {
        const jumpTo = jumpDate !== undefined
            ? self.parseDate(jumpDate)
            : self.latestSelectedDateObj ||
                (self.config.minDate && self.config.minDate > self.now
                    ? self.config.minDate
                    : self.config.maxDate && self.config.maxDate < self.now
                        ? self.config.maxDate
                        : self.now);
        const oldYear = self.currentYear;
        const oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        }
        catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange &&
            (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
            triggerEvent("onMonthChange");
        }
        self.redraw();
    }
    function timeIncrement(e) {
        const eventTarget = getEventTarget(e);
        if (~eventTarget.className.indexOf("arrow"))
            incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        const target = e && getEventTarget(e);
        const input = inputElem ||
            (target && target.parentNode && target.parentNode.firstChild);
        const event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        const fragment = window.document.createDocumentFragment();
        self.calendarContainer = createElement("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = createElement("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                const { weekWrapper, weekNumbers } = buildWeeks();
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = createElement("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = createElement("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) {
            fragment.appendChild(buildTime());
        }
        toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
        toggleClass(self.calendarContainer, "animate", self.config.animate === true);
        toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        const customAppend = self.config.appendTo !== undefined &&
            self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode)
                    self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined)
                    self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                const wrapper = createElement("div", "flatpickr-wrapper");
                if (self.element.parentNode)
                    self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput)
                    wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline)
            (self.config.appendTo !== undefined
                ? self.config.appendTo
                : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, dayNumber, i) {
        const dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 &&
            compareDates(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    toggleClass(dayElement, "startRange", self.selectedDates[0] &&
                        compareDates(date, self.selectedDates[0], true) === 0);
                    toggleClass(dayElement, "endRange", self.selectedDates[1] &&
                        compareDates(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay")
                        dayElement.classList.add("inRange");
                }
            }
        }
        else {
            dayElement.classList.add("flatpickr-disabled");
        }
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date))
                dayElement.classList.add("inRange");
        }
        if (self.weekNumbers &&
            self.config.showMonths === 1 &&
            className !== "prevMonthDay" &&
            dayNumber % 7 === 1) {
            self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        }
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range")
            onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        const startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        const endMonth = delta > 0 ? self.config.showMonths : -1;
        for (let m = startMonth; m != endMonth; m += delta) {
            const month = self.daysContainer.children[m];
            const startIndex = delta > 0 ? 0 : month.children.length - 1;
            const endIndex = delta > 0 ? month.children.length : -1;
            for (let i = startIndex; i != endIndex; i += delta) {
                const c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj))
                    return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        const givenMonth = current.className.indexOf("Month") === -1
            ? current.dateObj.getMonth()
            : self.currentMonth;
        const endMonth = delta > 0 ? self.config.showMonths : -1;
        const loopDelta = delta > 0 ? 1 : -1;
        for (let m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
            const month = self.daysContainer.children[m];
            const startIndex = givenMonth - self.currentMonth === m
                ? current.$i + delta
                : delta < 0
                    ? month.children.length - 1
                    : 0;
            const numMonthDays = month.children.length;
            for (let i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
                const c = month.children[i];
                if (c.className.indexOf("hidden") === -1 &&
                    isEnabled(c.dateObj) &&
                    Math.abs(current.$i - i) >= Math.abs(delta))
                    return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        const dayFocused = isInView(document.activeElement || document.body);
        const startElem = current !== undefined
            ? current
            : dayFocused
                ? document.activeElement
                : self.selectedDateElem !== undefined && isInView(self.selectedDateElem)
                    ? self.selectedDateElem
                    : self.todayDateElem !== undefined && isInView(self.todayDateElem)
                        ? self.todayDateElem
                        : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) {
            self._input.focus();
        }
        else if (!dayFocused) {
            focusOnDayElem(startElem);
        }
        else {
            getNextAvailableDay(startElem, offset);
        }
    }
    function buildMonthDays(year, month) {
        const firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        const prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        const daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        let dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
            days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        }
        for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
            days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
        }
        for (let dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth &&
            (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
            days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        }
        const dayContainer = createElement("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) {
            return;
        }
        clearNode(self.daysContainer);
        if (self.weekNumbers)
            clearNode(self.weekNumbers);
        const frag = document.createDocumentFragment();
        for (let i = 0; i < self.config.showMonths; i++) {
            const d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) {
            onMouseOver();
        }
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 ||
            self.config.monthSelectorType !== "dropdown")
            return;
        const shouldBuildMonth = function (month) {
            if (self.config.minDate !== undefined &&
                self.currentYear === self.config.minDate.getFullYear() &&
                month < self.config.minDate.getMonth()) {
                return false;
            }
            return !(self.config.maxDate !== undefined &&
                self.currentYear === self.config.maxDate.getFullYear() &&
                month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for (let i = 0; i < 12; i++) {
            if (!shouldBuildMonth(i))
                continue;
            const month = createElement("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) {
                month.selected = true;
            }
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        const container = createElement("div", "flatpickr-month");
        const monthNavFragment = window.document.createDocumentFragment();
        let monthElement;
        if (self.config.showMonths > 1 ||
            self.config.monthSelectorType === "static") {
            monthElement = createElement("span", "cur-month");
        }
        else {
            self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", (e) => {
                const target = getEventTarget(e);
                const selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        const yearInput = createNumberInput("cur-year", { tabindex: "-1" });
        const yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) {
            yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        }
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled =
                !!self.config.minDate &&
                    self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        const currentMonth = createElement("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container,
            yearElement,
            monthElement,
        };
    }
    function buildMonths() {
        clearNode(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for (let m = self.config.showMonths; m--;) {
            const month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = createElement("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = createElement("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = createElement("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: () => self.__hidePrevMonthArrow,
            set(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    toggleClass(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            },
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: () => self.__hideNextMonthArrow,
            set(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    toggleClass(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            },
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar)
            self.calendarContainer.classList.add("noCalendar");
        const defaults = getDefaultHours(self.config);
        self.timeContainer = createElement("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        const separator = createElement("span", "flatpickr-time-separator", ":");
        const hourInput = createNumberInput("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel,
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        const minuteInput = createNumberInput("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel,
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = pad(self.latestSelectedDateObj
            ? self.latestSelectedDateObj.getHours()
            : self.config.time_24hr
                ? defaults.hours
                : military2ampm(defaults.hours));
        self.minuteElement.value = pad(self.latestSelectedDateObj
            ? self.latestSelectedDateObj.getMinutes()
            : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr)
            self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            const secondInput = createNumberInput("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = pad(self.latestSelectedDateObj
                ? self.latestSelectedDateObj.getSeconds()
                : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[utils_int((self.latestSelectedDateObj
                ? self.hourElement.value
                : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer)
            self.weekdayContainer = createElement("div", "flatpickr-weekdays");
        else
            clearNode(self.weekdayContainer);
        for (let i = self.config.showMonths; i--;) {
            const container = createElement("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) {
            return;
        }
        const firstDayOfWeek = self.l10n.firstDayOfWeek;
        let weekdays = [...self.l10n.weekdays.shorthand];
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
            weekdays = [
                ...weekdays.splice(firstDayOfWeek, weekdays.length),
                ...weekdays.splice(0, firstDayOfWeek),
            ];
        }
        for (let i = self.config.showMonths; i--;) {
            self.weekdayContainer.children[i].innerHTML = `
      <span class='flatpickr-weekday'>
        ${weekdays.join("</span><span class='flatpickr-weekday'>")}
      </span>
      `;
        }
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        const weekWrapper = createElement("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        const weekNumbers = createElement("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper,
            weekNumbers,
        };
    }
    function changeMonth(value, isOffset = true) {
        const delta = isOffset ? value : value - self.currentMonth;
        if ((delta < 0 && self._hidePrevMonthArrow === true) ||
            (delta > 0 && self._hideNextMonthArrow === true))
            return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent = true, toInitial = true) {
        self.input.value = "";
        if (self.altInput !== undefined)
            self.altInput.value = "";
        if (self.mobileInput !== undefined)
            self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            const { hours, minutes, seconds } = getDefaultHours(self.config);
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent)
            triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.classList.remove("open");
            }
            if (self._input !== undefined) {
                self._input.classList.remove("active");
            }
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined)
            triggerEvent("onDestroy");
        for (let i = self._handlers.length; i--;) {
            self._handlers[i].remove();
        }
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode)
                self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        }
        else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                const wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while (wrapper.firstChild)
                        wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            }
            else
                self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode)
                self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config",
        ].forEach((k) => {
            try {
                delete self[k];
            }
            catch (_) { }
        });
    }
    function isCalendarElem(elem) {
        if (self.config.appendTo && self.config.appendTo.contains(elem))
            return true;
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            const eventTarget = getEventTarget(e);
            const isCalendarElement = isCalendarElem(eventTarget);
            const isInput = eventTarget === self.input ||
                eventTarget === self.altInput ||
                self.element.contains(eventTarget) ||
                (e.path &&
                    e.path.indexOf &&
                    (~e.path.indexOf(self.input) ||
                        ~e.path.indexOf(self.altInput)));
            const lostFocus = e.type === "blur"
                ? isInput &&
                    e.relatedTarget &&
                    !isCalendarElem(e.relatedTarget)
                : !isInput &&
                    !isCalendarElement &&
                    !isCalendarElem(e.relatedTarget);
            const isIgnored = !self.config.ignoredFocusElements.some((elem) => elem.contains(eventTarget));
            if (lostFocus && isIgnored) {
                if (self.timeContainer !== undefined &&
                    self.minuteElement !== undefined &&
                    self.hourElement !== undefined &&
                    self.input.value !== "" &&
                    self.input.value !== undefined) {
                    updateTime();
                }
                self.close();
                if (self.config &&
                    self.config.mode === "range" &&
                    self.selectedDates.length === 1) {
                    self.clear(false);
                    self.redraw();
                }
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear ||
            (self.config.minDate && newYear < self.config.minDate.getFullYear()) ||
            (self.config.maxDate && newYear > self.config.maxDate.getFullYear()))
            return;
        const newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate &&
            self.currentYear === self.config.maxDate.getFullYear()) {
            self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        }
        else if (self.config.minDate &&
            self.currentYear === self.config.minDate.getFullYear()) {
            self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        }
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless = true) {
        var _a;
        const dateToCheck = self.parseDate(date, undefined, timeless);
        if ((self.config.minDate &&
            dateToCheck &&
            compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0) ||
            (self.config.maxDate &&
                dateToCheck &&
                compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0))
            return false;
        if (!self.config.enable && self.config.disable.length === 0)
            return true;
        if (dateToCheck === undefined)
            return false;
        const bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for (let i = 0, d; i < array.length; i++) {
            d = array[i];
            if (typeof d === "function" &&
                d(dateToCheck))
                return bool;
            else if (d instanceof Date &&
                dateToCheck !== undefined &&
                d.getTime() === dateToCheck.getTime())
                return bool;
            else if (typeof d === "string") {
                const parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime()
                    ? bool
                    : !bool;
            }
            else if (typeof d === "object" &&
                dateToCheck !== undefined &&
                d.from &&
                d.to &&
                dateToCheck.getTime() >= d.from.getTime() &&
                dateToCheck.getTime() <= d.to.getTime())
                return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined)
            return (elem.className.indexOf("hidden") === -1 &&
                elem.className.indexOf("flatpickr-disabled") === -1 &&
                self.daysContainer.contains(elem));
        return false;
    }
    function onBlur(e) {
        const isInput = e.target === self._input;
        if (isInput &&
            (self.selectedDates.length > 0 || self._input.value.length > 0) &&
            !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
            self.setDate(self._input.value, true, e.target === self.altInput
                ? self.config.altFormat
                : self.config.dateFormat);
        }
    }
    function onKeyDown(e) {
        const eventTarget = getEventTarget(e);
        const isInput = self.config.wrap
            ? element.contains(eventTarget)
            : eventTarget === self._input;
        const allowInput = self.config.allowInput;
        const allowKeydown = self.isOpen && (!allowInput || !isInput);
        const allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput
                    ? self.config.altFormat
                    : self.config.dateFormat);
                return eventTarget.blur();
            }
            else {
                self.open();
            }
        }
        else if (isCalendarElem(eventTarget) ||
            allowKeydown ||
            allowInlineKeydown) {
            const isTimeObj = !!self.timeContainer &&
                self.timeContainer.contains(eventTarget);
            switch (e.keyCode) {
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    }
                    else
                        selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        if (self.daysContainer !== undefined &&
                            (allowInput === false ||
                                (document.activeElement && isInView(document.activeElement)))) {
                            const delta = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey)
                                focusOnDay(undefined, delta);
                            else {
                                e.stopPropagation();
                                changeMonth(delta);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    }
                    else if (self.hourElement)
                        self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    const delta = e.keyCode === 40 ? 1 : -1;
                    if ((self.daysContainer &&
                        eventTarget.$i !== undefined) ||
                        eventTarget === self.input ||
                        eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        }
                        else if (!isTimeObj)
                            focusOnDay(undefined, delta * 7);
                    }
                    else if (eventTarget === self.currentYearElement) {
                        changeYear(self.currentYear - delta);
                    }
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement)
                            self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        const elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM,
                        ]
                            .concat(self.pluginElements)
                            .filter((x) => x);
                        const i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            const target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    }
                    else if (!self.config.noCalendar &&
                        self.daysContainer &&
                        self.daysContainer.contains(eventTarget) &&
                        e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) {
            switch (e.key) {
                case self.l10n.amPM[0].charAt(0):
                case self.l10n.amPM[0].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[0];
                    setHoursFromInputs();
                    updateValue();
                    break;
                case self.l10n.amPM[1].charAt(0):
                case self.l10n.amPM[1].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[1];
                    setHoursFromInputs();
                    updateValue();
                    break;
            }
        }
        if (isInput || isCalendarElem(eventTarget)) {
            triggerEvent("onKeyDown", e);
        }
    }
    function onMouseOver(elem) {
        if (self.selectedDates.length !== 1 ||
            (elem &&
                (!elem.classList.contains("flatpickr-day") ||
                    elem.classList.contains("flatpickr-disabled"))))
            return;
        const hoverDate = elem
            ? elem.dateObj.getTime()
            : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        let containsDisabled = false;
        let minRange = 0, maxRange = 0;
        for (let t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
            if (!isEnabled(new Date(t), true)) {
                containsDisabled =
                    containsDisabled || (t > rangeStartDate && t < rangeEndDate);
                if (t < initialDate && (!minRange || t > minRange))
                    minRange = t;
                else if (t > initialDate && (!maxRange || t < maxRange))
                    maxRange = t;
            }
        }
        for (let m = 0; m < self.config.showMonths; m++) {
            const month = self.daysContainer.children[m];
            for (let i = 0, l = month.children.length; i < l; i++) {
                const dayElem = month.children[i], date = dayElem.dateObj;
                const timestamp = date.getTime();
                const outOfRange = (minRange > 0 && timestamp < minRange) ||
                    (maxRange > 0 && timestamp > maxRange);
                if (outOfRange) {
                    dayElem.classList.add("notAllowed");
                    ["inRange", "startRange", "endRange"].forEach((c) => {
                        dayElem.classList.remove(c);
                    });
                    continue;
                }
                else if (containsDisabled && !outOfRange)
                    continue;
                ["startRange", "inRange", "endRange", "notAllowed"].forEach((c) => {
                    dayElem.classList.remove(c);
                });
                if (elem !== undefined) {
                    elem.classList.add(hoverDate <= self.selectedDates[0].getTime()
                        ? "startRange"
                        : "endRange");
                    if (initialDate < hoverDate && timestamp === initialDate)
                        dayElem.classList.add("startRange");
                    else if (initialDate > hoverDate && timestamp === initialDate)
                        dayElem.classList.add("endRange");
                    if (timestamp >= minRange &&
                        (maxRange === 0 || timestamp <= maxRange) &&
                        isBetween(timestamp, initialDate, hoverDate))
                        dayElem.classList.add("inRange");
                }
            }
        }
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline)
            positionCalendar();
    }
    function open(e, positionElement = self._positionElement) {
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                const eventTarget = getEventTarget(e);
                if (eventTarget) {
                    eventTarget.blur();
                }
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        }
        else if (self._input.disabled || self.config.inline) {
            return;
        }
        const wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false &&
                (e === undefined ||
                    !self.timeContainer.contains(e.relatedTarget))) {
                setTimeout(() => self.hourElement.select(), 50);
            }
        }
    }
    function minMaxDateSetter(type) {
        return (date) => {
            const dateObj = (self.config[`_${type}Date`] = self.parseDate(date, self.config.dateFormat));
            const inverseDateObj = self.config[`_${type === "min" ? "max" : "min"}Date`];
            if (dateObj !== undefined) {
                self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] =
                    dateObj.getHours() > 0 ||
                        dateObj.getMinutes() > 0 ||
                        dateObj.getSeconds() > 0;
            }
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter((d) => isEnabled(d));
                if (!self.selectedDates.length && type === "min")
                    setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined)
                    self.currentYearElement[type] = dateObj.getFullYear().toString();
                else
                    self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled =
                    !!inverseDateObj &&
                        dateObj !== undefined &&
                        inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        const boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile",
        ];
        const userConfig = Object.assign(Object.assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        const formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: () => self.config._enable,
            set: (dates) => {
                self.config._enable = parseDateRules(dates);
            },
        });
        Object.defineProperty(self.config, "disable", {
            get: () => self.config._disable,
            set: (dates) => {
                self.config._disable = parseDateRules(dates);
            },
        });
        const timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            const defaultDateFormat = flatpickr.defaultConfig.dateFormat || options_defaults.dateFormat;
            formats.dateFormat =
                userConfig.noCalendar || timeMode
                    ? "H:i" + (userConfig.enableSeconds ? ":S" : "")
                    : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput &&
            (userConfig.enableTime || timeMode) &&
            !userConfig.altFormat) {
            const defaultAltFormat = flatpickr.defaultConfig.altFormat || options_defaults.altFormat;
            formats.altFormat =
                userConfig.noCalendar || timeMode
                    ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K")
                    : defaultAltFormat + ` h:i${userConfig.enableSeconds ? ":S" : ""} K`;
        }
        Object.defineProperty(self.config, "minDate", {
            get: () => self.config._minDate,
            set: minMaxDateSetter("min"),
        });
        Object.defineProperty(self.config, "maxDate", {
            get: () => self.config._maxDate,
            set: minMaxDateSetter("max"),
        });
        const minMaxTimeSetter = (type) => (val) => {
            self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
        };
        Object.defineProperty(self.config, "minTime", {
            get: () => self.config._minTime,
            set: minMaxTimeSetter("min"),
        });
        Object.defineProperty(self.config, "maxTime", {
            get: () => self.config._maxTime,
            set: minMaxTimeSetter("max"),
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for (let i = 0; i < boolOpts.length; i++)
            self.config[boolOpts[i]] =
                self.config[boolOpts[i]] === true ||
                    self.config[boolOpts[i]] === "true";
        HOOKS.filter((hook) => self.config[hook] !== undefined).forEach((hook) => {
            self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile =
            !self.config.disableMobile &&
                !self.config.inline &&
                self.config.mode === "single" &&
                !self.config.disable.length &&
                !self.config.enable &&
                !self.config.weekNumbers &&
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for (let i = 0; i < self.config.plugins.length; i++) {
            const pluginConf = self.config.plugins[i](self) || {};
            for (const key in pluginConf) {
                if (HOOKS.indexOf(key) > -1) {
                    self.config[key] = arrayify(pluginConf[key])
                        .map(bindToInstance)
                        .concat(self.config[key]);
                }
                else if (typeof userConfig[key] === "undefined")
                    self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) {
            self.config.altInputClass =
                getInputElem().className + " " + self.config.altInputClass;
        }
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap
            ? element.querySelector("[data-input]")
            : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" &&
            typeof flatpickr.l10ns[self.config.locale] === "undefined")
            self.config.errorHandler(new Error(`flatpickr: invalid locale ${self.config.locale}`));
        self.l10n = Object.assign(Object.assign({}, flatpickr.l10ns.default), (typeof self.config.locale === "object"
            ? self.config.locale
            : self.config.locale !== "default"
                ? flatpickr.l10ns[self.config.locale]
                : undefined));
        tokenRegex.K = `(${self.l10n.amPM[0]}|${self.l10n.amPM[1]}|${self.l10n.amPM[0].toLowerCase()}|${self.l10n.amPM[1].toLowerCase()})`;
        const userConfig = Object.assign(Object.assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined &&
            flatpickr.defaultConfig.time_24hr === undefined) {
            self.config.time_24hr = self.l10n.time_24hr;
        }
        self.formatDate = createDateFormatter(self);
        self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") {
            return void self.config.position(self, customPositionElement);
        }
        if (self.calendarContainer === undefined)
            return;
        triggerEvent("onPreCalendarPosition");
        const positionElement = customPositionElement || self._positionElement;
        const calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, ((acc, child) => acc + child.offsetHeight), 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" ||
            (configPosVertical !== "below" &&
                distanceFromBottom < calendarHeight &&
                inputBounds.top > calendarHeight);
        const top = window.pageYOffset +
            inputBounds.top +
            (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
        toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline)
            return;
        let left = window.pageXOffset + inputBounds.left;
        let isCenter = false;
        let isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        }
        else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        toggleClass(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        toggleClass(self.calendarContainer, "arrowCenter", isCenter);
        toggleClass(self.calendarContainer, "arrowRight", isRight);
        const right = window.document.body.offsetWidth -
            (window.pageXOffset + inputBounds.right);
        const rightMost = left + calendarWidth > window.document.body.offsetWidth;
        const centerMost = right + calendarWidth > window.document.body.offsetWidth;
        toggleClass(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static)
            return;
        self.calendarContainer.style.top = `${top}px`;
        if (!rightMost) {
            self.calendarContainer.style.left = `${left}px`;
            self.calendarContainer.style.right = "auto";
        }
        else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = `${right}px`;
        }
        else {
            const doc = getDocumentStyleSheet();
            if (doc === undefined)
                return;
            const bodyWidth = window.document.body.offsetWidth;
            const centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            const centerBefore = ".flatpickr-calendar.centerMost:before";
            const centerAfter = ".flatpickr-calendar.centerMost:after";
            const centerIndex = doc.cssRules.length;
            const centerStyle = `{left:${inputBounds.left}px;right:auto;}`;
            toggleClass(self.calendarContainer, "rightMost", false);
            toggleClass(self.calendarContainer, "centerMost", true);
            doc.insertRule(`${centerBefore},${centerAfter}${centerStyle}`, centerIndex);
            self.calendarContainer.style.left = `${centerLeft}px`;
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        let editableSheet = null;
        for (let i = 0; i < document.styleSheets.length; i++) {
            const sheet = document.styleSheets[i];
            try {
                sheet.cssRules;
            }
            catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        const style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile)
            return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 ||
            navigator.msMaxTouchPoints !== undefined) {
            setTimeout(self.close, 0);
        }
        else {
            self.close();
        }
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        const isSelectable = (day) => day.classList &&
            day.classList.contains("flatpickr-day") &&
            !day.classList.contains("flatpickr-disabled") &&
            !day.classList.contains("notAllowed");
        const t = findParent(getEventTarget(e), isSelectable);
        if (t === undefined)
            return;
        const target = t;
        const selectedDate = (self.latestSelectedDateObj = new Date(target.dateObj.getTime()));
        const shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth ||
            selectedDate.getMonth() >
                self.currentMonth + self.config.showMonths - 1) &&
            self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single")
            self.selectedDates = [selectedDate];
        else if (self.config.mode === "multiple") {
            const selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex)
                self.selectedDates.splice(parseInt(selectedIndex), 1);
            else
                self.selectedDates.push(selectedDate);
        }
        else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) {
                self.clear(false, false);
            }
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if (compareDates(selectedDate, self.selectedDates[0], true) !== 0)
                self.selectedDates.sort((a, b) => a.getTime() - b.getTime());
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            const isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth &&
            self.config.mode !== "range" &&
            self.config.showMonths === 1)
            focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined &&
            self.hourElement === undefined) {
            self.selectedDateElem && self.selectedDateElem.focus();
        }
        if (self.hourElement !== undefined)
            self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            const single = self.config.mode === "single" && !self.config.enableTime;
            const range = self.config.mode === "range" &&
                self.selectedDates.length === 2 &&
                !self.config.enableTime;
            if (single || range) {
                focusAndClose();
            }
        }
        triggerChange();
    }
    const CALLBACKS = {
        locale: [setupLocale, updateWeekdays],
        showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
        minDate: [jumpToDate],
        maxDate: [jumpToDate],
        clickOpens: [
            () => {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                }
                else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            },
        ],
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for (const key in option) {
                if (CALLBACKS[key] !== undefined)
                    CALLBACKS[key].forEach((x) => x());
            }
        }
        else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined)
                CALLBACKS[option].forEach((x) => x());
            else if (HOOKS.indexOf(option) > -1)
                self.config[option] = arrayify(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        let dates = [];
        if (inputDate instanceof Array)
            dates = inputDate.map((d) => self.parseDate(d, format));
        else if (inputDate instanceof Date || typeof inputDate === "number")
            dates = [self.parseDate(inputDate, format)];
        else if (typeof inputDate === "string") {
            switch (self.config.mode) {
                case "single":
                case "time":
                    dates = [self.parseDate(inputDate, format)];
                    break;
                case "multiple":
                    dates = inputDate
                        .split(self.config.conjunction)
                        .map((date) => self.parseDate(date, format));
                    break;
                case "range":
                    dates = inputDate
                        .split(self.l10n.rangeSeparator)
                        .map((date) => self.parseDate(date, format));
                    break;
                default:
                    break;
            }
        }
        else
            self.config.errorHandler(new Error(`Invalid date supplied: ${JSON.stringify(inputDate)}`));
        self.selectedDates = (self.config.allowInvalidPreload
            ? dates
            : dates.filter((d) => d instanceof Date && isEnabled(d, false)));
        if (self.config.mode === "range")
            self.selectedDates.sort((a, b) => a.getTime() - b.getTime());
    }
    function setDate(date, triggerChange = false, format = self.config.dateFormat) {
        if ((date !== 0 && !date) || (date instanceof Array && date.length === 0))
            return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj =
            self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) {
            self.clear(false);
        }
        updateValue(triggerChange);
        if (triggerChange)
            triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr
            .slice()
            .map((rule) => {
            if (typeof rule === "string" ||
                typeof rule === "number" ||
                rule instanceof Date) {
                return self.parseDate(rule, undefined, true);
            }
            else if (rule &&
                typeof rule === "object" &&
                rule.from &&
                rule.to)
                return {
                    from: self.parseDate(rule.from, undefined),
                    to: self.parseDate(rule.to, undefined),
                };
            return rule;
        })
            .filter((x) => x);
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        const preloadedDate = self.config.defaultDate ||
            ((self.input.nodeName === "INPUT" ||
                self.input.nodeName === "TEXTAREA") &&
                self.input.placeholder &&
                self.input.value === self.input.placeholder
                ? null
                : self.input.value);
        if (preloadedDate)
            setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate =
            self.selectedDates.length > 0
                ? self.selectedDates[0]
                : self.config.minDate &&
                    self.config.minDate.getTime() > self.now.getTime()
                    ? self.config.minDate
                    : self.config.maxDate &&
                        self.config.maxDate.getTime() < self.now.getTime()
                        ? self.config.maxDate
                        : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0)
            self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined)
            self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined)
            self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime =
            !!self.config.minDate &&
                (self.config.minDate.getHours() > 0 ||
                    self.config.minDate.getMinutes() > 0 ||
                    self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime =
            !!self.config.maxDate &&
                (self.config.maxDate.getHours() > 0 ||
                    self.config.maxDate.getMinutes() > 0 ||
                    self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode)
                self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput)
            self._input.setAttribute("readonly", "readonly");
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        const inputType = self.config.enableTime
            ? self.config.noCalendar
                ? "time"
                : "datetime-local"
            : "date";
        self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr =
            inputType === "datetime-local"
                ? "Y-m-d\\TH:i:S"
                : inputType === "date"
                    ? "Y-m-d"
                    : "H:i:S";
        if (self.selectedDates.length > 0) {
            self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        }
        if (self.config.minDate)
            self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate)
            self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step"))
            self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined)
            self.altInput.type = "hidden";
        try {
            if (self.input.parentNode)
                self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        }
        catch (_a) { }
        bind(self.mobileInput, "change", (e) => {
            self.setDate(getEventTarget(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true)
            return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined)
            return;
        const hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) {
            for (let i = 0; hooks[i] && i < hooks.length; i++)
                hooks[i](self.selectedDates, self.input.value, self, data);
        }
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        const e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for (let i = 0; i < self.selectedDates.length; i++) {
            if (compareDates(self.selectedDates[i], date) === 0)
                return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2)
            return false;
        return (compareDates(date, self.selectedDates[0]) >= 0 &&
            compareDates(date, self.selectedDates[1]) <= 0);
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav)
            return;
        self.yearElements.forEach((yearElement, i) => {
            const d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 ||
                self.config.monthSelectorType === "static") {
                self.monthElements[i].textContent =
                    monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            }
            else {
                self.monthsDropdownContainer.value = d.getMonth().toString();
            }
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow =
            self.config.minDate !== undefined &&
                (self.currentYear === self.config.minDate.getFullYear()
                    ? self.currentMonth <= self.config.minDate.getMonth()
                    : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow =
            self.config.maxDate !== undefined &&
                (self.currentYear === self.config.maxDate.getFullYear()
                    ? self.currentMonth + 1 > self.config.maxDate.getMonth()
                    : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(format) {
        return self.selectedDates
            .map((dObj) => self.formatDate(dObj, format))
            .filter((d, i, arr) => self.config.mode !== "range" ||
            self.config.enableTime ||
            arr.indexOf(d) === i)
            .join(self.config.mode !== "range"
            ? self.config.conjunction
            : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange = true) {
        if (self.mobileInput !== undefined && self.mobileFormatStr) {
            self.mobileInput.value =
                self.latestSelectedDateObj !== undefined
                    ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr)
                    : "";
        }
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) {
            self.altInput.value = getDateStr(self.config.altFormat);
        }
        if (triggerChange !== false)
            triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        const eventTarget = getEventTarget(e);
        const isPrevMonth = self.prevMonthNav.contains(eventTarget);
        const isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) {
            changeMonth(isPrevMonth ? -1 : 1);
        }
        else if (self.yearElements.indexOf(eventTarget) >= 0) {
            eventTarget.select();
        }
        else if (eventTarget.classList.contains("arrowUp")) {
            self.changeYear(self.currentYear + 1);
        }
        else if (eventTarget.classList.contains("arrowDown")) {
            self.changeYear(self.currentYear - 1);
        }
    }
    function timeWrapper(e) {
        e.preventDefault();
        const isKeyDown = e.type === "keydown", eventTarget = getEventTarget(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) {
            self.amPM.textContent =
                self.l10n.amPM[utils_int(self.amPM.textContent === self.l10n.amPM[0])];
        }
        const min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta ||
            (isKeyDown ? (e.which === 38 ? 1 : -1) : 0);
        let newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            const isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue =
                    max +
                        newValue +
                        utils_int(!isHourElem) +
                        (utils_int(isHourElem) && utils_int(!self.amPM));
                if (isMinuteElem)
                    incrementNumInput(undefined, -1, self.hourElement);
            }
            else if (newValue > max) {
                newValue =
                    input === self.hourElement ? newValue - max - utils_int(!self.amPM) : min;
                if (isMinuteElem)
                    incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM &&
                isHourElem &&
                (step === 1
                    ? newValue + curValue === 23
                    : Math.abs(newValue - curValue) > step)) {
                self.amPM.textContent =
                    self.l10n.amPM[utils_int(self.amPM.textContent === self.l10n.amPM[0])];
            }
            input.value = pad(newValue);
        }
    }
    init();
    return self;
}
function _flatpickr(nodeList, config) {
    const nodes = Array.prototype.slice
        .call(nodeList)
        .filter((x) => x instanceof HTMLElement);
    const instances = [];
    for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null)
                continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        }
        catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" &&
    typeof HTMLCollection !== "undefined" &&
    typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
        return _flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function (config) {
        return _flatpickr([this], config);
    };
}
var flatpickr = function (selector, config) {
    if (typeof selector === "string") {
        return _flatpickr(window.document.querySelectorAll(selector), config);
    }
    else if (selector instanceof Node) {
        return _flatpickr([selector], config);
    }
    else {
        return _flatpickr(selector, config);
    }
};
flatpickr.defaultConfig = {};
flatpickr.l10ns = {
    en: Object.assign({}, l10n_default),
    default: Object.assign({}, l10n_default),
};
flatpickr.localize = (l10n) => {
    flatpickr.l10ns.default = Object.assign(Object.assign({}, flatpickr.l10ns.default), l10n);
};
flatpickr.setDefaults = (config) => {
    flatpickr.defaultConfig = Object.assign(Object.assign({}, flatpickr.defaultConfig), config);
};
flatpickr.parseDate = createDateParser({});
flatpickr.formatDate = createDateFormatter({});
flatpickr.compareDates = compareDates;
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
    jQuery.fn.flatpickr = function (config) {
        return _flatpickr(this, config);
    };
}
Date.prototype.fp_incr = function (days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") {
    window.flatpickr = flatpickr;
}
/* harmony default export */ var esm = __webpack_exports__["default"] = (flatpickr);


/***/ }),

/***/ "3658":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputSearch_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("32f3");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputSearch_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputSearch_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputSearch_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3699":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageError_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0293");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageError_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageError_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageError_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3729":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "372b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("386c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("4541c690", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "386c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "td[data-v-816315cc],th[data-v-816315cc]{text-align:left}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "38a5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Spinner_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dfdf");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Spinner_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Spinner_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Spinner_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "393b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterWells_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("72a7");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterWells_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterWells_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterWells_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3987":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "398c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputOntology.vue?vue&type=template&id=e0232856&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroup',_vm._g(_vm._b({},'FormGroup',_vm.$props,false),_vm.$listeners),[(_vm.loading)?_c('Spinner'):_vm._e(),(_vm.graphqlError)?_c('MessageError',[_vm._v(_vm._s(_vm.graphqlError))]):_c('div',{staticClass:"p-0 m-0"},[_c('InputOntologySubtree',{staticClass:"pl-0",attrs:{"terms":_vm.terms,"selection":_vm.selection,"expanded":_vm.expanded,"list":_vm.list},on:{"toggleExpand":_vm.toggleExpand,"select":_vm.select,"deselect":_vm.deselect}})],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputOntology.vue?vue&type=template&id=e0232856&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/mixins/TableMixin.vue + 2 modules
var TableMixin = __webpack_require__("89c1");

// EXTERNAL MODULE: ./src/mixins/TableMetadataMixin.vue + 2 modules
var TableMetadataMixin = __webpack_require__("9961");

// EXTERNAL MODULE: ./src/forms/_formGroup.vue + 4 modules
var _formGroup = __webpack_require__("084c");

// EXTERNAL MODULE: ./src/forms/InputOntologySubtree.vue + 4 modules
var InputOntologySubtree = __webpack_require__("6d7a");

// EXTERNAL MODULE: ./src/forms/MessageError.vue + 2 modules
var MessageError = __webpack_require__("25b1");

// EXTERNAL MODULE: ./src/layout/Spinner.vue + 2 modules
var Spinner = __webpack_require__("0f35");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputOntology.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/**
 * Expects a table that has as structure {name, parent{name} and optionally code, definition, ontologyURI}
 *
 * Known limitations: this version retrieves complete ontology and renders in place. Purpose is to enable sensible data entry and limited use in filter user interface.
 *
 * For future versions we have many ideas for improvements, for example:
 * - want to make it more lazy, only retrieving the 'root' elements and loading the children when needed.
 * - adding search to pre-filter elements / paths
 */

/* harmony default export */ var InputOntologyvue_type_script_lang_js_ = ({
  extends: _baseInput["a" /* default */],
  mixins: [TableMixin["a" /* default */]],
  components: {
    FormGroup: _formGroup["default"],
    InputOntologySubtree: InputOntologySubtree["a" /* default */],
    MessageError: MessageError["a" /* default */],
    Spinner: Spinner["a" /* default */]
  },
  props: {
    /** if you don't want to use autoload using table you can provide options via 'items'. Should be format [{name:a, parent:b},{name:b}]
     */
    options: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      terms: [],
      selection: [],
      expanded: []
    };
  },

  computed: {
    //Override tableMixin
    orderByObject() {
      if (this.tableMetadata && this.tableMetadata.columns.some(c => c.name === "order")) {
        return {
          order: "ASC"
        };
      } else {
        return {};
      }
    }

  },
  methods: {
    getChildren(name) {
      return this.data.filter(o => o.parent && o.parent.name === name);
    },

    toggleExpand(name) {
      if (this.expanded.indexOf(name) === -1) {
        this.expanded.push(name);
      } else {
        this.expanded = this.expanded.filter(s => s !== name);
      }
    },

    select(items) {
      //if not a list you can only select one
      if (!this.list) {
        this.selection = [];
      } //add items not yet selected


      items.forEach(i => {
        if (this.selection.indexOf(i) === -1) {
          this.selection.push(i);
        }
      }); //if all children are selected for a node then also select the parent (query expansion)
      //alert("selectArray: " + JSON.stringify(this.selection));

      this.emitValue();
    },

    getParents(items) {
      let result = this.data.filter(t => t.parent && items.indexOf(t.name) != -1).map(t => t.parent.name); //get parents of the parents

      if (result.length > 0) {
        result.push(...this.getParents(result));
      }

      return result;
    },

    deselect(items) {
      if (this.list) {
        //add parents
        items.push(...this.getParents(items)); //should also deselect any (indirect) parents

        this.selection = this.selection.filter(name => !items.includes(name));
      } else {
        this.selection = [];
      }

      this.emitValue();
    },

    emitValue() {
      if (this.list) {
        this.$emit("input", this.selection.map(s => {
          return {
            name: s
          };
        }));
      } else {
        this.$emit("input", {
          name: this.selection[0]
        });
      }
    },

    reloadMetadata() {
      //we only load if not options provided
      if (!this.options) {
        TableMetadataMixin["a" /* default */].methods.reloadMetadata.call(this);
      }
    },

    reload() {
      //we only load if not options provided
      if (!this.options) {
        TableMixin["a" /* default */].methods.reload.call(this);
      }
    }

  },
  watch: {
    options() {
      this.data = this.options;
    },

    value() {
      if (this.list) {
        this.selection = this.value ? this.value.map(term => term.name) : [];
      } else {
        this.selection = this.value ? [this.value.name] : [];
      }
    },

    data() {
      if (this.data) {
        this.terms = this.data.filter(o => !o.parent).map(o => {
          let children = this.getChildren(o.name);

          if (children.length > 0) {
            o.children = children;
          }

          return o;
        });
      }
    }

  },

  created() {
    if (this.options) {
      this.data = this.options;
    } else {
      //override default
      this.limit = 10000;
    }

    this.loading = false;
  }

});
// CONCATENATED MODULE: ./src/forms/InputOntology.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputOntologyvue_type_script_lang_js_ = (InputOntologyvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputOntology.vue?vue&type=custom&index=0&blockType=docs
var InputOntologyvue_type_custom_index_0_blockType_docs = __webpack_require__("d917");

// CONCATENATED MODULE: ./src/forms/InputOntology.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputOntologyvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputOntologyvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputOntologyvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputOntology = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "39d9":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".input-group-append .input-append-show{display:none}.input-group-append:hover .input-append-show{display:block}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3afd":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "3c59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconBar_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("25fd");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconBar_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconBar_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconBar_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "3ede":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "3fbf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "print", function() { return /* binding */ print; });

// CONCATENATED MODULE: ../node_modules/graphql-request/node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
/* harmony default export */ var jsutils_nodejsCustomInspectSymbol = (nodejsCustomInspectSymbol);

// CONCATENATED MODULE: ../node_modules/graphql-request/node_modules/graphql/jsutils/inspect.mjs
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable flowtype/no-weak-types */

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(jsutils_nodejsCustomInspectSymbol)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

// CONCATENATED MODULE: ../node_modules/graphql-request/node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}

// CONCATENATED MODULE: ../node_modules/graphql-request/node_modules/graphql/jsutils/defineInspect.mjs


/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || invariant(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (jsutils_nodejsCustomInspectSymbol) {
    classObject.prototype[jsutils_nodejsCustomInspectSymbol] = fn;
  }
}

// CONCATENATED MODULE: ../node_modules/graphql-request/node_modules/graphql/language/ast.mjs


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */

// CONCATENATED MODULE: ../node_modules/graphql-request/node_modules/graphql/language/visitor.mjs


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error("Invalid AST Node: ".concat(inspect(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

// CONCATENATED MODULE: ../node_modules/graphql-request/node_modules/graphql/language/blockString.mjs
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

// CONCATENATED MODULE: ../node_modules/graphql-request/node_modules/graphql/language/printer.mjs


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap('', alias, ': ') + name;
    var argsLine = prefix + wrap('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}


/***/ }),

/***/ "42ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowButtonEdit.vue?vue&type=template&id=0ff8d12f&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('RowEditModal',{attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL,"pkey":_vm.pkey,"visible-columns":_vm.visibleColumns},on:{"close":_vm.closeForm}}):_c('IconAction',{attrs:{"icon":"pencil-alt"},on:{"click":_vm.openForm}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/RowButtonEdit.vue?vue&type=template&id=0ff8d12f&

// EXTERNAL MODULE: ./src/tables/RowButtonAdd.vue + 4 modules
var RowButtonAdd = __webpack_require__("fc2a");

// EXTERNAL MODULE: ./src/tables/RowEditModal.vue + 3 modules
var RowEditModal = __webpack_require__("8cae");

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowButtonEdit.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var RowButtonEditvue_type_script_lang_js_ = ({
  extends: RowButtonAdd["a" /* default */],
  components: {
    RowEditModal: RowEditModal["a" /* default */],
    IconAction: IconAction["a" /* default */]
  },
  props: {
    pkey: Object,
    visibleColumns: Array
  },
  computed: {
    title() {
      return `Update ${this.table}`;
    }

  }
});
// CONCATENATED MODULE: ./src/tables/RowButtonEdit.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_RowButtonEditvue_type_script_lang_js_ = (RowButtonEditvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/tables/RowButtonEdit.vue?vue&type=custom&index=0&blockType=docs
var RowButtonEditvue_type_custom_index_0_blockType_docs = __webpack_require__("0ead2");

// CONCATENATED MODULE: ./src/tables/RowButtonEdit.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tables_RowButtonEditvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof RowButtonEditvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(RowButtonEditvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var RowButtonEdit = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "44a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaultIsExtractableFile = __webpack_require__("117c");

module.exports = function extractFiles(value, path, isExtractableFile) {
  if (path === void 0) {
    path = '';
  }

  if (isExtractableFile === void 0) {
    isExtractableFile = defaultIsExtractableFile;
  }

  var clone;
  var files = new Map();

  function addFile(paths, file) {
    var storedPaths = files.get(file);
    if (storedPaths) storedPaths.push.apply(storedPaths, paths);
    else files.set(file, paths);
  }

  if (isExtractableFile(value)) {
    clone = null;
    addFile([path], value);
  } else {
    var prefix = path ? path + '.' : '';
    if (typeof FileList !== 'undefined' && value instanceof FileList)
      clone = Array.prototype.map.call(value, function (file, i) {
        addFile(['' + prefix + i], file);
        return null;
      });
    else if (Array.isArray(value))
      clone = value.map(function (child, i) {
        var result = extractFiles(child, '' + prefix + i, isExtractableFile);
        result.files.forEach(addFile);
        return result.clone;
      });
    else if (value && value.constructor === Object) {
      clone = {};

      for (var i in value) {
        var result = extractFiles(value[i], '' + prefix + i, isExtractableFile);
        result.files.forEach(addFile);
        clone[i] = result.clone;
      }
    } else clone = value;
  }

  return {
    clone: clone,
    files: files,
  };
};


/***/ }),

/***/ "44e4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputSelect_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f99e");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputSelect_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputSelect_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputSelect_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4545":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "4671":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2e19");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("31b951bb", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "46ab":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("799d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("262f3ca0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "48f5":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "494f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/LayoutForm.vue?vue&type=template&id=753932cc&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/LayoutForm.vue?vue&type=template&id=753932cc&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/LayoutForm.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */ var LayoutFormvue_type_script_lang_js_ = ({});
// CONCATENATED MODULE: ./src/layout/LayoutForm.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_LayoutFormvue_type_script_lang_js_ = (LayoutFormvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// CONCATENATED MODULE: ./src/layout/LayoutForm.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  layout_LayoutFormvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LayoutForm = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "4b35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/forms/InputString.vue + 4 modules
var InputString = __webpack_require__("ffa4");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputDecimal.vue?vue&type=script&lang=js&

/** Input for decimal values */

/* harmony default export */ var InputDecimalvue_type_script_lang_js_ = ({
  extends: InputString["a" /* default */],
  props: {
    placeholder: {
      default: "enter decimal (does not accept A-Za-z,)"
    },
    //for outputing not string but floats
    parser: {
      default() {
        return value => {
          return parseFloat(value);
        };
      }

    }
  },
  methods: {
    keyhandler(event) {
      if (!this.isDecimal(event)) event.preventDefault();
    },

    isDecimal(e) {
      var keyCode = e.which ? e.which : e.keyCode;
      var ret = keyCode >= 48 && keyCode <= 57 || keyCode === 8 || keyCode === 46 && !this.value.includes(".");
      return ret;
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputDecimal.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputDecimalvue_type_script_lang_js_ = (InputDecimalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputDecimal.vue?vue&type=custom&index=0&blockType=docs
var InputDecimalvue_type_custom_index_0_blockType_docs = __webpack_require__("2499");

// CONCATENATED MODULE: ./src/forms/InputDecimal.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputDecimalvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputDecimalvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputDecimalvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputDecimal = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "4b57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonAdd_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fbd5");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonAdd_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonAdd_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowButtonAdd_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4b97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/ReadMore.vue?vue&type=template&id=ef3f3f84&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.text === 'undefined')?_c('span'):(_vm.text.length <= _vm.length)?_c('span',[_vm._v(_vm._s(_vm.text))]):(_vm.expand)?_c('span',[_vm._v(" "+_vm._s(_vm.text)+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.expand = false}}},[_vm._v(" ... ")])]):_c('span',[_vm._v(" "+_vm._s(_vm.text.slice(0, _vm.length))+" "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.expand = true}}},[_vm._v(" ... ")])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/ReadMore.vue?vue&type=template&id=ef3f3f84&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/ReadMore.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var ReadMorevue_type_script_lang_js_ = ({
  props: {
    text: String,
    length: {
      type: Number,
      default: () => 20
    }
  },

  data() {
    return {
      expand: false
    };
  }

});
// CONCATENATED MODULE: ./src/layout/ReadMore.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_ReadMorevue_type_script_lang_js_ = (ReadMorevue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/layout/ReadMore.vue?vue&type=custom&index=0&blockType=docs
var ReadMorevue_type_custom_index_0_blockType_docs = __webpack_require__("2f89");

// CONCATENATED MODULE: ./src/layout/ReadMore.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  layout_ReadMorevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof ReadMorevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(ReadMorevue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var ReadMore = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "4bd9":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "4df2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisMenu_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2e60");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisMenu_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisMenu_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisMenu_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4e2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSimple_vue_vue_type_style_index_0_id_816315cc_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("372b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSimple_vue_vue_type_style_index_0_id_816315cc_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSimple_vue_vue_type_style_index_0_id_816315cc_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4eb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRefSelect_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4545");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRefSelect_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRefSelect_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRefSelect_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "4f57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutCard_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3ede");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutCard_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutCard_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutCard_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "52c2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSimple_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4bd9");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSimple_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSimple_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSimple_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "52c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (typeof Object.assign !== "function") {
    Object.assign = function (target, ...args) {
        if (!target) {
            throw TypeError("Cannot convert undefined or null to object");
        }
        for (const source of args) {
            if (source) {
                Object.keys(source).forEach((key) => (target[key] = source[key]));
            }
        }
        return target;
    };
}


/***/ }),

/***/ "53f0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterContainer_vue_vue_type_style_index_0_id_23780467_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e271");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterContainer_vue_vue_type_style_index_0_id_23780467_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterContainer_vue_vue_type_style_index_0_id_23780467_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "54cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputDate.vue?vue&type=template&id=f74789f6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-group',_vm._g(_vm._b({},'form-group',_vm.$props,false),_vm.$listeners),_vm._l((_vm.valueArray),function(el,idx){return _c('InputAppend',_vm._b({key:idx + _vm.valueArray.length,attrs:{"showClear":_vm.showClear(idx),"showMinus":_vm.showMinus(idx),"showPlus":_vm.showPlus(idx)},on:{"clear":function($event){return _vm.clearValue(idx)},"add":_vm.addRow}},'InputAppend',_vm.$props,false),[(_vm.readonly)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueArray[idx]),expression:"valueArray[idx]"}],class:{ 'form-control': true, 'is-invalid': _vm.errorMessage },attrs:{"readonly":""},domProps:{"value":(_vm.valueArray[idx])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.valueArray, idx, $event.target.value)}}}):_c('FlatPickr',{staticClass:"form-control active",class:{ 'is-invalid': _vm.errorMessage },staticStyle:{"background":"white"},attrs:{"config":_vm.config,"placeholder":_vm.placeholder,"disabled":_vm.readonly},on:{"input":function($event){return _vm.emitValue($event, idx)}},model:{value:(_vm.valueArray[idx]),callback:function ($$v) {_vm.$set(_vm.valueArray, idx, $$v)},expression:"valueArray[idx]"}})],1)}),1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputDate.vue?vue&type=template&id=f74789f6&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/_formGroup.vue + 4 modules
var _formGroup = __webpack_require__("084c");

// EXTERNAL MODULE: ../node_modules/vue-flatpickr-component/dist/vue-flatpickr.min.js
var vue_flatpickr_min = __webpack_require__("1713");
var vue_flatpickr_min_default = /*#__PURE__*/__webpack_require__.n(vue_flatpickr_min);

// EXTERNAL MODULE: ../node_modules/flatpickr/dist/flatpickr.css
var flatpickr = __webpack_require__("46ab");

// EXTERNAL MODULE: ./src/forms/_inputAppend.vue + 4 modules
var _inputAppend = __webpack_require__("5807");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputDate.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/** Show a data input */

/* harmony default export */ var InputDatevue_type_script_lang_js_ = ({
  extends: _baseInput["a" /* default */],
  components: {
    FlatPickr: vue_flatpickr_min_default.a,
    InputAppend: _inputAppend["a" /* default */],
    FormGroup: _formGroup["default"]
  },
  computed: {
    config() {
      return {
        wrap: true,
        // set wrap to true only when using 'input-group'
        dateFormat: "Y-m-d",
        allowInput: false,
        clickOpens: !this.readonly
      };
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputDate.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputDatevue_type_script_lang_js_ = (InputDatevue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputDate.vue?vue&type=custom&index=0&blockType=docs
var InputDatevue_type_custom_index_0_blockType_docs = __webpack_require__("0ab8");

// CONCATENATED MODULE: ./src/forms/InputDate.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputDatevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputDatevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputDatevue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputDate = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "5706":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("39d9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("c7fd7f8a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5782":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "5807":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/_inputAppend.vue?vue&type=template&id=178e415c&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-append"},[_vm._t("default"),(_vm.showClear)?_c('AppendClear',_vm._b({staticClass:"input-append",on:{"clear":function($event){return _vm.$emit('clear')}}},'AppendClear',_vm.$props,false)):_vm._e(),(_vm.showMinus)?_c('IconAction',{staticClass:"invisible",attrs:{"icon":"minus"}}):_vm._e(),(_vm.showPlus)?_c('IconAction',{attrs:{"icon":"plus"},on:{"click":function($event){return _vm.$emit('add')}}}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/_inputAppend.vue?vue&type=template&id=178e415c&

// EXTERNAL MODULE: ./src/forms/_appendClear.vue + 4 modules
var _appendClear = __webpack_require__("2cad");

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/_inputAppend.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var _inputAppendvue_type_script_lang_js_ = ({
  components: {
    IconAction: IconAction["a" /* default */],
    AppendClear: _appendClear["a" /* default */]
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    error: String,
    showClear: {
      type: Boolean,
      default: true
    },
    clear: {
      type: Boolean,
      default: true
    },
    showPlus: {
      type: Boolean,
      default: false
    },
    showMinus: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/forms/_inputAppend.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_inputAppendvue_type_script_lang_js_ = (_inputAppendvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/_inputAppend.vue?vue&type=style&index=0&lang=css&
var _inputAppendvue_type_style_index_0_lang_css_ = __webpack_require__("7c62");

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// CONCATENATED MODULE: ./src/forms/_inputAppend.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_inputAppendvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var _inputAppend = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "59a7":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "59a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterSidebar_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5f3e");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterSidebar_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterSidebar_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterSidebar_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "59ee":
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ "5a2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/Pagination.vue?vue&type=template&id=7c83e3d6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"Pagination"}},[_c('ul',{staticClass:"pagination justify-content-center mb-0"},[_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', 1)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("«")]),_c('span',{staticClass:"sr-only"},[_vm._v("First")])])]),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('input', Math.max(_vm.value - 1, 1))}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("‹")]),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])])]),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link text-nowrap",attrs:{"href":"#"}},[_vm._v(_vm._s((_vm.value - 1) * _vm.limit + 1)+" - "+_vm._s(Math.min(_vm.count, _vm.value * _vm.limit))+" of "+_vm._s(_vm.count))])]),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('input', Math.min(_vm.value + 1, _vm.totalPages))}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("›")]),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])]),_c('li',{staticClass:"page-item"},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', _vm.totalPages)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("»")]),_c('span',{staticClass:"sr-only"},[_vm._v("Last")])])])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/Pagination.vue?vue&type=template&id=7c83e3d6&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/Pagination.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Paginationvue_type_script_lang_js_ = ({
  props: {
    value: {
      type: Number,
      default: 1
    },
    count: Number,
    limit: {
      type: Number,
      default: 10
    }
  },
  computed: {
    offset() {
      return this.limit * (this.value - 1);
    },

    totalPages() {
      return Math.ceil(this.count / this.limit);
    }

  },
  watch: {
    value() {
      if (this.value < 1) {
        this.$emit("input", 1);
      }
    },

    count() {
      //reset page to within range in case count changes
      if (this.page > this.totalPages) {
        this.$emit("input", 1);
      }
    }

  },

  created() {
    if (this.value < 1) {
      this.$emit("input", 1);
    }
  }

});
// CONCATENATED MODULE: ./src/tables/Pagination.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_Paginationvue_type_script_lang_js_ = (Paginationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/tables/Pagination.vue?vue&type=style&index=0&scope=true&lang=css&
var Paginationvue_type_style_index_0_scope_true_lang_css_ = __webpack_require__("cbc0");

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/tables/Pagination.vue?vue&type=custom&index=0&blockType=docs
var Paginationvue_type_custom_index_0_blockType_docs = __webpack_require__("b529");

// CONCATENATED MODULE: ./src/tables/Pagination.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tables_Paginationvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof Paginationvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(Paginationvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var Pagination = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "5d1a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".form-control.is-invalid[data-v-33e178de]{background-image:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5f3e":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "6074":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  'use strict'

  /*istanbul ignore next:cant test*/
  if ( true && typeof module.exports === 'object') {
    module.exports = factory()
  } else if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else {}
})(this, function () {
  'use strict'

  var toStr = Object.prototype.toString

  function hasOwnProperty (obj, prop) {
    if (obj == null) {
      return false
    }
    //to handle objects with null prototypes (too edge case?)
    return Object.prototype.hasOwnProperty.call(obj, prop)
  }

  function isEmpty (value) {
    if (!value) {
      return true
    }
    if (isArray(value) && value.length === 0) {
      return true
    } else if (typeof value !== 'string') {
      for (var i in value) {
        if (hasOwnProperty(value, i)) {
          return false
        }
      }
      return true
    }
    return false
  }

  function toString (type) {
    return toStr.call(type)
  }

  function isObject (obj) {
    return typeof obj === 'object' && toString(obj) === '[object Object]'
  }

  var isArray = Array.isArray || function (obj) {
    /*istanbul ignore next:cant test*/
    return toStr.call(obj) === '[object Array]'
  }

  function isBoolean (obj) {
    return typeof obj === 'boolean' || toString(obj) === '[object Boolean]'
  }

  function getKey (key) {
    var intKey = parseInt(key)
    if (intKey.toString() === key) {
      return intKey
    }
    return key
  }

  function factory (options) {
    options = options || {}

    var objectPath = function (obj) {
      return Object.keys(objectPath).reduce(function (proxy, prop) {
        if (prop === 'create') {
          return proxy
        }

        /*istanbul ignore else*/
        if (typeof objectPath[prop] === 'function') {
          proxy[prop] = objectPath[prop].bind(objectPath, obj)
        }

        return proxy
      }, {})
    }

    var hasShallowProperty
    if (options.includeInheritedProps) {
      hasShallowProperty = function () {
        return true
      }
    } else {
      hasShallowProperty = function (obj, prop) {
        return (typeof prop === 'number' && Array.isArray(obj)) || hasOwnProperty(obj, prop)
      }
    }

    function getShallowProperty (obj, prop) {
      if (hasShallowProperty(obj, prop)) {
        return obj[prop]
      }
    }

    var getShallowPropertySafely
    if (options.includeInheritedProps) {
      getShallowPropertySafely = function (obj, currentPath) {
        if (typeof currentPath !== 'string' && typeof currentPath !== 'number') {
          currentPath = String(currentPath)
        }
        var currentValue = getShallowProperty(obj, currentPath)
        if (currentPath === '__proto__' || currentPath === 'prototype' ||
          (currentPath === 'constructor' && typeof currentValue === 'function')) {
          throw new Error('For security reasons, object\'s magic properties cannot be set')
        }
        return currentValue
      }
    } else {
      getShallowPropertySafely = function (obj, currentPath) {
        return getShallowProperty(obj, currentPath)
      }
    }

    function set (obj, path, value, doNotReplace) {
      if (typeof path === 'number') {
        path = [path]
      }
      if (!path || path.length === 0) {
        return obj
      }
      if (typeof path === 'string') {
        return set(obj, path.split('.').map(getKey), value, doNotReplace)
      }
      var currentPath = path[0]
      var currentValue = getShallowPropertySafely(obj, currentPath)
      if (path.length === 1) {
        if (currentValue === void 0 || !doNotReplace) {
          obj[currentPath] = value
        }
        return currentValue
      }

      if (currentValue === void 0) {
        //check if we assume an array
        if (typeof path[1] === 'number') {
          obj[currentPath] = []
        } else {
          obj[currentPath] = {}
        }
      }

      return set(obj[currentPath], path.slice(1), value, doNotReplace)
    }

    objectPath.has = function (obj, path) {
      if (typeof path === 'number') {
        path = [path]
      } else if (typeof path === 'string') {
        path = path.split('.')
      }

      if (!path || path.length === 0) {
        return !!obj
      }

      for (var i = 0; i < path.length; i++) {
        var j = getKey(path[i])

        if ((typeof j === 'number' && isArray(obj) && j < obj.length) ||
          (options.includeInheritedProps ? (j in Object(obj)) : hasOwnProperty(obj, j))) {
          obj = obj[j]
        } else {
          return false
        }
      }

      return true
    }

    objectPath.ensureExists = function (obj, path, value) {
      return set(obj, path, value, true)
    }

    objectPath.set = function (obj, path, value, doNotReplace) {
      return set(obj, path, value, doNotReplace)
    }

    objectPath.insert = function (obj, path, value, at) {
      var arr = objectPath.get(obj, path)
      at = ~~at
      if (!isArray(arr)) {
        arr = []
        objectPath.set(obj, path, arr)
      }
      arr.splice(at, 0, value)
    }

    objectPath.empty = function (obj, path) {
      if (isEmpty(path)) {
        return void 0
      }
      if (obj == null) {
        return void 0
      }

      var value, i
      if (!(value = objectPath.get(obj, path))) {
        return void 0
      }

      if (typeof value === 'string') {
        return objectPath.set(obj, path, '')
      } else if (isBoolean(value)) {
        return objectPath.set(obj, path, false)
      } else if (typeof value === 'number') {
        return objectPath.set(obj, path, 0)
      } else if (isArray(value)) {
        value.length = 0
      } else if (isObject(value)) {
        for (i in value) {
          if (hasShallowProperty(value, i)) {
            delete value[i]
          }
        }
      } else {
        return objectPath.set(obj, path, null)
      }
    }

    objectPath.push = function (obj, path /*, values */) {
      var arr = objectPath.get(obj, path)
      if (!isArray(arr)) {
        arr = []
        objectPath.set(obj, path, arr)
      }

      arr.push.apply(arr, Array.prototype.slice.call(arguments, 2))
    }

    objectPath.coalesce = function (obj, paths, defaultValue) {
      var value

      for (var i = 0, len = paths.length; i < len; i++) {
        if ((value = objectPath.get(obj, paths[i])) !== void 0) {
          return value
        }
      }

      return defaultValue
    }

    objectPath.get = function (obj, path, defaultValue) {
      if (typeof path === 'number') {
        path = [path]
      }
      if (!path || path.length === 0) {
        return obj
      }
      if (obj == null) {
        return defaultValue
      }
      if (typeof path === 'string') {
        return objectPath.get(obj, path.split('.'), defaultValue)
      }

      var currentPath = getKey(path[0])
      var nextObj = getShallowPropertySafely(obj, currentPath)
      if (nextObj === void 0) {
        return defaultValue
      }

      if (path.length === 1) {
        return nextObj
      }

      return objectPath.get(obj[currentPath], path.slice(1), defaultValue)
    }

    objectPath.del = function del (obj, path) {
      if (typeof path === 'number') {
        path = [path]
      }

      if (obj == null) {
        return obj
      }

      if (isEmpty(path)) {
        return obj
      }
      if (typeof path === 'string') {
        return objectPath.del(obj, path.split('.'))
      }

      var currentPath = getKey(path[0])
      getShallowPropertySafely(obj, currentPath)
      if (!hasShallowProperty(obj, currentPath)) {
        return obj
      }

      if (path.length === 1) {
        if (isArray(obj)) {
          obj.splice(currentPath, 1)
        } else {
          delete obj[currentPath]
        }
      } else {
        return objectPath.del(obj[currentPath], path.slice(1))
      }

      return obj
    }

    return objectPath
  }

  var mod = factory()
  mod.create = factory
  mod.withInheritedProps = factory({includeInheritedProps: true})
  return mod
})


/***/ }),

/***/ "608a":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "608b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ShowMore_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1099");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ShowMore_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ShowMore_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ShowMore_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "60f9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageSuccess_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c683");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageSuccess_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageSuccess_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageSuccess_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "61c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisFooter_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a619");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisFooter_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisFooter_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisFooter_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6223":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputBoolean.vue?vue&type=template&id=155da862&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inplace)?_c('div',[_c('div',{staticClass:"form-check form-check-inline",class:{ 'is-invalid': _vm.errorMessage }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueArray[0]),expression:"valueArray[0]"}],staticClass:"form-check-input",attrs:{"id":_vm.id,"type":"checkbox","aria-describedby":_vm.id + 'Help'},domProps:{"checked":Array.isArray(_vm.valueArray[0])?_vm._i(_vm.valueArray[0],null)>-1:(_vm.valueArray[0])},on:{"change":[function($event){var $$a=_vm.valueArray[0],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.valueArray, 0, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.valueArray, 0, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.valueArray, 0, $$c)}},function($event){return _vm.$emit('input', $event.target.checked)}]}})])]):_c('InputRadio',_vm._g(_vm._b({attrs:{"options":[true, false]},on:{"input":_vm.emitValue},model:{value:(_vm.valueArray[0]),callback:function ($$v) {_vm.$set(_vm.valueArray, 0, $$v)},expression:"valueArray[0]"}},'InputRadio',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputBoolean.vue?vue&type=template&id=155da862&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/InputRadio.vue + 4 modules
var InputRadio = __webpack_require__("a386");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputBoolean.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var InputBooleanvue_type_script_lang_js_ = ({
  components: {
    InputRadio: InputRadio["a" /* default */]
  },
  extends: _baseInput["a" /* default */]
});
// CONCATENATED MODULE: ./src/forms/InputBoolean.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputBooleanvue_type_script_lang_js_ = (InputBooleanvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputBoolean.vue?vue&type=custom&index=0&blockType=docs
var InputBooleanvue_type_custom_index_0_blockType_docs = __webpack_require__("d05a");

// CONCATENATED MODULE: ./src/forms/InputBoolean.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputBooleanvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputBooleanvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputBooleanvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputBoolean = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "62a4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSignin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("efc6");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSignin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSignin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSignin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "654b":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "6553":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconAction_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a56b");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconAction_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconAction_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IconAction_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6615":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e5c8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("c5a45878", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "6904":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputString_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0ead");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputString_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputString_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputString_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6ca8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VueTemplate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("59a7");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VueTemplate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VueTemplate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VueTemplate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6d7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputOntologySubtree.vue?vue&type=template&id=3ed0e50b&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticStyle:{"list-style-type":"none"}},_vm._l((_vm.terms),function(term){return _c('li',{key:term.name},[_c('div',{staticClass:"d-flex"},[_c('i',{staticClass:"fa-fw pl-2 pt-1",class:_vm.expandState(term),attrs:{"role":"button"},on:{"click":function($event){return _vm.toggleExpand(term)}}}),_c('i',{staticClass:"fa-fw text-primary pl-2 pt-1",class:_vm.selectState(term),attrs:{"role":"button"},on:{"click":function($event){return _vm.toggleSelect(term)}}}),_c('span',{staticClass:"flex-grow-1 pl-2",attrs:{"role":"button"},on:{"click":function($event){return _vm.toggleExpandOrSelect(term)}}},[_vm._v(" "+_vm._s(term.name)+" "),(term.children)?_c('span',[_vm._v("("+_vm._s(term.children.length)+")")]):_vm._e()])]),(_vm.expanded.indexOf(term.name) >= 0)?_c('InputOntologySubtree',{attrs:{"expanded":_vm.expanded,"selection":_vm.selection,"terms":term.children,"list":_vm.list},on:{"select":function($event){return _vm.select(term, $event)},"deselect":function($event){return _vm.$emit('deselect', $event)},"toggleExpand":function($event){return _vm.$emit('toggleExpand', $event)}}}):_vm._e()],1)}),0)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputOntologySubtree.vue?vue&type=template&id=3ed0e50b&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputOntologySubtree.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var InputOntologySubtreevue_type_script_lang_js_ = ({
  name: "InputOntologySubtree",
  props: {
    terms: Array,
    selection: Array,
    expanded: Array,
    list: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasChildren() {
      return this.terms.filter(t => t.children).length > 0;
    }

  },
  methods: {
    select(self, items) {
      //if all children selected then also select 'self'
      if (self.children) {
        let allSelected = [].concat(this.selection, items);
        let allChildren = self.children.map(c => c.name);

        if (allChildren.every(elem => allSelected.indexOf(elem) > -1)) {
          items.push(self.name);
        }
      }

      this.$emit("select", items);
    },

    expandState(item) {
      if (!item.children) {
        return "fas fa-angle-right invisible";
      } else if (this.expanded.includes(item.name)) {
        return "fas fa-angle-down";
      } else {
        return "fas fa-angle-right";
      }
    },

    selectState(item) {
      if (this.selection.includes(item.name)) {
        return this.list ? "fas fa-check-square" : "fas fa-check-circle";
      } else if (item.children && item.children.map(c => c.name).some(c => this.selection.indexOf(c) != -1)) {
        return this.list ? "far fa-check-square" : "far fa-circle";
      } else {
        return this.list ? "far fa-square" : "far fa-circle";
      }
    },

    getAllChildNames(term) {
      let result = [term.name];

      if (term.children) {
        term.children.forEach(t => {
          result.push(...this.getAllChildNames(t));
        });
      }

      return result;
    },

    toggleExpandOrSelect(term) {
      //if node  expand,
      if (term.children) {
        this.toggleExpand(term);
      } //leafs select
      else {
          this.toggleSelect(term);
        }
    },

    toggleSelect(term) {
      //if selecting then also expand
      //if deselection we keep it open
      if (this.selection.indexOf(term.name) === -1) {
        if (this.expanded.indexOf(term.name) === -1) {
          this.$emit("toggleExpand", term.name);
        } //select children, recursively in case of list


        if (this.list) {
          this.$emit("select", this.getAllChildNames(term));
        } else {
          this.$emit("select", [term.name]);
        }
      } else {
        this.$emit("deselect", this.getAllChildNames(term));
      }
    },

    toggleExpand(term) {
      this.$emit("toggleExpand", term.name);
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputOntologySubtree.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputOntologySubtreevue_type_script_lang_js_ = (InputOntologySubtreevue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// CONCATENATED MODULE: ./src/forms/InputOntologySubtree.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputOntologySubtreevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InputOntologySubtree = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "6e1f":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "7022":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputHeading.vue?vue&type=template&id=69a3b623&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex form-group bg-white rounded p-2"},[(!_vm.focus)?_c('span',[_c('h1',[_vm._v(_vm._s(_vm.label))]),_c('p',[_vm._v(_vm._s(_vm.description))])]):_c('textarea',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.inplace || _vm.editMeta),expression:"inplace || editMeta"}],class:{
      'form-control': true,
    },attrs:{"aria-describedby":_vm.id + 'Help'},domProps:{"value":_vm.description},on:{"input":function($event){return _vm.$emit('update:description', $event.target.value)},"blur":_vm.toggleFocus}}),_vm._v(" "),_c('div',[((_vm.inplace || _vm.editMeta) && !_vm.focus)?_c('IconAction',{staticClass:"hoverIcon align-top",attrs:{"icon":"pencil-alt"},on:{"click":_vm.toggleFocus}}):_vm._e()],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputHeading.vue?vue&type=template&id=69a3b623&

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputHeading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This is an component that does not have an input field but instead shows an header.
 * Otherwise it uses same mechanism as other input hence name 'InputHeader'
 */

/* harmony default export */ var InputHeadingvue_type_script_lang_js_ = ({
  components: {
    IconAction: IconAction["a" /* default */]
  },
  props: {
    inplace: Boolean,
    label: String,
    columnType: String,
    description: String,
    editMeta: Boolean
  },

  data() {
    return {
      focus: false
    };
  },

  methods: {
    toggleFocus() {
      this.focus = !this.focus;
    },

    stripHtml(input) {
      if (input) {
        return input.replace(/(<\/?(?:h1|h2|h3|h4|p|label|a)[^>]*>)|<[^>]+>/gi, "$1");
      } else {
        return input;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputHeading.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputHeadingvue_type_script_lang_js_ = (InputHeadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputHeading.vue?vue&type=custom&index=0&blockType=docs
var InputHeadingvue_type_custom_index_0_blockType_docs = __webpack_require__("1828");

// CONCATENATED MODULE: ./src/forms/InputHeading.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputHeadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputHeadingvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputHeadingvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputHeading = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "7028":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "72a7":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "7338":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "7343":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeDate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("608a");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeDate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeDate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeDate_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "746d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRef_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("db54");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRef_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRef_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRef_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "758c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/forms/InputString.vue + 4 modules
var InputString = __webpack_require__("ffa4");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputInt.vue?vue&type=script&lang=js&

/** Input for integer values */

/* harmony default export */ var InputIntvue_type_script_lang_js_ = ({
  extends: InputString["a" /* default */],
  props: {
    placeholder: {
      default: "Enter integer (does not accept A-Za-z,.)"
    },
    parser: {
      default() {
        return value => {
          return parseInt(value);
        };
      }

    }
  },
  methods: {
    keyhandler(event) {
      if (!this.isInt(event)) event.preventDefault();
    },

    isInt(e) {
      var specialKeys = [];
      specialKeys.push(8); // Backspace

      var keyCode = e.which ? e.which : e.keyCode;
      var ret = keyCode >= 48 && keyCode <= 57 || specialKeys.indexOf(keyCode) !== -1;
      return ret;
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputInt.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputIntvue_type_script_lang_js_ = (InputIntvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputInt.vue?vue&type=custom&index=0&blockType=docs
var InputIntvue_type_custom_index_0_blockType_docs = __webpack_require__("eda2");

// CONCATENATED MODULE: ./src/forms/InputInt.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputIntvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputIntvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputIntvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputInt = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "78ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputText_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("270c");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputText_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputText_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputText_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "799d":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".flatpickr-calendar{background:transparent;opacity:0;display:none;text-align:center;visibility:hidden;padding:0;-webkit-animation:none;animation:none;direction:ltr;border:0;font-size:14px;line-height:24px;border-radius:5px;position:absolute;width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;-ms-touch-action:manipulation;touch-action:manipulation;background:#fff;-webkit-box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,.08);box-shadow:1px 0 0 #e6e6e6,-1px 0 0 #e6e6e6,0 1px 0 #e6e6e6,0 -1px 0 #e6e6e6,0 3px 13px rgba(0,0,0,.08)}.flatpickr-calendar.inline,.flatpickr-calendar.open{opacity:1;max-height:640px;visibility:visible}.flatpickr-calendar.open{display:inline-block;z-index:99999}.flatpickr-calendar.animate.open{-webkit-animation:fpFadeInDown .3s cubic-bezier(.23,1,.32,1);animation:fpFadeInDown .3s cubic-bezier(.23,1,.32,1)}.flatpickr-calendar.inline{display:block;position:relative;top:2px}.flatpickr-calendar.static{position:absolute;top:calc(100% + 2px)}.flatpickr-calendar.static.open{z-index:999;display:block}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7){-webkit-box-shadow:none!important;box-shadow:none!important}.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1){-webkit-box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-2px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-calendar .hasTime .dayContainer,.flatpickr-calendar .hasWeeks .dayContainer{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.flatpickr-calendar .hasWeeks .dayContainer{border-left:0}.flatpickr-calendar.hasTime .flatpickr-time{height:40px;border-top:1px solid #e6e6e6}.flatpickr-calendar.noCalendar.hasTime .flatpickr-time{height:auto}.flatpickr-calendar:after,.flatpickr-calendar:before{position:absolute;display:block;pointer-events:none;border:solid transparent;content:\"\";height:0;width:0;left:22px}.flatpickr-calendar.arrowRight:after,.flatpickr-calendar.arrowRight:before,.flatpickr-calendar.rightMost:after,.flatpickr-calendar.rightMost:before{left:auto;right:22px}.flatpickr-calendar.arrowCenter:after,.flatpickr-calendar.arrowCenter:before{left:50%;right:50%}.flatpickr-calendar:before{border-width:5px;margin:0 -5px}.flatpickr-calendar:after{border-width:4px;margin:0 -4px}.flatpickr-calendar.arrowTop:after,.flatpickr-calendar.arrowTop:before{bottom:100%}.flatpickr-calendar.arrowTop:before{border-bottom-color:#e6e6e6}.flatpickr-calendar.arrowTop:after{border-bottom-color:#fff}.flatpickr-calendar.arrowBottom:after,.flatpickr-calendar.arrowBottom:before{top:100%}.flatpickr-calendar.arrowBottom:before{border-top-color:#e6e6e6}.flatpickr-calendar.arrowBottom:after{border-top-color:#fff}.flatpickr-calendar:focus{outline:0}.flatpickr-wrapper{position:relative;display:inline-block}.flatpickr-months{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-months .flatpickr-month{background:transparent;color:rgba(0,0,0,.9);fill:rgba(0,0,0,.9);height:34px;line-height:1;text-align:center;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}.flatpickr-months .flatpickr-next-month,.flatpickr-months .flatpickr-prev-month{text-decoration:none;cursor:pointer;position:absolute;top:0;height:34px;padding:10px;z-index:3;color:rgba(0,0,0,.9);fill:rgba(0,0,0,.9)}.flatpickr-months .flatpickr-next-month.flatpickr-disabled,.flatpickr-months .flatpickr-prev-month.flatpickr-disabled{display:none}.flatpickr-months .flatpickr-next-month i,.flatpickr-months .flatpickr-prev-month i{position:relative}.flatpickr-months .flatpickr-next-month.flatpickr-prev-month,.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month{left:0}.flatpickr-months .flatpickr-next-month.flatpickr-next-month,.flatpickr-months .flatpickr-prev-month.flatpickr-next-month{right:0}.flatpickr-months .flatpickr-next-month:hover,.flatpickr-months .flatpickr-prev-month:hover{color:#959ea9}.flatpickr-months .flatpickr-next-month:hover svg,.flatpickr-months .flatpickr-prev-month:hover svg{fill:#f64747}.flatpickr-months .flatpickr-next-month svg,.flatpickr-months .flatpickr-prev-month svg{width:14px;height:14px}.flatpickr-months .flatpickr-next-month svg path,.flatpickr-months .flatpickr-prev-month svg path{-webkit-transition:fill .1s;transition:fill .1s;fill:inherit}.numInputWrapper{position:relative;height:auto}.numInputWrapper input,.numInputWrapper span{display:inline-block}.numInputWrapper input{width:100%}.numInputWrapper input::-ms-clear{display:none}.numInputWrapper input::-webkit-inner-spin-button,.numInputWrapper input::-webkit-outer-spin-button{margin:0;-webkit-appearance:none}.numInputWrapper span{position:absolute;right:0;width:14px;padding:0 4px 0 2px;height:50%;line-height:50%;opacity:0;cursor:pointer;border:1px solid rgba(57,57,57,.15);-webkit-box-sizing:border-box;box-sizing:border-box}.numInputWrapper span:hover{background:rgba(0,0,0,.1)}.numInputWrapper span:active{background:rgba(0,0,0,.2)}.numInputWrapper span:after{display:block;content:\"\";position:absolute}.numInputWrapper span.arrowUp{top:0;border-bottom:0}.numInputWrapper span.arrowUp:after{border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:4px solid rgba(57,57,57,.6);top:26%}.numInputWrapper span.arrowDown{top:50%}.numInputWrapper span.arrowDown:after{border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid rgba(57,57,57,.6);top:40%}.numInputWrapper span svg{width:inherit;height:auto}.numInputWrapper span svg path{fill:rgba(0,0,0,.5)}.numInputWrapper:hover{background:rgba(0,0,0,.05)}.numInputWrapper:hover span{opacity:1}.flatpickr-current-month{font-size:135%;line-height:inherit;font-weight:300;color:inherit;position:absolute;width:75%;left:12.5%;padding:7.48px 0 0 0;line-height:1;height:34px;display:inline-block;text-align:center;-webkit-transform:translateZ(0);transform:translateZ(0)}.flatpickr-current-month span.cur-month{font-family:inherit;font-weight:700;color:inherit;display:inline-block;margin-left:.5ch;padding:0}.flatpickr-current-month span.cur-month:hover{background:rgba(0,0,0,.05)}.flatpickr-current-month .numInputWrapper{width:6ch;width:7ch\\0;display:inline-block}.flatpickr-current-month .numInputWrapper span.arrowUp:after{border-bottom-color:rgba(0,0,0,.9)}.flatpickr-current-month .numInputWrapper span.arrowDown:after{border-top-color:rgba(0,0,0,.9)}.flatpickr-current-month input.cur-year{background:transparent;-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;cursor:text;padding:0 0 0 .5ch;margin:0;display:inline-block;font-size:inherit;font-family:inherit;font-weight:300;line-height:inherit;height:auto;border:0;border-radius:0;vertical-align:initial;-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}.flatpickr-current-month input.cur-year:focus{outline:0}.flatpickr-current-month input.cur-year[disabled],.flatpickr-current-month input.cur-year[disabled]:hover{font-size:100%;color:rgba(0,0,0,.5);background:transparent;pointer-events:none}.flatpickr-current-month .flatpickr-monthDropdown-months{appearance:menulist;background:transparent;border:none;border-radius:0;box-sizing:border-box;color:inherit;cursor:pointer;font-size:inherit;font-family:inherit;font-weight:300;height:auto;line-height:inherit;margin:-1px 0 0 0;outline:none;padding:0 0 0 .5ch;position:relative;vertical-align:initial;-webkit-box-sizing:border-box;-webkit-appearance:menulist;-moz-appearance:menulist;width:auto}.flatpickr-current-month .flatpickr-monthDropdown-months:active,.flatpickr-current-month .flatpickr-monthDropdown-months:focus{outline:none}.flatpickr-current-month .flatpickr-monthDropdown-months:hover{background:rgba(0,0,0,.05)}.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month{background-color:transparent;outline:none;padding:0}.flatpickr-weekdays{background:transparent;text-align:center;overflow:hidden;width:100%;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;height:28px}.flatpickr-weekdays,.flatpickr-weekdays .flatpickr-weekdaycontainer{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-weekdays .flatpickr-weekdaycontainer,span.flatpickr-weekday{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}span.flatpickr-weekday{cursor:default;font-size:90%;background:transparent;color:rgba(0,0,0,.54);line-height:1;margin:0;text-align:center;display:block;font-weight:bolder}.dayContainer,.flatpickr-weeks{padding:1px 0 0 0}.flatpickr-days{position:relative;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;width:307.875px}.flatpickr-days:focus{outline:0}.dayContainer{padding:0;outline:0;text-align:left;width:307.875px;min-width:307.875px;max-width:307.875px;-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:flex;-webkit-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-wrap:wrap;-ms-flex-pack:justify;-webkit-justify-content:space-around;justify-content:space-around;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}.dayContainer+.dayContainer{-webkit-box-shadow:-1px 0 0 #e6e6e6;box-shadow:-1px 0 0 #e6e6e6}.flatpickr-day{background:none;border:1px solid transparent;border-radius:150px;-webkit-box-sizing:border-box;box-sizing:border-box;color:#393939;cursor:pointer;font-weight:400;width:14.2857143%;-webkit-flex-basis:14.2857143%;-ms-flex-preferred-size:14.2857143%;flex-basis:14.2857143%;max-width:39px;height:39px;line-height:39px;margin:0;display:inline-block;position:relative;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center}.flatpickr-day.inRange,.flatpickr-day.nextMonthDay.inRange,.flatpickr-day.nextMonthDay.today.inRange,.flatpickr-day.nextMonthDay:focus,.flatpickr-day.nextMonthDay:hover,.flatpickr-day.prevMonthDay.inRange,.flatpickr-day.prevMonthDay.today.inRange,.flatpickr-day.prevMonthDay:focus,.flatpickr-day.prevMonthDay:hover,.flatpickr-day.today.inRange,.flatpickr-day:focus,.flatpickr-day:hover{cursor:pointer;outline:0;background:#e6e6e6;border-color:#e6e6e6}.flatpickr-day.today{border-color:#959ea9}.flatpickr-day.today:focus,.flatpickr-day.today:hover{border-color:#959ea9;background:#959ea9;color:#fff}.flatpickr-day.endRange,.flatpickr-day.endRange.inRange,.flatpickr-day.endRange.nextMonthDay,.flatpickr-day.endRange.prevMonthDay,.flatpickr-day.endRange:focus,.flatpickr-day.endRange:hover,.flatpickr-day.selected,.flatpickr-day.selected.inRange,.flatpickr-day.selected.nextMonthDay,.flatpickr-day.selected.prevMonthDay,.flatpickr-day.selected:focus,.flatpickr-day.selected:hover,.flatpickr-day.startRange,.flatpickr-day.startRange.inRange,.flatpickr-day.startRange.nextMonthDay,.flatpickr-day.startRange.prevMonthDay,.flatpickr-day.startRange:focus,.flatpickr-day.startRange:hover{background:#569ff7;-webkit-box-shadow:none;box-shadow:none;color:#fff;border-color:#569ff7}.flatpickr-day.endRange.startRange,.flatpickr-day.selected.startRange,.flatpickr-day.startRange.startRange{border-radius:50px 0 0 50px}.flatpickr-day.endRange.endRange,.flatpickr-day.selected.endRange,.flatpickr-day.startRange.endRange{border-radius:0 50px 50px 0}.flatpickr-day.endRange.startRange+.endRange:not(:nth-child(7n+1)),.flatpickr-day.selected.startRange+.endRange:not(:nth-child(7n+1)),.flatpickr-day.startRange.startRange+.endRange:not(:nth-child(7n+1)){-webkit-box-shadow:-10px 0 0 #569ff7;box-shadow:-10px 0 0 #569ff7}.flatpickr-day.endRange.startRange.endRange,.flatpickr-day.selected.startRange.endRange,.flatpickr-day.startRange.startRange.endRange{border-radius:50px}.flatpickr-day.inRange{border-radius:0;-webkit-box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6;box-shadow:-5px 0 0 #e6e6e6,5px 0 0 #e6e6e6}.flatpickr-day.flatpickr-disabled,.flatpickr-day.flatpickr-disabled:hover,.flatpickr-day.nextMonthDay,.flatpickr-day.notAllowed,.flatpickr-day.notAllowed.nextMonthDay,.flatpickr-day.notAllowed.prevMonthDay,.flatpickr-day.prevMonthDay{color:rgba(57,57,57,.3);background:transparent;border-color:transparent;cursor:default}.flatpickr-day.flatpickr-disabled,.flatpickr-day.flatpickr-disabled:hover{cursor:not-allowed;color:rgba(57,57,57,.1)}.flatpickr-day.week.selected{border-radius:0;-webkit-box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7;box-shadow:-5px 0 0 #569ff7,5px 0 0 #569ff7}.flatpickr-day.hidden{visibility:hidden}.rangeMode .flatpickr-day{margin-top:1px}.flatpickr-weekwrapper{float:left}.flatpickr-weekwrapper .flatpickr-weeks{padding:0 12px;-webkit-box-shadow:1px 0 0 #e6e6e6;box-shadow:1px 0 0 #e6e6e6}.flatpickr-weekwrapper .flatpickr-weekday{float:none;width:100%;line-height:28px}.flatpickr-weekwrapper span.flatpickr-day,.flatpickr-weekwrapper span.flatpickr-day:hover{display:block;width:100%;max-width:none;color:rgba(57,57,57,.3);background:transparent;cursor:default;border:none}.flatpickr-innerContainer{display:block;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;overflow:hidden}.flatpickr-innerContainer,.flatpickr-rContainer{-webkit-box-sizing:border-box;box-sizing:border-box}.flatpickr-rContainer{display:inline-block;padding:0}.flatpickr-time{text-align:center;outline:0;display:block;height:0;line-height:40px;max-height:40px;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.flatpickr-time:after{content:\"\";display:table;clear:both}.flatpickr-time .numInputWrapper{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1;width:40%;height:40px;float:left}.flatpickr-time .numInputWrapper span.arrowUp:after{border-bottom-color:#393939}.flatpickr-time .numInputWrapper span.arrowDown:after{border-top-color:#393939}.flatpickr-time.hasSeconds .numInputWrapper{width:26%}.flatpickr-time.time24hr .numInputWrapper{width:49%}.flatpickr-time input{background:transparent;-webkit-box-shadow:none;box-shadow:none;border:0;border-radius:0;text-align:center;margin:0;padding:0;height:inherit;line-height:inherit;color:#393939;font-size:14px;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}.flatpickr-time input.flatpickr-hour{font-weight:700}.flatpickr-time input.flatpickr-minute,.flatpickr-time input.flatpickr-second{font-weight:400}.flatpickr-time input:focus{outline:0;border:0}.flatpickr-time .flatpickr-am-pm,.flatpickr-time .flatpickr-time-separator{height:inherit;float:left;line-height:inherit;color:#393939;font-weight:700;width:2%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-align-self:center;-ms-flex-item-align:center;align-self:center}.flatpickr-time .flatpickr-am-pm{outline:0;width:18%;cursor:pointer;text-align:center;font-weight:400}.flatpickr-time .flatpickr-am-pm:focus,.flatpickr-time .flatpickr-am-pm:hover,.flatpickr-time input:focus,.flatpickr-time input:hover{background:#eee}.flatpickr-input[readonly]{cursor:pointer}@-webkit-keyframes fpFadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fpFadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "79ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/recursive-iterator/src/RecursiveIterator.js
var RecursiveIterator = __webpack_require__("9da6");
var RecursiveIterator_default = /*#__PURE__*/__webpack_require__.n(RecursiveIterator);

// EXTERNAL MODULE: ../node_modules/object-path/index.js
var object_path = __webpack_require__("6074");
var object_path_default = /*#__PURE__*/__webpack_require__.n(object_path);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/mixins/GraphqlRequestMixin.vue?vue&type=script&lang=js&


/* harmony default export */ var GraphqlRequestMixinvue_type_script_lang_js_ = ({
  methods: {
    requestMultipart(url, query, variables) {
      return new Promise(function (resolve, reject) {
        //thanks to https://medium.com/@danielbuechele/file-uploads-with-graphql-and-apollo-5502bbf3941e
        const formData = new FormData(); // search for File objects on the request and set it as formData

        for (let {
          node,
          path
        } of new RecursiveIterator_default.a(variables)) {
          if (node instanceof File) {
            const id = Math.random().toString(36);
            formData.append(id, node);
            object_path_default.a.set(variables, path.join("."), id);
          }
        }

        formData.append("query", query);
        formData.append("variables", JSON.stringify(variables || {}));
        fetch(url, {
          body: formData,
          method: "POST"
        }).then(response => {
          if (response.ok) {
            response.json().then(result => {
              if (!result.errors && result.data) {
                resolve({
                  data: result.data
                });
              } else {
                {
                  reject({
                    errors: result.errors
                  });
                }
              }
            });
          } else {
            response.json().then(result => {
              reject({
                errors: result.errors
              });
            });
          }
        }).catch(error => {
          alert("catch: " + error.json());
          reject({
            status: error,
            query: query
          });
        });
      });
    }

  }
});
// CONCATENATED MODULE: ./src/mixins/GraphqlRequestMixin.vue?vue&type=script&lang=js&
 /* harmony default export */ var mixins_GraphqlRequestMixinvue_type_script_lang_js_ = (GraphqlRequestMixinvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// CONCATENATED MODULE: ./src/mixins/GraphqlRequestMixin.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mixins_GraphqlRequestMixinvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var GraphqlRequestMixin = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "7a10":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowCard_vue_vue_type_style_index_0_id_366673e6_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1b73");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowCard_vue_vue_type_style_index_0_id_366673e6_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowCard_vue_vue_type_style_index_0_id_366673e6_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7b77":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "7b9a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5d1a");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("d91ecb24", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7c62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_inputAppend_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5706");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_inputAppend_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_inputAppend_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7d21":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "7f62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableSearch.vue?vue&type=template&id=69efba9b&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.graphqlError)?_c('MessageError',[_vm._v(_vm._s(_vm.graphqlError))]):_c('div',{staticStyle:{"text-align":"center"}},[(_vm.showHeaderIfNeeded)?_c('form',{staticClass:"form-inline justify-content-between mb-2 bg-white"},[(_vm.table)?_c('InputSearch',{model:{value:(_vm.searchTerms),callback:function ($$v) {_vm.searchTerms=$$v},expression:"searchTerms"}}):_vm._e(),_c('Pagination',{staticClass:"ml-2",attrs:{"limit":_vm.limit,"count":_vm.count},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}),(_vm.showSelect)?_c('SelectionBox',{attrs:{"selection":_vm.selection},on:{"update:selection":function($event){return _vm.$emit('update:selection', $event)}}}):_vm._e()],1):_vm._e(),(_vm.loading)?_c('Spinner'):_c('div',[_c('TableMolgenis',{attrs:{"selection":_vm.selection,"metadata":_vm.tableMetadata,"columns":_vm.columnsVisible,"data":_vm.data,"showSelect":_vm.showSelect},on:{"update:selection":function($event){return _vm.$emit('update:selection', $event)},"select":_vm.select,"deselect":_vm.deselect},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("colheader",null,null,_vm.$props),_c('label',[_vm._v(_vm._s(_vm.count)+" records found")])]},proxy:true},{key:"colheader",fn:function(){return [_vm._t("colheader",null,{"canEdit":_vm.canEdit,"reload":_vm.reload,"grapqlURL":_vm.graphqlURL},_vm.$props),(_vm.canEdit)?_c('RowButtonAdd',{staticClass:"d-inline p-0",attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL},on:{"close":_vm.reload}}):_vm._e()]},proxy:true},{key:"rowheader",fn:function(slotProps){return [_vm._t("rowheader",null,{"row":slotProps.row,"metadata":_vm.tableMetadata,"rowkey":slotProps.rowkey}),(_vm.canEdit)?_c('RowButtonEdit',{attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL,"pkey":_vm.getPkey(slotProps.row)},on:{"close":_vm.reload}}):_vm._e(),(_vm.canEdit)?_c('RowButtonDelete',{attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL,"pkey":_vm.getPkey(slotProps.row)},on:{"close":_vm.reload}}):_vm._e()]}}],null,true)})],1)],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/TableSearch.vue?vue&type=template&id=69efba9b&

// EXTERNAL MODULE: ./src/mixins/TableMixin.vue + 2 modules
var TableMixin = __webpack_require__("89c1");

// EXTERNAL MODULE: ./src/tables/TableMolgenis.vue + 34 modules
var TableMolgenis = __webpack_require__("0dcd");

// EXTERNAL MODULE: ./src/forms/MessageError.vue + 2 modules
var MessageError = __webpack_require__("25b1");

// EXTERNAL MODULE: ./src/forms/InputSearch.vue + 4 modules
var InputSearch = __webpack_require__("e1de");

// EXTERNAL MODULE: ./src/tables/Pagination.vue + 4 modules
var Pagination = __webpack_require__("5a2b");

// EXTERNAL MODULE: ./src/layout/Spinner.vue + 2 modules
var Spinner = __webpack_require__("0f35");

// EXTERNAL MODULE: ./src/tables/SelectionBox.vue + 4 modules
var SelectionBox = __webpack_require__("a870");

// EXTERNAL MODULE: ./src/tables/RowButtonAdd.vue + 4 modules
var RowButtonAdd = __webpack_require__("fc2a");

// EXTERNAL MODULE: ./src/tables/RowButtonEdit.vue + 4 modules
var RowButtonEdit = __webpack_require__("42ad");

// EXTERNAL MODULE: ./src/tables/RowButtonDelete.vue + 4 modules
var RowButtonDelete = __webpack_require__("c64d");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/TableSearch.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var TableSearchvue_type_script_lang_js_ = ({
  components: {
    SelectionBox: SelectionBox["a" /* default */],
    TableMolgenis: TableMolgenis["a" /* default */],
    MessageError: MessageError["a" /* default */],
    InputSearch: InputSearch["a" /* default */],
    Pagination: Pagination["a" /* default */],
    Spinner: Spinner["a" /* default */],
    RowButtonEdit: RowButtonEdit["a" /* default */],
    RowButtonDelete: RowButtonDelete["a" /* default */],
    RowButtonAdd: RowButtonAdd["a" /* default */]
  },
  mixins: [TableMixin["a" /* default */]],
  props: {
    /** two-way binding of the selection */
    selection: {
      type: Array,
      default: () => []
    },

    /** enables checkbox to select rows */
    showSelect: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showColumns: {
      type: Array
    }
  },
  data: function () {
    return {
      page: 1,
      loading: true
    };
  },
  computed: {
    showHeaderIfNeeded() {
      return this.showHeader || this.count > this.limit;
    },

    columnsVisible() {
      return this.tableMetadata.columns.filter(c => this.showColumns == null && !c.name.startsWith("mg_") || this.showColumns != null && this.showColumns.includes(c.name));
    }

  },
  methods: {
    select(value) {
      this.$emit("select", value);
    },

    deselect(value) {
      this.$emit("deselect", value);
    }

  },
  watch: {
    page() {
      this.loading = true;
      this.offset = this.limit * (this.page - 1);
      this.reload();
    }

  }
});
// CONCATENATED MODULE: ./src/tables/TableSearch.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_TableSearchvue_type_script_lang_js_ = (TableSearchvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/tables/TableSearch.vue?vue&type=custom&index=0&blockType=docs
var TableSearchvue_type_custom_index_0_blockType_docs = __webpack_require__("c3f7");

// CONCATENATED MODULE: ./src/tables/TableSearch.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tables_TableSearchvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof TableSearchvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(TableSearchvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var TableSearch = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "842e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/_baseInput.vue?vue&type=script&lang=js&
//
//
//
const uuidv4 = __webpack_require__("dad4");

/* harmony default export */ var _baseInputvue_type_script_lang_js_ = ({
  props: {
    /**  value */
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: null
    },

    /** wether to enable in place editing */
    inplace: Boolean,

    /** value to be shown as placeholder in the input (if possible) */
    placeholder: String,

    /** label to be shown above the input */
    label: String,

    /** optional description string shown below input */
    description: String,

    /** whether input must be required (does not validate, but show option to clear input) */
    required: {
      type: Boolean,
      default: false
    },

    /** whether input is readonly (default: false) */
    readonly: {
      type: Boolean,
      default: false
    },

    /** message when in error state */
    errorMessage: null,

    /** whether this is a list of values*/
    list: {
      type: Boolean,
      default: false
    },

    /** whether to show clear buttons */
    clear: {
      type: Boolean,
      default: true
    },

    /** parse function, such as parseInt to type value*/
    parser: Function,

    /** whether metadata can be edited */
    editMeta: Boolean
  },

  data() {
    return {
      /** unique identifier, autogenerated */
      id: uuidv4(),

      /** whether list input should show empty input */
      showNewItem: false,

      /** whether input has focus */
      focus: false
    };
  },

  computed: {
    valueArray() {
      let result = this.value;
      if (!result) result = null;

      if (!Array.isArray(result)) {
        result = [result];
      }

      result = this.removeNulls(result);

      if (result.length == 0 || this.list && this.showNewItem) {
        result.push(null);
      }

      return result;
    }

  },

  // generate automatic id
  mounted() {
    this.id = Math.random().toString(36).substring(7);
  },

  methods: {
    removeNulls(arr) {
      return arr.filter(v => v === 0 || v);
    },

    //emit update with new item on list
    emitValue(event, idx) {
      let value = event ? event.target ? event.target.value : event : null;
      let result;

      if (this.list) {
        result = this.valueArray; //update value

        result[idx] = value; //update newItem if needed

        if (this.showNewItem && result[result.length - 1] != null) {
          this.showNewItem = false;
        } //remove nulls


        result = this.removeNulls(result);
      } else {
        result = value;
      }

      this.$emit("input", result);
    },

    toggleFocus() {
      this.focus = !this.focus;
    },

    addRow() {
      this.showNewItem = true;
    },

    clearValue(idx) {
      let result = this.valueArray;

      if (this.list) {
        result.splice(idx, 1);
      } else {
        result = null;
      }

      this.$emit("input", result);
    },

    showPlus(idx) {
      //always on last line
      return this.list && !this.showNewItem && idx == this.valueArray.length - 1 && this.valueArray[idx] != null;
    },

    //always show on empty lines in list view
    showClear() {
      return this.clear && !this.readonly && this.value != null;
    },

    showMinus(idx) {
      return this.list && !this.showPlus(idx);
    }

  },
  directives: {
    focus: {
      inserted(el, binding) {
        if (binding.value) {
          el.focus();
        }
      }

    }
  }
});
// CONCATENATED MODULE: ./src/forms/_baseInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_baseInputvue_type_script_lang_js_ = (_baseInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// CONCATENATED MODULE: ./src/forms/_baseInput.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_baseInputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var _baseInput = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "8543":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "85cf":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "866f":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "86ab":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".checkbox-clear-value{display:none}.checkbox-form-group:hover .checkbox-clear-value{display:inline}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "87e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ReactNativeFile_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ee24");
/* harmony import */ var _ReactNativeFile_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ReactNativeFile_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "ReactNativeFile", function() { return _ReactNativeFile_js__WEBPACK_IMPORTED_MODULE_0___default.a; });
/* harmony import */ var _extractFiles_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("44a5");
/* harmony import */ var _extractFiles_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_extractFiles_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "extractFiles", function() { return _extractFiles_js__WEBPACK_IMPORTED_MODULE_1___default.a; });
/* harmony import */ var _isExtractableFile_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("117c");
/* harmony import */ var _isExtractableFile_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_isExtractableFile_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "isExtractableFile", function() { return _isExtractableFile_js__WEBPACK_IMPORTED_MODULE_2___default.a; });





/***/ }),

/***/ "8801":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "8927":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "89c1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/graphql-request/dist/index.js
var dist = __webpack_require__("9b3c");

// EXTERNAL MODULE: ./src/mixins/TableMetadataMixin.vue + 2 modules
var TableMetadataMixin = __webpack_require__("9961");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/mixins/TableMixin.vue?vue&type=script&lang=js&


/* harmony default export */ var TableMixinvue_type_script_lang_js_ = ({
  extends: TableMetadataMixin["a" /* default */],
  props: {
    /** Name of the table within graphql endpoint */
    table: String,

    /** pass filters conform TableMixin */
    filter: {},

    /** pass orderBy as Object {field1: 'ASC', field2 {field3:'ASC'}}*/
    orderBy: {},
    initialSearchTerms: {
      type: String,
      default: () => null
    }
  },
  data: function () {
    return {
      data: [],
      count: 0,
      offset: 0,
      limit: 20,
      searchTerms: this.initialSearchTerms
    };
  },
  computed: {
    //filter can be passed as prop or overridden in subclass
    graphqlFilter() {
      if (this.filter) {
        return this.filter;
      } else return {};
    },

    graphql() {
      if (this.tableMetadata == undefined) {
        return "";
      }

      let search = this.searchTerms != null && this.searchTerms !== "" ? ',search:"' + this.searchTerms.trim() + '"' : "";
      return `query ${this.table}($filter:${this.table}Filter, $orderby:${this.table}orderby){
              ${this.table}(filter:$filter,limit:${this.limit},offset:${this.offset}${search},orderby:$orderby){${this.columnNames}}
              ${this.table}_agg(filter:$filter${search}){count}}`;
    },

    tableMetadata() {
      return this.getTable(this.table);
    },

    //this method allows overrides
    orderByObject() {
      if (this.orderBy) {
        return this.orderBy;
      } else {
        return {};
      }
    },

    columnNames() {
      let result = "";

      if (this.tableMetadata != null) {
        this.tableMetadata.columns.forEach(col => {
          if (["REF", "REF_ARRAY", "REFBACK", "ONTOLOGY", "ONTOLOGY_ARRAY"].includes(col.columnType) > 0) {
            result = result + " " + col.name + "{" + this.refGraphql(col) + "}";
          } else if (col.columnType == "FILE") {
            result = result + " " + col.name + "{id,size,extension,url}";
          } else if (col.columnType != "HEADING") {
            result = result + " " + col.name;
          }
        });
      }

      return result;
    }

  },
  methods: {
    reload() {
      if (this.tableMetadata != undefined) {
        this.loading = true;
        this.graphqlError = null;
        Object(dist["request"])(this.graphqlURL, this.graphql, {
          filter: this.graphqlFilter,
          orderby: this.orderByObject
        }).then(data => {
          this.data = data[this.table];
          this.count = data[this.table + "_agg"]["count"];
          this.loading = false;
        }).catch(error => {
          if (Array.isArray(error.response.errors)) {
            this.graphqlError = error.response.errors[0].message;
          } else {
            this.graphqlError = error;
          }

          this.loading = false;
        });
      }
    },

    refGraphql(column) {
      let graphqlString = "";
      this.getTable(column.refTable).columns.forEach(c => {
        if (c.key == 1) {
          graphqlString += c.name + " ";

          if (["REF", "REF_ARRAY", "REFBACK", "ONTOLOGY", "ONTOLOGY_ARRAY"].includes(c.columnType) > 0) {
            graphqlString += "{" + this.refGraphql(c) + "}";
          }
        }
      });
      return graphqlString;
    },

    getTable(table) {
      let result = undefined;

      if (this.schema != null && this.schema.tables != null) {
        this.schema.tables.forEach(t => {
          if (t.name == table) {
            result = t;
          }
        });

        if (!result) {
          this.graphqlError = "Table " + table + " not found";
        }
      }

      if (result) return result;
    },

    getPkey(row) {
      //we only have pkey when the record has been saved
      if (!row["mg_insertedOn"]) return null;
      let result = {};

      if (this.tableMetadata != null) {
        this.tableMetadata.columns.forEach(col => {
          if (col.key == 1 && row[col.name]) {
            result[col.name] = row[col.name];
          }
        });
      }

      return result;
    }

  },
  watch: {
    searchTerms: {
      handler(newValue) {
        this.$emit("searchTerms", newValue);
        this.reload();
      }

    },
    graphqlFilter: {
      deep: true,

      handler() {
        this.reload();
      }

    },
    table: "reload",
    schema: "reload",
    limit: "reload"
  }
});
// CONCATENATED MODULE: ./src/mixins/TableMixin.vue?vue&type=script&lang=js&
 /* harmony default export */ var mixins_TableMixinvue_type_script_lang_js_ = (TableMixinvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/mixins/TableMixin.vue?vue&type=custom&index=0&blockType=docs
var TableMixinvue_type_custom_index_0_blockType_docs = __webpack_require__("e567");

// CONCATENATED MODULE: ./src/mixins/TableMixin.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mixins_TableMixinvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof TableMixinvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(TableMixinvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var TableMixin = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "89e2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientError = void 0;
var ClientError = /** @class */ (function (_super) {
    __extends(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = ClientError.extractMessage(response) + ": " + JSON.stringify({
            response: response,
            request: request,
        });
        _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ClientError.prototype);
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_this, ClientError);
        }
        return _this;
    }
    ClientError.extractMessage = function (response) {
        try {
            return response.errors[0].message;
        }
        catch (e) {
            return "GraphQL Error (Code: " + response.status + ")";
        }
    };
    return ClientError;
}(Error));
exports.ClientError = ClientError;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ "8a9c":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "8b19":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("86ab");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("586987fb", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8cae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowEditModal.vue?vue&type=template&id=42123a2e&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLogin)?_c('div',[(_vm.graphqlError)?_c('MessageError',[_vm._v(_vm._s(_vm.graphqlError))]):_vm._e(),_c('SigninForm',{on:{"login":_vm.loginSuccess,"cancel":_vm.cancel}})],1):_c('LayoutModal',{attrs:{"title":_vm.title,"show":true},on:{"close":function($event){return _vm.$emit('close')}},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.tableMetadata && (_vm.pkey == null || _vm.value))?_c('LayoutForm',_vm._l((_vm.columnsWithoutMeta),function(column){return _c('span',{key:column.name},[(
            (_vm.visibleColumns == null ||
              _vm.visibleColumns.includes(column.name)) &&
            _vm.visible(column.visible) &&
            column.name != 'mg_tableclass' &&
            //if dependent, show only if dependent value is set
            (!column.refLink || _vm.value[column.refLink])
          )?_c('RowFormInput',{attrs:{"label":column.name,"description":column.description,"columnType":column.columnType,"table":column.refTable,"filter":_vm.refLinkFilters[column.name],"refLabel":column.refLabel,"refBack":column.refBack,"required":column.required,"errorMessage":_vm.errorPerColumn[column.name],"readonly":column.readonly || (_vm.pkey && column.key == 1),"graphqlURL":_vm.graphqlURL,"refBackType":_vm.getRefBackType(column),"pkey":_vm.getPkey(_vm.value)},model:{value:(_vm.value[column.name]),callback:function ($$v) {_vm.$set(_vm.value, column.name, $$v)},expression:"value[column.name]"}}):_vm._e()],1)}),0):_vm._e()]},proxy:true},{key:"footer",fn:function(){return [(_vm.success)?_c('MessageSuccess',[_vm._v(_vm._s(_vm.success))]):_vm._e(),(_vm.graphqlError)?_c('MessageError',[_vm._v(_vm._s(_vm.graphqlError))]):_vm._e(),_c('ButtonAlt',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")]),_c('ButtonOutline',{on:{"click":_vm.saveDraft}},[_vm._v("Save draft")]),_c('ButtonAction',{on:{"click":_vm.save}},[_vm._v("Save "+_vm._s(_vm.table))])]},proxy:true}])})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/RowEditModal.vue?vue&type=template&id=42123a2e&

// EXTERNAL MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowEditModal.vue?vue&type=script&lang=js&
var RowEditModalvue_type_script_lang_js_ = __webpack_require__("feb6");

// CONCATENATED MODULE: ./src/tables/RowEditModal.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_RowEditModalvue_type_script_lang_js_ = (RowEditModalvue_type_script_lang_js_["a" /* default */]); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// CONCATENATED MODULE: ./src/tables/RowEditModal.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tables_RowEditModalvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RowEditModal = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "8cd3":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "91f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputPassword.vue?vue&type=template&id=40e0a580&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-group',{attrs:{"id":_vm.id,"label":_vm.label,"placeholder":_vm.placeholder,"description":_vm.description}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueArray[0]),expression:"valueArray[0]"}],staticClass:"form-control",attrs:{"id":_vm.id,"type":"password","aria-describedby":_vm.id + 'Help',"placeholder":_vm.placeholder},domProps:{"value":(_vm.valueArray[0])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.valueArray, 0, $event.target.value)},_vm.emitValue]}})])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputPassword.vue?vue&type=template&id=40e0a580&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/_formGroup.vue + 4 modules
var _formGroup = __webpack_require__("084c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputPassword.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/** Input for passwords */

/* harmony default export */ var InputPasswordvue_type_script_lang_js_ = ({
  extends: _baseInput["a" /* default */],
  components: {
    FormGroup: _formGroup["default"]
  }
});
// CONCATENATED MODULE: ./src/forms/InputPassword.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputPasswordvue_type_script_lang_js_ = (InputPasswordvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputPassword.vue?vue&type=custom&index=0&blockType=docs
var InputPasswordvue_type_custom_index_0_blockType_docs = __webpack_require__("a1e9");

// CONCATENATED MODULE: ./src/forms/InputPassword.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputPasswordvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputPasswordvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputPasswordvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputPassword = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "9345":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "93ab":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "94ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableExplorer_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9d11");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableExplorer_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableExplorer_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableExplorer_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9683":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeDecimal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3729");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeDecimal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeDecimal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRangeDecimal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "96d7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonAlt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ee54");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonAlt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonAlt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonAlt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9905":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutCard_vue_vue_type_style_index_0_id_73e3b44c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c807");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutCard_vue_vue_type_style_index_0_id_73e3b44c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutCard_vue_vue_type_style_index_0_id_73e3b44c_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9961":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/graphql-request/dist/index.js
var dist = __webpack_require__("9b3c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/mixins/TableMetadataMixin.vue?vue&type=script&lang=js&

/* harmony default export */ var TableMetadataMixinvue_type_script_lang_js_ = ({
  props: {
    graphqlURL: {
      default: "graphql",
      type: String
    }
  },
  data: function () {
    return {
      session: null,
      schema: null,
      loading: true,
      graphqlError: null
    };
  },
  methods: {
    reloadMetadata() {
      this.loading = true;
      this.graphqlError = null;
      Object(dist["request"])(this.graphqlURL, "{_session{email,roles}_schema{name,tables{name,description,externalSchema,semantics,columns{name,columnType,key,refTable,refLink,refLabel,refBack,required,semantics,description,position}settings{key,value}}}}").then(data => {
        this.session = data._session;
        this.schema = data._schema;
        this.loading = false;
      }).catch(error => {
        if (Array.isArray(error.response.errors)) {
          this.graphqlError = error.response.errors[0].message;
        } else {
          this.graphqlError = error;
        }

        this.loading = false;
      });
    }

  },
  computed: {
    canEdit() {
      return this.session && (this.session.email == "admin" || this.session.roles && (this.session.roles.includes("Editor") || this.session.roles.includes("Manager")));
    },

    canManage() {
      return this.session && (this.session.email == "admin" || this.session.roles.includes("Manager"));
    }

  },

  created() {
    this.reloadMetadata();
  }

});
// CONCATENATED MODULE: ./src/mixins/TableMetadataMixin.vue?vue&type=script&lang=js&
 /* harmony default export */ var mixins_TableMetadataMixinvue_type_script_lang_js_ = (TableMetadataMixinvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/mixins/TableMetadataMixin.vue?vue&type=custom&index=0&blockType=docs
var TableMetadataMixinvue_type_custom_index_0_blockType_docs = __webpack_require__("113e");

// CONCATENATED MODULE: ./src/mixins/TableMetadataMixin.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  mixins_TableMetadataMixinvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof TableMetadataMixinvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(TableMetadataMixinvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var TableMetadataMixin = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "9a70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputFile_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8cd3");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputFile_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputFile_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputFile_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9b3c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gql = exports.batchRequests = exports.request = exports.rawRequest = exports.GraphQLClient = exports.ClientError = void 0;
var cross_fetch_1 = __importStar(__webpack_require__("e5fe")), CrossFetch = cross_fetch_1;
var printer_1 = __webpack_require__("3fbf");
var createRequestBody_1 = __importDefault(__webpack_require__("d475"));
var types_1 = __webpack_require__("89e2");
var types_2 = __webpack_require__("89e2");
Object.defineProperty(exports, "ClientError", { enumerable: true, get: function () { return types_2.ClientError; } });
/**
 * Convert the given headers configuration into a plain object.
 */
var resolveHeaders = function (headers) {
    var oHeaders = {};
    if (headers) {
        if ((typeof Headers !== 'undefined' && headers instanceof Headers) ||
            headers instanceof CrossFetch.Headers) {
            oHeaders = HeadersInstanceToPlainObject(headers);
        }
        else if (Array.isArray(headers)) {
            headers.forEach(function (_a) {
                var name = _a[0], value = _a[1];
                oHeaders[name] = value;
            });
        }
        else {
            oHeaders = headers;
        }
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 *
 * @param {string} str GraphQL query
 * @returns {string} Cleaned query
 */
var queryCleanner = function (str) { return str.replace(/([\s,]|#[^\n\r]+)+/g, ' ').trim(); };
/**
 * Create query string for GraphQL request
 *
 * @param {object} param0 -
 *
 * @param {string|string[]} param0.query the GraphQL document or array of document if it's a batch request
 * @param {string|undefined} param0.operationName the GraphQL operation name
 * @param {any|any[]} param0.variables the GraphQL variables to use
 */
var buildGetQueryParams = function (_a) {
    var query = _a.query, variables = _a.variables, operationName = _a.operationName;
    if (!Array.isArray(query)) {
        var search = ["query=" + encodeURIComponent(queryCleanner(query))];
        if (variables) {
            search.push("variables=" + encodeURIComponent(JSON.stringify(variables)));
        }
        if (operationName) {
            search.push("operationName=" + encodeURIComponent(operationName));
        }
        return search.join('&');
    }
    if (typeof variables !== 'undefined' && !Array.isArray(variables)) {
        throw new Error('Cannot create query with given variable type, array expected');
    }
    // Batch support
    var payload = query.reduce(function (accu, currentQuery, index) {
        accu.push({
            query: queryCleanner(currentQuery),
            variables: variables ? JSON.stringify(variables[index]) : undefined,
        });
        return accu;
    }, []);
    return "query=" + encodeURIComponent(JSON.stringify(payload));
};
/**
 * Fetch data using POST method
 */
var post = function (_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions;
    return __awaiter(void 0, void 0, void 0, function () {
        var body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    body = createRequestBody_1.default(query, variables, operationName);
                    return [4 /*yield*/, fetch(url, __assign({ method: 'POST', headers: __assign(__assign({}, (typeof body === 'string' ? { 'Content-Type': 'application/json' } : {})), headers), body: body }, fetchOptions))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
/**
 * Fetch data using GET method
 */
var get = function (_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, operationName = _a.operationName, headers = _a.headers, fetch = _a.fetch, fetchOptions = _a.fetchOptions;
    return __awaiter(void 0, void 0, void 0, function () {
        var queryParams;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    queryParams = buildGetQueryParams({
                        query: query,
                        variables: variables,
                        operationName: operationName,
                    });
                    return [4 /*yield*/, fetch(url + "?" + queryParams, __assign({ method: 'GET', headers: headers }, fetchOptions))];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
};
/**
 * todo
 */
var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(url, options) {
        this.url = url;
        this.options = options || {};
    }
    GraphQLClient.prototype.rawRequest = function (query, variables, requestHeaders) {
        var _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? 'POST' : _c, fetchOptions = __rest(_a, ["headers", "fetch", "method"]);
        var url = this.url;
        return makeRequest({
            url: url,
            query: query,
            variables: variables,
            headers: __assign(__assign({}, resolveHeaders(headers)), resolveHeaders(requestHeaders)),
            operationName: undefined,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
        });
    };
    /**
     * Send a GraphQL document to the server.
     */
    GraphQLClient.prototype.request = function (document, variables, requestHeaders) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, _b, fetch, _c, method, fetchOptions, url, _d, query, operationName, data;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? 'POST' : _c, fetchOptions = __rest(_a, ["headers", "fetch", "method"]);
                        url = this.url;
                        _d = resolveRequestDocument(document), query = _d.query, operationName = _d.operationName;
                        return [4 /*yield*/, makeRequest({
                                url: url,
                                query: query,
                                variables: variables,
                                headers: __assign(__assign({}, resolveHeaders(headers)), resolveHeaders(requestHeaders)),
                                operationName: operationName,
                                fetch: fetch,
                                method: method,
                                fetchOptions: fetchOptions,
                            })];
                    case 1:
                        data = (_e.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * Send a GraphQL document to the server.
     */
    GraphQLClient.prototype.batchRequests = function (documents, requestHeaders) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, _b, fetch, _c, method, fetchOptions, url, queries, variables, data;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.options, headers = _a.headers, _b = _a.fetch, fetch = _b === void 0 ? cross_fetch_1.default : _b, _c = _a.method, method = _c === void 0 ? 'POST' : _c, fetchOptions = __rest(_a, ["headers", "fetch", "method"]);
                        url = this.url;
                        queries = documents.map(function (_a) {
                            var document = _a.document;
                            return resolveRequestDocument(document).query;
                        });
                        variables = documents.map(function (_a) {
                            var variables = _a.variables;
                            return variables;
                        });
                        return [4 /*yield*/, makeRequest({
                                url: url,
                                query: queries,
                                variables: variables,
                                headers: __assign(__assign({}, resolveHeaders(headers)), resolveHeaders(requestHeaders)),
                                operationName: undefined,
                                fetch: fetch,
                                method: method,
                                fetchOptions: fetchOptions,
                            })];
                    case 1:
                        data = (_d.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    GraphQLClient.prototype.setHeaders = function (headers) {
        this.options.headers = headers;
        return this;
    };
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    GraphQLClient.prototype.setHeader = function (key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) {
            // todo what if headers is in nested array form... ?
            //@ts-ignore
            headers[key] = value;
        }
        else {
            this.options.headers = (_a = {}, _a[key] = value, _a);
        }
        return this;
    };
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
    GraphQLClient.prototype.setEndpoint = function (value) {
        this.url = value;
        return this;
    };
    return GraphQLClient;
}());
exports.GraphQLClient = GraphQLClient;
function makeRequest(_a) {
    var url = _a.url, query = _a.query, variables = _a.variables, headers = _a.headers, operationName = _a.operationName, fetch = _a.fetch, _b = _a.method, method = _b === void 0 ? 'POST' : _b, fetchOptions = _a.fetchOptions;
    return __awaiter(this, void 0, void 0, function () {
        var fetcher, isBathchingQuery, response, result, successfullyReceivedData, headers_1, status_1, errorResult;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    fetcher = method.toUpperCase() === 'POST' ? post : get;
                    isBathchingQuery = Array.isArray(query);
                    return [4 /*yield*/, fetcher({
                            url: url,
                            query: query,
                            variables: variables,
                            operationName: operationName,
                            headers: headers,
                            fetch: fetch,
                            fetchOptions: fetchOptions,
                        })];
                case 1:
                    response = _c.sent();
                    return [4 /*yield*/, getResult(response)];
                case 2:
                    result = _c.sent();
                    successfullyReceivedData = isBathchingQuery && Array.isArray(result) ? !result.some(function (_a) {
                        var data = _a.data;
                        return !data;
                    }) : !!result.data;
                    if (response.ok && !result.errors && successfullyReceivedData) {
                        headers_1 = response.headers, status_1 = response.status;
                        return [2 /*return*/, __assign(__assign({}, (isBathchingQuery ? { data: result } : result)), { headers: headers_1, status: status_1 })];
                    }
                    else {
                        errorResult = typeof result === 'string' ? { error: result } : result;
                        throw new types_1.ClientError(__assign(__assign({}, errorResult), { status: response.status, headers: response.headers }), { query: query, variables: variables });
                    }
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * todo
 */
function rawRequest(url, query, variables, requestHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var client;
        return __generator(this, function (_a) {
            client = new GraphQLClient(url);
            return [2 /*return*/, client.rawRequest(query, variables, requestHeaders)];
        });
    });
}
exports.rawRequest = rawRequest;
/**
 * Send a GraphQL Document to the GraphQL server for exectuion.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await request('https://foo.bar/graphql', `
 *   {
 *     query {
 *       users
 *     }
 *   }
 * `)
 *
 * // You can also pass a GraphQL DocumentNode. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * // If you don't actually care about using DocumentNode but just
 * // want the tooling support for gql template tag like IDE syntax
 * // coloring and prettier autoformat then note you can use the
 * // passthrough gql tag shipped with graphql-request to save a bit
 * // of performance and not have to install another dep into your project.
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 */
function request(url, document, variables, requestHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var client;
        return __generator(this, function (_a) {
            client = new GraphQLClient(url);
            return [2 /*return*/, client.request(document, variables, requestHeaders)];
        });
    });
}
exports.request = request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for exectuion.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
function batchRequests(url, documents, requestHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var client;
        return __generator(this, function (_a) {
            client = new GraphQLClient(url);
            return [2 /*return*/, client.batchRequests(documents, requestHeaders)];
        });
    });
}
exports.batchRequests = batchRequests;
exports.default = request;
/**
 * todo
 */
function getResult(response) {
    var contentType = response.headers.get('Content-Type');
    if (contentType && contentType.startsWith('application/json')) {
        return response.json();
    }
    else {
        return response.text();
    }
}
/**
 * helpers
 */
function resolveRequestDocument(document) {
    var _a;
    if (typeof document === 'string')
        return { query: document };
    var operationName = undefined;
    var operationDefinitions = document.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; });
    if (operationDefinitions.length === 1) {
        operationName = (_a = operationDefinitions[0].name) === null || _a === void 0 ? void 0 : _a.value;
    }
    return { query: printer_1.print(document), operationName: operationName };
}
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 *
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */
function gql(chunks) {
    var variables = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        variables[_i - 1] = arguments[_i];
    }
    return chunks.reduce(function (accumulator, chunk, index) { return "" + accumulator + chunk + (index in variables ? variables[index] : ''); }, '');
}
exports.gql = gql;
/**
 * Convert Headers instance into regular object
 */
function HeadersInstanceToPlainObject(headers) {
    var o = {};
    headers.forEach(function (v, k) {
        o[k] = v;
    });
    return o;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "9b41":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".card-fullscreen[data-v-73e3b44c]{display:block;z-index:9999;position:fixed;width:100%;height:100%;top:0;right:0;left:0;bottom:0;overflow-y:scroll}.card-fullscreen-icon[data-v-73e3b44c]{float:right;position:absolute;top:0;right:0}.card-fullscreen .card-body[data-v-73e3b44c]{overflow-x:scroll}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9d11":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "9d88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiDrag", function() { return MultiDragPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sortable", function() { return Sortable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Swap", function() { return SwapPlugin; });
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults) {
      if (defaults.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend,
  throttle: throttle,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index(n1);
  i2 = index(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      var sortable = _ref5.sortable,
          cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      var sortable = _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index(lastMultiDragSelect),
                currentIndex = index(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

/* harmony default export */ __webpack_exports__["default"] = (Sortable);



/***/ }),

/***/ "9da6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const {isObject, getKeys} = __webpack_require__("bd1c")

// PRIVATE PROPERTIES
const BYPASS_MODE = '__bypassMode'
const IGNORE_CIRCULAR = '__ignoreCircular'
const MAX_DEEP = '__maxDeep'
const CACHE = '__cache'
const QUEUE = '__queue'
const STATE = '__state'

const EMPTY_STATE = {}

class RecursiveIterator {
  /**
   * @param {Object|Array} root
   * @param {Number} [bypassMode=0]
   * @param {Boolean} [ignoreCircular=false]
   * @param {Number} [maxDeep=100]
   */
  constructor (root, bypassMode = 0, ignoreCircular = false, maxDeep = 100) {
    this[BYPASS_MODE] = bypassMode
    this[IGNORE_CIRCULAR] = ignoreCircular
    this[MAX_DEEP] = maxDeep
    this[CACHE] = []
    this[QUEUE] = []
    this[STATE] = this.getState(undefined, root)
  }
  /**
   * @returns {Object}
   */
  next () {
    const {node, path, deep} = this[STATE] || EMPTY_STATE

    if (this[MAX_DEEP] > deep) {
      if (this.isNode(node)) {
        if (this.isCircular(node)) {
          if (this[IGNORE_CIRCULAR]) {
            // skip
          } else {
            throw new Error('Circular reference')
          }
        } else {
          if (this.onStepInto(this[STATE])) {
            const descriptors = this.getStatesOfChildNodes(node, path, deep)
            const method = this[BYPASS_MODE] ? 'push' : 'unshift'
            this[QUEUE][method](...descriptors)
            this[CACHE].push(node)
          }
        }
      }
    }

    const value = this[QUEUE].shift()
    const done = !value

    this[STATE] = value

    if (done) this.destroy()

    return {value, done}
  }
  /**
   *
   */
  destroy () {
    this[QUEUE].length = 0
    this[CACHE].length = 0
    this[STATE] = null
  }
  /**
   * @param {*} any
   * @returns {Boolean}
   */
  isNode (any) {
    return isObject(any)
  }
  /**
   * @param {*} any
   * @returns {Boolean}
   */
  isLeaf (any) {
    return !this.isNode(any)
  }
  /**
   * @param {*} any
   * @returns {Boolean}
   */
  isCircular (any) {
    return this[CACHE].indexOf(any) !== -1
  }
  /**
   * Returns states of child nodes
   * @param {Object} node
   * @param {Array} path
   * @param {Number} deep
   * @returns {Array<Object>}
   */
  getStatesOfChildNodes (node, path, deep) {
    return getKeys(node).map(key =>
      this.getState(node, node[key], key, path.concat(key), deep + 1)
    )
  }
  /**
   * Returns state of node. Calls for each node
   * @param {Object} [parent]
   * @param {*} [node]
   * @param {String} [key]
   * @param {Array} [path]
   * @param {Number} [deep]
   * @returns {Object}
   */
  getState (parent, node, key, path = [], deep = 0) {
    return {parent, node, key, path, deep}
  }
  /**
   * Callback
   * @param {Object} state
   * @returns {Boolean}
   */
  onStepInto (state) {
    return true
  }
  /**
   * @returns {RecursiveIterator}
   */
  [Symbol.iterator] () {
    return this
  }
}

module.exports = RecursiveIterator


/***/ }),

/***/ "9ecf":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "a010":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonDanger_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ceda");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonDanger_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonDanger_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonDanger_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a11f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("128f");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("4bc75f41", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a1d5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonOutline_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("48f5");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonOutline_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonOutline_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ButtonOutline_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a1e9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputPassword_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2621");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputPassword_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputPassword_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputPassword_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a2fd":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "a386":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRadio.vue?vue&type=template&id=92ffe200&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-group',_vm._g(_vm._b({staticClass:"radio-form-group"},'form-group',_vm.$props,false),_vm.$listeners),[_c('div',[_vm._l((_vm.options),function(item,idx){return _c('div',{key:idx,staticClass:"form-check form-check-inline",class:{ 'is-invalid': _vm.errorMessage }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueArray[0]),expression:"valueArray[0]"}],staticClass:"form-check-input",attrs:{"id":_vm.id + idx,"type":"radio","aria-describedby":_vm.id + 'Help'},domProps:{"value":item,"checked":_vm.valueArray[0] == item,"checked":_vm._q(_vm.valueArray[0],item)},on:{"change":[function($event){return _vm.$set(_vm.valueArray, 0, item)},function($event){return _vm.emitValue($event, idx)}]}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id + idx}},[_vm._v(_vm._s(item))])])}),(_vm.valueArray[0] !== null)?_c('a',{staticClass:"radio-clear-value",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.clearValue(0)}}},[_vm._v(" clear ")]):_vm._e()],2)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputRadio.vue?vue&type=template&id=92ffe200&

// EXTERNAL MODULE: ./src/forms/InputSelect.vue + 4 modules
var InputSelect = __webpack_require__("bdae");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRadio.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var InputRadiovue_type_script_lang_js_ = ({
  extends: InputSelect["a" /* default */]
});
// CONCATENATED MODULE: ./src/forms/InputRadio.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputRadiovue_type_script_lang_js_ = (InputRadiovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/InputRadio.vue?vue&type=style&index=0&lang=css&
var InputRadiovue_type_style_index_0_lang_css_ = __webpack_require__("d69e");

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputRadio.vue?vue&type=custom&index=0&blockType=docs
var InputRadiovue_type_custom_index_0_blockType_docs = __webpack_require__("d402");

// CONCATENATED MODULE: ./src/forms/InputRadio.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputRadiovue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputRadiovue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputRadiovue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputRadio = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "a56b":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "a619":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "a6c2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "a870":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/SelectionBox.vue?vue&type=template&id=522a4b72&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ButtonAlt',{on:{"click":_vm.toggle}},[_vm._v(" Selection "),_c('i',{staticClass:"fa fa-lg fa-check-square-o"}),(_vm.selection && _vm.selection.filter(function (s) { return s != null; }).length > 0)?_c('span',{staticClass:"badge badge-pill badge-danger",staticStyle:{"top":"-7px","left":"-7px"}},[_vm._v(" "+_vm._s(Array.isArray(_vm.selection) ? _vm.selection.filter(function (s) { return s != null; }).length : 0)+" ")]):_vm._e()]),(_vm.expand)?_c('LayoutModal',{attrs:{"title":"Show selection"},on:{"close":function($event){_vm.expand = false}},scopedSlots:_vm._u([{key:"body",fn:function(){return [(
          !Array.isArray(_vm.selection) ||
          _vm.selection.filter(function (s) { return s != null; }).length == 0
        )?_c('span',[_vm._v(" No items selected ")]):_vm._l((_vm.selection.filter(function (s) { return s != null; })),function(item,idx){return _c('span',{key:JSON.stringify(item),staticClass:"btn-outline-primary btn-sm mr-2"},[_vm._v(" "+_vm._s(_vm.flattenObject(item))+" "),_c('IconAction',{attrs:{"icon":"times"},on:{"click":function($event){return _vm.deselect(idx)}}})],1)})]},proxy:true},{key:"footer",fn:function(){return [(Array.isArray(_vm.selection) && _vm.selection.length > 0)?_c('ButtonAlt',{on:{"click":_vm.clear}},[_vm._v(" clear selection ")]):_vm._e()]},proxy:true}],null,false,228215393)}):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/SelectionBox.vue?vue&type=template&id=522a4b72&

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// EXTERNAL MODULE: ./src/forms/ButtonAlt.vue + 4 modules
var ButtonAlt = __webpack_require__("bd01");

// EXTERNAL MODULE: ./src/layout/LayoutModal.vue + 4 modules
var LayoutModal = __webpack_require__("ed0c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/SelectionBox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var SelectionBoxvue_type_script_lang_js_ = ({
  components: {
    IconAction: IconAction["a" /* default */],
    ButtonAlt: ButtonAlt["a" /* default */],
    LayoutModal: LayoutModal["a" /* default */]
  },
  props: {
    selection: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      expand: false
    };
  },

  methods: {
    deselect(idx) {
      let update = this.selection;
      update.splice(idx, 1);
      this.$emit("update:selection", update);
    },

    clear() {
      let update = this.selection;
      update.splice(0, update.length);
      this.$emit("update:selection", update);
    },

    toggle() {
      this.expand = !this.expand;
    },

    flattenObject(object) {
      let result = "";
      Object.keys(object).forEach(key => {
        if (object[key] === null) {//nothing
        } else if (typeof object[key] === "object") {
          result += this.flattenObject(object[key]);
        } else {
          result += "." + object[key];
        }
      });
      return result.replace(/^\./, "");
    }

  }
});
// CONCATENATED MODULE: ./src/tables/SelectionBox.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_SelectionBoxvue_type_script_lang_js_ = (SelectionBoxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/tables/SelectionBox.vue?vue&type=custom&index=0&blockType=docs
var SelectionBoxvue_type_custom_index_0_blockType_docs = __webpack_require__("231d");

// CONCATENATED MODULE: ./src/tables/SelectionBox.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tables_SelectionBoxvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof SelectionBoxvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(SelectionBoxvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var SelectionBox = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "a89d":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "abe4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Molgenis_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5782");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Molgenis_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Molgenis_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Molgenis_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ae84":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterWell_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b58f");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterWell_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterWell_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FilterWell_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b261":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDateTime_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("866f");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDateTime_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDateTime_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDateTime_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b454":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ../node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ../node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "b4af":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "b513":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "b529":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7028");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "b58f":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "b5c9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputFile.vue?vue&type=template&id=33e178de&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-group',_vm._g(_vm._b({},'form-group',_vm.$props,false),_vm.$listeners),[_c('div',{staticClass:"input-group"},[_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"id":_vm.id,"type":"file"},on:{"change":_vm.handleFileUpload}}),_c('input',{staticClass:"form-control active",class:{ 'is-invalid': _vm.errorMessage },attrs:{"placeholder":_vm.filename},on:{"click":function($event){return _vm.$refs.file.click()},"keydown":function($event){$event.preventDefault();}}}),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn bg-transparent",class:{
          'text-primary': !_vm.errorMessage,
          'text-danger': _vm.errorMessage,
        },staticStyle:{"margin-left":"-40px","z-index":"100"},attrs:{"type":"button","title":"Toggle","data-toggle":""},on:{"click":_vm.clearInput}},[_c('i',{staticClass:"fa fa-times"},[_c('span',{staticClass:"sr-only",attrs:{"aria-hidden":"true"}},[_vm._v("Clear")])])])]),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn",class:{
          'btn-outline-primary': !_vm.errorMessage,
          'btn-outline-danger': _vm.errorMessage,
        },attrs:{"type":"button","title":"Toggle","data-toggle":""},on:{"click":function($event){return _vm.$refs.file.click()}}},[_vm._v(" Browse ")])])]),_vm._l((_vm.valueArray),function(val){return _c('div',{key:JSON.stringify(val)},[(val && val.url)?_c('a',{attrs:{"href":val.url}},[_vm._v(" Previous value: "+_vm._s(_vm.name)+"."+_vm._s(val.extension)+" ")]):_vm._e()])})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputFile.vue?vue&type=template&id=33e178de&scoped=true&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/_formGroup.vue + 4 modules
var _formGroup = __webpack_require__("084c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputFile.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var InputFilevue_type_script_lang_js_ = ({
  extends: _baseInput["a" /* default */],
  components: {
    FormGroup: _formGroup["default"]
  },
  computed: {
    filename() {
      if (this.value) return this.value.name;
      return null;
    }

  },
  methods: {
    handleFileUpload() {
      this.value = this.$refs.file.files[0];
      this.$emit("input", this.value);
    },

    clearInput() {
      this.$refs.file.value = "";
      this.value = null;
      this.$emit("input", this.value);
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputFile.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputFilevue_type_script_lang_js_ = (InputFilevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/InputFile.vue?vue&type=style&index=0&id=33e178de&scoped=true&lang=css&
var InputFilevue_type_style_index_0_id_33e178de_scoped_true_lang_css_ = __webpack_require__("06eb");

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputFile.vue?vue&type=custom&index=0&blockType=docs
var InputFilevue_type_custom_index_0_blockType_docs = __webpack_require__("9a70");

// CONCATENATED MODULE: ./src/forms/InputFile.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputFilevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "33e178de",
  null
  
)

/* custom blocks */

if (typeof InputFilevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputFilevue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputFile = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "b7dc":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "bac8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRefback_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7b77");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRefback_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRefback_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRefback_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "bb21":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "bd01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonAlt.vue?vue&type=template&id=c932fa66&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn border-0",class:_vm.light ? 'btn-outline-light' : 'btn-outline-primary',attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.icon)?_c('i',{staticClass:"mr-2 ml-0",class:'fa fa-fw fa-' + _vm.icon}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/ButtonAlt.vue?vue&type=template&id=c932fa66&

// EXTERNAL MODULE: ./src/forms/ButtonAction.vue + 4 modules
var ButtonAction = __webpack_require__("c268");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonAlt.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//

/** Cancel button */

/* harmony default export */ var ButtonAltvue_type_script_lang_js_ = ({
  extends: ButtonAction["a" /* default */],
  props: {
    light: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/forms/ButtonAlt.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_ButtonAltvue_type_script_lang_js_ = (ButtonAltvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/ButtonAlt.vue?vue&type=custom&index=0&blockType=docs
var ButtonAltvue_type_custom_index_0_blockType_docs = __webpack_require__("96d7");

// CONCATENATED MODULE: ./src/forms/ButtonAlt.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_ButtonAltvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof ButtonAltvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(ButtonAltvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var ButtonAlt = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "bd1c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @param {*} any
 * @returns {Boolean}
 */
function isObject (any) {
  return any !== null && typeof any === 'object'
}
/**
 * @param {*} any
 * @returns {Boolean}
 */
const {isArray} = Array
/**
 * @param {*} any
 * @returns {Boolean}
 */
function isArrayLike (any) {
  if (!isObject(any)) return false
  if (!('length' in any)) return false
  const length = any.length
  if (!isNumber(length)) return false
  if (length > 0) {
    return (length - 1) in any
  } else {
    for (const key in any) {
      return false
    }
  }
}
/**
 * @param {*} any
 * @returns {Boolean}
 */
function isNumber (any) {
  return typeof any === 'number'
}
/**
 * @param {Object|Array} object
 * @returns {Array<String>}
 */
function getKeys (object) {
  const keys_ = Object.keys(object)
  if (isArray(object)) {
    // skip sort
  } else if (isArrayLike(object)) {
    const index = keys_.indexOf('length')
    if (index > -1) {
      keys_.splice(index, 1)
    }
    // skip sort
  } else {
    // sort
    keys_.sort()
  }
  return keys_
}

exports.getKeys = getKeys
exports.isArray = isArray
exports.isArrayLike = isArrayLike
exports.isObject = isObject
exports.isNumber = isNumber


/***/ }),

/***/ "bdae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputSelect.vue?vue&type=template&id=af878424&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inplace)?_c('span',[(_vm.focus)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.toggleFocus),expression:"toggleFocus"}],staticClass:"dropdown show"},_vm._l((_vm.valueArray),function(el,idx){return _c('div',{key:idx,staticClass:"dropdown-menu show"},_vm._l((_vm.options),function(option){return _c('a',{key:option,staticClass:"dropdown-item",class:{ 'text-primary': option == el },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.select(option, idx)}}},[_vm._v(_vm._s(option ? option : "‌"))])}),0)}),0):_vm._e(),_c('span',{staticClass:"d-flex flex-nowrap",staticStyle:{"min-width":"1em"},on:{"click":_vm.toggleFocus,"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_vm._v(" "+_vm._s(_vm.value ? _vm.value : "‌‌")+" "),_c('IconAction',{staticClass:"hoverIcon",attrs:{"icon":"pencil-alt"}}),(_vm.errorMessage)?_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],1)]):_c('FormGroup',_vm._g(_vm._b({},'FormGroup',_vm.$props,false),_vm.$listeners),_vm._l((_vm.valueArray),function(el,idx){return _c('InputAppend',_vm._b({key:idx + '.' + _vm.valueArray.length,attrs:{"showPlus":_vm.showPlus(idx),"showClear":false},on:{"add":_vm.addRow}},'InputAppend',_vm.$props,false),[(!_vm.options)?_c('MessageError',[_vm._v("No options provided")]):_c('select',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.inplace),expression:"inplace"}],class:{ 'form-control': true, 'is-invalid': _vm.errorMessage },attrs:{"id":_vm.id},domProps:{"value":_vm.valueArray[idx]},on:{"change":function($event){return _vm.emitValue($event, idx)}}},[(!_vm.required)?_c('option',{domProps:{"selected":el === undefined}}):_vm._e(),_vm._l((_vm.options.filter(
          function (o) { return el == o || !_vm.valueArray.includes(o); }
        )),function(option,index){return _c('option',{key:index,domProps:{"value":option,"selected":el == option}},[_vm._v(" "+_vm._s(option)+" ")])})],2)],1)}),1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputSelect.vue?vue&type=template&id=af878424&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/_inputAppend.vue + 4 modules
var _inputAppend = __webpack_require__("5807");

// EXTERNAL MODULE: ./src/forms/_formGroup.vue + 4 modules
var _formGroup = __webpack_require__("084c");

// EXTERNAL MODULE: ./src/forms/MessageError.vue + 2 modules
var MessageError = __webpack_require__("25b1");

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// EXTERNAL MODULE: ../node_modules/v-click-outside/dist/v-click-outside.umd.js
var v_click_outside_umd = __webpack_require__("27d8");
var v_click_outside_umd_default = /*#__PURE__*/__webpack_require__.n(v_click_outside_umd);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputSelect.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var InputSelectvue_type_script_lang_js_ = ({
  directives: {
    clickOutside: v_click_outside_umd_default.a.directive
  },
  extends: _baseInput["a" /* default */],
  components: {
    InputAppend: _inputAppend["a" /* default */],
    FormGroup: _formGroup["default"],
    MessageError: MessageError["a" /* default */],
    IconAction: IconAction["a" /* default */]
  },
  methods: {
    select(option, idx) {
      this.toggleFocus();
      this.emitValue(option, idx);
    }

  },
  props: {
    options: Array
  }
});
// CONCATENATED MODULE: ./src/forms/InputSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputSelectvue_type_script_lang_js_ = (InputSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputSelect.vue?vue&type=custom&index=0&blockType=docs
var InputSelectvue_type_custom_index_0_blockType_docs = __webpack_require__("44e4");

// CONCATENATED MODULE: ./src/forms/InputSelect.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputSelectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputSelectvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputSelectvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputSelect = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "be64":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisSignin.vue?vue&type=template&id=d06988d0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('Spinner'):(_vm.success)?_c('div',[_c('MessageSuccess',[_vm._v(_vm._s(_vm.success))]),_c('ButtonAlt',{on:{"click":_vm.cancel}},[_vm._v("Close")])],1):_c('LayoutModal',{attrs:{"title":"Sign in","show":true},on:{"close":_vm.cancel},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('LayoutForm',[(_vm.error)?_c('MessageError',[_vm._v(_vm._s(_vm.error))]):_vm._e(),_c('InputString',{attrs:{"label":"Username","placeholder":"Enter username","description":"Please enter username"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_c('InputPassword',{attrs:{"label":"Password","placeholder":"Enter password","description":"Please enter the provided password"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signin.apply(null, arguments)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)]},proxy:true},{key:"footer",fn:function(){return [_c('ButtonAlt',{on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_c('ButtonAction',{on:{"click":_vm.signin}},[_vm._v("Sign in")])]},proxy:true}])})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/MolgenisSignin.vue?vue&type=template&id=d06988d0&

// EXTERNAL MODULE: ./src/forms/ButtonAction.vue + 4 modules
var ButtonAction = __webpack_require__("c268");

// EXTERNAL MODULE: ./src/forms/ButtonAlt.vue + 4 modules
var ButtonAlt = __webpack_require__("bd01");

// EXTERNAL MODULE: ./src/forms/InputString.vue + 4 modules
var InputString = __webpack_require__("ffa4");

// EXTERNAL MODULE: ./src/forms/InputPassword.vue + 4 modules
var InputPassword = __webpack_require__("91f4");

// EXTERNAL MODULE: ./src/forms/MessageError.vue + 2 modules
var MessageError = __webpack_require__("25b1");

// EXTERNAL MODULE: ./src/forms/MessageSuccess.vue + 2 modules
var MessageSuccess = __webpack_require__("e74d");

// EXTERNAL MODULE: ./src/layout/LayoutForm.vue + 4 modules
var LayoutForm = __webpack_require__("494f");

// EXTERNAL MODULE: ./src/layout/LayoutModal.vue + 4 modules
var LayoutModal = __webpack_require__("ed0c");

// EXTERNAL MODULE: ./src/layout/Spinner.vue + 2 modules
var Spinner = __webpack_require__("0f35");

// EXTERNAL MODULE: ../node_modules/graphql-request/dist/index.js
var dist = __webpack_require__("9b3c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/MolgenisSignin.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var MolgenisSigninvue_type_script_lang_js_ = ({
  components: {
    ButtonAction: ButtonAction["a" /* default */],
    ButtonAlt: ButtonAlt["a" /* default */],
    InputPassword: InputPassword["a" /* default */],
    InputString: InputString["a" /* default */],
    MessageError: MessageError["a" /* default */],
    MessageSuccess: MessageSuccess["a" /* default */],
    LayoutForm: LayoutForm["a" /* default */],
    LayoutModal: LayoutModal["a" /* default */],
    Spinner: Spinner["a" /* default */]
  },
  data: function () {
    return {
      email: null,
      password: null,
      loading: false,
      error: null,
      success: null
    };
  },
  methods: {
    signin() {
      if (this.email == null || this.password == null) {
        this.error = "Email and password should be filled in";
      } else {
        this.error = null;
        this.loading = true;
        Object(dist["request"])("/api/graphql", `mutation{signin(email: "${this.email}", password: "${this.password}"){status,message}}`).then(data => {
          if (data.signin.status === "SUCCESS") {
            this.success = "Signed in with " + this.email;
            this.$emit("signin", this.email);
            location.reload();
          } else this.error = data.signin.message;
        }).catch(error => this.error = "internal server graphqlError" + error);
        this.loading = false;
      }
    },

    cancel() {
      /**
       * when cancel is pushed
       */
      this.error = null;
      this.$emit("cancel");
    }

  }
});
// CONCATENATED MODULE: ./src/layout/MolgenisSignin.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_MolgenisSigninvue_type_script_lang_js_ = (MolgenisSigninvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/layout/MolgenisSignin.vue?vue&type=custom&index=0&blockType=docs
var MolgenisSigninvue_type_custom_index_0_blockType_docs = __webpack_require__("62a4");

// CONCATENATED MODULE: ./src/layout/MolgenisSignin.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  layout_MolgenisSigninvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof MolgenisSigninvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(MolgenisSigninvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var MolgenisSignin = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "c1b6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRef.vue?vue&type=template&id=57832cee&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroup',_vm._g(_vm._b({},'FormGroup',_vm.$props,false),_vm.$listeners),[(_vm.loading)?_c('Spinner'):_c('div',[(_vm.list && _vm.count > _vm.maxNum)?_c('div',[_vm._l((_vm.selection),function(item,key){return _c('FilterWell',{key:JSON.stringify(item),attrs:{"label":_vm.flattenObject(item)},on:{"click":function($event){return _vm.deselect(key)}}})}),_c('ButtonAlt',{staticClass:"pl-1",attrs:{"icon":"fa fa-clear"},on:{"click":_vm.emitClear}},[_vm._v(" clear selection ")])],2):_c('div',[(_vm.selection.length > 0)?_c('ButtonAlt',{staticClass:"pl-1",attrs:{"icon":"fa fa-clear"},on:{"click":_vm.emitClear}},[_vm._v(" clear selection ")]):_vm._e()],1),_c('div',{class:_vm.showMultipleColumns ? 'd-flex align-content-stretch flex-wrap' : ''},[_vm._l((_vm.notSelectedRows),function(row,index){return _c('div',{key:index,staticClass:"form-check custom-control custom-checkbox",class:_vm.showMultipleColumns ? 'col-12 col-md-6 col-lg-4' : ''},[(_vm.list)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selection),expression:"selection"}],staticClass:"form-check-input",attrs:{"id":_vm.id + index,"type":"checkbox"},domProps:{"value":_vm.getPkey(row),"checked":Array.isArray(_vm.selection)?_vm._i(_vm.selection,_vm.getPkey(row))>-1:(_vm.selection)},on:{"change":[function($event){var $$a=_vm.selection,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.getPkey(row),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selection=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selection=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selection=$$c}},function($event){return _vm.$emit('input', _vm.selection)}]}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selection),expression:"selection"}],staticClass:"form-check-input",attrs:{"id":_vm.id + index,"name":_vm.id,"type":"radio"},domProps:{"value":_vm.getPkey(row),"checked":_vm._q(_vm.selection,_vm.getPkey(row))},on:{"change":[function($event){_vm.selection=_vm.getPkey(row)},function($event){_vm.$emit('input', _vm.getPkey(row))}]}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id + index}},[_vm._v(" "+_vm._s(_vm.flattenObject(_vm.getPkey(row)))+" ")])])}),_c('ButtonAlt',{staticClass:"pl-0",class:_vm.showMultipleColumns ? 'col-12 col-md-6 col-lg-4' : '',attrs:{"icon":"fa fa-search"},on:{"click":function($event){_vm.showSelect = true}}},[_vm._v(" "+_vm._s(_vm.count > _vm.limit ? "view all " + _vm.count + " options." : "view as table")+" ")])],2),(_vm.showSelect)?_c('LayoutModal',{attrs:{"title":_vm.title},on:{"close":_vm.closeSelect},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.errorMessage)?_c('MessageError',[_vm._v(_vm._s(_vm.graphqlError))]):_vm._e(),(_vm.list)?_c('TableSearch',{attrs:{"selection":_vm.selection,"table":_vm.table,"filter":_vm.filter,"graphqlURL":_vm.graphqlURL,"showSelect":true,"limit":10},on:{"update:selection":function($event){_vm.selection=$event}}}):_c('TableSearch',{attrs:{"selection":[_vm.valueArray[0]],"table":_vm.table,"filter":_vm.filter,"graphqlURL":_vm.graphqlURL,"showSelect":true,"limit":10},on:{"select":function($event){return _vm.select($event)},"deselect":_vm.emitClear}})]},proxy:true},{key:"footer",fn:function(){return [_c('ButtonAlt',{on:{"click":_vm.closeSelect}},[_vm._v("Close")])]},proxy:true}],null,false,1689553669)}):_vm._e()],1)],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputRef.vue?vue&type=template&id=57832cee&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/tables/TableSearch.vue + 4 modules
var TableSearch = __webpack_require__("7f62");

// EXTERNAL MODULE: ./src/layout/LayoutModal.vue + 4 modules
var LayoutModal = __webpack_require__("ed0c");

// EXTERNAL MODULE: ./src/forms/MessageError.vue + 2 modules
var MessageError = __webpack_require__("25b1");

// EXTERNAL MODULE: ./src/forms/_formGroup.vue + 4 modules
var _formGroup = __webpack_require__("084c");

// EXTERNAL MODULE: ./src/forms/ButtonAlt.vue + 4 modules
var ButtonAlt = __webpack_require__("bd01");

// EXTERNAL MODULE: ./src/mixins/TableMixin.vue + 2 modules
var TableMixin = __webpack_require__("89c1");

// EXTERNAL MODULE: ./src/tables/FilterWell.vue + 4 modules
var FilterWell = __webpack_require__("026f");

// EXTERNAL MODULE: ./src/layout/Spinner.vue + 2 modules
var Spinner = __webpack_require__("0f35");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRef.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var InputRefvue_type_script_lang_js_ = ({
  extends: _baseInput["a" /* default */],
  mixins: [TableMixin["a" /* default */]],
  data: function () {
    return {
      showSelect: false,
      selectIdx: null,
      options: [],
      id: Math.random(),
      selection: []
    };
  },
  components: {
    Spinner: Spinner["a" /* default */],
    TableSearch: TableSearch["a" /* default */],
    MessageError: MessageError["a" /* default */],
    LayoutModal: LayoutModal["a" /* default */],
    FormGroup: _formGroup["default"],
    ButtonAlt: ButtonAlt["a" /* default */],
    FilterWell: FilterWell["a" /* default */]
  },
  props: {
    /** change if graphql URL != 'graphql'*/
    graphqlURL: {
      default: "graphql",
      type: String
    },
    filter: Object,
    multipleColumns: Boolean,
    maxNum: {
      type: Number,
      default: 11
    }
  },
  computed: {
    title() {
      return "Select " + this.table;
    },

    notSelectedRows() {
      if (this.data) {
        let result = this.data.filter(row => this.count <= this.maxNum || !this.selection.some(v => this.flattenObject(this.getPkey(row)) == this.flattenObject(v))); //truncate on maxNum (we overquery because we include all selected which might not be in query)

        result.length = Math.min(result.length, this.maxNum);
        return result;
      }

      return [];
    },

    showMultipleColumns() {
      return this.multipleColumns && this.count > 12;
    }

  },
  methods: {
    deselect(key) {
      this.selection.splice(key, 1);
      this.$emit("input", this.selection);
    },

    emitClear() {
      if (this.list) this.$emit("input", []);else this.$emit("input", null);
    },

    select(event) {
      if (this.list) {
        this.$emit("input", this.selection);
      } else {
        this.$emit("input", event);
      }
    },

    closeSelect() {
      this.showSelect = false;
      this.reload();

      if (this.list) {
        this.$emit("input", this.selection);
      }
    },

    openSelect(idx) {
      this.showSelect = true;
      this.selectIdx = idx;
    },

    flattenObject(object) {
      let result = "";
      Object.keys(object).forEach(key => {
        if (object[key] === null) {//nothing
        } else if (typeof object[key] === "object") {
          result += this.flattenObject(object[key]);
        } else {
          result += " " + object[key];
        }
      });
      return result;
    }

  },
  watch: {
    value() {
      this.selection = this.value ? this.value : []; //we overquery because we include all selected which might not be in query

      this.limit = this.maxNum + this.selection.length;
    }

  },

  created() {
    this.limit = this.maxNum + this.selection.length;
    this.selection = this.value ? this.value : [];
    this.reloadMetadata();
  }

});
// CONCATENATED MODULE: ./src/forms/InputRef.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputRefvue_type_script_lang_js_ = (InputRefvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputRef.vue?vue&type=custom&index=0&blockType=docs
var InputRefvue_type_custom_index_0_blockType_docs = __webpack_require__("746d");

// CONCATENATED MODULE: ./src/forms/InputRef.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputRefvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputRefvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputRefvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputRef = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "c268":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonAction.vue?vue&type=template&id=c8c4eb92&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.icon)?_c('i',{staticClass:"mr-2 ml-0",class:'fa fa-fw fa-' + _vm.icon}):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/ButtonAction.vue?vue&type=template&id=c8c4eb92&

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonAction.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/** Button that is shown as a primary action */
/* harmony default export */ var ButtonActionvue_type_script_lang_js_ = ({
  props: {
    href: String,
    icon: String
  },
  methods: {
    onClick() {
      if (this.href) {
        window.open(this.href, "_self");
      } else {
        /** emitted on click */
        this.$emit("click");
      }
    }

  }
});
// CONCATENATED MODULE: ./src/forms/ButtonAction.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_ButtonActionvue_type_script_lang_js_ = (ButtonActionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/ButtonAction.vue?vue&type=custom&index=0&blockType=docs
var ButtonActionvue_type_custom_index_0_blockType_docs = __webpack_require__("029a");

// CONCATENATED MODULE: ./src/forms/ButtonAction.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_ButtonActionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof ButtonActionvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(ButtonActionvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var ButtonAction = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "c3f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSearch_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8801");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSearch_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSearch_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableSearch_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c64d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowButtonDelete.vue?vue&type=template&id=577418f0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('LayoutModal',{attrs:{"title":_vm.title},on:{"close":_vm.closeForm},scopedSlots:_vm._u([{key:"body",fn:function(){return [(_vm.success)?_c('MessageSuccess',[_vm._v(_vm._s(_vm.success))]):(_vm.error)?_c('MessageError',[_vm._v(_vm._s(_vm.error))]):_c('div',[_vm._v(" Delete "),_c('strong',[_vm._v(_vm._s(_vm.table)+"("+_vm._s(_vm.pkeyAsString)+")")]),_c('br'),_vm._v("Are you sure? "),_c('br')])]},proxy:true},{key:"footer",fn:function(){return [_c('ButtonAlt',{on:{"click":_vm.closeForm}},[_vm._v("Close")]),(!_vm.success && !_vm.success)?_c('ButtonAction',{on:{"click":_vm.executeDelete}},[_vm._v(" Delete ")]):_vm._e()]},proxy:true}],null,false,1509064844)}):_c('IconDanger',{attrs:{"icon":"trash"},on:{"click":_vm.openForm}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/RowButtonDelete.vue?vue&type=template&id=577418f0&

// EXTERNAL MODULE: ./src/tables/RowButtonAdd.vue + 4 modules
var RowButtonAdd = __webpack_require__("fc2a");

// EXTERNAL MODULE: ./src/layout/LayoutModal.vue + 4 modules
var LayoutModal = __webpack_require__("ed0c");

// EXTERNAL MODULE: ./src/forms/IconDanger.vue + 4 modules
var IconDanger = __webpack_require__("3212");

// EXTERNAL MODULE: ./src/forms/ButtonAlt.vue + 4 modules
var ButtonAlt = __webpack_require__("bd01");

// EXTERNAL MODULE: ./src/forms/ButtonAction.vue + 4 modules
var ButtonAction = __webpack_require__("c268");

// EXTERNAL MODULE: ./src/forms/MessageError.vue + 2 modules
var MessageError = __webpack_require__("25b1");

// EXTERNAL MODULE: ./src/forms/MessageSuccess.vue + 2 modules
var MessageSuccess = __webpack_require__("e74d");

// EXTERNAL MODULE: ../node_modules/graphql-request/dist/index.js
var dist = __webpack_require__("9b3c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowButtonDelete.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var RowButtonDeletevue_type_script_lang_js_ = ({
  extends: RowButtonAdd["a" /* default */],
  data: function () {
    return {
      success: null,
      error: null
    };
  },
  components: {
    LayoutModal: LayoutModal["a" /* default */],
    IconDanger: IconDanger["a" /* default */],
    ButtonAction: ButtonAction["a" /* default */],
    ButtonAlt: ButtonAlt["a" /* default */],
    MessageSuccess: MessageSuccess["a" /* default */],
    MessageError: MessageError["a" /* default */]
  },
  props: {
    pkey: Object,
    graphqlURL: {
      type: String,
      default: "graphql"
    }
  },
  computed: {
    title() {
      return `Delete from ${this.table}`;
    },

    pkeyAsString() {
      return this.flattenObject(this.pkey);
    }

  },
  methods: {
    executeDelete() {
      let query = `mutation delete($pkey:[${this.table}Input]){delete(${this.table}:$pkey){message}}`;
      let variables = {
        pkey: [this.pkey]
      };
      Object(dist["request"])(this.graphqlURL, query, variables).then(data => {
        this.success = data.delete.message;
        this.$emit("close");
      }).catch(error => {
        this.error = error.response.errors[0].message;
      });
    },

    //duplicated code from MolgenisTable, think of util lib
    flattenObject(object) {
      let result = "";
      Object.keys(object).forEach(key => {
        if (object[key] === null) {//nothing
        } else if (typeof object[key] === "object") {
          result += this.flattenObject(object[key]);
        } else {
          result += " " + object[key];
        }
      });
      return result;
    }

  }
});
// CONCATENATED MODULE: ./src/tables/RowButtonDelete.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_RowButtonDeletevue_type_script_lang_js_ = (RowButtonDeletevue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/tables/RowButtonDelete.vue?vue&type=custom&index=0&blockType=docs
var RowButtonDeletevue_type_custom_index_0_blockType_docs = __webpack_require__("34d3");

// CONCATENATED MODULE: ./src/tables/RowButtonDelete.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tables_RowButtonDeletevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof RowButtonDeletevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(RowButtonDeletevue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var RowButtonDelete = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "c683":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "c807":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9b41");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("aa0f6cdc", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ca98":
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("9d88"));
	else {}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a481");
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __webpack_require__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vuedraggable.umd.js.map

/***/ }),

/***/ "cbc0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_scope_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f1cb");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_scope_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_scope_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ceda":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "cf2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMolgenis_vue_vue_type_style_index_0_id_01efe152_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a11f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMolgenis_vue_vue_type_style_index_0_id_01efe152_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMolgenis_vue_vue_type_style_index_0_id_01efe152_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d03d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSignup_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9345");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSignup_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSignup_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSignup_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d05a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputBoolean_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6e1f");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputBoolean_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputBoolean_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputBoolean_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d0e5":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".is-invalid[data-v-5fa2b2e3]{background-image:none}span:hover .hoverIcon[data-v-5fa2b2e3]{visibility:visible}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d23b":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "d3dd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/forms/InputDate.vue + 4 modules
var InputDate = __webpack_require__("54cd");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputDateTime.vue?vue&type=script&lang=js&

/* harmony default export */ var InputDateTimevue_type_script_lang_js_ = ({
  extends: InputDate["a" /* default */],
  computed: {
    config() {
      return {
        wrap: true,
        // set wrap to true only when using 'input-group'
        dateFormat: "Y-m-dTH:i:S",
        allowInput: false,
        enableTime: true,
        clickOpens: !this.readonly
      };
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputDateTime.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputDateTimevue_type_script_lang_js_ = (InputDateTimevue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputDateTime.vue?vue&type=custom&index=0&blockType=docs
var InputDateTimevue_type_custom_index_0_blockType_docs = __webpack_require__("b261");

// CONCATENATED MODULE: ./src/forms/InputDateTime.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputDateTimevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputDateTimevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputDateTimevue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputDateTime = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "d402":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRadio_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dfc8");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRadio_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRadio_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRadio_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d475":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var extract_files_1 = __webpack_require__("87e0");
var form_data_1 = __importDefault(__webpack_require__("115a"));
/**
 * Duck type if NodeJS stream
 * https://github.com/sindresorhus/is-stream/blob/3750505b0727f6df54324784fe369365ef78841e/index.js#L3
 */
var isExtractableFileEnhanced = function (value) {
    return extract_files_1.isExtractableFile(value) ||
        (value !== null && typeof value === 'object' && typeof value.pipe === 'function');
};
/**
 * Returns Multipart Form if body contains files
 * (https://github.com/jaydenseric/graphql-multipart-request-spec)
 * Otherwise returns JSON
 */
function createRequestBody(query, variables, operationName) {
    var _a = extract_files_1.extractFiles({ query: query, variables: variables, operationName: operationName }, '', isExtractableFileEnhanced), clone = _a.clone, files = _a.files;
    if (files.size === 0) {
        if (!Array.isArray(query)) {
            return JSON.stringify(clone);
        }
        if (typeof variables !== 'undefined' && !Array.isArray(variables)) {
            throw new Error('Cannot create request body with given variable type, array expected');
        }
        // Batch support
        var payload = query.reduce(function (accu, currentQuery, index) {
            accu.push({ query: currentQuery, variables: variables ? variables[index] : undefined });
            return accu;
        }, []);
        return JSON.stringify(payload);
    }
    var Form = typeof FormData === 'undefined' ? form_data_1.default : FormData;
    var form = new Form();
    form.append('operations', JSON.stringify(clone));
    var map = {};
    var i = 0;
    files.forEach(function (paths) {
        map[++i] = paths;
    });
    form.append('map', JSON.stringify(map));
    i = 0;
    files.forEach(function (paths, file) {
        form.append("" + ++i, file);
    });
    return form;
}
exports.default = createRequestBody;
//# sourceMappingURL=createRequestBody.js.map

/***/ }),

/***/ "d55b":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "d622":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputText.vue?vue&type=template&id=dd26e210&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inplace && !_vm.focus)?_c('span',{on:{"click":_vm.toggleFocus}},[_vm._v(" "+_vm._s(_vm.value ? _vm.value : "")+" "),_c('IconAction',{staticClass:"hoverIcon",attrs:{"icon":"pencil-alt"}})],1):_c('FormGroup',_vm._g(_vm._b({attrs:{"id":_vm.id,"label":_vm.label,"description":_vm.description}},'FormGroup',_vm.$props,false),_vm.$listeners),_vm._l((_vm.valueArray),function(el,idx){return _c('InputAppend',_vm._b({key:idx,attrs:{"showClear":_vm.showClear(idx),"showPlus":_vm.showPlus(idx),"showMinus":_vm.showMinus(idx)},on:{"clear":function($event){return _vm.clearValue(idx)},"add":_vm.addRow}},'InputAppend',_vm.$props,false),[_c('textarea',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.inplace && !_vm.list),expression:"inplace && !list"},{name:"autogrow",rawName:"v-autogrow"},{name:"model",rawName:"v-model",value:(_vm.valueArray[idx]),expression:"valueArray[idx]"}],ref:"textarea",refInFor:true,class:{ 'form-control': true, 'is-invalid': _vm.errorMessage },staticStyle:{"resize":"none"},attrs:{"id":_vm.id + idx,"aria-describedby":_vm.id + 'Help',"placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":(_vm.valueArray[idx])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.valueArray, idx, $event.target.value)},function($event){return _vm.emitValue($event, idx)}],"blur":_vm.toggleFocus}})])}),1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputText.vue?vue&type=template&id=dd26e210&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/_inputAppend.vue + 4 modules
var _inputAppend = __webpack_require__("5807");

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputText.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/** Input for text */

/* harmony default export */ var InputTextvue_type_script_lang_js_ = ({
  extends: _baseInput["a" /* default */],
  components: {
    InputAppend: _inputAppend["a" /* default */],
    FormGroup: () => Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "084c")),
    //because it uses itself in nested form
    IconAction: IconAction["a" /* default */]
  },
  directives: {
    autogrow: {
      //thank you! https://github.com/wrabit/vue-textarea-autogrow-directive/blob/master/src/VueTextareaAutogrowDirective.js
      inserted(el) {
        let observe, minHeight; // If used in a component library such as buefy, a wrapper will be used on the component so check if a child is the textarea

        el = el.tagName.toLowerCase() === "textarea" ? el : el.querySelector("textarea");
        minHeight = parseFloat(getComputedStyle(el).getPropertyValue("min-height"));

        if (window.attachEvent) {
          observe = function (element, event, handler) {
            element.attachEvent("on" + event, handler);
          };
        } else {
          observe = function (element, event, handler) {
            element.addEventListener(event, handler, false);
          };
        }

        let resize = () => {
          el.style.height = "auto";
          let border = el.style.borderTopWidth * 2;
          el.style.height = (el.scrollHeight < minHeight ? minHeight : el.scrollHeight) + border + "px";
        }; // 0-timeout to get the already changed el


        let delayedResize = () => {
          window.setTimeout(resize, 0);
        }; // When the textarea is being shown / hidden


        var respondToVisibility = (element, callback) => {
          let intersectionObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.intersectionRatio > 0) callback();
            });
          }, {
            root: document.documentElement
          });
          intersectionObserver.observe(element);
        };

        respondToVisibility(el, resize);
        observe(el, "beforeInput", resize);
        observe(el, "change", resize);
        observe(el, "cut", delayedResize);
        observe(el, "paste", delayedResize);
        observe(el, "drop", delayedResize);
        observe(el, "input", resize);
        resize();
      },

      componentUpdated(el) {
        //in case values are changed from outside in
        let minHeight = parseFloat(getComputedStyle(el).getPropertyValue("min-height"));

        let resize = () => {
          el.style.height = "auto";
          let border = el.style.borderTopWidth * 2;
          el.style.height = (el.scrollHeight < minHeight ? minHeight : el.scrollHeight) + border + "px";
        };

        resize();
      }

    }
  }
});
// CONCATENATED MODULE: ./src/forms/InputText.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputTextvue_type_script_lang_js_ = (InputTextvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputText.vue?vue&type=custom&index=0&blockType=docs
var InputTextvue_type_custom_index_0_blockType_docs = __webpack_require__("78ff");

// CONCATENATED MODULE: ./src/forms/InputText.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputTextvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputTextvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputTextvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputText = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "d62d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ShowHide_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("85cf");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ShowHide_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ShowHide_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ShowHide_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d69e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRadio_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4671");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRadio_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputRadio_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d917":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputOntology_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b7dc");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputOntology_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputOntology_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputOntology_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "dad4":
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__("59ee");
var bytesToUuid = __webpack_require__("e1f7");

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ "db4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/MessageWarning.vue?vue&type=template&id=64f50b79&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/MessageWarning.vue?vue&type=template&id=64f50b79&

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/MessageWarning.vue?vue&type=custom&index=0&blockType=docs
var MessageWarningvue_type_custom_index_0_blockType_docs = __webpack_require__("e27e");

// CONCATENATED MODULE: ./src/forms/MessageWarning.vue

var script = {}


/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof MessageWarningvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(MessageWarningvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var MessageWarning = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "db54":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "dc36":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "dd2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Breadcrumb_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b4af");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Breadcrumb_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Breadcrumb_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Breadcrumb_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "dddb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputString_vue_vue_type_style_index_0_id_5fa2b2e3_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3250");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputString_vue_vue_type_style_index_0_id_5fa2b2e3_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputString_vue_vue_type_style_index_0_id_5fa2b2e3_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "de24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonOutline.vue?vue&type=template&id=61c115e0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.light ? 'btn btn-outline-light' : 'btn btn-outline-primary',attrs:{"type":"button"},on:{"click":_vm.onClick}},[(_vm.icon)?_c('i',{staticClass:"mr-2 ml-0",class:_vm.icon}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/ButtonOutline.vue?vue&type=template&id=61c115e0&

// EXTERNAL MODULE: ./src/forms/ButtonAlt.vue + 4 modules
var ButtonAlt = __webpack_require__("bd01");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/ButtonOutline.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//

/** Cancel button */

/* harmony default export */ var ButtonOutlinevue_type_script_lang_js_ = ({
  extends: ButtonAlt["a" /* default */]
});
// CONCATENATED MODULE: ./src/forms/ButtonOutline.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_ButtonOutlinevue_type_script_lang_js_ = (ButtonOutlinevue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/ButtonOutline.vue?vue&type=custom&index=0&blockType=docs
var ButtonOutlinevue_type_custom_index_0_blockType_docs = __webpack_require__("a1d5");

// CONCATENATED MODULE: ./src/forms/ButtonOutline.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_ButtonOutlinevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof ButtonOutlinevue_type_custom_index_0_blockType_docs["default"] === 'function') Object(ButtonOutlinevue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var ButtonOutline = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "dfc8":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "dfdf":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "e054":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "e10d":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "e11d":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".page-item{border:none}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "e1de":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputSearch.vue?vue&type=template&id=d51757d8&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-group',_vm._g(_vm._b({},'form-group',_vm.$props,false),_vm.$listeners),[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-prepend"},[_c('button',{staticClass:"btn border-right-0 border btn-outline-primary",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search"})])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueArray[0]),expression:"valueArray[0]"}],class:{ 'form-control': true, 'is-invalid': _vm.errorMessage },attrs:{"id":_vm.id,"aria-describedby":_vm.id + 'Help',"placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":(_vm.valueArray[0])},on:{"keypress":_vm.keyhandler,"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.valueArray, 0, $event.target.value)},_vm.emitValue]}}),_c('AppendClear',{on:{"clear":function($event){return _vm.clearValue(0)}}})],1)])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputSearch.vue?vue&type=template&id=d51757d8&

// EXTERNAL MODULE: ./src/forms/InputString.vue + 4 modules
var InputString = __webpack_require__("ffa4");

// EXTERNAL MODULE: ./src/forms/_appendClear.vue + 4 modules
var _appendClear = __webpack_require__("2cad");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputSearch.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var InputSearchvue_type_script_lang_js_ = ({
  extends: InputString["a" /* default */],
  components: {
    AppendClear: _appendClear["a" /* default */]
  }
});
// CONCATENATED MODULE: ./src/forms/InputSearch.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputSearchvue_type_script_lang_js_ = (InputSearchvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputSearch.vue?vue&type=custom&index=0&blockType=docs
var InputSearchvue_type_custom_index_0_blockType_docs = __webpack_require__("3658");

// CONCATENATED MODULE: ./src/forms/InputSearch.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputSearchvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputSearchvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputSearchvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputSearch = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "e1f7":
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ "e21a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0f1e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("98bf3338", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e271":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ebfe");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("855d80c6", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e27e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageWarning_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8a9c");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageWarning_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageWarning_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MessageWarning_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "e3df":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowFormInput_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3afd");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowFormInput_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowFormInput_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RowFormInput_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "e4d2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutModal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8543");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutModal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutModal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LayoutModal_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "e567":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMixin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a2fd");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMixin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMixin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMixin_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "e5c8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".fold-btn[data-v-1bdd26b7]{margin-top:-1rem;width:3rem;height:3rem;text-align:right}.fa-chevron-down[data-v-1bdd26b7],.fa-chevron-up[data-v-1bdd26b7]{width:.66rem;height:.66rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "e5fe":
/***/ (function(module, exports) {

var __self__ = (function (root) {
function F() {
this.fetch = false;
this.DOMException = root.DOMException
}
F.prototype = root;
return new F();
})(typeof self !== 'undefined' ? self : this);
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

}({}));
})(__self__);
delete __self__.fetch.polyfill
exports = __self__.fetch // To enable: import fetch from 'cross-fetch'
exports.default = __self__.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = __self__.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = __self__.Headers
exports.Request = __self__.Request
exports.Response = __self__.Response
module.exports = exports


/***/ }),

/***/ "e74d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/MessageSuccess.vue?vue&type=template&id=0aab1234&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._t("default")],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/MessageSuccess.vue?vue&type=template&id=0aab1234&

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/MessageSuccess.vue?vue&type=custom&index=0&blockType=docs
var MessageSuccessvue_type_custom_index_0_blockType_docs = __webpack_require__("60f9");

// CONCATENATED MODULE: ./src/forms/MessageSuccess.vue

var script = {}


/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof MessageSuccessvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(MessageSuccessvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var MessageSuccess = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "e9a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMolgenis_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e054");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMolgenis_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMolgenis_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableMolgenis_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ebfe":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("022d");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".filter-header h6[data-v-23780467]{vertical-align:top}.filter-header[data-v-23780467]:hover{cursor:move}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ec6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputCheckbox_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8b19");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputCheckbox_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputCheckbox_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ecf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ListDisplay_vue_vue_type_style_index_0_id_1bdd26b7_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6615");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ListDisplay_vue_vue_type_style_index_0_id_1bdd26b7_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_7_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_7_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_7_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ListDisplay_vue_vue_type_style_index_0_id_1bdd26b7_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ed0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/LayoutModal.vue?vue&type=template&id=66761957&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{staticClass:"modal fade show",staticStyle:{"display":"block"},attrs:{"role":"dialog","tabindex":"-1","aria-modal":"true"}},[(_vm.show)?_c('div',{staticClass:"modal-dialog modal-xl",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.title))]),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.close}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_c('div',{directives:[{name:"scroll-lock",rawName:"v-scroll-lock",value:(_vm.show),expression:"show"}],staticClass:"modal-body bg-light"},[_vm._t("body")],2),_c('div',{staticClass:"modal-footer"},[_vm._t("footer")],2)])]):_vm._e()]):_vm._e()])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/LayoutModal.vue?vue&type=template&id=66761957&scoped=true&

// EXTERNAL MODULE: ../node_modules/v-scroll-lock/dist/v-scroll-lock.esm.js
var v_scroll_lock_esm = __webpack_require__("f42c");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/layout/LayoutModal.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LayoutModalvue_type_script_lang_js_ = ({
  directives: {
    VScrollLock: v_scroll_lock_esm["a" /* default */]
  },
  props: {
    /** Shown as the title of the model */
    title: {
      type: String,
      default: ""
    },

    /** When true the modal will be shown */
    show: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      /** when the close x button is clicked */
      this.$emit("close");
    }

  }
});
// CONCATENATED MODULE: ./src/layout/LayoutModal.vue?vue&type=script&lang=js&
 /* harmony default export */ var layout_LayoutModalvue_type_script_lang_js_ = (LayoutModalvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/layout/LayoutModal.vue?vue&type=style&index=0&id=66761957&scoped=true&lang=css&
var LayoutModalvue_type_style_index_0_id_66761957_scoped_true_lang_css_ = __webpack_require__("3103");

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/layout/LayoutModal.vue?vue&type=custom&index=0&blockType=docs
var LayoutModalvue_type_custom_index_0_blockType_docs = __webpack_require__("e4d2");

// CONCATENATED MODULE: ./src/layout/LayoutModal.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  layout_LayoutModalvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "66761957",
  null
  
)

/* custom blocks */

if (typeof LayoutModalvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(LayoutModalvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var LayoutModal = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "eda2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputInt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b513");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputInt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputInt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InputInt_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "edb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRefback.vue?vue&type=template&id=018f8c0b&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormGroup',_vm._g(_vm._b({},'FormGroup',_vm.$props,false),_vm.$listeners),[(!this.tableMetadata)?_c('Spinner'):(_vm.pkey)?_c('TableMolgenis',{attrs:{"data":_vm.data,"columns":_vm.visibleColumns,"table-metadata":_vm.tableMetadata},scopedSlots:_vm._u([{key:"colheader",fn:function(){return [_vm._t("colheader",null,{"canEdit":_vm.canEdit,"reload":_vm.reload,"grapqlURL":_vm.graphqlURL},_vm.$props),(_vm.canEdit)?_c('RowButtonAdd',{staticClass:"d-inline p-0",attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL,"visible-columns":_vm.visibleColumnNames,"default-value":_vm.defaultValue},on:{"close":_vm.reload}}):_vm._e()]},proxy:true},{key:"rowheader",fn:function(slotProps){return [_vm._t("rowheader",null,{"row":slotProps.row,"metadata":_vm.tableMetadata,"rowkey":slotProps.rowkey}),(_vm.canEdit)?_c('RowButtonEdit',{attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL,"visible-columns":_vm.visibleColumnNames,"pkey":_vm.getPkey(slotProps.row)},on:{"close":_vm.reload}}):_vm._e(),(_vm.canEdit)?_c('RowButtonDelete',{attrs:{"table":_vm.table,"graphqlURL":_vm.graphqlURL,"pkey":_vm.getPkey(slotProps.row)},on:{"close":_vm.reload}}):_vm._e()]}}],null,true)}):_c('MessageWarning',[_vm._v(" This can only be filled in after you have saved (or saved draft). ")])],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputRefback.vue?vue&type=template&id=018f8c0b&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/_formGroup.vue + 4 modules
var _formGroup = __webpack_require__("084c");

// EXTERNAL MODULE: ./src/tables/TableMolgenis.vue + 34 modules
var TableMolgenis = __webpack_require__("0dcd");

// EXTERNAL MODULE: ./src/mixins/TableMixin.vue + 2 modules
var TableMixin = __webpack_require__("89c1");

// EXTERNAL MODULE: ./src/tables/RowButtonAdd.vue + 4 modules
var RowButtonAdd = __webpack_require__("fc2a");

// EXTERNAL MODULE: ./src/tables/RowButtonDelete.vue + 4 modules
var RowButtonDelete = __webpack_require__("c64d");

// EXTERNAL MODULE: ./src/tables/RowButtonEdit.vue + 4 modules
var RowButtonEdit = __webpack_require__("42ad");

// EXTERNAL MODULE: ./src/forms/MessageWarning.vue + 2 modules
var MessageWarning = __webpack_require__("db4e");

// EXTERNAL MODULE: ./src/layout/Spinner.vue + 2 modules
var Spinner = __webpack_require__("0f35");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputRefback.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var InputRefbackvue_type_script_lang_js_ = ({
  extends: _baseInput["a" /* default */],
  mixins: [TableMixin["a" /* default */]],
  components: {
    FormGroup: _formGroup["default"],
    TableMolgenis: TableMolgenis["a" /* default */],
    RowButtonDelete: RowButtonDelete["a" /* default */],
    RowButtonEdit: RowButtonEdit["a" /* default */],
    RowButtonAdd: RowButtonAdd["a" /* default */],
    Spinner: Spinner["a" /* default */],
    MessageWarning: MessageWarning["a" /* default */]
  },
  props: {
    /** name of the column in the other table */
    refBack: String,

    /** pkey of the current table that refback should point to */
    pkey: Object
  },
  computed: {
    defaultValue() {
      var result = new Object();
      result[this.refBack] = this.pkey;
      return result;
    },

    graphqlFilter() {
      var result = new Object();
      result[this.refBack] = {
        equals: this.pkey
      };
      return result;
    },

    visibleColumnNames() {
      return this.visibleColumns.map(c => c.name);
    },

    visibleColumns() {
      //columns, excludes refback and mg_
      if (this.tableMetadata && this.tableMetadata.columns) {
        return this.tableMetadata.columns.filter(c => c.name != this.refBack && !c.name.startsWith("mg_"));
      }

      return [];
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputRefback.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputRefbackvue_type_script_lang_js_ = (InputRefbackvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputRefback.vue?vue&type=custom&index=0&blockType=docs
var InputRefbackvue_type_custom_index_0_blockType_docs = __webpack_require__("bac8");

// CONCATENATED MODULE: ./src/forms/InputRefback.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputRefbackvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof InputRefbackvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputRefbackvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputRefback = __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ "ee24":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
    name = _ref.name,
    type = _ref.type;
  this.uri = uri;
  this.name = name;
  this.type = type;
};


/***/ }),

/***/ "ee54":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "efc6":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "f1cb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e11d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("b454").default
var update = add("9d09abd4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "f42c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function e(e){return function(e){if(Array.isArray(e)){for(var t=0,o=new Array(e.length);t<e.length;t++)o[t]=e[t];return o}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var t=!1;if("undefined"!=typeof window){var o={get passive(){t=!0}};window.addEventListener("testPassive",null,o),window.removeEventListener("testPassive",null,o)}var n,i,r="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&/iP(ad|hone|od)/.test(window.navigator.platform),l=[],d=!1,c=-1,s=function(e){return l.some((function(t){return!(!t.options.allowTouchMove||!t.options.allowTouchMove(e))}))},a=function(e){var t=e||window.event;return!!s(t.target)||(t.touches.length>1||(t.preventDefault&&t.preventDefault(),!1))},u={enableBodyScroll:function(e){if(r){if(!e)return void console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");e.ontouchstart=null,e.ontouchmove=null,l=l.filter((function(t){return t.targetElement!==e})),d&&0===l.length&&(document.removeEventListener("touchmove",a,t?{passive:!1}:void 0),d=!1)}else(l=l.filter((function(t){return t.targetElement!==e}))).length||setTimeout((function(){void 0!==i&&(document.body.style.paddingRight=i,i=void 0),void 0!==n&&(document.body.style.overflow=n,n=void 0)}))},disableBodyScroll:function(o,u){if(r){if(!o)return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");if(o&&!l.some((function(e){return e.targetElement===o}))){var v={targetElement:o,options:u||{}};l=[].concat(e(l),[v]),o.ontouchstart=function(e){1===e.targetTouches.length&&(c=e.targetTouches[0].clientY)},o.ontouchmove=function(e){1===e.targetTouches.length&&function(e,t){var o=e.targetTouches[0].clientY-c;!s(e.target)&&(t&&0===t.scrollTop&&o>0?a(e):function(e){return!!e&&e.scrollHeight-e.scrollTop<=e.clientHeight}(t)&&o<0?a(e):e.stopPropagation())}(e,o)},d||(document.addEventListener("touchmove",a,t?{passive:!1}:void 0),d=!0)}}else{!function(e){setTimeout((function(){if(void 0===i){var t=!!e&&!0===e.reserveScrollBarGap,o=window.innerWidth-document.documentElement.clientWidth;t&&o>0&&(i=document.body.style.paddingRight,document.body.style.paddingRight="".concat(o,"px"))}void 0===n&&(n=document.body.style.overflow,document.body.style.overflow="hidden")}))}(u);var f={targetElement:o,options:u||{}};l=[].concat(e(l),[f])}},install:function(e,t){if(t){var o=t.enableBodyScroll,n=t.disableBodyScroll,i=t.bodyScrollOptions;o&&(this.enableBodyScroll=o),n&&(this.disableBodyScroll=n),i&&(this.bodyScrollOptions=i)}e.directive("scroll-lock",{inserted:this.inserted.bind(this),componentUpdated:this.componentUpdated.bind(this),unbind:this.unbind.bind(this)})},inserted:function(e,t){t.value&&this.disableBodyScroll(e,this.bodyScrollOptions)},componentUpdated:function(e,t){t.value?this.disableBodyScroll(e,this.bodyScrollOptions):this.enableBodyScroll(e)},unbind:function(e){this.enableBodyScroll(e)}};"undefined"!=typeof window&&window.Vue&&window.Vue.use(u);/* harmony default export */ __webpack_exports__["a"] = (u);


/***/ }),

/***/ "f484":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSession_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3987");
/* harmony import */ var _node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSession_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSession_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0__);
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_vue_cli_plugin_styleguidist_empty_object_loader_js_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolgenisSession_vue_vue_type_custom_index_0_blockType_docs__WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f99e":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "fa15":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "fbd5":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "fc2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowButtonAdd.vue?vue&type=template&id=ab593a3a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('RowEditModal',{attrs:{"table":_vm.table,"defaultValue":_vm.defaultValue,"graphqlURL":_vm.graphqlURL,"visible-columns":_vm.visibleColumns},on:{"close":_vm.closeForm}}):_c('IconAction',{attrs:{"icon":"plus"},on:{"click":_vm.openForm}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/tables/RowButtonAdd.vue?vue&type=template&id=ab593a3a&

// EXTERNAL MODULE: ./src/tables/RowEditModal.vue + 3 modules
var RowEditModal = __webpack_require__("8cae");

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/tables/RowButtonAdd.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var RowButtonAddvue_type_script_lang_js_ = ({
  data: function () {
    return {
      open: false
    };
  },
  components: {
    RowEditModal: RowEditModal["a" /* default */],
    IconAction: IconAction["a" /* default */]
  },
  props: {
    table: String,
    graphqlURL: {
      defaultValue: "graphql",
      type: String
    },
    visibleColumns: Array,
    defaultValue: Object
  },
  computed: {
    title() {
      return "Add new row to table " + this.table;
    }

  },
  methods: {
    openForm() {
      this.open = true;
    },

    closeForm() {
      this.open = false;
      this.$emit("close");
    }

  }
});
// CONCATENATED MODULE: ./src/tables/RowButtonAdd.vue?vue&type=script&lang=js&
 /* harmony default export */ var tables_RowButtonAddvue_type_script_lang_js_ = (RowButtonAddvue_type_script_lang_js_); 
// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/tables/RowButtonAdd.vue?vue&type=custom&index=0&blockType=docs
var RowButtonAddvue_type_custom_index_0_blockType_docs = __webpack_require__("4b57");

// CONCATENATED MODULE: ./src/tables/RowButtonAdd.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  tables_RowButtonAddvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */

if (typeof RowButtonAddvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(RowButtonAddvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var RowButtonAdd = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "fd53":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "feb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _layout_LayoutForm_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("494f");
/* harmony import */ var _layout_LayoutModal_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ed0c");
/* harmony import */ var _forms_MessageError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("25b1");
/* harmony import */ var _forms_MessageSuccess__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("e74d");
/* harmony import */ var _forms_ButtonAction_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("c268");
/* harmony import */ var _forms_ButtonAlt_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("bd01");
/* harmony import */ var _forms_ButtonOutline__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("de24");
/* harmony import */ var _layout_MolgenisSignin__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("be64");
/* harmony import */ var _mixins_TableMixin__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("89c1");
/* harmony import */ var _mixins_GraphqlRequestMixin__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("79ca");
/* harmony import */ var _RowFormInput_vue__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("2b6d");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  extends: _mixins_TableMixin__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"],
  mixins: [_mixins_GraphqlRequestMixin__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"]],
  data: function () {
    return {
      showLogin: false,
      value: {},
      errorPerColumn: {},
      success: null
    };
  },
  props: {
    /** when updating existing record, this is the primary key value */
    pkey: Object,

    /** visible columns, useful if you only want to allow partial edit (array of strings) */
    visibleColumns: Array,

    /** whebn creating new record, this is initialization value */
    defaultValue: Object
  },
  components: {
    LayoutForm: _layout_LayoutForm_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"],
    RowFormInput: _RowFormInput_vue__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"],
    ButtonAction: _forms_ButtonAction_vue__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"],
    ButtonAlt: _forms_ButtonAlt_vue__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"],
    LayoutModal: _layout_LayoutModal_vue__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"],
    MessageError: _forms_MessageError__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"],
    MessageSuccess: _forms_MessageSuccess__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"],
    SigninForm: _layout_MolgenisSignin__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"],
    ButtonOutline: _forms_ButtonOutline__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"]
  },
  methods: {
    getRefBackType(column) {
      if (column.columnType === "REFBACK") {
        //get the other table, find the refback column and check its type
        return this.getTable(column.refTable).columns.filter(c => c.name === column.refBack).map(c => c.columnType)[0];
      }
    },

    reload() {
      //override superclass
      if (this.pkey) {
        _mixins_TableMixin__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"].methods.reload.call(this);
      }
    },

    loginSuccess() {
      this.graphqlError = null;
      this.success = null;
      this.showLogin = false;
    },

    saveDraft() {
      this.executeCommand(true);
    },

    save() {
      this.executeCommand(false);
    },

    executeCommand(isDraft) {
      this.graphqlError = null;
      this.success = null; // todo spinner

      let name = this.table; // indicate if draft

      if (isDraft) {
        this.value["mg_draft"] = true;
      } else {
        this.value["mg_draft"] = false;
      }

      let variables = {
        value: [this.value]
      };
      let query = `mutation insert($value:[${name}Input]){insert(${name}:$value){message}}`;

      if (this.pkey) {
        query = `mutation update($value:[${name}Input]){update(${name}:$value){message}}`;
      }

      this.requestMultipart(this.graphqlURL, query, variables).then(data => {
        if (data.insert) {
          this.success = data.insert.message;
        }

        if (data.update) {
          this.success = data.update.message;
        }

        this.$emit("close");
      }).catch(error => {
        if (error.status === 403) {
          this.graphqlError = "Schema doesn't exist or permission denied. Do you need to Sign In?";
          this.showLogin = true;
        } else {
          this.graphqlError = error.errors;
        }
      });
    },

    eval(expression) {
      try {
        return eval("(function (row) { " + expression + "})")(this.value); // eslint-disable-line
      } catch (e) {
        return "Script error contact admin: " + e.message;
      }
    },

    visible(expression) {
      if (expression) {
        return this.eval(expression);
      } else {
        return true;
      }
    },

    validate() {
      if (this.tableMetadata) {
        this.tableMetadata.columns.forEach(column => {
          // make really empty if empty
          if (/^\s*$/.test(this.value[column.name])) {//this.value[column.name] = null;
          }

          delete this.errorPerColumn[column.name]; // when required

          if (column.required && (this.value[column.name] == null || typeof this.value[column.name] === "number" && isNaN(this.value[column.name]))) {
            this.errorPerColumn[column.name] = column.name + " is required ";
          } else {
            // when not empty
            // when validation
            if (typeof this.value[column.name] !== "undefined" && typeof column.validation !== "undefined") {
              let value = this.value[column.name]; //used for eval, two lines below

              this.errorPerColumn[column.name] = value; //dummy assign

              this.errorPerColumn[column.name] = this.eval(column.validation);
            } else if (column.refLink && this.value[column.name] && this.value[column.refLink] && !JSON.stringify(this.value[column.name]).includes(JSON.stringify(this.value[column.refLink]))) {
              //reflinks should overlap
              this.errorPerColumn[column.name] = "value should match your selection in column '" + column.refLink + "' ";
            }
          }
        });
      }
    }

  },
  computed: {
    columnsWithoutMeta() {
      return this.tableMetadata.columns.filter(c => !c.name.startsWith("mg_"));
    },

    refLinkFilters() {
      let filter = {};

      if (this.tableMetadata) {
        this.tableMetadata.columns.forEach(c => {
          if (c.refLink) {
            //get the overlap, should be a key column of [refLink][refTable]
            this.tableMetadata.columns.forEach(c2 => {
              if (c2.name === c.refLink) {
                this.schema.tables.forEach(t => {
                  if (t.name === c.refTable) {
                    t.columns.forEach(c3 => {
                      if (c3.refTable === c2.refTable) {
                        filter[c.name] = {};
                        filter[c.name][c3.name] = {
                          equals: this.value[c.refLink]
                        };
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }

      return filter;
    },

    //@overide
    graphqlFilter() {
      let result = {};

      if (this.tableMetadata && this.pkey) {
        this.tableMetadata.columns.filter(c => c.key == 1).map(c => result[c.name] = {
          equals: this.pkey[c.name]
        });
      }

      return result;
    },

    // override from tableMixin
    title() {
      if (this.pkey) {
        return `update ${this.table}`;
      } else {
        return `insert ${this.table}`;
      }
    }

  },
  watch: {
    data(val) {
      //TODO prevent loading of parent class if no pkey
      if (this.pkey && val && val.length > 0) {
        let data = val[0];
        let defaultValue = {};
        this.tableMetadata.columns.forEach(column => {
          if (data[column.name]) {
            defaultValue[column.name] = data[column.name];
          }
        });
        this.value = defaultValue;
      }
    },

    // validation happens here
    value: {
      handler() {
        this.validate();
      },

      deep: true
    },
    tableMetadata: {
      handler() {
        this.validate();
      },

      deep: true
    }
  },

  created() {
    //pass by value
    if (this.defaultValue) {
      this.value = JSON.parse(JSON.stringify(this.defaultValue));
    }

    this.validate();
  }

});

/***/ }),

/***/ "ffa4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"972b89a0-vue-loader-template"}!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputString.vue?vue&type=template&id=5fa2b2e3&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.inplace && !_vm.focus && !_vm.errorMessage)?_c('span',{on:{"click":_vm.toggleFocus}},[(_vm.list && _vm.value)?_c('span',[_vm._v(_vm._s(_vm.value.join(", ")))]):_c('span',[_vm._v(" "+_vm._s(_vm.value ? _vm.value : "‌‌"))])]):_c('FormGroup',_vm._g(_vm._b({},'FormGroup',_vm.$props,false),_vm.$listeners),_vm._l((_vm.valueArray),function(item,idx){return _c('InputAppend',_vm._b({key:idx,attrs:{"showClear":_vm.showClear(idx),"showPlus":_vm.showPlus(idx),"showMinus":_vm.showMinus(idx)},on:{"clear":function($event){return _vm.clearValue(idx)},"add":_vm.addRow}},'InputAppend',_vm.$props,false),[_c('input',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.inplace && !_vm.list),expression:"inplace && !list"}],class:{ 'form-control': true, 'is-invalid': _vm.errorMessage },attrs:{"aria-describedby":_vm.id + 'Help',"placeholder":_vm.placeholder,"readonly":_vm.readonly},domProps:{"value":item},on:{"keypress":_vm.keyhandler,"input":function($event){return _vm.emitValue($event, idx)},"blur":_vm.toggleFocus}})])}),1),(_vm.inplace && !_vm.focus)?_c('IconAction',{staticClass:"hoverIcon",attrs:{"icon":"pencil-alt"},on:{"click":_vm.toggleFocus}}):_vm._e()],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/forms/InputString.vue?vue&type=template&id=5fa2b2e3&scoped=true&

// EXTERNAL MODULE: ./src/forms/_baseInput.vue + 2 modules
var _baseInput = __webpack_require__("842e");

// EXTERNAL MODULE: ./src/forms/_inputAppend.vue + 4 modules
var _inputAppend = __webpack_require__("5807");

// EXTERNAL MODULE: ./src/forms/IconAction.vue + 4 modules
var IconAction = __webpack_require__("15e7");

// CONCATENATED MODULE: ../node_modules/cache-loader/dist/cjs.js??ref--13-0!../node_modules/thread-loader/dist/cjs.js!../node_modules/babel-loader/lib!../node_modules/cache-loader/dist/cjs.js??ref--1-0!../node_modules/vue-loader/lib??vue-loader-options!./src/forms/InputString.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var InputStringvue_type_script_lang_js_ = ({
  extends: _baseInput["a" /* default */],
  components: {
    InputAppend: _inputAppend["a" /* default */],
    FormGroup: () => Promise.resolve(/* import() */).then(__webpack_require__.bind(null, "084c")),
    //because it uses itself in nested form
    IconAction: IconAction["a" /* default */]
  },
  methods: {
    keyhandler(event) {
      return event;
    }

  }
});
// CONCATENATED MODULE: ./src/forms/InputString.vue?vue&type=script&lang=js&
 /* harmony default export */ var forms_InputStringvue_type_script_lang_js_ = (InputStringvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/forms/InputString.vue?vue&type=style&index=0&id=5fa2b2e3&scoped=true&lang=css&
var InputStringvue_type_style_index_0_id_5fa2b2e3_scoped_true_lang_css_ = __webpack_require__("dddb");

// EXTERNAL MODULE: ../node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("a6c2");

// EXTERNAL MODULE: ./src/forms/InputString.vue?vue&type=custom&index=0&blockType=docs
var InputStringvue_type_custom_index_0_blockType_docs = __webpack_require__("6904");

// CONCATENATED MODULE: ./src/forms/InputString.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  forms_InputStringvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "5fa2b2e3",
  null
  
)

/* custom blocks */

if (typeof InputStringvue_type_custom_index_0_blockType_docs["default"] === 'function') Object(InputStringvue_type_custom_index_0_blockType_docs["default"])(component)

/* harmony default export */ var InputString = __webpack_exports__["a"] = (component.exports);

/***/ })

/******/ });
//# sourceMappingURL=emx2-styleguide.common.js.map